var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfacmSlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 228 228",
    width: 228,
    height: 228,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AF6_228px_BFA Favicon SVG-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h228v228h-228z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h228v228h-228z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none } \n\t\t.s1 { fill: #e53a14 } \n\t\t.s2 { fill: #e53a11 } \n\t\t.s3 { fill: #e42f12 } \n\t\t.s4 { fill: #e63f10 } \n\t\t.s5 { fill: #e53a13 } \n\t\t.s6 { fill: #e53b11 } \n\t\t.s7 { fill: #e53512 } \n\t\t.s8 { fill: #e63f11 } \n\t\t.s9 { fill: #e63c11 } \n\t\t.s10 { fill: #e9580f } \n\t\t.s11 { fill: #e42d13 } \n\t\t.s12 { fill: #e53213 } \n\t\t.s13 { fill: #e74a0f } \n\t\t.s14 { fill: #e74a11 } \n\t\t.s15 { fill: #e64011 } \n\t\t.s16 { fill: #e95b0c } \n\t\t.s17 { fill: #e9560d } \n\t\t.s18 { fill: #f08501 } \n\t\t.s19 { fill: #e53914 } \n\t\t.s20 { fill: #e63e13 } \n\t\t.s21 { fill: #e52f13 } \n\t\t.s22 { fill: #e63d13 } \n\t\t.s23 { fill: #e64113 } \n\t\t.s24 { fill: #e53513 } \n\t\t.s25 { fill: #e53413 } \n\t\t.s26 { fill: #e53613 } \n\t\t.s27 { fill: #e53113 } \n\t\t.s28 { fill: #e53313 } \n\t\t.s29 { fill: #e74611 } \n\t\t.s30 { fill: #e42c13 } \n\t\t.s31 { fill: #e53411 } \n\t\t.s32 { fill: #e53412 } \n\t\t.s33 { fill: #e53312 } \n\t\t.s34 { fill: #e53012 } \n\t\t.s35 { fill: #e53611 } \n\t\t.s36 { fill: #e53211 } \n\t\t.s37 { fill: #e53112 } \n\t\t.s38 { fill: #e53212 } \n\t\t.s39 { fill: #e43012 } \n\t\t.s40 { fill: #e42c12 } \n\t\t.s41 { fill: #e42e12 } \n\t\t.s42 { fill: #fefefe } \n\t\t.s43 { fill: #e53713 } \n\t\t.s44 { fill: #e53811 } \n\t\t.s45 { fill: #e53912 } \n\t\t.s46 { fill: #e53812 } \n\t\t.s47 { fill: #e42a12 } \n\t\t.s48 { fill: #e53712 } \n\t\t.s49 { fill: #e42b13 } \n\t\t.s50 { fill: #e42512 } \n\t\t.s51 { fill: #e53711 } \n\t\t.s52 { fill: #e53a12 } \n\t\t.s53 { fill: #e74a10 } \n\t\t.s54 { fill: #e53014 } \n\t\t.s55 { fill: #e64013 } \n\t\t.s56 { fill: #e53514 } \n\t\t.s57 { fill: #e53511 } \n\t\t.s58 { fill: #e64310 } \n\t\t.s59 { fill: #e42d12 } \n\t\t.s60 { fill: #e63e11 } \n\t\t.s61 { fill: #e74910 } \n\t\t.s62 { fill: #e63d11 } \n\t\t.s63 { fill: #e74810 } \n\t\t.s64 { fill: #e7480f } \n\t\t.s65 { fill: #e7490f } \n\t\t.s66 { fill: #e64211 } \n\t\t.s67 { fill: #e74d0f } \n\t\t.s68 { fill: #e95411 } \n\t\t.s69 { fill: #e74912 } \n\t\t.s70 { fill: #e64111 } \n\t\t.s71 { fill: #e85111 } \n\t\t.s72 { fill: #e74d10 } \n\t\t.s73 { fill: #e8510e } \n\t\t.s74 { fill: #e84e0f } \n\t\t.s75 { fill: #e95a0c } \n\t\t.s76 { fill: #e8520e } \n\t\t.s77 { fill: #e9570c } \n\t\t.s78 { fill: #e84f0e } \n\t\t.s79 { fill: #e74911 } \n\t\t.s80 { fill: #f39501 } \n\t\t.s81 { fill: #f29000 } \n\t\t.s82 { fill: #ec6e05 } \n\t\t.s83 { fill: #f08401 } \n\t\t.s84 { fill: #f29200 } \n\t\t.s85 { fill: #ea6209 } \n\t\t.s86 { fill: #ec6e04 } \n\t\t.s87 { fill: #eb6408 } \n\t\t.s88 { fill: #f18c00 } \n\t\t.s89 { fill: #f08800 } \n\t\t.s90 { fill: #ef7f00 } \n\t\t.s91 { fill: #f59d00 } \n\t\t.s92 { fill: #ec6d04 } \n\t\t.s93 { fill: #f28e00 } \n\t\t.s94 { fill: #f5a103 } \n\t\t.s95 { fill: #f29001 } \n\t\t.s96 { fill: #f18900 } \n\t\t.s97 { fill: #f28e01 } \n\t\t.s98 { fill: #ee7701 } \n\t\t.s99 { fill: #ef8001 } \n\t\t.s100 { fill: #f18800 } \n\t\t.s101 { fill: #ef7f01 } \n\t\t.s102 { fill: #f49c00 } \n\t\t.s103 { fill: #f08200 } \n\t\t.s104 { fill: #e42e13 } \n\t\t.s105 { fill: #e53814 } \n\t\t.s106 { fill: #e53a15 } \n\t\t.s107 { fill: #e42513 } \n\t\t.s108 { fill: #e64012 } \n\t\t.s109 { fill: #e74711 } \n\t\t.s110 { fill: #e42e11 } \n\t\t.s111 { fill: #e42f11 } \n\t\t.s112 { fill: #e53c11 } \n\t\t.s113 { fill: #e53911 } \n\t\t.s114 { fill: #e42d11 } \n\t\t.s115 { fill: #e53d11 } \n\t\t.s116 { fill: #e74b11 } \n\t\t.s117 { fill: #e64213 } \n\t\t.s118 { fill: #e74715 } \n\t\t.s119 { fill: #e64313 } \n\t\t.s120 { fill: #e64112 } \n\t\t.s121 { fill: #e8530e } \n\t\t.s122 { fill: #ea610a } \n\t\t.s123 { fill: #e84d10 } \n\t\t.s124 { fill: #e63e12 } \n\t\t.s125 { fill: #e53815 } \n\t\t.s126 { fill: #eb6409 } \n\t\t.s127 { fill: #e63e18 } \n\t\t.s128 { fill: #e84c1b } \n\t\t.s129 { fill: #e53515 } \n\t\t.s130 { fill: #e95b0e } \n\t\t.s131 { fill: #e53c13 } \n\t\t.s132 { fill: #e95710 } \n\t\t.s133 { fill: #e64312 } \n\t\t.s134 { fill: #e42f13 } \n\t\t.s135 { fill: #e84b1b } \n\t\t.s136 { fill: #e64212 } \n\t\t.s137 { fill: #e84e14 } \n\t\t.s138 { fill: #e64017 } \n\t\t.s139 { fill: #e9561f } \n\t\t.s140 { fill: #e95510 } \n\t\t.s141 { fill: #e95727 } \n\t\t.s142 { fill: #e84f20 } \n\t\t.s143 { fill: #e9562b } \n\t\t.s144 { fill: #e84f18 } \n\t\t.s145 { fill: #e63c17 } \n\t\t.s146 { fill: #e64010 } \n\t\t.s147 { fill: #eb6137 } \n\t\t.s148 { fill: #e95823 } \n\t\t.s149 { fill: #ec673d } \n\t\t.s150 { fill: #eb6336 } \n\t\t.s151 { fill: #e6431b } \n\t\t.s152 { fill: #e64210 } \n\t\t.s153 { fill: #e74617 } \n\t\t.s154 { fill: #e42c11 } \n\t\t.s155 { fill: #e53813 } \n\t\t.s156 { fill: #e74318 } \n\t\t.s157 { fill: #eb6233 } \n\t\t.s158 { fill: #eb6614 } \n\t\t.s159 { fill: #ea5f2e } \n\t\t.s160 { fill: #ea620d } \n\t\t.s161 { fill: #e8530d } \n\t\t.s162 { fill: #e64117 } \n\t\t.s163 { fill: #fdf7f2 } \n\t\t.s164 { fill: #ec6c3f } \n\t\t.s165 { fill: #e84f14 } \n\t\t.s166 { fill: #ec6e41 } \n\t\t.s167 { fill: #e53311 } \n\t\t.s168 { fill: #fdf2e9 } \n\t\t.s169 { fill: #e53614 } \n\t\t.s170 { fill: #e53714 } \n\t\t.s171 { fill: #e63d18 } \n\t\t.s172 { fill: #e53915 } \n\t\t.s173 { fill: #e42412 } \n\t\t.s174 { fill: #e42b12 } \n\t\t.s175 { fill: #e74710 } \n\t\t.s176 { fill: #e53c14 } \n\t\t.s177 { fill: #e63e15 } \n\t\t.s178 { fill: #e7451b } \n\t\t.s179 { fill: #e63c13 } \n\t\t.s180 { fill: #e53111 } \n\t\t.s181 { fill: #e8550e } \n\t\t.s182 { fill: #e9580d } \n\t\t.s183 { fill: #e9570e } \n\t\t.s184 { fill: #e9570d } \n\t\t.s185 { fill: #e84f0f } \n\t\t.s186 { fill: #e74c0f } \n\t\t.s187 { fill: #e8560e } \n\t\t.s188 { fill: #e8550f } \n\t\t.s189 { fill: #e8540d } \n\t\t.s190 { fill: #e8500e } \n\t\t.s191 { fill: #e64510 } \n\t\t.s192 { fill: #e74610 } \n\t\t.s193 { fill: #e64110 } \n\t\t.s194 { fill: #e74812 } \n\t\t.s195 { fill: #e74b10 } \n\t\t.s196 { fill: #e74811 } \n\t\t.s197 { fill: #e74b0f } \n\t\t.s198 { fill: #ed7103 } \n\t\t.s199 { fill: #ed7003 } \n\t\t.s200 { fill: #eb6906 } \n\t\t.s201 { fill: #eb6508 } \n\t\t.s202 { fill: #e84e0e } \n\t\t.s203 { fill: #ea6109 } \n\t\t.s204 { fill: #f18901 } \n\t\t.s205 { fill: #f5a100 } \n\t\t.s206 { fill: #f5a200 } \n\t\t.s207 { fill: #f39601 } \n\t\t.s208 { fill: #f39701 } \n\t\t.s209 { fill: #f18d00 } \n\t\t.s210 { fill: #f49b00 } \n\t\t.s211 { fill: #f28f01 } \n\t\t.s212 { fill: #f08101 } \n\t\t.s213 { fill: #ef7d01 } \n\t\t.s214 { fill: #ec6b05 } \n\t\t.s215 { fill: #eb6309 } \n\t\t.s216 { fill: #e9590c } \n\t\t.s217 { fill: #e9590d } \n\t\t.s218 { fill: #ef7d00 } \n\t\t.s219 { fill: #f29100 } \n\t\t.s220 { fill: #f08500 } \n\t\t.s221 { fill: #ef7e00 } \n\t\t.s222 { fill: #f39300 } \n\t\t.s223 { fill: #f29301 } \n\t\t.s224 { fill: #f39500 } \n\t\t.s225 { fill: #f08601 } \n\t\t.s226 { fill: #f29300 } \n\t\t.s227 { fill: #f08400 } \n\t\t.s228 { fill: #f49d00 } \n\t\t.s229 { fill: #f08301 } \n\t\t.s230 { fill: #f39802 } \n\t\t.s231 { fill: #f39602 } \n\t\t.s232 { fill: #f08300 } \n\t\t.s233 { fill: #f08700 } \n\t\t.s234 { fill: #f59f03 } \n\t\t.s235 { fill: #f39400 } \n\t\t.s236 { fill: #ef7c01 } \n\t\t.s237 { fill: #ef7a00 } \n\t\t.s238 { fill: #ef8101 } \n\t\t.s239 { fill: #ee7801 } \n\t\t.s240 { fill: #f08600 } \n\t\t.s241 { fill: #f08801 } \n\t\t.s242 { fill: #ed7303 } \n\t\t.s243 { fill: #f18d01 } \n\t\t.s244 { fill: #ee7901 } \n\t\t.s245 { fill: #ed7205 } \n\t\t.s246 { fill: #ef7d02 } \n\t\t.s247 { fill: #f18b01 } \n\t\t.s248 { fill: #f18e01 } \n\t\t.s249 { fill: #ee7802 } \n\t\t.s250 { fill: #f18c02 } \n\t\t.s251 { fill: #f49d01 } \n\t\t.s252 { fill: #f6a301 } \n\t\t.s253 { fill: #ef7b01 } \n\t\t.s254 { fill: #f39900 } \n\t\t.s255 { fill: #e43112 } \n\t\t.s256 { fill: #e53913 } \n\t\t.s257 { fill: #e63f13 } \n\t\t.s258 { fill: #e53b13 } \n\t\t.s259 { fill: #e53011 } \n\t\t.s260 { fill: #e43011 } \n\t\t.s261 { fill: #e42712 } \n\t\t.s262 { fill: #ea5f0a } \n\t\t.s263 { fill: #e9540d } \n\t\t.s264 { fill: #e7470f } \n\t\t.s265 { fill: #fdf1e8 } \n\t\t.s266 { fill: #fdf1e7 } \n\t\t.s267 { fill: #e74c0e } \n\t\t.s268 { fill: #e9550d } \n\t\t.s269 { fill: #ea5f0b } \n\t\t.s270 { fill: #ea5d0b } \n\t\t.s271 { fill: #ec6911 } \n\t\t.s272 { fill: #ec6c05 } \n\t\t.s273 { fill: #ee7601 } \n\t\t.s274 { fill: #eb6707 } \n\t\t.s275 { fill: #ed6f04 } \n\t\t.s276 { fill: #eb6907 } \n\t\t.s277 { fill: #e95c0c } \n\t\t.s278 { fill: #ec6b06 } \n\t\t.s279 { fill: #ed7004 } \n\t\t.s280 { fill: #ea610b } \n\t\t.s281 { fill: #ee7b02 } \n\t\t.s282 { fill: #eb6807 } \n\t\t.s283 { fill: #ec6c06 } \n\t\t.s284 { fill: #ed7203 } \n\t\t.s285 { fill: #ea620a } \n\t\t.s286 { fill: #e74d0e } \n\t\t.s287 { fill: #ea600a } \n\t\t.s288 { fill: #e74510 } \n\t\t.s289 { fill: #e53b12 } \n\t\t.s290 { fill: #e53c12 } \n\t\t.s291 { fill: #e53612 } \n\t\t.s292 { fill: #fcede0 } \n\t\t.s293 { fill: #e7460f } \n\t\t.s294 { fill: #e8550d } \n\t\t.s295 { fill: #eb6608 } \n\t\t.s296 { fill: #e64410 } \n\t\t.s297 { fill: #e9580c } \n\t\t.s298 { fill: #e74913 } \n\t\t.s299 { fill: #e53013 } \n\t\t.s300 { fill: #e63d14 } \n\t\t.s301 { fill: #e64214 } \n\t\t.s302 { fill: #ec6a06 } \n\t\t.s303 { fill: #ee7602 } \n\t\t.s304 { fill: #eb6809 } \n\t\t.s305 { fill: #eb6806 } \n\t\t.s306 { fill: #ec6d05 } \n\t\t.s307 { fill: #e8520d } \n\t\t.s308 { fill: #ee7703 } \n\t\t.s309 { fill: #f08201 } \n\t\t.s310 { fill: #ee7503 } \n\t\t.s311 { fill: #f49a02 } \n\t\t.s312 { fill: #f39600 } \n\t\t.s313 { fill: #ed7402 } \n\t\t.s314 { fill: #f5a003 } \n\t\t.s315 { fill: #ef7e01 } \n\t\t.s316 { fill: #f18c01 } \n\t\t.s317 { fill: #ed7404 } \n\t\t.s318 { fill: #f29400 } \n\t\t.s319 { fill: #ee7702 } \n\t\t.s320 { fill: #f39401 } \n\t\t.s321 { fill: #ee7502 } \n\t\t.s322 { fill: #f28f00 } \n\t\t.s323 { fill: #e9590f } \n\t\t.s324 { fill: #ed7302 } \n\t\t.s325 { fill: #ee7a02 } \n\t\t.s326 { fill: #f39302 } \n\t\t.s327 { fill: #f18a01 } \n\t\t.s328 { fill: #ef7b02 } \n\t\t.s329 { fill: #f39301 } \n\t\t.s330 { fill: #f5a101 } \n\t\t.s331 { fill: #f08100 } \n\t\t.s332 { fill: #f18b00 } \n\t\t.s333 { fill: #ed7503 } \n\t\t.s334 { fill: #f49e01 } \n\t\t.s335 { fill: #ec6e08 } \n\t\t.s336 { fill: #eb6509 } \n\t\t.s337 { fill: #f08520 } \n\t\t.s338 { fill: #f18801 } \n\t\t.s339 { fill: #ed7105 } \n\t\t.s340 { fill: #ed7005 } \n\t\t.s341 { fill: #ee7902 } \n\t\t.s342 { fill: #eb6609 } \n\t\t.s343 { fill: #f49c01 } \n\t\t.s344 { fill: #f49b03 } \n\t\t.s345 { fill: #ef7f02 } \n\t\t.s346 { fill: #f18a00 } \n\t\t.s347 { fill: #e95d0c } \n\t\t.s348 { fill: #ea5e0b } \n\t\t.s349 { fill: #e63d10 } \n\t\t.s350 { fill: #ec6a07 } \n\t\t.s351 { fill: #ef8201 } \n\t\t.s352 { fill: #eb630b } \n\t\t.s353 { fill: #eb640a } \n\t\t.s354 { fill: #ed6f05 } \n\t\t.s355 { fill: #e9550f } \n\t\t.s356 { fill: #e8570d } \n\t\t.s357 { fill: #e95c0b } \n\t\t.s358 { fill: #ea5c0b } \n\t\t.s359 { fill: #e63b11 } \n\t\t.s360 { fill: #ed7403 } \n\t\t.s361 { fill: #eb6708 } \n\t\t.s362 { fill: #ed7104 } \n\t\t.s363 { fill: #ef7d04 } \n\t\t.s364 { fill: #e9550e } \n\t\t.s365 { fill: #ee7a01 } \n\t\t.s366 { fill: #ea5d0c } \n\t\t.s367 { fill: #ea5f0c } \n\t\t.s368 { fill: #ec6f05 } \n\t\t.s369 { fill: #e95a0d } \n\t\t.s370 { fill: #e9570f } \n\t\t.s371 { fill: #ed7502 } \n\t\t.s372 { fill: #eb6607 } \n\t\t.s373 { fill: #f18600 } \n\t\t.s374 { fill: #e95c0d } \n\t\t.s375 { fill: #ef7c02 } \n\t\t.s376 { fill: #f08701 } \n\t\t.s377 { fill: #ec6d07 } \n\t\t.s378 { fill: #f08703 } \n\t\t.s379 { fill: #f28f02 } \n\t\t.s380 { fill: #f08001 } \n\t\t.s381 { fill: #f08802 } \n\t\t.s382 { fill: #ee7304 } \n\t\t.s383 { fill: #f18700 } \n\t\t.s384 { fill: #ec6f04 } \n\t\t.s385 { fill: #ec6b07 } \n\t\t.s386 { fill: #ef8000 } \n\t\t.s387 { fill: #eb630a } \n\t\t.s388 { fill: #ec6e06 } \n\t\t.s389 { fill: #ec6d06 } \n\t\t.s390 { fill: #f08202 } \n\t\t.s391 { fill: #eb6908 } \n\t\t.s392 { fill: #ec7004 } \n\t\t.s393 { fill: #ed7204 } \n\t\t.s394 { fill: #f08302 } \n\t\t.s395 { fill: #ec6b08 } \n\t\t.s396 { fill: #f08702 } \n\t\t.s397 { fill: #ec6907 } \n\t\t.s398 { fill: #ed6f06 } \n\t\t.s399 { fill: #f39703 } \n\t\t.s400 { fill: #f29202 } \n\t\t.s401 { fill: #eb640b } \n\t\t.s402 { fill: #eb6808 } \n\t\t.s403 { fill: #f18c04 } \n\t\t.s404 { fill: #f39800 } \n\t\t.s405 { fill: #e74e0e } \n\t\t.s406 { fill: #e9560c } \n\t\t.s407 { fill: #eb6308 } \n\t\t.s408 { fill: #ee7803 } \n\t\t.s409 { fill: #ec6f03 } \n\t\t.s410 { fill: #ee7504 } \n\t\t.s411 { fill: #e8540e } \n\t\t.s412 { fill: #f18e00 } \n\t\t.s413 { fill: #ec6a08 } \n\t\t.s414 { fill: #ef7e03 } \n\t\t.s415 { fill: #ea5e0c } \n\t\t.s416 { fill: #f08102 } \n\t\t.s417 { fill: #ea600b } \n\t\t.s418 { fill: #ef8002 } \n\t\t.s419 { fill: #f18a02 } \n\t\t.s420 { fill: #f08602 } \n\t\t.s421 { fill: #ef7e02 } \n\t\t.s422 { fill: #ee7501 } \n\t\t.s423 { fill: #f18804 } \n\t\t.s424 { fill: #ef7a03 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0 0h228v228h-228z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m-33.5 221.8v-1.5c1.8-2.5 4.9-3.4 6.7-5.8 1-0.9 1.5-2.1 1.8-3.3 1.2-2.4 3.5-1.6 5.4-2 0.4-1.3-1.1-2.4-0.1-3.7q0.4-0.4 0.9-0.7c2-0.4 4-0.1 6-0.2 2 0.2 3.8 0.8 5.5 1.6 1.2 0.1 2.3-0.5 3.5-0.5 1.7-0.1 2.8-1.6 4.4-2.1 1.9-0.5 3.7-1.1 5.1 0.8q0.2 0.5 0 1c-1 1.4-1 3.1 0.9 3.1 2.1 0 4.8 1 6.4-1.8 1.5-2.8 4.2-0.8 6.1-0.8 2 0 0.5 2.2 0.8 3.4 0.6 2.4-2.5 5.2 0.8 7.3-0.1-2.3 2.1-4 1.1-6.5-0.4-1.1 1-2.4 2.2-1.7 2.1 1 4.6 0.8 6.1 2.7 0 0 0.1 0.2 0.1 0.2 0 0 0.1-0.1 0.1-0.1 1-1.5 2.4-1.6 3.7-0.8 1.6 0.9 0.8 2.1 0.1 3.2-0.6 1 0.2 1.6 0.9 2.2 0.8 0.8 2 1.1 2.7 2 0.4 0.7 0.3 1.4 0.4 2.2 0.2 1.2-0.9 3.3 1.8 3 1.1-0.1 2.2 0.2 2.4 1.3 0.4 1.4-0.9 1.8-1.9 2.3-0.7 0.2-1.3 0.6-1.9 0.8-2.6 0.5-5.1 1-7.7 0.9q-0.2-0.1-0.2-0.1-0.2-0.1 0.2 0.1c1.1 0.1 2.7-0.5 2.6 1.3-0.2 2.5-2.5 2.1-4.2 2.6 1.8 0.4 4.4-2.5 5.1 1.7 2.1-2.1 2.4-5.5 5.3-6.8 0.9-0.4 1.8-0.3 2.7-0.3q0.6 0.1 1.1 0.3c0.8 0.6 1.8 1.1 2.6 1.8 0.9 1.5-0.8 2.7-0.5 4.1 0.1-0.1 0.1-0.1 0.1-0.2-0.1-1.7 1.3-3 1.5-4.6 0.1-1.3 0.9-2.5 2.5-2.3 1.6 0.3 2.6 1.4 2.8 3.1 0 1.2-0.4 2.2-0.7 3.3-2.6 4.9-4 5.6-9.3 4.9-3.8-0.5-7 1.7-9 3.9-1.7 2-3.4 2.6-5.4 3.3-0.9 0.4-1.8 0.4-2.7-0.1-2.7-2.5-5.8-2.8-9.1-1.2-0.9 0.3-1.9 0.8-2.5 0-2.5-3.9-6.3-1.7-9.4-2.4 0.4 0.2-0.4 0.4-0.3 0.4 4.7-0.2 4.9 1.4 1.9 4.4q-0.6 0.5-1.3 0.9-0.5 0.2-0.9 0.3c-1 0.4-1.9 0.7-2.9 0.7q-0.4 0-0.9 0-0.7 0.1-1.4 0.2c-1.2 0-2.3-0.4-3.3-1q-0.4-0.4-0.6-0.9c0-1-0.7-1.6-1.1-2.3-1.6-3.3-1.2-4.8 1.8-7 0.5-0.5 0.7-1 1.1-1.5 0.3-0.2 0.7-0.4 0.9-0.7 1.9-2.4 3.7 2.3 5.8 0 1.8-2 3.9-0.5 5.9 0.3 2 0.9 4.2 2.3 5.9-0.5 0.6-0.9 1.4-1.5 2.5-1.5 1.2 0.2 1.6-0.6 1.9-1.5q0.2-0.5 0.7-0.8c1.6-0.6 2.1-1.7 1.1-3.2-0.9-1.3-2.1-2.4-3.7-0.8-1.7 1.7-5.4 0.1-5.9 3.7-0.1 0.7-0.2 1.4-0.6 2-1.3 1.4-2.5 0.8-2.9-0.6-0.6-2.4-1.8-5-0.6-7.6-1.2-0.2-2.2 0.5-3.2 0.9-1.6 0.8-3.4 0.9-4.7-0.1-3.4-2.6-7.5-2.8-11.4-3.9-0.5-0.2-1-0.6-1.7-0.5q-1.5 0.7-2.9 1.5-0.3 0.1-0.3 0.1c-0.4 0.1-0.5 0.2-0.2 0.1 0.6 0 1.1-0.3 1.6-0.6 3.7-0.7 4.2 0.2 3.4 6 2.1 0.3 4.2 0.7 6.4 0.7 1.3 0 2.5 0.4 2.8 2 0.2 1.4-0.4 2.6-1.8 2.9-1 0.3-1.7 0.9-2.3 1.7-1.4 0.9-3.2 1.3-4 3-0.8 0.7-1.6 1.3-2.4 2-1.9 0.4-3.6 1.2-3.4 3.6-2.2 3-3.5 0.9-4.9-0.8-0.7-1.9-1-3.9-2.1-5.6-3.1 3.1-6.9 2.9-9.8-0.4v-5.3c2-3.1 0.1-6.2 0-9.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m-33.5 107.1v-13c1.3-1.4 2.5-1.9 4.1-0.1 1.7 1.9 3.7 2.5 5.6-0.1 0.6-0.9 1.4-1.4 2.5-1.4 2.2 0 1.2-1.4 1.1-2.4q0-0.6 0.2-1.2c2.2-3.1 3.5-3.1 6.3 0 0.3 0.7 0.1 1.5-0.2 2.2-0.2 1.4 0.3 1.8 1.6 1.5 0.9-0.2 1.7-0.4 2.5-0.2 0.9-0.5 0.3-1.8 1.3-2.2 1.1-0.8 2 0 3 0.5 1.7 1.1 3.2 2.3 1.6 4.5-1.9 0.8-2.3 2.1-1.3 3.9 0.5 1.5 0.9 3 2.5 0.7 0.6-0.9 1.4-1.6 2.6-1.5 0.4 0.1 0.9 0.1 1.4 0-0.4 0-0.8 0.1-1.2 0-1.1-0.1-1.5-0.9-1.6-1.8-0.3-3.1-2.3-4.8-4.7-6.2 0.4-3.6 4-5.8 7.4-4.5 0.7 1.2 1.4 3 2.8 0.6 0.9-1 0.4-2.3 1-3.3 0.7-1.1 1.7-1.5 2.8-1.8 2.2 0.3 3.2 2.2 4.7 3.5 1.6 1.2 2.7 3.1 5.4 2.4 0.8-0.3 2.2 0.2 3 1.2 1.6 3.2 1 4-2 5.3-3.7 1.6-7.7 0.6-11.4 1.5 4-1 8.1 0.9 12.1-0.5 0.8-0.3 1.8 0.2 2.2 1.2-0.2 0.5 0-0.2-0.2 0.3 0 0.3-0.2 0.7 0 1 0.1 0.2 0.2 0.1-0.1-0.2-0.1-0.2 0-0.4 0.1-0.6 0.5-0.8-0.1-1.5-0.2-2.2-0.1-2.1 1.7-3.6 2.9-2.2 2.7 2.9 6.8 1.9 9.7 4q0.3 0.5 0.3 1c-3 4.9-7.7 5.9-12.9 5.9-0.7-0.8-1.7-0.8-2.7-0.8-2.8 0.4-5.4 1.3-7.2-2.2-0.9-1.7-2.9-1.2-4.3-0.1-1.8 1.4-4 2.2-4.9 4.7 1-2.4 3.1-3.4 4.9-4.7 1.4-1.1 3.2-1.5 4.3 0.2 1.1 1.6-0.1 2.2-1.7 2.9-1.7 0.6-0.1 3.2-1.9 4.1-0.7 0.8-0.9 1.8-1.8 2.4 1.2-0.3 1-1.6 1.7-2.3 0.8-0.8 1.3-1.6 1.2-2.7-0.2-2 1.6-1.8 2.6-2 1.3-0.4 1.7 1 1.6 2-0.2 2.3 1.2 1.8 2.6 1.9 4.8 0.5 6.3 2.9 4.2 6.6-1.4 0.9-2.7 0.2-3.7-0.3 0.9 1.1 2.7 0.3 3.9 1.2-0.3 4.7-1.6 5.6-6 4.2-1.9-0.6-4-0.6-5.7-1.7-0.2-0.1-0.3-0.4-0.4-0.6 0 0.9 1 1.1 1 1.9-0.3 2-2.1 2.5-3.4 2.1-4.5-1.1-7.1 0.8-8.7 4.8-0.7 0.8-1.7 1.4-2.7 1.9-0.6 0.2-1.1 0.5-1.7 0.8-1.7 1.2-3.6 1.4-5-0.3-1.6-1.9-0.1-3.3 1.2-4.6-2-1.3-4.2 1.3-6.1-0.5-1.7-2.4-1.1-4.1 1.4-5.3 0.9-0.3 1.8 0.1 2.7 0.1 0.4 0 0.9 0 1.4-0.2 1.1-1.1 2.6-1.5 3.9-2.3 0.8 0 1.5 0 0.6-1.1q0-0.5 0.2-1c0.4-0.6 1.1-0.9 1.4-1.6 0.3-0.5 0.9-0.7 0.8-1.4-0.6 0.2-1.1 0.6-1.7 0.7-1.2 0.2-3-1.2-3.1 1.9-0.1 2.1-3.2 1.6-5.5-1.1 0.1-1.4-0.4-2.9 0.7-4.1 2.5-1.9-0.2-3-0.8-5-0.4 2.2 3.7 2.8 1 4.8-1.5 1.1-0.9 3.5-2.7 4.3-0.4 0.4-0.8 0.7-1.2 0.9-1.2 0.8-2.1 2.6-3.9 1.8-1.8-0.7-1.3-2.5-1.4-3.9-0.2-3-0.7-3.2-4.4-1.9-1.9 0.9-3.8 1.1-5.6-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m237.5 139.2v4.6c-0.6 0.6-1.1 1.3-2.1 1.3q-0.5 0-0.9-0.3c-1.3-0.4-1.7-2.2-3.3-1.8-1 0.8-1 2.6-2.7 2.8-0.7 0.1-1.4-0.2-2.1-0.6q-0.4-0.3-0.6-0.8c-0.4-0.6-0.9-1.3-1.7-1.1-1.1 0.3-1 1.2-1 2.1 0 0.7-0.3 1.3-0.6 1.9-0.6 1.3-1.9 2.2-2 3.8-0.4 1-1.2 1.5-2.1 1.8 0.5 0.1 0.9-0.1 1.3 0.1q0.6 0.2 1 0.6c1.7 2.9-0.7 3.3-2.6 4q-0.5 0.2-1.1 0.2c-3.4-0.4-6.4-2.5-10.1-2-1.5 0.2-3.2-0.9-4.2-2.3q-0.4-0.4-0.5-0.9c-0.2-0.9-0.5-1.8-1.5-2.1-0.1 0-0.7-0.4-0.6 0.3 0.1 0.2 0.4 0.3 0.6 0.5q0.4 0.4 0.6 0.8c0.2 1.2 0.4 2.4 0.8 3.6q0.2 1.6-1 2.6c-1.8 1-3 0-4.2-1.2-2.5-6.2-6.3-11.6-10.3-17-1.8-2.3-3.5-5-2.8-8.3 0.7-2.4 2.1-4.1 4.9-4 1.1-0.6 2.2-1.1 3.5-0.6 1.3 0.2 2.4 0.7 3.1 1.8 0.7 0.8 1.5 1.3 2.6 1.4 1.7 0.1 3.4 0.2 4.3-1.7 0.5-1 2-1 2.2-2.2-0.7-5.3 3.8-5.1 7-6.5-0.9-1.4-1.8-2.8-1.7-4.5 0.5-1.4 1.4-2.4 2.9-2.5 4-0.2 7.5-2 11.3-2.9 1.8 0.3 3.6 0.6 5.5-0.1 1.8-0.6 3.9-0.7 5.5 0.9 0.7 1.9-0.2 2.8-2 2.9-0.9 0.2-1.6 0.4-1.7 1.6-0.2 1.8-1.1 3.2-2.8 4.1-4.5-0.6-7.2 2.9-10.4 5.1-0.9 0.6-1.6 1.6-2.9 1.6 2.2 0 3.2 1.3 4 3 0.9 0.8 0.6 1.7 0.1 2.8 1.4-1.3 0.4-2.1-0.2-3-0.7-3 0.3-4.9 2.8-5.5 1.8-0.5 3.6 0.2 3.4 1.9-0.3 2.8 0.8 5.7-0.1 8.5-0.3 0.9-0.6 1.7-1.6 2-0.7 0.3-1.3 0-2-0.2q0.4 0.2 0.6 0.4c1.1 1.2 1.9 0.9 2.3-0.4 0.6-1.8 2.4-2.4 3.4-3.5 2.8-3.2 6.5-2.2 9.7-3v6.2c-0.9 1.2-1.5 2.5 0 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m-9 121.6c-0.2 0.3-0.4 0.6-0.5 1-0.5 1.4-3.7 1.7-2 3.7 1.2 1.3 3 0.1 4.5-0.6 0.3-0.1 0.7-0.2 1-0.3 0.8-0.6 1.4-0.3 1.9 0.4-0.7 2.7-1.4 5.4 1.4 7.4 0.6 1.9 1.8 0.6 2.7 0.6q0.6-0.1 1.1 0.1c0.9 0.4 1.5 1.1 2 1.9 0.5 1.3 0.5 2.6-0.4 3.8-1.5 1.2-4.6-0.1-4.9 3-0.4 0.6-1 1-1.8 0.9-0.8 0.1-1.6 0-2.5-0.1-1 0.2-1.9 0.5-2.9 0.1 1 0.4 2 0 3-0.1 0.9 0.1 1.7 0.1 2.6 0.2 0.4 0.5 1 0.7 1.7 0.9 1.5 0.5 2.5 1.8 1.2 3.5-0.1 0.1-0.4 0-0.3 0.3 1.6-0.1 1.3-2.2 2.8-2.4 1.3-0.4 2.5 0 3.8 0.2 1.4 0 2.6 0.3 2.7 2-0.6 2.3-2.7 2.5-4.4 3.2-0.5 0.2-1 0.2-1.4 0.3q-0.5 0.2-1 0.3c-2.2 1.8-5.2 3-3.9 6.8 0.3 0.7 0.6 1.3 0.4 2.1-0.9 2.1-1 4.4-2.1 6.4-0.7 1.3-1.3 2.5-3 2.4-2.1-0.6-3.1-3.1-5.4-3.4-0.7-0.3-1.3-0.8-1.4-1.6-0.1-1.6 1-2.4 2.1-3.2 1.3-0.8 4.2 0 3.4-3.1-0.8-1.9-2.3-3.3-4-4.3-1-0.1-1.3-1.1-2.1-1.3 1.9 1.4 0.4 2.6-0.4 3.8-0.8 0.7-1.8 1.1-2.8 1.6-1.3 0.2-1.3 1.5-1.7 2.4-2.2 2.7 0.8 2.2 1.8 2.9 0.5 0.3 0.9 0.7 1.2 1.2 0.7 0.9 1.5 1.8 0.9 3-0.7 1.1-2.1 1.2-3 2.5-1.9 2.8-3.8 0.4-5.6-1-0.5-0.3-0.9-0.8-1.4-1.1-0.8-0.5-1.7-0.3-2.4-0.6-0.7-0.3-1.2-0.8-1.4-1.5-0.2-1.3 0.2-2.1 1.5-2.4q0.3 0 0.6 0.2 0-0.1-0.1-0.1c-0.6-0.5-0.7-1-0.7-1.7q0-0.4 0.2-0.9c0.1-0.4 0.2-0.8 0.3-1.3q0-0.4 0.1-0.9c0.1-0.4 0.3-0.7 0.5-1 0.2-0.3 0.6-0.4 1-0.6-0.5 0-0.9 0.2-1.4 0.2q-0.6-0.1-1-0.4-0.4-0.4-0.6-0.9c-0.4-1-0.7-2.1-0.7-3.2q0.1-0.5 0.3-1c0.4-0.5 0.8-0.8 1.4-0.8 0.3-0.1 0.7 0 1 0-0.4-0.1-0.8 0-1.2-0.3-1-2.8 1.3-2.2 2.4-2.5-2.8 0.3-3.8-1.2-3.6-3.9-0.1 0.2-0.1 0.6-0.1 1 0.1 0.9 0.8 2.2-0.6 2.6-1.4 0.3-2.2-0.5-2.4-1.8-0.1-0.7-0.4-1.2-0.9-1.7v-6.8q1.3-1.6 0-3.1v-0.8c1.6-0.9 1.6-1 0-2.3v-1.5c0.6-1.3 2.2-0.7 3-1.6 1.3-0.4 2.6-0.4 3.5-2.1 1.3-2.4 3.1-1.1 4.7 0.1q0.4 0.2 0.9 0.3 0.4 0.1 0.9 0.3c0.7 0.4 1.5 0.3 2.3 0.6 1.5 0.8 2.8 1.9 4.5 2.4-0.1 0-0.3-0.1-0.3-0.1-2.2-0.9-4-2.1-4.8-4.5-0.5-1.4-0.5-2.4 1-3.1 3 0.4 5.7-2.2 8.8-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m237.5 180.5v16.8c-1.4 1.5-2.8 2.9-5.1 1.7-0.3-0.4-0.8-1-1.2-0.8-0.3 0.2 0-0.3 0.3 0.1 0.2 0.1 0.4 0.2 0.6 0.3 2 1 3.4 2.6 4.3 4.7 0.2 2-1.2 3-2.6 3.9-1 0.6-1.9 1.1-2.5 2.1q-0.5 0.4-1 0.5c-1.9 0.8-3.7 0.3-5.4-0.3-1.6-2.4-5-3.7-4-7.7 0.3-1.3-1.8-2.2-2.3-3.6-1.2 2-4.3-2.6-5.1 1.4-0.2 0.8-1.3 1.4-2.2 1.1-1.6-0.6-1-2.1-1.2-3.3-1.8 1.1-3.4 1.2-4.9-0.3-0.5-0.7-1.3-1-2-1.5q-0.3-0.4-0.4-0.9c0.2-1 1-1.4 1.9-2.2-2 1.6-4.1 2.4-6.1 3.3q-0.9 0.2-1.7-0.2c-1.6-1-2.3-2.4-1.5-4.3 1.9-2.6 4.5-4.8 6.2-7.6 2.1-1.1 0.7-3.6 2-5 1.5-1.3 3.6-0.4 4.9-0.2 4.2 0.7 8.5-0.4 12.6 0.8 0.4 0.1 0.7 0.4 1 0.5 4.8 2.7 5.8 2.3 6.8-2.6 2.4-1.3 4.6-2 5.3 1.7 0.1 0.3 0.1 0.5 0.9 0.3 1.2-0.2 1.9 0.3 2.4 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m-33.5 78.8v-3.1c1.3-1 0.7-2 0-3v-11.5c3.3-1.6 4.6 1 5.9 3 1 1.4 0.9 3.1 1.2 4.7 0.1-0.1 0-0.1 0-0.1 0.6-3.3 4.1-4.4 5.8-4.3 2.8 0.3 5.5-0.5 8.2-0.3q0.5 0.3 0.8 0.8c0.4 1.2 0.1 2.4 0 3.7 2.8-2.4 5.7-1.2 8.6-0.5 0.5 0.3 1 0.6 1.6 0.3 1.7-0.8 3.5-0.9 5.2-1.2 1.8-0.4 3.1 0.6 3.8 2.3 5.4-5.4 7.3-5.6 12-0.9 0.5 1.4 2.2 1.1 3.1 1.9q0.4 0.4 0.6 0.8c1.4 2.5 4.4 4.4 2.8 7.9-2.7 3-9 4-13.1 2.1-1.8-0.8-3.7-0.9-5.3-2.1-0.8-0.6-1.4-0.3-1.8 0.5-0.5 1.1-1.3 2-2.3 2.8-0.7 0.3-1.3 0.6-2.1 0.6q-0.6-0.1-1-0.4c-0.5-0.6-0.9-1.2-1.3-2 0.3 1.5 1.7 3-0.4 4.2-1.7 1-3.3 1.8-5-0.1-0.7-0.7-1.8-0.9-2.8-1.2-3.1-0.9-3.4-1.7-1.4-4.3 0.3-0.4 0.6-0.3 0-0.7-1.7-1.3-1.2-3-0.9-4.3 0.4 3-2.5 1.9-4.3 2.5 0.7-0.1 0 0 0.1-0.1 4.4-0.6 5.3 1 2.3 4.1-1.3 1.3-2 2-1.3 3.9 0.5 1.4-0.5 2.3-2.2 2.1-3.5-0.6-6.5-2.8-10-3.4-1.2-0.1-1.7-1.8-1.5-2.8 0.4-3.1-1.2 0.6-1.3-0.4q-0.5 0.2-1.1 0.1c-1.1-0.3-2.1-0.8-2.9-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m223.8 110.9c-3.7 4.3-9.5 2.2-13.8 4.6q-0.3 0-0.6 0c-2-0.3-2.9-1.7-2.1-3.4 0.9-2.2 3-2.3 5-1.9-0.1 0 0 0-0.1 0-2.6-0.9-2.8-2.9-2.5-5.1 0.3-0.9 0.3-1.9 0.4-2.9q0.2-1 0.9-1.6c0-1.1-1.2-0.6-1.6-1.1q-0.5-0.2-0.8-0.6c-1-3.8-0.9-4 2.5-3.7 0.5 0-0.2 0.3 0.3 0.2 0 0-0.1-0.1-0.2-0.2-1.2-1.6-2.4-0.1-3.7 0.1-1.5 0.1-2.8-0.6-3.2-2.1-0.5-1.7 0.8-2.1 2.1-2.5 0.9-0.2 1.7-0.6 3.2-0.2-1.7-1.5-1.9-2.8-0.5-3.9 2.3-1.7 4.8-1.4 7.2-0.3 2.4 1.1 1.7 3.1 1 4.9-0.2 0.4-0.4 0.7-0.3 1.1 0.2 0.1 0 0 0.1 0 0.8-1.9 0.4-4.7 3.6-4.9 2.1 1.4 5.7 1 6.3 4.7 0.7 1.2 1.8 0.9 2.8 0.6 4.5-2.8 5.3-2.7 7.7 0.6v3.8q-0.8 0.8 0 1.6v5.3q-0.7 0.4 0 0.8v22.2c-3.1 1.8-6.8-0.3-9.6 1.5 2.5-0.1 5.3-0.7 8.1-0.9 0.8 0 1.2 0.4 1.5 0.9v0.8c-1.3 1.5-2.7 2.8-5.1 1.9-1.3-0.4-6.6 3.5-6.6 5 0 2.6-2.8 2.1-3.7 4.2-1-4.1-1-4.1-3.8-5.1 0.4-1.3 1.4-0.8 2.2-0.7 3.5 0.4 4.6-1 3.5-4.4-0.3-0.8-1.5-1.2-0.8-2.3 0.9-1.1 2.1-2.6 0.2-3.3-0.8-0.4-2.8 0.7-3.6 2.1-0.4 0.7-0.4 1.7-0.6 2.6-0.9-0.5-1.8-1.2-2.8-1.3-3.4-0.5-3.2-2.7-3-5.2 2.3-0.4 0.6 2.6 2.6 2.2 1.2-0.7-0.5-3.6 1.5-3.5 4 0.1 6.3-5.5 10.9-3q0.4 0.4 0.3 0.9c-0.1 0.5-0.3 0.9-1 1.3 0.9-0.4 1-1.1 1.4-1.6 2.4-1.5 1.4-4.7 3.1-6.7 1.3 0.3 2.4 0.4 2.3-1.5-0.3-0.8-1.2-1.1-1.7-1.8-0.6-1.1-1.9-1.9-1.7-3.4 0-0.5 0.1-1 0.4-1.4 0.9-0.6 0.7-1.5 0.3-2.4-1.1-2.7-2-0.5-3.1 0.1-0.8 0.5-1.7 0.6-2.5 0.1-0.7-3.2-0.7-3.2-3.5-3.7-0.3-1-1.1-0.9-1.8-0.8 0.1 0 0.1 0.1 0.1 0 0.5-0.1 0.9 0 1.4 0.2 1.5 1.2 4 1.5 3.6 4.3 1.2 1.2 3.3 0.4 4.3 1.9q0.6 0.6 0.7 1.5c0 0.8-0.2 1.5-0.9 2q-0.5 0.3-1 0.4c-3.3-1-6.5-1.7-9.7-2.7 0 0 0 0.2 0 0.2 0 0 0.2-0.2 0.2-0.2 0.8 0.3 1.4 0.9 2.3 1.1q0.6 0.3 1 1c0.4 0.7 0.5 1.5 0.8 2.2 0.2 0.5 0.2 0.9 0.1 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m-2.9 68.8c-1.2 0.2-2.4 1-3.6 0.4-3.1-1.4-5-0.1-6.3 2.8-0.3-2.5-0.1-4.8 0.7-7 0.5-0.2-0.2-0.1 0.3-0.2q-0.1 0.1-0.3 0.2c-1.3 0.1-3.4-0.6-1.4 2.8-2.2-1.5-4.4-0.3-5.9-2.2-0.1-0.2-0.6-0.3-0.6-0.3-1.3 2.4-4.4 2.2-5.9 4.3q-0.3 0.6-0.7 0c-2-2-1.9-5.3-4.3-7.1-0.8-0.7-1.6-1.1-2.6-1.3v-6.9c0.6-0.8 0.4-2.4 2.1-2.1 1.6 0.2 1.9 1.4 1.8 2.8 0 0.6 0 1.2 0.2 1.8 0.3 1 1 1.6 1.9 2.1 1.2 0.1 2.4 1.4 3.4-0.3 0.4-2.7 2.3-2.5 3.8-1.4 1.4 0.9 2.9 1.3 4.5 1.6 3.6 1.2 7.2 2.8 10.6-0.6 0.6-0.7 1.7-1 2.5-0.5 2.4 1.6 4.3 0.5 6.6-0.6 2.8-1.5 5.7-0.7 8.3 0.9 1.3 1.4 2.6 2.8 4.4 3.5 2.4 1 3.9 2.7 4.6 5.1q0.3 0.9-0.1 1.8c-0.3 0.8-0.7 1.5-1.8 1.2-0.8-0.4-1.6-0.7-2.4-1.1-4.4-2.6-6.4-1.8-7.9 3.2-0.3 0.9-0.3 0.9-1 0.6-1-0.6-1.1-1.6-1.5-2.5-0.9-1.8-1.7-1.7-3 0.1-0.7 1-1 0.3-1.4-0.1-1.1-1.2-2.3-0.8-3.5-0.2-0.8 0.4-1.2-0.1-1.5-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m237.5 72.7v4.5c-1.1 1.2-1.7 3-3.5 3.4-1.3 0.1-2.6 0-3.8 1-1.4 1.3-2.7 0.8-3.3-1.1q0 0 0 0c0.4 0.4-0.1-0.1 0.2 0.3-0.2 3-2.8 3.1-4.7 4.1q-1.3 0.1-2.1-0.8c-1.3-2-2.7-2.1-4.8-0.9-2.5 1.6-5.2 2.2-7.2-1-2.8-1.4-4.3-3.4-3.4-6.7 2.5-2.4 3.1 1.4 4.8 1.5 0.3 0.3 0.6 0.5 1 0.6q-0.4-0.1-0.7-0.4c-2.2-1.1-2.4-2.4-0.2-3.7 0.9-0.5 1.5-1.2 2.1-2 1.5-1.8 3-2.1 4.7-0.4 0.2-0.1 0.4-0.2 0.5-0.5 1.1-1.7 2.6-2.8 4.5-2.5-0.5 0-1.2-0.1-2 0.1-1.5 0.3-2.1-0.6-2.2-1.8-0.1-1.3 0.3-2.5 1.7-2.6 1.3-0.1 2.5-0.2 3.5-1.1 1.3-0.4 2.7-0.6 3.7-1.8 2.2-1.1 4-0.4 5.5 1.4-0.5 2.8 2.2 4.7 1.8 7.5q-0.2 0.3-0.5 0.4-0.2 0.1 0.3 0.1c0.7 0.1 1.2 0.3 1.8 0.6 0.8 0.6 1.7 1 2.3 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m231.4 62.7c-1.6 0.4-2.8-2-4.6-0.7-0.4 0.4-0.9 0.4-1.5 0.2-0.6-0.6-0.5-1.3-0.2-2q0.1-0.2 0.3-0.5-0.3 0.1-0.7 0.1-0.5 0-0.9-0.2c-3.4-1.6-3.5-2.2-0.8-4.8 0.4-0.5 0.4-1.1 0.9-1.5-0.1 0 0-0.1 0-0.1 0 0-0.2 0-0.2 0-0.9-0.1-1.2-0.7-1.3-1.5q0-0.5 0.1-1c2.1-2.2 4.7-3.6 7.6-4.4q0.7-0.4 1.5-0.6c1.6 0.2 3-0.8 4.6-0.7 0.6 0.1 1 0.5 1.3 0.9v13c-0.6 0.9-1 2-1.2 3.1-0.1 1.4-0.8 2.5-2.2 2.8-1.6 0.3-2.1-0.9-2.7-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m237.5 209.5v6.2c-1.5 1.6-0.3 5.6-4.2 5.2-0.8 0.8 0.3 1.6-0.1 2.3-0.2 1-0.7 2-0.8 3.1-0.9 1.5-0.3 4.2-3.3 4.2-1.1-0.6-2.1-0.5-2.7 0.9-0.4 1-0.8 1.8 0.7 2.2 1 0.4 1.7 1 1.6 2.2-1.6 3.5-4.3 2.6-7 1.7-1.6-1.6-3.6-1.7-5.6-1.6-1.4-0.3-2.7-1.2-4.3 0-1.3 1-2.9 0.6-4-0.8q-0.3-0.4-0.4-1c0-3 2.2-4 4.6-4.6 1.5-0.5 3.2-0.6 4.8-0.9 3.6 0.6 8.2-2.5 9-6.1 1.5-5.3 4.3-9.8 9-12.9 0.9-0.6 1.8-1 2.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m222.2 84.1c0.4-2.7 3.9-1.5 4.6-3.8 1 0.9 2 1.4 2.9 0.1 1.1-1.7 2.5-1.2 4-0.9 1 0.9 0.7 1.9 0.5 2.9-0.2 0.6 0.1 1 0.6 1.3 1.3 0.6 1.5 2.2 2.7 2.7v2.3q-0.2 0.4-0.6 0.4c-0.9 0.1-1.8 0-2.7 0 0.1 0 0.3 0 0.6 0 1 0.1 2.3-0.4 2.1 1.3 0 0.6 0.3 1 0.6 1.4v1.5c-2.4-1.3-4.8-2.6-6.2 1.2-0.1 0.3-0.9 0.2-1.4 0.3-0.6-1.1-1.4-1.6-2.7-1.2-0.9 0.4-1.6-0.1-1.9-1-0.9-0.6 0.6-3.1-1.8-2.2-2.5 0.9-2.5-0.9-2.8-2.4-0.2-0.7-0.7-1.2-0.7-2 0-1.5 1.5-1.2 2.2-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m228.4 145.3c0.9-1.1 1.2-2.5 1.5-3.8 3-1 2.5 1.6 2.5 2.8 0 2.1 0.1 3.4 2.5 4 1.9 0.4 1.4 2.8 2.6 3.9v6.1c-1.4 1.6-3 1.1-4.6 0.5-1.1-0.7-1.2-2.1-2.3-2.8q-0.4-0.3-0.8-0.3 0.5 0 0.9 0.4c0.5 0.7 0.2 1.4-0.2 2-2.3 2.2-4.8 4.1-8.3 3.4-0.7-0.4-1.4-1.1-1-1.8 1.3-2.8 0.4-5.7 0.9-8.5 1.1-1.3 1.4-3 2.4-4.4 0.9-1.5 2.1-2.3 3.9-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m233 158.3c1.5-0.6 3 0.2 4.5 0v1.5c-1 1.1-0.9 2.1 0 3.1v0.8c-1.5 3.7-5.1 2.1-7.7 2.9q-0.5 0.2-1.1 0.3c-0.7 0-1.5-0.3-2.1 0.4-1.9 2.7-4 2-6.2 0.6q-1.4-0.8-2.6-1.7c-1.3-0.7-2.8-1.1-2.9-2.9q0.1-0.6 0.5-1c2.3-1.9 3.9 0.3 5.7 1 0.7 0.3 1.4 0.3 2-0.3-0.5-0.4-1-0.8-1.2-1.4q-0.1-0.6 0.3-1c2.9-0.4 5.1-2.1 7.7-3.1q0.2 0.2 0.4 0.3c0.6 0.7 0.9 2.4 2.2 0.7q0.2-0.1 0.5-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m237.5 180.5c-1 0.1-3.6-1.9-2 1.6 0.3 0.6 0.3 1.3-0.5 1.5-0.6 0.2-0.9-0.3-1.1-0.8-0.7-1.5-2.9-2.8 0-4.8-2.1-0.3-3.4-0.4-4.8-0.6-1 0.9-1.3 3-3.3 2.4-1.6-0.4-2.3-1.8-2-3.5q0.2-0.5 0.5-0.9c1.1-0.8 2.8-0.6 3.4-2.1 0.8-0.8 2.2-0.9 2.6-2.1 2.2-3 4.9-0.1 7.2-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m237.5 24.5v4.6c-0.1 2.2-2.7 2.5-3.4 4.3-0.4 1.2-1.1 2.2-2.4 2.7-3.2 0.8-5.1-1.8-7.5-3-0.6-1.2-0.3-2.6 0.8-2.9 2.7-0.7 0.9-2.2 0.8-3.3q0-0.9 0.4-1.6c1-1.1 2.2-1.3 3.5-1.3q0.8 0.2 1.2 1c0.1 0.5 0.1 0.9-0.6 1 0.4 0 0.7-0.1 1-0.4 0.4-0.5 1-0.7 1.5-0.9 1.6-0.4 3.1-1.7 4.7-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m237.5 209.5c-1.9 1.6-5.7 1.6-4.8 5.6-3.1 0.6-3.3 3.6-4.8 5.5-0.5 0.6-0.7 1.3-1.1 1.9-0.8 0.8-1.7 0.7-2.6 0.1-1-0.8 0.3-2.4-1-3.1 1-4.4 3.8-7.6 6.7-10.7q0.4 0 0.8 0c2.1-1.1 4.1-3.2 6.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m232.2 32.9c0.7-2.8 4.1-1.8 5.3-3.8v16.8h-1.5c-1.6-0.1-3.2-0.3-4.6 0.8q-0.4 0.3-0.7 0.7c-1.6-0.4-3-1-2.9-2.9 0.1-1.5 0.9-2.3 2.4-2.6 0.3 0 1 0.2 0.8-0.1-1.4-2.8 1.2-4.2 2.3-5.8 1.7-2.2 0.3-2.4-1.1-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m229.1 166c0.3-1.3 1.1-1.4 2.3-1.4 2.1 0.2 4.2-0.1 6.1-0.9v6.1c-0.6 0.6-1.4 0.6-2 0-1.6-1.5-3.1-0.8-4.3 0.3-1.7 1.5-3.6 1.7-5.6 1.5-1.9-0.3-3.3 1.7-5.3 1.2-3-2.5-2.8-4.2 0.4-6.1 1.9 0.7 3.8 2.2 5.3-0.9 0.4-1 2.1-0.4 3.1 0.2 0.2 0.4 0.1-0.3 0.2 0.2q-0.1-0.1-0.2-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m228.4 235.6c-0.7-0.7-1.5-0.8-2.3-0.8-0.9-0.1-2.3-0.7-1.6-1.4 1.2-1.4 2.1-3.6 4.6-3.2 2-0.9 0.8-3.4 2.3-4.6 1.9-1.5 3.8-3 6.1-0.8v2.3c-1 1.6-0.6 3.6-1.5 5.3-0.5 0.8-1.3 1.1-2.1 1.3-0.5 0.3-1.1 0.4-0.9 1.2 0.9 1.1 1.6 2.2 0.4 3.5-3.6 1.4-4.7 0.8-5-2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m237.5 2.3v10.7c-2 0.9-4.4 0.9-6.2 2.3q-0.5 0.3-1 0.3c-1.8-0.1-3.9 2.1-5.2-0.3-1.1-2.2 0.5-4.1 1.6-5.9 0.5-0.7 1.4-1.1 2-1.8 0.7-0.6 1.6-0.9 2.5-0.4 0.6 0.7 1.1 1.8 2 0.4 2.3-0.8 0.7-2.9 1.4-4.1 0.3-1.2-0.4-2.7 1.4-3.1 1.3 0 1 1.3 1.5 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m237.5 24.5c-1.7-0.2-2.7 2.1-4.6 1.5-0.6-0.6-1.4-0.6-2.3-0.7q-0.3-0.4-0.7-0.8-0.4-0.4-0.6-0.9c-0.1-0.7 0.2-1.4 0.7-1.9 0.4-0.5 1-0.8 1.5-1.1 0.3-0.2 0.7-0.3 1.1-0.6q0.2-0.2 0.4-0.5c0.1-0.4 0-0.8-0.2-1.1-0.8-0.9-1.7-0.6-2.7-0.4q-0.9 0-1.4-0.7c-0.8-2 0.8-2.2 2-2.8 2.3-1 4.5-1.7 6.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m106.6-12.2h4.6c2.3 1.1 3.7 2.8 3.3 5.5q-0.3 0.4-0.8 0.6c-0.5 0.4-1.4-0.2-1.5 0.3 0 0.5 0.8 0.9 1.2 1.3 0.7 0.8 0.8 1.7 0.4 2.7q-0.5 3.2-3.7 2.9c-1.1 0-2.3 0.1-2.9-1.2-0.4-0.8 1.1-1.1 0.4-2q-0.1-0.4-0.1-0.9c0.4-2.3-2.2-1.9-3-3.1-0.7-0.5-1.4-1.1-1.4-2.1 0.1-1.2 0.8-1.9 1.7-2.5 0.7-0.4 1.4-0.8 1.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m237.5 128.5c-3.5 1.7-8.1-0.3-11.4 3.4-0.3-1.4-0.8-2.8-0.7-4 0.2-1.1 0.1-4.5 2.5-1.1 0.5 0.7 1.6 0.6 2.2 0.2 1.2-0.8-1-1.7 0-2.9 2.2 1.5 4.3 3.8 7.4 2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m225.3 170.5c2.2 0.2 4.3-0.1 6-1.8 2.1-2.1 3.9-3 5.2 0.8 0.1 0.2 0.7 0.2 1 0.3v0.7c-1.3 1-2.1 4.5-4.3 0.6-0.8-1.3-1.2 0.5-1.8 1-2.2 1.1-4.5 0.7-6.8 0.3-0.7-0.9 0-1.4 0.7-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m-16.7 221c-0.2-2.5 1.9-1.7 3.1-2.3 0.7-0.1 1.1 0.4 1.5 0.8 2.7 0.1 6.2-2.4 7.4 2.3 0.9-0.1 1.2-0.7 1.5-1.2 0.5-0.9 0.2-2.8 1.9-2.2 1.6 0.6 0.7 1.8 0.1 2.8-0.6 1 0.1 1.8 1.1 2 1.4 0.2 2.9 1.5 4.1-0.2 1.6-2.3 4-0.6 5.8-1.3 0.5-0.2 1.4 0.2 1.4 1-0.1 1.1-0.7 2.1-1.8 2.2-2.1 0.2-2.2 0.5-0.4 1.6 1.1 0.7-0.2 1.7 0.1 2.4 0.4 0.9-1.2 2.6 1 2.8 3.2-1.5 4 1.3 5.4 3.1-0.7 2.7-4.6 3.9-6.8 2-2.1-1.7-2.1-1.7-4.6-2.1-0.7 1.2 3 1.2 0.8 2.5-1.8 1.1-4.1 0.2-4.9-1.2-1.1-1.9-1.8-1.1-2.9-0.5-1.9 0.6-3.6 0.6-4.6-1.5-0.2-2.6 4.8-2.6 3.4-3.9-1.8-1.5-5.3-0.9-8.1-1.2-1-0.1-2.1 1.5-3-0.1-1-1.9 0.9-1.6 1.5-2.3 0.7-1.1 0.7-2.9 0.5-4.4-0.1-0.6-1.2 0.6-2 0.4-0.4-0.5-1.4-0.5-1.5-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m5.5 205c-2.8-0.4-5.6-1-7.3 2.3-0.4 0.8-1.2 0.4-1.9 0-0.4-1.4 0.8-2.2 1-3.3 0.1-1.8-0.2-3.6 1.9-4.5 2.5 0.1 4.7-1.4 7.2-0.9 0.8 0.8 1.6 0.8 2.7 0.4 1.8-0.6 3.4-0.2 4.5 1.5 0.8 0.4 0.6-0.4 0.8-0.7 0.8-1.5 2.4-1.9 3.8-2.2 1.7-0.4 3.6-0.2 4.4 1.5 0.9 2-1.5 2.2-2.5 3.1q-0.3 0.4-0.7 0.8c0 0.3-0.9 0.7-0.3 0.9 1.2 0.3 2.4 0.7 3.7 0.7q0.5 0.1 0.9 0.3c1.9 0.7 2.8-0.9 4.1-1.6 0.9-0.5 1.3-1.7 2.5-1.9q0.5-0.1 1.1 0c2.8 0.8 1.5 4.6 3.1 5.2 2.2 0.7 3.9 1.7 5.1 3.5 1.4 2 0.5 4.2-2 4.7-1.7 0.4-2.3 1.9-3.7 2.4-1.9-1.8-1.9-3.6 0-5.5-1.4-1.2-2.6-0.3-3.9 0.1-2.4-0.3-5-0.2-6.7-2.7 0.6 1.1-1.6 2.8 1 3.5 0.9 0.3 1.5 1.7 0.5 2.5-1.4 1.2-1-1.4-2.1-1.3-0.5 2.3-0.5 2.3 1.2 3.6-4.3 3.6-5.3-2.1-7.9-2.9 2-1 1.8-1 1.1-3.2-0.4-1.6 0.8-3.1 2.5-4.2-1.5-0.9-2.9 0.5-4.2-0.4-0.5-0.4-1.4-0.3-1.2 0.6 0.4 1.8-0.6 2.8-1.9 2.5-2.6-0.5-5.7 1.8-7.7-0.3-1.1-1.3-2.5-1.8-4-2.9 1.5-1.4 3.6-0.6 4.9-1.6 1.1 1.1 2.8 1.1 4.1 2-1.3-0.9-3-0.9-4.1-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m33.9 217.2c1.6-0.9-0.4-6 4.2-3.4 0.6 0.4 0.8-0.7 0.7-1.3-0.2-2.3-1.3-3.8-3.6-4.2-1.7-0.2-3.5-0.5-6.2-0.9 4.7-1.4 4.1-3.3 1.8-5.5 0.4-1 1.8-0.3 2.3-1.3-1.4-0.4-1.8 0.6-2.3 1.3q-1.2 1.1-2.3 2.3c-1.8 0.3-3.1 2.8-5.4 1.5-0.8-0.8-1.8-1.5-1.5-2.9 0.2-0.8 0.6-1.4 1.1-1.9 0.8-0.5 1.6-0.3 2.5-0.3 1.1-0.1-0.1-0.5 0-0.8q-0.3-0.4-0.3-0.9c0.3-1.7 0.6-3.5 2.7-3.8 0 0 0.1-0.2 0-0.2-0.7-0.4-1-0.9-0.7-1.6 0.9-1.2 2.6-1.1 3.3-2.3 0.4-0.6 2.8-0.3 0.7-2-1.1-0.8 0.4-2 1.3-2.5 1.4-0.8 2.8-1.1 4.3-0.2 2.2 1.1 3.5 3.3 5.3 4.9 1.3 1.3 2.2 3.3-1.1 3.3-2.1 0.1-1 1.6-1.4 2.5 1.8 2.8-1.5 4.7-1.4 7.2q0 0.4-0.1 0.8c0 1.2 1 0.4 1.5 0.8 0.9 0.3 1.4 1 1.7 1.8 0.5 1.3 0.8 2.5 2.1 3.3q0.4 0.2 0.7 0.6 0.5 0.6 1 1.2 0.3 0.4 0.4 1 0.1 0.8-0.2 1.5c-0.5 0.6-0.9 1.2-1.2 2-0.7 2.1-2.1 2.9-4 1.3-1-0.8-2-0.1-2.9-0.5q-1.5-0.4-3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m56.1 231.7c-1.8-0.7-3.6 1.9-5.4 0-0.9-1.4 2.2-4-1.6-4.6-0.9 2.1-2 4.3-3.8 6.2v-0.1c-0.5-1.2-0.3-2.5 0-3.8-0.4-0.4-0.9-0.9-1.2-1.5q-0.1-0.4-0.1-0.9c0.1-0.7 0.3-1.3 0.4-2 0.4-1.6-0.9-2.8-1.2-4.3q0-0.6 0.2-1.1c1.4-2.7 3.5-0.7 5.4-0.7 1.2-0.1 2 0.6 2.8 1.5 1.5 1.6 1.7 4.2 4.5 4.9 1.3 0.3 0.3 2.5 0.8 3.8 0.3 0.9 0.5 1.7-0.3 2.4q-0.3 0.1-0.5 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m20.1 231c-0.1 0.7-0.2 1.4-0.3 2.2-0.1 0.5 0.1 1.5-0.6 1.6-1 0.1-1-1-1.4-1.5-2.4-1.6-5.4-2-7.7-3.9 0.8-1.8 1.4-3.6 4.2-3.5 1.9 0 4-1 2.9-4.3 1.6 3 6.5 1.8 6.3 6 0 1.9-0.6 4-3.4 3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m30 227.9c2.9-0.2 5.2-3.5 8.5-1.5 0.8 0.2 1.4 0.6 1.5 1.5-1.9 3.3-3.4 7-7.5 8.6-1.9-1.4 0.7-2.5 0.7-4-1.9-0.6-2.8 0.5-3.6 1.9-0.5 1-1.3 2.3-2.6 1.4-0.8-0.6-0.7-1.9 0.2-2.7 1.4-1.2-0.3-2.1-0.4-3.1 2-1.3 3.7 3 5.3 0.2 1.2-2-1.6-1.2-2.1-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m48.4 219.5c-0.2 1-0.4 1.9-1.6 2.8-0.4-1.7 0-5-3-2-3.3 2.9-4.4 2.9-6.9 0v-2.3c1.7-0.5-1.4-2.8 1-2.8 1 0 3.1-0.4 2.7 2.1-0.2 0.7 0.4 1.2 1.2 1 0.6-0.1 1-0.5 0.7-1.4-0.8-2.1 0.6-2.1 2.1-2 2.2 0.8 4.4 1.5 3.8 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m36.9 220.3c2.3 0.8 4.6 0 6.9 0 0.8 1.3 0.7 2.9 1.1 4.4-0.2 0.8 0.4 1.7-0.3 2.4-0.3 0.7-0.7 1.2-1.5 0.8-0.7-1.3-3.3 0-3.1-2.3 0.4-0.2 0.9-0.5 1.7-1-2.2-0.2-4.1-0.4-6.2-0.6 0.1-1.5 1.8-2.3 1.4-3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m10.1 229.4c3.4-0.4 6.3 0.3 7.7 3.9q-1.6 0.1-2.3 1.5c-2.5 0.2-3.2-2.6-5.4-3.1q0-1.1 0-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m-1.4 204.2c-0.5 1.1-0.7 2.6-2.3 3.1q-1.9 0.3-3.8 0.7c-1.1-2.2-2.8-4.6 1-6.1 3.1-2.3 4.2-0.2 5.1 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m35.4 219.8c-1.1 0.8-1.3 1-1.5 1.1-1.8 0.9-3.6-0.2-5.5-0.2-0.7 0.1 0.7-1.9 2.3-1.6 0.8 0.2 1.6 0.6 2.5 0.8 0.4 0.1 0.9 0 2.2-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m10.5 218.4c-2-0.7-4.2 0.9-6.5-1.1 2.5 0.2 4.6-1.1 6.5 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m1 211c0.7 0.4 1 0.6 1.2 0.8 0.8 1.1 2.4 2.2 1.5 3.5-1 1.5-1.5 0.2-1.7-0.8-0.2-0.6-0.3-1.2-0.5-1.8-0.1-0.4-0.3-0.8-0.5-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m30 211.8c0.2 0.5 0.4 1 0.6 1.4 0.9 1.2 0 1.7-0.8 2.3-0.5 0.3-1 0.5-1.4 0-0.8-0.9 0-1.5 0.5-2.2 0.3-0.5 0.7-1 1.1-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m0 213.5c-1.8-1.1-3.4-1.2-2.8-3.2 0.2-0.6 0.7-1.1 1.4-0.8 1.8 0.7 0.1 2.3 1.4 4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m40 225.6c0.9 1 2.8 0.6 3 2.3q-1.5 0-3 0-1.3-0.2-1.5-1.5 0.7-0.4 1.5-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m30 227.9c-0.6-0.6-2.2-0.6-1.5-2 0.4-0.8 1.7-1 2.3-0.4 1 0.9-0.6 1.5-0.8 2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m6.7 213.9c-0.5 0.5-0.8 0.8-0.8 0.7-0.3-0.1-0.7-0.3-0.8-0.6-0.2-0.4 0-0.8 0.5-0.6 0.4 0.1 0.7 0.3 1.1 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s29",
    d: "m43 227.9q0.8-0.4 1.6-0.8 0.4 1.2 0.7 2.3-1.5-0.1-2.3-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m7.8 107.1c-0.7-1.6 0.7-5.4 2.2-5.5 1-0.1 1.2-0.4 1-1.1-0.2-0.9-1.1-1.2-1.8-0.9-2.1 0.6-4 1.8-4.9 3.6-1.6 3.6-3.6 3-6.7 0.9 4-0.1 6.1-2.6 8.6-4.3 2.2-1.4 4.1-2.1 6.4 0.2 1.4 1.4 3.9 2.5 5.4-0.6 0 0 0.2 0 0.3 0.1 0.1 0.2 0.2 0.5 0.3 0.7 0.7 1 1.2 2.2 1.8 3.3 0.3 1.2 1.3 1.7 2.2 2.4 1.7 1.3 4.3 1.9 3.7 5.2-0.3 1.3 2.3 1.8 2.6 3.4q0.1 1.4-1.2 1.9c-0.4-0.1 0.3-0.3-0.2-0.1q-0.3 0.1-0.2 0.2 0 0.1 0.3 0.1c0.5 0.4 0.6 0.9 0.5 1.5-0.9 2-3.1 2-4.7 2.9-0.7 1 0.8 1.4 0.8 2.2 0.3 0.3-0.8 1.1 0.1 1 2.4-0.2 2.5 2 3.8 3 1.2 1 2.2 0.3 3.2-0.4 3.2 0.5 6.6-1.3 9.6 1.6 0.7 0.6 3.1-0.4 4.8-0.2 0.9 0.4 1.4 0.2 1.3-0.9q0.7-0.5 1.5-0.4c1.2 0.1 2 0.8 2.7 1.7q0.4 0.6 0.6 1.4c0.6 1 1 2.1-0.1 3q-0.1 0.4 0 0.5 0-0.3 0.2-0.6c2-3.3 3.7-0.7 5.5 0.1 1.5 1.3 1.4 2.9 1 4.6 1.8 3.4 1.4 4-3.1 4.7-0.8-0.3-1.7-0.5-2.5-1.1-1.1-0.8 0.1-3.4-2.4-3.2-0.7 0-1.4 0-2-0.3-1.6-0.8-3.6 0-5.1-1.1-2-0.6-3.4-4-6-1.1-1.8 0.9-3.5 2-5.2 3.1-1.9 0.6-3.7-0.4-5.6-0.7-1.9-0.5-1.4-3.6-3.7-3.7-1.3-0.7-2.8-0.6-4-1.3-0.6-0.5-0.9-1.2-0.7-2 0.3-0.6 0.8-0.9 1.4-1.1-0.4-0.3-1-0.4-1.4-0.4-2.3 0.1-4.7-0.4-6.9 0.8 0.1 0.8 0.5 1.5 0.2 2.3q-0.3 0.8-1.1 1c-1.2 0.1-2.4-0.3-3.7-0.2-0.7-0.2-1.4-0.5-1.9-1.1-0.9-1.3-0.8-2.6-0.3-3.9q0.3-0.8 1-1.3c0.5-0.5 1.1-0.8 1.6-1.4 1.4-2.2 1.4-6.2 5.9-4.7-1.5-0.7-3.2 0.4-4.4-0.8-0.8-0.8 0.8-1.5 0.1-2.3-1.8-0.6-1.3-2.7-2.5-3.9 2.8 2.6 7 0.9 9.9 3.5 0.9 0.8 1.9 1 1.8-0.8-0.1-1.7 2.1-1.3 2.3-2.6-0.5-0.5-0.8-0.9-0.8-1.6 0.4-1.2 1.6-2.6-0.3-3.6-1.4-0.6-2.6-2.5-4.3-0.5-0.9 1.2-1.1 0-1.6-0.4-1.6-1.2-2.9-2.5-1.1-4.6-3.7-0.9-1.2 4.2-4.2 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m-19 89.5c-1-1.4-2.1-2.2-4.1-2-2.4 0.2-4.8-0.1-4.5-3.7 0.1-1.7-2.7-2.2-2.1-4.3 1.8-0.3 1.2-3.3 2.2-3 2.6 0.7-0.4 2.8 0.4 4.2 0.3 0.6 0.5 1.4 0.7 1.9 1.1 0.5 2.1-4.5 2.9 0.2 3-0.7 4.1 2.7 6.7 3 0.5 0.1 1.1 0.3 1.3-0.3 0.1-0.4-0.1-1-0.3-1.4-1.7-2.2-1.5-3.4 1.1-3.8 1.8-0.3 1.6-1.5 1.7-2.8-0.5 0-0.9 0-1.2 0.2-1.5 1-2.9 0.4-4.3-0.3-0.2-0.1-0.4-0.7-0.3-0.9 0.9-1.6 2.7-0.9 3.8-0.9 1.8 0.1 2.2-0.1 2.6-1.8 0.2-0.9 1.1-2.3 2.5-2.7 0.6-0.2 1.2-0.7 1.7-0.1 0.5 0.6 0.2 1.2-0.3 1.7-0.7 0.8-1.4 1.5-2 2.3-0.5 0.8-0.5 1.8 0.2 2.5 1.7 1.5 0.6-1 1.2-1 0.4 0 0.9 0 1 0.1 0.3 0.9 0.6 1.9 0.7 2.9 0.1 0.7-0.5 1.1-1.3 0.9-0.9-0.2-1.9-0.5-2 0.8 0 1.2 1.1 1.2 2 1.4 0.6 0.1 1.4 0.1 1.8 0.4 1.8 1.6 3.6 1.8 5.9 0.8-0.5-1.5-3.8-1.7-2.4-3.9 1-1.6 3.1-1.4 5.5-1.3-1.5 1.2-1.8 2.6-1.2 4 0.4 1.2 3.5 2.1 0.6 3.8h-0.6c-1 0.1-2.6-1.4-2.9 1.2-0.3 2-3.9-0.1-4 2.6q0.5 0.3 0.3 0.6-0.1 0.2-0.3 0.2-1.1-0.6-2.3 0c-2.9-0.1 0.4 1.8-0.7 2.3-1.9-0.9-2.5 2.3-4.9 1.3-2.4-1.1-2.9-1.7-1.2-3.6 0.6-0.3 1.2-0.6 0.7-1.5-1.5-1.3-3-3.6-4.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m21.6 96.4c-2.6-1.3-4.8 1.5-7.5 0.6-2.7-1-5.7-1.5-8.5-2.4-0.6-0.2-2.5-0.4-1.5-1.9 0.9-1.3 1.7-0.1 2.5 0.5 2.1 1.7 7.3 1.2 8.8-1.1 0.6-1 0.8-0.4 1.3-0.3 2 0.5 2 0.4 4.3-0.5-1.6-0.8-2.3-1.7-0.2-2.6q0.2-0.2 0.4-0.4c3.2 0.4 5.9 1.7 8.7 3.1 1.4 1.3 3.4 0.8 4.9 1.8 0.9 0.6 2.5 0.7 2.1 2.1-0.3 1.7-1.8 1.4-3 1.1-2.6 0.8-5.3-1.5-8 0.2-0.4 0.3-1-0.9-1.2-1.7-0.1-1.1-0.2-2.3-1.9-2.2 0.3 1.4 0.4 2.8-1.2 3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m13.2 80.3c4.2 0.6 8.4 0.6 12.2-1.5q0.3 0 0.6 0c1 0.5 1.9 1.5 1.3 2.4-1.7 2.4 0.1 4.1 1 6q0 0.5-0.3 1c-2.2 2.3-4.8-0.2-7.2 0.5-3-0.6-5.9-0.8-8.6 1.9 1.7-2.1 1.6-3.7-0.5-4.9q0-0.3 0.1-0.5c0.4-1.2-0.3-1.9-1.1-2.5-0.6-0.7-1.2-1.5-0.6-2.3 0.9-1 2-0.3 3.1-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m33.9 96.4c0.6-0.4 1.2-0.7 2-1.1-1.8-2-4.9-0.9-6.6-2.8-0.2-0.9 0.4-1.6 1.1-1.6 3 0.2 6-0.5 9 0.5 2.4 2.7 5.5 4.8 7.1 8.2 0.2 0.5 0.2 1 0.3 1.5 0.3 1.3 0.4 2.6-1.1 3.2-1.3 0.4-2.6-0.2-3.2-1.4-1.3-2.4-3-2.9-5.3-1.7-1.5 0-2.7 0.8-4.1 1-3.5-2.3 0.5-3.4 0.8-5.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m33.9 97.1c0.9 1.8-2.4 2.8-0.8 4.6 2.3-1 2.1 0.8 2.4 2.1 0.2 1.2-0.1 2.9-1.3 2.6-4.1-0.8-8.5 1.5-12.3-1.4-0.6-0.5-1.2-1-1.4-1.8 0.1-1.1 0.6-1.8 1.9-1.5 0.1 0.2 0.2 0.6 0.3 0.6 0.7 0 0.7-0.6 0.9-1 0.3-0.4-0.1-1.8 0.7-1.2 4.6 3.1 5.9-3.5 9.6-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m8.6 117.8q0.8 0.7 0 1.5c-0.5 1.4-0.5 3-2.6 2.8-0.6 0.3-0.5-1.7-1.3-0.4-2.4 1.7-4.5 4.3-8 2.6q-0.2-0.2-0.4-0.4c-0.3-4.7 4.2-4.9 6.7-6.9 0.5-0.5 1.2 0.1 1.6 0.6 1.3 1.7 2.6 0.7 4 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m13.2 80.3q-1.2 0.2-2.4 0.5 0.5 0.5 0.9 1c0.9 1.3 1 2.6 0 3.9-1.7-0.9-2.8-2.3-3.9-3.9-2 0.6-2.5-0.8-3-2.3-0.3-1.7 0.5-2.9 2.1-3.4 1.7-0.5 1.5 1.2 2.1 2 1 1.5 3 1.1 4.2 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m-6 91v-0.8c2.2-0.1 3.5 2.3 5.9 1.9 0.8-0.1 0.5 1.1 0.5 1.8-0.1 1.4-1.2 2.6-0.2 4q0.3 0.3 0.2 0.5-0.1 0.3-0.2 0.3-1.2 0.7-2.3 1.5-0.3-0.1-0.5-0.2c-1.3-1.2-3.4-1.9-2.5-4.3q0.3-0.5 0.7-0.9c0.7-1.7-0.1-2.9-1.6-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m7.8 107.1c1.4 3.5 0.7 4.8-2.8 5.3-1.2 0.1-1.5-1.1-1.4-1.2 1.6-0.8-1.6-2.5 0.6-3.1 1.2-0.3 2.4-0.7 3.6-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m4.8 87.2c-0.4 0.6-1 1.3-1 1.9-0.1 2.5-2 1.7-3 1.5-1.6-0.4-0.4-1.5-0.2-2.4 0.2-0.5 0.2-1.2 0.3-1.8 0.7-0.5 1.6-0.4 2.4-0.7 0.8 0.1 1.7 0.3 1.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m19.3 112.4q0.4 0.8 0.8 1.6c-2.6-0.2-5.2-0.4-8.1-1.5 1.7-0.8 3.1-1.3 4.1-2.4 1.3 0.5 0.8 3.4 3.2 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m4.8 79.5q1.5 1.2 3 2.3-0.7 1.4-2.3 1.6c-0.3 0.3-0.4 0.9-1 1.1q-0.5 0-1-0.3c-0.7-0.7-0.9-1.5-0.3-2.4-0.7-1.5 1.1-1.5 1.6-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m22.4 101.7q-0.8 0.8-1.6 1.5c-0.2 0.8-0.6 1.2-1.5 0.8-1-1.1-0.7-2.5-0.8-3.8 1.3 0.6 2.9 0.2 3.9 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m-1 107c3.5 0.6 2 2.3 1.5 4-2.2-0.8-1.4-2.5-1.5-4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m4.8 84.1q0.3-0.4 0.7-0.7c1.3 1.5 2.5 3.1-0.7 3.8q-0.8-0.4-1.6-0.8c-0.6-1.5 1.1-1.5 1.6-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m0.2 98.7v-0.8c1.5-0.2 2.5-2.3 4.5-1-1.3 1.3-2.6 2.3-4.5 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m21.6 96.4c1 1 2.7 0.5 3.8 1.9h-5.3c-0.1-1.2 0.9-1.4 1.5-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m-4.4 126.2q-0.8-0.4-1.6-0.8 1.2-0.7 2.3-1.5c1.1 0.6 2.6 0.7 2.8 2.3q0 0.6-0.2 1.1c-1.7 1.4-2.7 0.9-3.3-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m45.6 99.4c-1.5-2.9-5.1-4.1-6.1-7.5-1.2-3.1-1.1-6.4-1.2-9.7-0.6-4.5 0.2-8.9 0-13.4 0-1.8 0-3.6-0.5-5.3 0.3-1.7-0.2-3.3 0-4.9 0.5-3.3 2.2-4.8 5.5-3.8 0.7 0 1.3 0 1.9 0.1 4.3 0.4 8.7 0.7 12.9 2.2 1.9 0.9 4 0.8 5.9 0.8 5.2-0.1 10 1.4 15 2.2q0.9 0 1.9 0c3.7 0 7.4 0.8 11.1 1.2q1.2 0.3 2.4 0.4c3.8 0.3 6.3 2.8 8.5 5.6 2.9 3.3 4.4 7.3 6.1 11.2 0.6-0.8 0-1.6 0.1-2.4q0-0.5 0-1.1c0.4-2.1 1.2-4.2 1.2-6.4 0.7-5.2 0.3-10.5 1.8-15.6 2-3.9 5.6-6 8.9-8.5 0.8-1 1.7-1.7 2.7-2.4 0.8-0.6 1.6-1.2 2.1-2 0.5-0.5 1-0.9 1.4-1.4q0.3-0.4 0.7-0.7c1.1-0.6 1.7-1.8 2.9-2.3 2.8-0.8 5.6-1.4 8.3-2.3 3.6-1.1 7.4-1.6 11.1-2.3 1 0 2 0 3-0.1q0.6-0.1 1.1-0.2c1.9 0 3.8 0 5.7-0.4q0.6-0.2 1.2-0.2 4.1-0.1 8.2-0.6c3.8-0.3 4.6 2 4.4 5q0 0.7 0 1.3c-0.7 4.5-2.5 8.7-3.6 13.1q-0.2 0.9-0.2 1.8c-0.4 2-0.5 4.1-2 5.7-0.8 0.7-1.8 1-2.8 0.5-0.9-0.6-1.1-1.5-0.8-2.5 0.1-0.5 0.5-1-0.2-1.3-1.4 0.6-1.4 2-1.9 3.1-0.9 1.5-1.3 3.1-2.2 4.6-0.4 1-0.8 1.9-1 2.9-0.5 1.1-0.8 2.3-1.6 3.3-0.7 0.9-1.8 1.5-2.3 2.6-1.9 3.2-1.1 7.1-2.8 10.3-1.7 2-2.6 4.5-3.6 6.9-0.2 0.5-0.3 1-0.5 1.4-0.9 1.3-1.4 2.8-2.2 4.1-0.8 0.9-1.3 2-1.8 3.1-2.5 2.3-5.1 4.4-8.7 4.5-0.9 0.1-1.5 0.9-2.3 1.3-0.3 0.3-0.7 0.5-0.9 1 0.1 1.8 1.5 1.5 2.5 1.3 2.8-0.5 5.6-0.6 8.3-1.3q0.5-0.1 1-0.1c1.7 0.3 2.7-1.3 4.2-1.5 0.7 0 1.4 0 2.2 0 2.7 0.6 5.5 1.3 7.9 2.9 3.1 0.3 5.4 2.5 8.5 2.7 2 0.9 4.2 1.4 6 2.8 2.2 1.3 3.9 2.9 5.1 5.1 0.4 0.6 0.8 1.2 1.1 1.9 1.1 3.5 2.9 6.6 4.4 9.9 0.8 1.6 1.3 3.2 1 5 1.8 5.9 6 10.3 9.2 15.3 1.9 3 4 6 4.2 9.8-0.1 1.5-1.1 2.2-2.3 2.6-3.2 1.5-6.7 1.4-10 2.4-4.4 0.9-8.9 2.1-13.4 3-1.9 0.4-3.9 1-5.8 1.6q-0.6 0.1-1.2 0c-2.3-0.1-4.5 0-6.8-0.1-1.9-0.4-3.8-0.9-5.6-1.5-2.5-1.1-4.6-2.8-6.8-4.3-1.3-1-2.6-1.9-4-2.5-2.7-0.6-3.4-3.1-5-4.8-1.4-2.8-3.5-5.1-6.1-6.8-1.2-1.3-2.6-2.3-3.6-4-1.1 2.2-0.1 4.5-1.4 6.4q-0.5 0.6-1.4 0.8c-1.9 0-2.5-1.9-4-3-1.7 3.1-3.1 6.4-6 8.5q-0.5 0.5-1 1 0.5-0.5 1-1c1.3-1 2.3-2.3 3.4-3.5 1.5-1.7 3.2-2.3 5.3-1.2 0.6 0.6 1.3 1.1 1.5 2-0.2 1.1 0.8 0.7 1.3 1 0.8 0.6 1.2 1.5 1.6 2.3 0.7 1.6 0.1 3.3 0.4 4.9 0.2 1.2-0.3 2.3-0.1 3.5-0.4 5-4.1 7.9-7 11.4-0.9 1.2-2.2 2.1-3.2 3.2q-0.5 0.6-1.1 1.2c-3.6 3.9-7.1 7.9-11.4 11.2q-0.4 0.3-0.9 0.6-2.1 2-4.5 3.6c-1.4 2.6-4.8 3-6.1 5.7-2.4 3.5-5.6 5.8-9.9 6.5-0.6-0.2-1.1-0.4-1.6-0.7-2.7-0.6-4.9-2.2-7.5-2.8-1.5-0.4-2.3-1.8-2.8-3.4q-0.1-1.1-0.6-2.2c-1.4-6.1-2.7-12.3-4.3-18.4-0.7-3.1-1.4-6.4-1.5-9.7 0.2-1 0.3-1.9 0.2-3q-0.1-0.4-0.3-0.9c-0.1-1.5 0.2-3.1-0.5-4.5-0.2-7.9 2-14.9 7.3-20.9 2.2-2.4 2.9-5.9 5.9-7.7 1.1-0.8 2-1.6 2.6-2.7 1.8-2.3 3.9-4.3 6.4-5.9-1.9-0.2-3.8-0.3-5.4-1.2-3.6-0.7-7-2-10.5-2.4-1.2-0.7-2.7-0.6-3.8-1.3-2.8-1.1-5.7-1.8-8.4-3.2-5.1-3.6-9.7-7.7-11.9-13.9-0.4-0.9-1.3-1.6-1.6-2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m195.4 158.3q1.2-0.7 2.4-1.5c1 0 1.8 1.4 3 0.7 2.2-0.8 0.8-3.4 2.3-4.5 2.5 0.9 4.6 2.1 7.7 1.2 1.7-0.4 4 1.7 6.1 2.6 2 0.5 4.4 0.4 3.9 3.7-0.1 0.6 0.8 0.8 1.4 0.9 1.5 0.6 3 1.1 5.5 2.1-3.4 0.6-5.5 3.2-8.2 0.4-1.1-1.1-2.6-1.6-4.2-1-1-1.7-2.2-3.4-3.5-4.9 1.3 1.6 2.4 3.2 3.5 4.9 0.6 1.3 2.2 1.4 3.1 2.3 0.9 2 0.3 3.8-1.1 5.4-1.8 0.2-3.2 1.1-4.7 1.9-4.1-0.6-2.2-3.4-2.1-5.5 0.1-0.6 0.5-1.4-0.5-1.3-0.6 0-0.5 0.8-0.6 1.2-0.5 1-0.7 2.2-1.6 2.9-1.5 1.1-3.1 0.8-4.7 0.7-0.5 0.1-1 0-1.3 0.3 0.7-0.4 1.5-0.3 2.2 0.2 1 3.7-2.8 2.8-4.1 4.2-1.3 0.7-1.5 2.6-3.2 2.8q-0.8 0.1-1.7 0.4c-1.3 0.2-2.5 1-3.9 0.9q-0.6 0-1.1 0c-0.5-0.1-1-0.3-1.5-0.1-3.4 1-5.1-0.1-5.7-3.6-0.3-2 1.7-1.3 2.4-2.2-1.1 0.8-2.1 0.8-3.1-0.2-0.6-1.2-2.1-1-2.9-1.8-0.4-0.7-0.3-1.3-0.1-2 0.3-0.9 0.5-2-1-1.4-1.6 0.5-3.1 1.1-4.8 0.6-1-0.4-2-0.9-2.7-1.8-1.2-1.5-0.9-2.6 1.1-3.1 4.4-1.9 8.9-3 13.7-3.2 1.4 0.6 2.7-0.5 4-0.3 1 0.2 3.6-0.7 1.6 2 0 0.1 1.6 1.2 2.7 0.5q0.4-0.6 0.6-1.3c0.3-0.8 0.6-1.6 1.6-1.7 4.4 2.2 4.4 2.2 7 1.2-1.8 1.7-4.3 1.3-6.6-1-0.6-0.4-1.3-0.6-0.9-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m210 115.5c1.5 1.2 1.6 4.4 5 2.7-0.7 3.7-3.5 3.8-5.8 4.3-4 0.8-4.3 1.3-2.3 4.5-4.7 1.4-5.4 1.2-7.2-2.7-0.9 1.2-1.4 2.7-3 2.9-2.7-0.2-5.6 0.4-8.2-1.1-0.3-2-1.8-4-0.1-6 2.4-0.5 4.9 0.5 7.7-0.5-2.2-1.3-4.7 1.7-6.3-0.9-0.1-2.8 3-3.3 3.9-5.4q0.6-0.1 1.1 0c1.6 0.2 2.9 1.6 4.6 0.8 0.2-0.5 0.3-1 0.6-1.4 2.4-1.8 4.7-1.7 6.6 0.6 0.9 1.2 2.1 1.7 3.4 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m184.4 131.7c-3.1-4.5-4.6-9.7-6.5-14.7 2.4-1.2 4.3-1.6 4.6 2.1 0.1 1.2 1.2 2 2.2 2.4 1.9 0.9 3.1 2.5 3.9 4.4 1.1 0.9 0.5 2.2 0.7 3.3-0.1 0.3-0.2 0.7-0.3 0.7-2.2 0.1-3.2 0.5-4.6 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m229.1 107.1h0.8c2-1.3 2.3 1.6 3.8 1.5 0.9 0.6 1.7 1.1 0.8 2.3-2.2 0.4-4.4-0.1-6.5 1.4-1.4 1-3-0.1-4.2-1.4q-0.4-0.4-0.8-0.8c-0.4-0.7-1.3-1.2-0.8-2.3q-0.4-0.3-0.7-0.7c0.2-2 1.7-1.6 2.9-1.3 1.5 0.5 3.2 0.7 4.7 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m211.8 139.8c-1.2-1.5-4.2-2-2.6-5 0.3-0.6-0.6-1.3-1.5-1-0.7 0.2-1.1 2.3-2.2 0.3-0.7-1.5-0.9-2.9 0.1-4.3 0.7-1.1 1.8-1.4 2.9-0.9 2 0.9 3.5 2.8 3 4.6-0.7 2.3-0.1 4.1 0.3 6.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m197 126.2c0.9-3.6 3.2-3.6 6.1-2.6-0.2 1.2-1.6 0.8-2.1 1.4 1.6 2 3.8 2.1 5.9 2-1 1.1-2.4 1.7-3.8 2.2-1.5 1.4-4.3-0.2-5.4 2.3-1-0.5-3.1 1.3-3-1.5 0-1-0.1-2.1 0.5-3 0.4-0.6 1.3-0.2 1.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m222.2 161.4c-1.5 1.5-3.2 1-3-0.9 0.2-2.2 0.3-2.6-2-1.9-0.9 0.2-0.2-1.2-0.3-1.8h0.7c0.5-0.5 1.2-0.3 1.8-0.4 2.6-0.4 2.3-1.4 0.5-2.7h-0.7c-0.6-0.4-2-0.1-1.6-1.5l2.3-1.5q0.2-0.2 0.5-0.3c1-0.1 2 0.1 2.6 1 0.4 3.1 0.7 6.2-0.8 9.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m205.4 143q0.4 0.4 0.8 0.8c0.7 2.3 1.1 4.4-2.3 4.6-5.2-2.7-5.3-3.2-2.5-7.2 1.8-2.7 2.8-1.5 4 0.3 0 0.5-2.1 1 0 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m232.2 112.4c0.7 1.5-0.3 2.7-0.7 3.9-0.5 1.6-1 3.2 1.7 3.5-1.9 1.9-3.1 1.2-4.1-0.5q-0.4 0.6-0.7 0 0-0.4 0-0.8c0.2-1.5 1.8-2.5 1.2-4.6-0.5-1.7 1.6-1.1 2.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m197.7 131.5c0.1-0.6 0.1-1.2 0.3-1.8 0.7-1.8 1.2-4.7 3.3-0.8 0.2 0.3 1.2 0.2 1.8 0.3-1 2.8-1.9 5.4-5.4 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m200.8 152.2c-1.9 0.6-3.1 0.4-3.2-2-0.1-1.8-0.4-2.4 2-1.5 3.9 1.6 4.1 1.2 3.5 3.5-0.8 0.7-1.5 0.2-2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m219.2 129.3c2.9-1.4 2.5 1.7 2.8 2.6 0.5 1.3-1.2 1-2.2 1-0.6 0-1.2-0.2-1.8-0.2-0.8 0.1-1.8 1.4-2-0.3-0.2-0.8 0.2-2.1 1.8-1.5 1.5 0.5 0.8-1.2 1.4-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s47",
    d: "m197 126.2q-0.8 0.4-1.6 0.8c-0.9 1.4-2.8 0.3-3.8 1.5-1-0.6-1.6 0.2-2.3 0.7-1.5-0.7-0.9-1.9-0.8-3q-0.3-0.3-0.2-0.5 0.1-0.3 0.2-0.3 4.3 0.4 8.5 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m205.4 143q-0.4 0.4-0.9 0.7c-0.6 0.4 0.2 2.5-1.7 1.4-1.9-1.1 0.2-1.7 0.4-2.5 0.3-1 1.3-1.1 2.2-1.1 1.5-0.7 3-1.9 5.1-0.1-1.9 0.6-4-0.1-5.1 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m200.8 152.2c0.8-1.6 1.5-0.7 2.3 0v0.8c0 1.2 1.2 1.8 1.8 3q-2.1 0.8-4.1 1.5c0.2-0.5 0.5-1 0-1.5-1.2-1.3 0.5-2.5 0-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m203.9 148.4c1.7-1.1 1.6-3 2.2-4.6 1.2 1.5 3.7-0.8 4.6 1.5-1.1 0.9-2.8 1.2-3 3.1q-0.4 0-0.8 0c-1 0.8-2 0.5-3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m203.3 137.4c-1.3 1.9-3 2.4-4.9 1.3-1.5-0.9-0.7-2.1-0.1-3.8 1 2.4 2.7 3.1 5 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m192 132.3c-0.9 1.3-0.4 3.9-3 3.6-0.6-0.1-1.5-1.9-1.3-2.5 0.8-2.1 2.8-0.8 4.3-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m228.4 145.3c-1.6 0.1-2.2 1.4-3.1 2.3-0.7 0.3-1.4 0.3-2.1 0.3-0.8 0-1.3-0.5-1.7-1.1q0.4-0.7 0.7-1.5 0.2-0.3 0.3-0.6c1.4-1.5 2.8-1.6 4.3-0.2q0.8 0.4 1.6 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m222.2 145.3c-0.8-1.4-1.5-2.8 0.8-3.5 1.8-0.4 3.6-0.8 3.8 2-1.6 0.1-3.5-0.3-4.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s49",
    d: "m207.7 148.4q-0.1-3.1 3-3.1c0.5 0.9 0.9 1.8 1.5 3-1.6 0-3.2-1.3-4.5 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s49",
    d: "m212.9 151.9c0.2-1.8-0.3-3.3 1-4.2 0.7-0.5 1.1 0.3 1.4 0.9 0.8 1.9-0.8 2.3-2.4 3.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m221.5 146.8h2.3c1.1 3.7-2.2 3-3.9 3.9-1.4-0.6-1.8-1.2-0.4-2.3 0.7-0.5 1.3-1 2-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m191.6 128.5c0.9-1.6 2.3-1.6 3.8-1.5 1.6 1.4 0 2.1-0.7 3-0.9-0.8-1.8-1.6-3.1-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m217.6 152.2q0.8 0.8 1.6 1.5c-1.1 0.6-2.4 2-3.2-0.1-0.5-1.3 0.3-1.9 1.6-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m222.2 145.3c0.8-2.9 2.6-2.4 4.6-1.5v0.7q-2.3 0.4-4.6 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m219.9 153.7c0.7 0.1 1.7 0 1.8 1 0.2 0.8-0.3 1.5-1.1 1.7-0.9 0.3-2 0.3-3 0.4 0.8-1 3.7-0.5 2.3-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s50",
    d: "m194.7 135.7c-0.5-0.3-1.4-0.1-1.3-0.9 0.1-0.3 0.9-0.6 1.3-0.6 0.3 0.1 0.9 0.5 1 0.9 0.1 0.7-0.5 0.7-1 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s51",
    d: "m219 118.1c0.2 0.7 0 1-0.3 1-0.5-0.1-1-0.4-1.2-0.7-0.3-0.5-0.1-1 0.5-0.9 0.4 0.1 0.8 0.5 1 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m203.9 148.4q1.5 0 3 0c-1 3.7-2 0.4-3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m200.8 152.2c2 1.3-0.6 2.5 0 3.8-1.2-1.3-0.6-2.5 0-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m228.4 140c-0.3 0.2-0.6 0.4-0.9 0.5-0.1 0.1-0.3-0.2-0.5-0.3 0.3-0.2 0.6-0.5 0.9-0.6 0.1-0.1 0.3 0.2 0.5 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m216.6 138.7q0.4 0.3 0.9 0.6c-0.2 0.2-0.4 0.5-0.4 0.5-0.4-0.2-0.7-0.4-1-0.6 0.2-0.1 0.3-0.3 0.5-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m-12.9 189.7h-2.2c-0.4-0.8-0.7-1.7-1.2-2.3-1.5-1.9-2.3-3.3 1.2-3.5 2.1 0 1.6-2.2 2.2-3.5 0.9-2.1-1-2.8-2.2-3.7 2.2-1.5 1.8-4.7 4.2-6.1 0.5-0.2 1-0.3 1.6-0.5q0.3-0.2 0.6-0.4c0.4-0.4 0.7-0.6 1.2-0.7 2.4-2.3 2.4-5.9 4.6-8.4q0.3 0 0.5 0c2.3 0.6 3.3-2.5 5.5-1.9 0.9 0.5 1.8 0.5 2.8 0.3q0.5 0.1 0.9 0.2c2 1 3.8 1.3 4.9-1.2 0.5-0.7 1.1-1.3 1.6-2 3.4-0.4 5 1.9 6.4 4.5-1.7 1.5-1.7 1.5-0.7 3.2-0.7 2.7-3.4 3.2-5.1 2.9-3.3-0.6-4.8 1.3-6.6 3.2-1.6 1-3.7-1.4-5 0.5-1.5 2.4-3.3 4.8-3.9 7.7-0.4 1.7-0.9 3.4-1.3 5.2-0.4 0.8-1 1.4-2.1 1.2-0.4-0.3-0.7-0.6-1-0.9 0.3 0.3 0.7 0.7 1.1 1 0.4 0.4 0.5 0.9 0.6 1.4-0.8 3.3-2.5 5.5-6.2 5.3q-0.8 0.8-1.6 0c0-0.6-0.3-1.1-0.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m5.5 131.5q0.8 0.4 1.6 0.8 0.3 0.3 0.4 0.8c0.1 0.5-0.1 0.9-0.2 1.3 0 0.5 0.4 0.7 0.7 0.9 1.4 0.7 2.3-0.4 3.3-0.9 2.1-1 4.2-2.3 6.6-0.9-0.1 2.7 1.5 4.8 2.7 7-0.4 2-1.8 2-3.2 1.3-1.3-0.6-2.6-0.7-4-0.1-1.9-0.1-3.3 1.7-5.3 1.7-1.1 0-2.2-0.1-3.1 0.8q-0.3 0.3-0.7 0.6c-1.1 0.5-1.8 1.2-2.6 2-1 1.3-1.7 3.3-3.8 1.6 0-0.5 0.5-0.5 0.7-0.8 0-1-0.7-2.4-1.5-2-3.4 1.6-0.5-1.7-1.5-1.8q-0.3-0.3-0.2-0.5 0.1-0.3 0.2-0.3 0.7-0.4 1.5-0.7c0.2-1.9 0.9-3.1 3.1-2.5 0.8 0.2 1.6 0.1 2.3-0.6q-0.9-1.5 0-3.1c-0.4-1.6 0.8-3.1 0.6-4.7q0.4-0.4 0.9-0.4c0.6 0 1.1 0.2 1.5 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m7.8 142.2c1.3-0.1 1.9-1.1 2.7-1.7 0.9-0.6 2-1.5 2.7 0.2 2.3-0.1 4.8-0.5 4.1 3.2q-0.1 0.7-0.4 1.2c0 0.2 0 0.4 0.3 0.5 0.2 0.2 0.4 0.4 0.6 0.6 0.4 0.9 0.8 1.8 0.7 2.8-0.2 0.7-0.7 1.1-1.2 1.5 0 0 0.1 0.2 0.1 0.2 0.6-0.5 1.2-0.4 1.6 0.2q0.4 0.8 0.1 1.6c-1.5 2.9-4.4 2.2-6.9 2.5-1.2-0.2-2.4 0-3.5 0.4q-0.6 0.1-1.1 0c-1.3-0.6-2.7-0.5-4.1-0.6-0.7-0.2-1.2-0.6-1.5-1.3 0.1-1-0.7-1.8-0.3-2.8q0.8-0.7 1.5 0c1-1.9 2.8-2.1 4.6-2.3q0.3-0.1 0.5-0.2c0.5-0.8 1.4-1 2.3-1.2-0.9-0.8-2.3-0.5-2.8-1.7-0.3-0.7-0.5-1.4-0.5-2.1q0.2-0.5 0.5-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m-4.4 126.2c0.9 0.5 1.8 1.5 3 0.8 1 0.1 1.7 0.6 2.1 1.5q0.1 0.5 0.1 1c-0.3 1.1 0.5 1.9 1 2.8 0.4 0.9 1.2 2.2-0.9 2.3h-0.7c-1.3-0.3-2.8 0.6-3.9-0.8-1.2-0.3-1.2-3.4-3.6-1.6-0.4 0.4-0.8-0.8-0.5-1.3 1.1-1.6 1.4-3.7 3.4-4.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m1.7 150.7c0.6 0.6 1.4 1.2 0.8 2.3-0.7 0.9-0.7 2.2-1.6 3-1 1.5-2.9 1.8-4.1 2.9q-0.2 0.1-0.5 0.2c-1.7-3.5 0.4-6.8 5.4-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m0.9 134.6c0.9-1.3-0.2-2-1-2.3-3.7-1.4-1-2.1 0.3-3.1q0.2 0 0.5 0c1.5 0.1 2.9 0.2 2.5 2.3 1.3 1.8 0.5 3.3-0.7 4.6q-0.8-0.7-1.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m7.8 143q0.4 0.8 0.8 1.5c-0.6 0.8 0.2 1.3 0.3 2 0.2 0.9 0.6 2-1.1 1.9-0.5-1.1-1.3-1.3-2.3-0.8-0.6-1.2-3.8-1.4-1.5-3.8q1.7-1.3 3.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m2.5 139.2c-0.3 1.3-1.4 2-2.4 1.6-1.8-0.7-2.1 0.8-3 1.5-0.9-2.7 0-3.8 2.8-3.6 0.8 0.1 1.7 0.3 2.6 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m4 143.8c-0.4 1.6 2.4 2 1.5 3.8q-1.9-0.4-3.8-0.8c0-1.6 0.2-3 2.3-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m-3.7 133.8c1.5-0.5 2.7-0.2 3.9 0.8-0.8 0.5-0.8 2.1-2.1 1.8-1.4-0.3-1.7-1.3-1.8-2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m-2.9 160.6q-0.4-0.8-0.8-1.5c1.1-0.8 2.6-1.2 3 0.3 0.3 1.3-0.9 1.9-2.2 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m3.2 150.7h-1.5c0.1-0.6-0.2-1.5 0.7-1.5 0.7 0 0.7 0.9 0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m203.1 195h0.8c0.6 0.6 1.5 0.3 2.2 0.8 0.5 1.6 1.5 1.5 2.7 0.8 1.4-0.9 2.8-1.8 4.7-2.9-0.5 2.4-2.8 3.7-1.8 6.3 0.8-2.2 1.9-3.8 3.7-4.7 0.8-0.3 1-0.2 0.7 1.1-0.2 0.8 0.1 0.9 0.5 1.1 0.7 0.3 1.4 0.3 1.6-0.5 0.4-1 0.6-2 1-3.5 1.4 1.5 1.2 3 1.3 4.3 0.1 0.4-0.6 0.9 0.2 1.1 4.8 1.2 2.6 3.5 0.4 6.1 2.2-0.2 4.9-1.2 3.2 2.3-0.1 0.2 0.6 1 1 1.5 0.1 0.6 0 1.3-0.3 1.9-2.1 5-3.3 5.1-7.9 0.9-0.8-1.6-1.8-3.2-0.5-5 0.3-0.5 0.6-1.1 0.7-1.6-0.7 1.8-1.9 1.1-3.1 0.6-2.1-1.3-3.7-3.5-6.4-3.4 0.1 0 0.1 0 0.1 0 3.2 0.2 4.8 2.6 7 4.2 1.1 0.7 1.2 1.9 0.7 3.1-0.5 1.1-1.5 1.2-2.6 1.1 0 0-0.8-0.9-0.5 0.2 0.5 1.4 0.6 2.7-0.9 3.7-1.3 0.8-2.6 0.6-3.8-0.4-2.9-2-5.7-2.1-8.5-0.1-2.5 1.8-4.9 2.6-7.4 0.1-0.4-0.4-0.6-0.9-0.8-1.4q-0.8-1.2-1.3-2.5-0.4-0.8-1.1-1.4c-2.3-2.1-0.6-3.1 1.1-4.2-0.1-2.5-0.1-4.6 2.8-6.2 1.1-0.6 0.7-4.1 3.8-3.4q0.3 0 0.6 0 0.7 0 1.5 0c1.5 0.9 3.1 0.5 4.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s54",
    d: "m208.4 166.7c-1-1-1.7-2-0.1-3.1 1.1-0.8 2.6-0.4 3 0.4 0.5 0.9 2.7 1.7 0.8 3.5-1.3 1.3-1.5 3.1 0.2 4.6 1.3-1.1 2.8-2 4.6-2.3q0.7-2.3 1.5-4.6 1.2 0.8 2.3 1.5c-1 1.8-2.4 3.6 0 5.4 0.7 1.1 1.7 1.5 3 1.7 0.8 0.2 1.4 1 0.8 2.1-0.7 1.9-2 3-4.1 2.4 0.1 0-0.1 0.2 0 0.2 0.4 0.7 0.7 1.3 0.3 2-1.8-0.2-3.7-1.6-5.4 0.8-0.4 0.5-3.3-0.1-4.4-1-2.2-1.6-3.2-0.7-4 1.5-0.9-1.4-1.2-3.1-3-2.8-1.3-2.1-4.5-2.4-4.6-5.4 1.5-0.7 3.5-0.6 4.6-2.3-0.5-0.4-1.3-0.6-0.8-1.5q1.9-0.4 3.8-0.8c1.2 0.6 1.7-0.2 2-1.1-0.1-0.3 0.8-0.5 0.1-0.9q-0.4 0-0.6-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s55",
    d: "m224.5 209.5c-0.2-0.7 0.4-0.6 0.8-0.7 1.5-0.7 3.1 0.8 4.6 0 0 0.6 0.3 1.6 0 1.8-3 2.3-3.4 6.4-6.1 8.9-0.3 1.5-1 2.6-2.5 3q-0.5 0.1-0.9 0.2-0.7 0.2-1.3 0.5-0.5 0.2-1 0.2c-1.3-0.5-2.8-0.3-4.1-1.2-1.1-1.7-4.3-1.3-4.6-4.1 1.3-3.7 2.6-4.6 6.3-4.1 1.6 0.2 3.1-0.3 4.5-0.1 3.7 0.7 4.5-1.3 4.3-4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m202.3 184.3c-1.3 3.1-3 6-6.1 7.7q-0.4 0.3-0.9 0.3c-1.3 0.3-2.5-0.6-3.8-0.1-1.6 0.8-0.7 3.4-2.7 3.9-1.2 0.3-2.5 0.4-3.7-0.1-2.8-1.8-0.9-4.1-0.3-6.1 0.9-3.2 3.9-2.4 5.2-2.6-3.8 0-4.5-0.7-3.1-4.2q0.3-0.5 0.7-0.8c1.7-0.4 3.5-0.3 5.2-0.5 1.5-0.1 2.8 0.4 3.3 2 0.1 0.2 0.1 0.4 0.1 0.6 0.1-0.1 0.3 0 0.3-0.1 0.2-0.2 0.3-0.4 0.6-0.6 1.4-0.9 3-0.9 4.5-0.2q0.5 0.3 0.7 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s56",
    d: "m202.3 184.3h-0.7c-1.7-1.7-3.7-2.8-5.8-3.7q-0.5-0.4-0.7-0.9c-0.3-1 0.4-1.6 1.1-2.3 1.4-1 0.2-4 3.1-3.8 0.9 1 2 1.4 3.3 1.6 2.7 0.5 2.9 1.8 1.3 3.8 0 1.7 0.9 3.2 1.6 4.7q-1.6 0.3-3.2 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m218.4 177.4c2-0.8 4.4 0.3 6.1-1.5 0.2 1.1 0.6 2.1 1.8 3.5-0.2-3 1.1-2.9 2.8-2 2.4 2.2 0.6 4.4-0.1 6.9-2.1-2.9-6.6 0-8.3-3.8q-0.8-1.5-2.3-2.3-0.3-0.3-0.2-0.5 0.1-0.3 0.2-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m203.1 195c0.4 2.7-2 2.9-3.4 3-1.6 0.1-1-1.8-1.2-3 1.2-1.2 1.5-4 4.2-2.1 1.1-1.6 1.7-3.8 4.4-3 0.8 2.8 0.8 2.8-2.3 3.8-0.6 0.2-1.1 0.9-1.7 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s57",
    d: "m195.4 192h0.8c-0.4 1.1 0.6 2 0.8 3-2.3 0.2-4.6-0.1-6.5 1.7-0.5 0.6-1.9 0.8-2-0.9 1-1.7 0.1-4.2 2.3-5.4 1.5 0.7 2.9 1.8 4.6 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m228.9 200.7c1.3-1.6-2.3-2.6-0.2-3.8 1.1-0.6 3.1-0.1 3.4 0.9 0.4 2-2.6 1.1-3.2 2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m206.2 195.8c-1 0.4-2 0.8-2.3-0.8 1-0.5 1.7-0.3 2.3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m22.4 71.9v-0.8c-0.8-1.2 0.2-2 0.6-3 2.2-4.5 6-2.9 9.4-2.2q0.6 0.1 1 0.5 0.3 0.5 0.4 1.1c0 0.8-0.4 1.4-0.9 2-1.2 1.9-2.5 3.7-5.1 4q-0.5 0-1-0.2c-1.2-1.4-3.3-0.1-4.4-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m22.4 71.9c1.7-1.2 3.4-1.8 4.6 0.8 0.8 1 1.1 2.2 1.5 3.3 0.9 2.6 0 3.3-3.1 2.8 0.4-2.3-0.9-3.7-2.6-4.9-0.6-0.5-2.4-0.9-0.4-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m4.8 84.1c-0.2 1-1 1.6-1.6 2.3h-2.3c2-1.3-1.3-2.5 0-3.8h0.8c1.5-0.5 1.6 0.9 2.3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m15 73.5c0.1 0.9-0.3 1.3-1.1 1.2-0.7-0.1-1.5-0.3-1.6-1.2-0.1-0.8 0.6-1.1 1.2-1.1 0.9-0.2 1.3 0.5 1.5 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m23.9 68.8q-0.8 1.2-1.5 2.3c-1.2-0.2-2.7 0.3-3.1-1.5q0.4-0.8 0.8-1.5c1.5-0.8 2.8-0.7 3.8 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m12.8 76.4c2.5-0.3 2.6 0.8 2.9 2.1-1.6 0.1-1.7-1.3-2.9-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m-2.9 68.8q0.8 0.4 1.5 0.8 0.3 0.6 0.6 1.3c-0.5 0-1 0.1-1.4 0-1.1-0.3-1-1.2-0.7-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s58",
    d: "m2.8 73.3c-0.6 0.3-0.9 0.6-1.2 0.5-0.2 0-0.4-0.5-0.6-0.7 0.2-0.1 0.4-0.3 0.6-0.3 0.3 0 0.6 0.2 1.2 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m4 84.1q-1.1-0.7-2.3-1.5 0.8-0.4 1.5-0.8 0.4 1.2 0.8 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m220.7 86.4c1.7 0.5 0.7 1 0 1.6-2 1.2-2.1 3.9-3.8 5.3-0.6-0.8-3.6-0.4-1-2.9 2.2-2.2 0.1-3.1-2.3-3.3-1.5 0-3.7-0.4-4.2 0.9-0.7 1.9 1 1.3 2 1 0.6-0.2 1-0.9 1.8-0.3-1.6 3.4-5.1 3-8.1 4 0.9 1 1.8 1.8 3.2 1.3 4.2-1.4 5.4-0.7 6.3 4.1-2.4 0.7-3.4-1.6-5.1-2.6-1.1 1 0 2.2-0.3 3.2-1.4 1.1-3.1 1.6-4.9 1.5q-0.5-0.1-1-0.4c-0.8-0.9-1.8-1.1-2.9-1.2-1.4-0.2-2.4-0.9-2-2.7-0.9 1.4-0.5 2.5 0.9 3.1 1.2 0.5 2.1 1.3 2 2.8q-0.2 0.8-1.1 1.1c-4.6-0.3-5.5-1-6.4-5.5-0.1-0.8-0.8-1.2-1.2-1.8-1.1-1.2-1.2-2.6-1.3-4.1 1.6-4.6 3.3-5.4 9-4.2 2.1-0.7 3.9-1.9 5.1-3.9 0.9-1 2.1-1.6 3-2.6q0.5-0.1 0.8 0.3c1.9 2.4 3.3 2 6.4-0.2 1.3-0.9 4-0.5 5.7 0.1 1.4 0.5-0.1 1.6-0.6 2.4-0.3 0.2-0.4 0.6-0.6 0.9-0.1 0.3-0.1 0.7 0.1 1.1 0.1 0.3 0.2 0.7 0.5 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m210 115.5c-1.7 0.8-2.9-0.3-4.1-1.2-1.5-1.2-3.1-2.1-5.1-1.1-2 0.1-2.1-1-1.3-2.3 1.6-2.9 3.5-3.5 7.2-2.2-3.4-3.6-3.3-4.7 0.6-7.7 1.1-0.2 2.1 0.2 2.7 1.1q0.3 0.5 0.5 0.9c0.2 0.4 0.2 0.9 0.2 1.3q0 0.3 0 0.5c-0.3 2.7 0.9 4.2 3.6 4.5 1 0.1 2.2-0.1 1.8 1.6-0.3 0.7-0.9 0.7-1.5 0.8-0.9-0.1-1.8-0.1-2.6-0.1-1.4-0.1-2.9-0.7-3.7 0.8-1.2 1.8 1.7 1.7 1.7 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m229.9 104.8c-1.7-0.5-3.5-0.6-4.6-2.3 0.2-0.3 0.3-0.8 0.8-0.8q1.1-0.4 2.3-0.7c1.7-1.1 3.3-1.1 4.6 0.7 1.1 1.4 2.6 2.9-0.8 3.1-0.8 0.6-1.5-0.2-2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m226.1 101.7q-0.4 0.4-0.8 0.8c0-2.2-2.1-3-3.1-4.6q0.4-0.4 0.8 0c1.7 0.6 3.5-0.6 5.3 0.5q-1.1 1.7-2.2 3.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m229.1 107.1c-2.5 0.6-5.1-1.8-7.6 0q-1.2-0.8-2.3-1.6c-0.7 0.1-1.1-0.3-1.6-0.7 4.1-0.5 7.9 0.2 11.5 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m233 101.7q-2.3-0.4-4.6-0.7c2.5-3.2 3.8-3.2 5.4-0.2 0.3 0.5-0.4 0.8-0.8 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m223 97.9h-0.8q-1.1 0.8-2.3 1.5c-1 1-2 0.6-3 0 0.9-0.7 2-1.2 2.6-2.1 1.7-2.3 2.5-0.8 3.5 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m203.9 99.4c1.8 0 3.2-2.8 5.3-0.7h0.8c0.5 1.2-0.5 1.6-1.3 2.1-0.6 0.1-1.1 0.2-1.7 0.3-1.6 0.5-3.1 0.8-3.1-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m225.3 92.5c0.9 0.6 1.9 0.4 2.8 0.4 1.3-0.1 2.3 0.3 1.8 1.9-1.1-0.5-2-0.5-3.2-0.1-2.2 0.7-1.9-0.8-1.4-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m228.4 119.3h0.7c-1.2 2.9-2 3-5.3 0.5 1.4-1.2 3.2 1 4.6-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m217.6 104.8q0.8 0.4 1.6 0.7c0 1.1 0.7 2.3-0.8 2.9-0.4 0.1-1.2 0-1.3-0.2-0.8-1.2 0.6-2.2 0.5-3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m208.4 100.2q0.8-0.8 1.6-1.5c0.9-0.5 1.6 0.1 2.3 0.5 0.5 0.4 1.7 0.4 1.2 1.4-0.2 0.3-1.3 0.2-2 0.4q-0.2 0-0.5 0c-0.8 0.2-1.6 0.3-2.3-0.4q-0.1-0.2-0.3-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m206.9 100.2h1.6-0.1c0.9 1.1 2.2-0.1 3.1 0.8q-0.4 0.7-0.7 1.5c0.2 0.7-0.2 0.9-0.8 0.7q-1.2-0.7-2.3-1.5c-0.7-0.3-1.2-0.7-0.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m216.9 99.4q1.5 0 3 0c0.5 0.6 0.4 1.2-0.4 1.4-1.2 0.3-2-0.4-2.6-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s60",
    d: "m216.9 93.3c0.3 0.6 1.3 1.1 0.4 1.9-0.4 0.3-1.1 0.4-1.3-0.1-0.6-1 0.3-1.3 0.9-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m222.2 107.8c0.2 0.8 1.4 1.3 0.8 2.3-1.4-0.4-1.7-1.1-0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m214.6 111.7q0.7-0.4 1.5-0.8c0.3 0.4 0.5 0.8 0 1.2-0.6 0.3-1.1 0-1.5-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m210 103.2q0.4-0.3 0.7-0.7 2 1.1 0 2.3c-0.5-0.4-1.2-0.7-0.7-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s61",
    d: "m11.7 58.9c-3.4-0.8-6.7-1.9-9.8 1.1-0.9 0.9-3.4 3.5-4.2-0.8-0.2-1.1-1.5-0.6-2.4 0.2-3.3 2.9-7.6 2.9-11.2 0.3 1.6-0.3 2.7-1.1 3.2-2.7 1-0.7 1.9-0.2 2.9 0.1 0.4 0.1 0 0.5 0.3 0.1 0.1-0.3-0.4-0.3-0.6-0.5-1.6-0.6-3.3-0.9-4.4-2.5-1.2-1.6-1.1-2.7 0.7-3.5 0.7-0.3 1.4 0 2.1 0.2 2 1.1 4 1.5 6.1 0.3q0.5-0.3 1-0.4c3.5-0.5 6.8-1.6 10-3 1.5-0.5 2.6-0.3 3.1 1.4 0.4 0.7-0.9 1.7 0.3 2.3 0.2-0.1 0.4-0.3 0.5-0.5 0.2-0.6 0-1.2 0.1-1.8 0.1-1.3 0.7-2.4 1.9-3q0.5-0.2 1.1-0.2c1.2 0.3 2.1 1.1 3.2 1.5q0.5 0.3 0.9 0.6c1.9 1.6 3.8-0.4 5.6-0.2 1.1 0.2 2.1-0.1 3.1-0.2 1.7 0.3 3.6-0.9 5 0.8q0.5 0.6 0.5 1.4-0.1 0.6-0.3 1c-0.7 0.8-0.8 1.8-1.2 2.7-0.7 1-1.5 1.6-2.8 1.4-1.1-0.3-1.9-1.1-2.8-1.8-0.8-0.7-1-0.1-1.2 0.5-0.3 0.7-0.8 1.4-1.6 1.5-1.6 0.2-0.1 0.8-0.2 1.3q0.1 0.8-0.3 1.5c-1.1 1.8-2.3 3.3-4.7 2.2q-0.5-0.3-0.9-0.6c-0.7-1-1.8-0.2-2.6-0.4q-0.2-0.2-0.4-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s62",
    d: "m23.9 68.8c-1.4 0.5-2.7 0.2-3.8-0.7v-1.6c0.2-0.9 0.1-1.8-0.4-2.8-0.7-1.3-0.1-2.3 1.2-2.9q0.6-0.2 1.1-0.1c1.4 0.7 2.7 1.4 4.3 0.6 1.4 0 2.7 0.2 4.1-0.2 2.7-0.9 4-0.1 2.8 2.9-0.3 0.8 0.6 1.7-0.1 2.5-0.4 0.2-0.7 0.5-1.1 0.4-2.9-0.4-5.9-0.8-8.1 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s63",
    d: "m21.6 61.2c-1.1 0.6-1.6 1.5-0.8 2.7 0.9 1.2 0.4 2-0.7 2.6-1.3-4-5.9-3.5-8.4-6-0.8-0.9-1.6-1 0-1.6 1.2 0.6 2.5-1.2 3.8 0 0.7 1.5 1.6 2.6 3.5 1.4 1.2-0.7 2.3-1.1 2.6 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m9.5 62.9c-0.9 5.2-4 3.4-6.8 2.5-0.4-0.1-2.2 0.2-1.2-1.4 0.3-0.4-1-1.1 0.3-1.3 1-0.1 2-0.1 2.9-0.2 0.4 5 2.2 0.6 3.3 0.6 0.4 0 0.8-0.1 1.5-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s64",
    d: "m8.5 59.9c-0.8 0.8-1.6 1.1-3.3 1.1 1.3-1.1 2-1.4 3.3-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m232.2 32.9c1.3-0.2 2.7-0.4 4.3-0.6-0.2 3.6-3 5.7-4.9 8.4 0.6 1.2 3 0.2 2.9 2.3-1.7 1.1-4.2-1.5-5.4 0.9-0.7 1.4 0.6 2.5 1.6 3.5q-3.9 1.9-7.7 3.9c-0.7-0.7-1.5-0.4-2.2-0.3 0 0 0 0 0.1 0 0.8-0.2 1.5-0.3 2.1 0.3q0.2 1.2 1.5 1.5c-0.4 2.7 2.6 0.7 3.1 2.3-0.4 1.1-1.4 0.7-2.2 0.7-1.3-0.1-2.7-0.3-3.1 1.3-0.3 1.4 2.2 0.3 2.2 1.8-1.7 1.6-3.4 0.3-5 0.1 1.3 1.5 4.6-0.8 5.4 2.4q0 0.5-0.3 0.9c-0.5 0.3-0.9 0.4-1.4 0.3-0.3 0-0.5-0.2-0.8-0.1q0.3 0.2 0.5 0.5 0 0.3 0.1 0.5c-0.7 1.3-1.9 1.5-3.2 1.4-1.4-0.1-1.6 0.9-1.3 1.8 0.7 1.5 1-0.4 1.3-0.4 2.5 0.5 4.3 2.1 6.3 3.5-3.2-0.4-6.4-1.7-8.5 2.1 0.6 0.6 1.8 1.1 0.8 2.3-3.2 1.4-2.4-2.4-4.2-3.2-1.3 1.7-1.5 4.6-4.7 4.3-0.5 0 0.2 1.3 0.5 2-1.9 0.6-2.7-2.2-4.6-1.6q-3.6 1.8-3.6-2.2c1.4-3.4 4.9-3.1 7.6-4.1 1-0.3 1.7-0.8 2.1-1.8 0.2-0.4 0.5-0.7 0.4-1.1-0.1-0.4-0.4-0.7-0.6-1-0.4-0.6-1-1-1.5-1.5-0.4-0.4-0.8-0.8-0.8-1.3-0.1 0-0.3-0.2-0.3-0.1-0.1 0.4-0.4 0.5-0.8 0.5q-0.5 0-0.9-0.3c-1.7-1.4-0.5-3-0.4-4.6 0.8-1.8 1.9-3.6 1-5.7 0.9-0.9 1.9-0.8 3-0.6 1.8 0.3 2.4-1.6 3.7-2.2 0.7-0.5 1.1-1.2 1.7-1.8 2-2.7-2-2.5-2.1-4.2q-0.1-0.6 0-1.1c0.3-0.8 0.6-1.5 1.3-2 1-0.5 1.9-0.4 2.9-0.3 0.8 0.2 1.2 0.9 1.8 1.1 1.5 0.6 0.4-0.4 0.5-0.8-0.1-0.5 0-1 0.3-1.4 2.2-1 3.9-2.7 5.4-4.5 1.1-0.4 1.9 0.5 2.9 0.8 0.5 0.3 1.1 0.7 1.7 0.3q0.3-0.4 0.7-0.6c1.1-0.5 1.3-1.3 0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s66",
    d: "m202.3 73.4c0.1 2.1 1.9 1.8 3.1 2.3 0.1 2.7 1.6 4.2 3.8 5.4h-0.8c-1.9 1.9-3.8 1.6-5.3-0.4-0.8-1.1-2.5-1.4-2.8-2.9-0.3-1.6-2.1-1.3-2.9-2.3q-0.4-0.4-0.6-1-0.2-0.9 0.1-1.7 0.2-0.6 0.7-1c1.9-1.3 3.4-0.7 4.6 1.1q0 0.2 0.1 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s67",
    d: "m220.6 73.8c1.2-0.6 2.1-1.4 3.2-0.3 0.1 0.2 0 0.8-0.1 1-1.1 1.3-2 0.4-3.1-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s51",
    d: "m226.8 80.3c-1.6-0.1-3.2 0-5.7-1.5 2.9-0.4 4.3 0.3 5.7 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m219.2 83.4h1.5q0.8 0.3 1.5 0.7-0.7 1.2-1.5 2.3-0.4-0.4-0.8-0.7c-0.8-0.6-1.6-1.2-0.7-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s53",
    d: "m210 77.2c1.6 0.1 3.2 0.1 5 2-2.2-0.4-3.7-1-5-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m225.3 62q0.8 0 1.5 0c-0.7 2-2.4 1.3-3.8 1.5-0.5-1.5 1.2-0.9 1.5-1.5q0.4-0.6 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s68",
    d: "m218.4 74.2q-0.4-1.2-0.8-2.3c1.4 0.4 1.8 1.1 0.8 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m187 239.4c-4-0.7-7.6 1.3-11.5 1.5-4.5-1-7.5 2.4-11.3 3.7q-0.5 0-1-0.2-0.8-0.4-1-1.2c-0.3-0.5 1-2.7-1.2-1-0.4 0.2-1-0.1-1.4-0.3q-0.5-0.3-0.8-0.7c-1.9-2.7-4.4-1.7-6.8-1.1-1.9-0.3-3.8-0.6-5.7 0-2.2 0.6-4 0-5-2.2-0.3-1.7 0.8-2.6 2.2-2.9 1.2-0.3 1.8-1.1 2.3-2.1 1.1-0.8 2.7-1.2 3.2-2.8 0.8-0.7 1.5-1.7 2.8-1.8 1.3 0.4 2 1.4 2.6 2.4 0 2.6 1.4 0.8 2.3 0.8 1.9-0.3 3.7 0.3 5.3 1.4 1.1 1.6 2.5 2.7 4.6 2.3 2.4 0 5 0.6 7.1-1.3 5-0.5 10-1.4 14.9-0.1 0.8 0.4 1.5 0.6 2.3 0.5 0.9-0.1 1.6-0.5 2.4-0.6 1.1-0.1 2.2-0.8 3.4-0.1q0.8 0.6 1.1 1.5c0.2 1.9-0.8 3.1-2.6 3.5-2.1 0.4-4.2 1.4-6.5 1.5-0.6-0.1-1.2-0.4-1.7-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s69",
    d: "m35.4 245.5q0-0.8 0-1.5c2.8 2 2.7-3.1 4.8-2 1.6 0.7 2.5 0.9 4.4 0.6 4.4-0.6 5.4-5 9-6.1 1.4-0.4 3.6-2.2 2.5-4.8 2.3-3 5.2-3.7 8.8-2.4q0.7 0.5 0.9 1.3c0 2.8-2.9 3.3-4.1 5.1q-2 5.1-6.4 8.3c-3 0.8-6.7 0-8.4 3.8 0.7 0.6 1.4 1.2 0.7 2.2-1.2 1.5-2.7 1.8-4.4 1.1q-0.5-0.2-0.9-0.3-0.5-0.2-0.9-0.5c-1.1-0.9-2.8-0.3-3.8-1.4q-0.4-0.3-0.7-0.7c-0.5-0.9-1.6-1.5-1.5-2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m225.3 62h-0.8c-2.2-3-5.5-2.1-9.6-2.5 3.7-2.4 6.8 0.1 9.6-0.6 0.6 0.4 1.3 0.8 1.6 1.5q-0.4 0.8-0.8 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m226.1 60.4q-0.8-0.7-1.6-1.5c1.6 0.2 2.7-0.9 4.2-1.8-0.2 2-1.9 2.3-2.6 3.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m224.5 52.8c1.2-0.9 2.5-1.1 4.3-0.1-1.7 1.3-3 0.1-4.3 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s71",
    d: "m219.9 221.8q0.4 0 0.8 0c1.3-1.2 2.6 0.9 3.8 0q1.2 0.4 2.3 0.7c0 1.8 2.4 0.7 2.7 2.5-2.8 0.3-5 0.9-6.3 4.1-1 2.4-4.1 2.1-6.3 0.3-0.3-0.6-1.1-0.9-1.2-1.7 0.1-1.4 1-2.2 2.1-2.7 1.5-0.7 1.9-1.9 2.1-3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s72",
    d: "m216.1 227.9c0.6 0.1 1.3 0.1 1.5 0.9 0.1 0.1-0.5 0.4-0.7 0.6-1.1 0.8-2 1.4-3.6 1.4-1.9 0-4.3 0.6-4.9 3.2-1.4-0.1-0.6-2.4-2.3-2.3-1.2-2 0.2-3.1 1.3-4.5 1-1.3 2.5-2 3.4-3.4 2.8-1.5 4 0.3 5 2.4 0.1 0.6 0.1 1.2 0.3 1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s73",
    d: "m229.1 230.2c-0.4 1.1-0.6 2.3-2.2 2.4-1.2 0.2-2.2 0.9-0.8 2.2-2.9-0.3-3.1-0.7-2-2.8 0.9-2.1 2.8-3 4.5-4.3 0.8 0.7 0.4 1.6 0.5 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m235.2 151.9c-4.5 3.5-6.5 3.2-8.7-1.3 2.8 2 5.5 0.9 8.7 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m219.9 150.7c0.1-2.5 4-1.2 3.9-3.9q0.7 0.4 1.5 0.8c-0.7 1.3-0.7 3-2.3 3.8-1.3 0.7-2.4 0.8-3.1-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m230.7 156c-1.3-0.1-2.9 0.8-3.9-1.2 1.6-0.1 2.8 0.4 3.9 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s74",
    d: "m5.5 49c-1.9 2-5.4 1.2-7.2 3.9-0.6 1-1.4-1.8-2.7-0.9q-0.4-0.3-0.5-0.8c-0.2 0.3 0 0.6-0.3 0.8-2.3 2.5-4.6 1.8-6.9 0-0.4-0.4-0.6-1.2-1.5-0.7-1 2.5 0.9 3.1 2.6 3.4 0.9 0.2 1.7 0 2 1.1-0.3 0.8 0 1.7-0.8 2.3q-1.5-0.4-3-0.7-0.4 0.3-0.8 0c-0.5-0.6-1.2-1.7-1.5-1.6-6.5 2.5-3.9-3.1-4.9-5.4-0.2-0.5-0.3-1-0.5-1.4-0.5-0.9 0-1.4 0.5-2 2.5-1 5.4-0.3 7.6-2.2 0.6-0.5 1.4 0.1 2 0.7 3.5 1.1 6.9 1.9 10.6 0.4 2.8-1.2 4.6 0 5.3 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m229.9 157.5q1.5 0.4 3.1 0.8c0.3 1.1 1 2.6 0 3.1-0.8 0.5-2.5 0.4-3.4-0.2-1.7-1.1 0.4-2.4 0.3-3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m224.5 175.9c-0.8-1.5-2.1-1.6-3.5-0.9-1 0.4-2 1.2-3.2 0.3-0.5-0.4-0.4-1.1-0.1-1.7 0.6-1.7 1.9-0.4 2.9-0.6 0.1 0 0.2-0.2 0.2-0.2 0-0.3-0.1-0.5-0.1-0.7 1.6-0.4 2.6-2.5 4.6-1.6q-0.4 0.8-0.8 1.6c1 1.3 3.8-0.6 3.9 2.3-0.4 2.7-2.6 1-3.9 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m228.4 174.4c-0.7-0.6-1.3-1.1-2.4-0.6-1.7 0.7-1.9-0.3-1.5-1.7 2.3-1.1 4.6-0.4 6.9 0 0.4 2.6-2.5 0.9-3 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s75",
    d: "m226.8 26.8c1.4 0.8 0.5 3.5 3.3 3.2-1.7 2.1-5.2-0.8-5.6 2.9q0.6 0.6 0.5 1.4c-0.6 1.5-1.8 1.7-3.1 1.3-1.5-0.4-2.4 0.3-3.3 1.2-2.5 0.5-2.3-1.6-2.8-3q-0.1-0.8 0-1.5c0.3-1-0.2-1.8-0.7-2.6-0.6-1.7-2.7-1.4-3.6-2.7-0.3-0.5-0.3-1 0-1.5 1.1-1 1.8-2.2 1.9-3.8 0.3-0.7 0.9-1 1.7-1 1.1 0.2 2.4 0.3 3.5 0.8 0.9 0.7 1.7 1.6 2.8 2.1 0.8 0.6 1.8 0.8 2.6 1.4 0.8 0.8 2.3 0.5 2.8 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s76",
    d: "m224.5 34.4q0-0.7 0-1.5c1.1 0 2.3-1 3.1 0.4 0.8 1.7 2.5 1.5 3.8 1.9q0 0.4 0 0.7c-0.7 0.7-1.5 0.7-2.3 0.1q-1.5-0.4-3-0.8-0.3 0-0.5 0c-0.5-0.1-0.9-0.3-1.1-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s77",
    d: "m229.9 23.7q0 0.4 0 0.8c-0.9 0.9-1.8 1.6-3.1 0.8-0.8 0.3-1.4-0.1-1.9-0.7-0.4-1.3 0.1-2.2 1.1-2.9q0.6-0.3 1.1-0.3 0.6 0 1.1 0.3c0.8 0.5 1.2 1.3 1.7 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s78",
    d: "m225.3 24.5q0.8 0.4 1.5 0.8v1.5c-1.5-0.9-2.4 0.9-4 0.8 0.3-0.9 0.7-1.6 1-2.3q-0.4-0.6 0-1c0.5-0.3 1-0.3 1.5 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s79",
    d: "m224.5 221.8c-1.2 2.7-2.5-0.5-3.8 0q1.5-1.2 3.1-2.3c0.8 0.6 0.7 1.5 0.7 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m229.1 166c2.2 1.9-1.2 1.8-1.2 3 0 0.4-0.9 0.2-1.1-0.4-0.3-1.8 1.8-1.6 2.3-2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s80",
    d: "m49.9-2.3q6.2-0.7 12.3-1.5c2-1.1 2.9-0.1 3.4 1.7 0 0.8-0.7 1.5-0.6 2.4 0.7 1.8 3.2 2.2 3.6 4.2q0 0.6-0.2 1.1c-1.5 1.3-3.7 1.3-5.2 2.6q-0.8 0.3-1.5-0.1c-1.3-1.3-1.3 0.1-1.5 0.8q-0.2 0.5-0.5 0.9c-0.6 0.4-1.2 0.8-1.8 1.2-0.6 0.3-1.3 0.6-2 0.3q-0.6-0.2-0.9-0.6c-0.7-1.3 0.2-2.4 0.5-3.6 0.5-1.9-0.1-3.2-1.8-4-1.1-1.9-4.8-2-3.8-5.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s81",
    d: "m49.9-2.3c1 2.1 3.4 2.8 4.6 4.6-0.3 0.4-0.7 0.8-1.2 1-1.7 0.2-3.4 0.2-5.2 0.2q-0.7-0.2-1.1-0.9c-0.5-0.9 0.1-1.8-0.1-2.6q-0.3-0.2-0.7-0.2-0.4 0-0.8 0.1c-1.7 0.3-2.7 2.1-4.5 2-1.5 0.4-3.1 0.6-4-1-1.1-1.9-3.6-0.3-4.6-2.1-0.8-1.8 1.5-2.6 1.6-4.1q0.4-0.8 0.7-1.6c2-0.7 3.6 1.1 5.5 0.9q0.8 0.2 1.3 0.9c0.2 0.3 0.3 0.7 0.4 1.1 0 0 0.1 0.1 0.1 0.1 0 0 0-0.1 0-0.2 0.6-2.2 1.9-2.4 3.7-1.4q0.3 0.1 0.5 0.2c1.4-0.5 3.3 0.2 3.9-2.1 0.4-1.2 1.9-0.9 3-1-0.4 1-0.8 2 0.8 2.3-0.5 2.1-3.6 1.5-3.9 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m180.1-3.1c1.5-0.4 0.8-2.6 2.3-3 1.2-0.3 1.4 0.6 1.7 1.4 0 2.6-1.8 3.5-3.9 4.1-1.1 0.3-2.3 0.7-2.8-0.9q-0.1-0.6 0.2-1.1c0.7-0.6 1.5-0.8 2.5-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s83",
    d: "m170.2-2.3c1.6 0.3 2.9-1.3 4.6-0.7 0.7 1.5 0 2.6-1 3.7-0.9 0.4-1.8 0.7-2.8 0.3-0.6-1-1.1-2.1-0.8-3.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s84",
    d: "m173.2 0q0.8-1.5 1.6-3h0.7q1.2-1 1.9 0.3c0 1.1-0.2 2-1.1 2.6-0.6 0.5-1.3 0.9-2.1 0.7q-0.6-0.1-1-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s85",
    d: "m230.7 14.5c-0.9 0.9-1.7 1.8-1.6 3.1q-0.1 0.3-0.1 0.5-0.5 0.8-1.4 1c-0.9 0-1.8-0.4-2.8-0.4-3.1 0-3.7-2.1-3.7-4.6 0-1.2-0.5-2.2-0.8-3.2-0.4-1.7-1.9-3.7 1.1-4.6q0.8-0.1 1.5 0.4c1.2 1.4 2.2 0.1 3.3-0.1 1.6-0.3 3.1-0.6 2.9 1.8-0.7 1.2-1.4 2.4-2.2 3.6-0.7 0.9-1.5 2.1-0.7 3 1.4 1.5 1.1-1.1 2-1.1 0.8 0.1 1.6 0.4 2.5 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s86",
    d: "m229.1 8.4c-0.7-1.3-2.2-1.4-2.7-0.5-1.7 2.7-2.9 1.2-4.2-0.2 0.1-2.4 2.1-2.6 3.6-3.4 1.1-0.2 2.1-0.9 3.2-0.3 0.5 0.3 0.8 0.8 0.9 1.4q0.8 1.1 1.5 2.3-1.1 0.3-2.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s73",
    d: "m227.6 22.2q-0.4 0-0.8 0c-0.5-0.2-0.9-0.4-1.1-1 0.1-2.2 2.8-1.9 3.4-3.6q0.4-0.4 0.8-0.8c1.8-0.9 2.7 0.8 4 1.3 0.7 0.9 1.2 1.8-0.2 2.6-0.8 0.5-1.8-0.4-2.7 0.2-1.1 0.5-2 1.4-3.4 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s77",
    d: "m227.6 22.2q1.5-1.5 3.1-3.1c0.6 0.7 2 0.9 1.5 2.3q-0.8 0.4-1.5 0.8-1.6 1.1-3.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s87",
    d: "m227.6 22.2h3.1q-0.4 0.7-0.8 1.5-1.6-0.1-2.3-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s88",
    d: "m107.4-0.7c0.9 0.8 2 0.7 3 0.7 0.9 0.7 2 0.4 2.9 0.5q0.5 0.2 0.7 0.7c0.5 1.3-0.6 2.3-0.9 3.5q-0.4 0.8-1.1 1.1c-1.1 0.3-1.8-0.1-2.4-0.9-0.3-0.6-0.6-1.1-1.2-1.4-1-0.1-1.9 0.2-2.9-0.1-1.1-0.3-2.4-0.3-3.4-0.9-1-0.7-1.8-1.4-2-2.7 0.1-0.6 0.4-1 0.9-1.4 1.4-0.2 2.6-1.1 4.1-0.9 0.9 0.3 1.8 0.7 2.3 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s89",
    d: "m112.7-2.3c0.2-0.5 0.5-1 0-1.5-0.6-0.8-0.3-1.5 0.4-2 0.6-0.3 1.2-0.3 1.8-0.2 1.2 0.6 1.8 1.9 3.1 2.4 0.7 0.8 0.9 1.7 0.6 2.7q-1.3 1.8-3.4 2.8c-0.9 0.2-1.3-0.5-1.7-1.1-0.5-1-0.1-2.2-0.8-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s90",
    d: "m105.1-1.5q-1.9 0.4-3.9 0.8c-1.4-2.4 0.7-3 2.1-3.9 0.6-0.5 1.1-1.1 1.9-1.2 1.4 0.5 3.2 0.5 2.9 2.8q0 0.3 0 0.7c-0.8 0.8-1.7 1.6-3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s91",
    d: "m112.7-2.3c2 0.6 1.9 1.7 0.8 3.1-1.2 0.5-2.2 0.2-3-0.8 1.7 0.3 1.8-1.2 2.2-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s80",
    d: "m105.1-1.5q1.5-0.4 3-0.8c0.6 0.9 1.7 0.4 2.5 0.9-1 1.1-2.2 0.5-3.2 0.6-0.9 0-1.7-0.1-2.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s92",
    d: "m229.9 5.4q-0.4-0.4-0.8-0.8-0.3-0.3-0.7-0.6c-1.2-0.4-2.6-0.4-3.8-1.1q-0.9-0.8-0.9-1.9c0.9-3.7 3.2-5.5 7-5.6q0.3 0 0.7 0c2.7 3.8 1.4 7-1.5 10z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s93",
    d: "m27.7-1.5c0.2-1.1 0.8-1.1 1.6-0.8 0.8-0.6 1.7-0.8 2.5 0.1 0.3 1.3 1.2 2.3 2.5 2.3 2.4-0.1 4 1.6 6 2.4 0.2 0.8-0.2 1.3-0.5 1.9-0.3 0.8-0.5 1.7-1.1 2.3-0.6 0.6-1.4 0.9-2.3 1.1-0.6 0-1.2-0.3-1.9-0.2-1.5 1.5-3.1 2.4-5.3 1.9q-0.5-0.1-1-0.3-0.7-0.5-1-1.3c-0.6-2 1.5-3.5 0.8-5.5 0.2-0.7 0.3-1.4 0.2-2.2-0.1-0.6-0.4-1.1-0.5-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s94",
    d: "m26.2-1.5q0.4 0 0.8 0h0.7c0.9 0 1.7 0.1 2.3 0.8q-0.2 0.2-0.4 0.5c-1.5 0.6-3 1.1-3.4-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s95",
    d: "m76.8-4.6q0.3 0 0.7 0c0.6 0.6 0.6 1.4 0.7 2.1 0 0.6 0.1 1.1 0.6 1.5q0.3 0.3 0.7 0.7c0.5 0.5 1.4 0.8 1.9 1.5 0.3 0.7 0.5 1.3 0.1 2-1.7 0.9-3.6 1.1-5.4 1.6-1.6-0.5-2.9-1.4-4.3-2.4q-0.3-0.4-0.6-0.9c-0.2-0.7-0.2-1.4-0.2-2.1 0.2-0.9-0.2-1.9 0.4-2.8 0.5-0.5 1.1-0.7 1.7-0.7 1.3 0.2 2.3-1.4 3.7-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s96",
    d: "m76.8-2.3c-0.7-1 0.5-1.5 0.7-2.3q0.4-0.8 0.8-1.5c0.4-1.6 1.2-2.2 2.9-1.6 1.8 0.6 3 1.3 2.2 3.4-0.6 2.8-1.9 4.6-5.1 4.3-1-0.4-1.3-1.4-1.5-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s97",
    d: "m191.6-7.6q0-0.4 0-0.8c2.3-0.8 4.6-1.7 7-2.3 0.8-0.2 2.2-0.7 2.3 0.9 0.1 1.8-1.7 0.7-2.6 1.1 0.9 2.1 2.9 0.8 4 1.8q0.4 0.4 0.4 1c-0.1 0.6-0.4 1-0.9 1.3-1.3 0.8-2.8-0.2-4.2 0.2 0.3 1 1.5 1.1 1.9 2 0.5 1.2 0.1 2-1 2.6-2.8 0.4-5.7 0.2-8.4 1.3-1.3-1.7-5.2-1.4-4-5.1q0.3-0.5 0.8-0.8 0.5-0.3 1.1-0.3c2.2 0.3 3.4-0.7 3.6-2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s98",
    d: "m202.3-6.1q0-0.4 0-0.8c0.1-1 0.1-2 1.6-1.5q1.9-0.8 3.8 0c1.8 1.6 3-0.8 4.6-0.8 2.7 1.5 1.9 3.6 1.1 5.8q0 0.7-0.1 1.5c0.3 4.2 0.1 4.5-4.3 3.9-1-0.1-2 0-2.9-0.6-1.4-1.1-1.2-2.6-1.5-4-0.3-0.6-0.9-0.9-1.3-1.3-0.7-0.6-0.6-1.5-1-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s99",
    d: "m129.6-3.8c1.7-0.2 3.2 0.5 4.6 1.5 0.7 1.2-0.7 3.7 2.2 3.5 0.9 0.3 1.6 1 1.9 1.9 1.9 4.4 1.3 6.2-2.6 7.7-1.3-0.3-2.5-0.7-3.6-1.5-2-2.3-4.7-0.8-7-1.4q-0.4-0.1-0.8-0.4c-0.5-0.4-0.9-0.6-1.6-0.5q-0.9 0.2-1.9 0-0.5-0.2-0.9-0.4c-0.6-0.5-1-1.1-1.3-1.7-0.3-1-1.1-1.9-0.9-3.1q0.1-0.5 0.4-1c0.5-0.6 0.9-1.3 1.6-1.6q1.1-0.4 2.2 0.1c1 0.7 1.3 2.2 2.7 2.4 0.4 0.3-0.1-0.1 0.3 0.2-0.1-0.2-0.2-0.2-0.4-0.3-1-0.4-1.8-1-1.4-2.2 0.4-1.3 1.4-1.6 2.7-1.3q0.9 0.1 1.8 0.1 1-0.1 1.3-1 0.1-0.6 0.7-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s100",
    d: "m129.6-3.8q0 0.7 0 1.5c-0.3 0.5-0.8 0.7-1.3 0.7-1-0.2-1.8 0.4-2.6 0.8-0.7-0.2-1.5-0.6-1.8 0.4-0.3 0.8 0.8 0.7 1.1 1.2 0.5 0.9 0.5 1.5-0.8 1.5-1.3-0.2-1.8-1.3-2.3-2.3-1.4-1-2.9-1.9-1.7-4 0.4-0.8 1.2-1.2 1.5-2.1q0.3-0.5 0.7-0.8c2.6-2.3 4.3-1 5.6 1.6 0 1 1.1 1 1.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s101",
    d: "m134.9-3c-1.2-1-2.9-1.8-1.5-3.9 0.4 0.5 1 0.8 1.7 0.9 1.7 0.7 3.8-0.4 5.4 1 0.9 1.2 0.5 2.4 0 3.6q-0.2 0.5-0.6 0.9c-0.8 0.6-1.7 0.3-2.6 0q-0.5-0.2-0.9-0.5c-0.6-0.6-0.9-1.4-1.5-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s95",
    d: "m134.9-3q1.6 0.1 2.3 1.5c-1.3 0.9-0.7 2.7-1.5 3.8-1.3-0.2-3.2 0.6-3.7-0.9-0.6-1.6 1.7-2.3 2.2-3.7q0.4-0.4 0.7-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s90",
    d: "m146.4-5.4q0-0.3 0-0.7c1-0.5 2.1-1 3.1 0q0 0.2 0.1 0.5c0.8 1.1 1.7 2.3 0.9 3.8-0.6 1-1.4 2-1.9 3.1-1 1-2.1 2-3.8 1.7-0.8-0.1-1.7 0.1-2.5-0.5-1.2-1.6 0.5-3.3-0.2-4.8q0-0.5 0.1-1c0.3-0.5 0.6-0.9 1.2-0.5h0.7c0.8-0.4 2.1-0.3 2.3-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s90",
    d: "m149.5-6.1q0.8-0.4 1.5-0.8c0.5-0.4 1.1-0.3 1.7-0.2q0.3 0 0.7-0.1c0.6-0.1 1.2-0.1 1.7 0.2 0.8 0.4 1.2 1.1 1.6 1.8 0.2 1.4 1.5 1.7 2.4 2.4 1.6 3.1-0.8 2.9-2.6 3-0.9-0.1-1.7-0.6-2.6-0.7-0.9-0.5-1.9-0.8-2.7-1.5-0.3-1.4-1.9-2.4-1.7-4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s93",
    d: "m13.2-4.6c1.6-0.9 4.3-0.1 4.6-3q0.4 0 0.7-0.1c0.9-0.6 1.8-0.5 2.6 0.1 1.2 1.3 1.7 2.9 1.6 4.6-0.1 1.4-1.2 2.4-1.5 3.7 0 1 0.9 1.7 0.8 2.7-1.4 2.6-4 1.2-6 2-1.3-0.2-2.1-0.9-2.7-2.1-0.6-1.4 0.3-2.5 0.9-3.6 0.4-2.4-2.1-0.4-2.6-1.7q-0.3-0.4-0.3-0.9c0.1-1.1 1.1-1.3 1.9-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s97",
    d: "m117.3-3.1c-0.6-2.5 2.7-2 3.1-3.8-0.7-0.7-0.6-1.5 0-2.2v-0.8c0.8 0.8 1.7 1.6 3.1 1.5q-0.4 1.2-0.8 2.3 0 0.4 0 0.8c0.5 1.5-1.3 0.7-1.5 1.5-1.1 1.5 0.5 2.5 0.7 3.8h-2.3q-0.7 0.1-1.3-0.3-0.1-0.2-0.2-0.5-0.4-1.1-0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s98",
    d: "m219.2-6.1q0.7-0.8 1.5-1.5c0.7 0.3 1.6 0.4 2.2 1.1 0.3 0.3 0.7 0.5 1.1 0.7 0.2 0.1 0.3 0.2 0.3 0.1 0.4-0.2-0.1-0.2-0.1-0.4-0.7-1.2-0.5-2.2 0.3-3.1 1.3 1.2 3 1.8 4.6 2.3 1.4 0.2 0.3 2 1.6 2.3-2.1 1.8-5 2.6-6.2 5.4q-0.4 0.4-0.9 0.7-1.1 0.5-2.1-0.3c-1.1 0.4 0.7-2.8-1.6-1.1-1.1 0.8-2.1 0-2-1.5 0.1-0.8 0.8-1.1 1.3-1.7v0.1c0.5-1.1-0.2-2.1 0-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s102",
    d: "m10.9-8.4h-1.5c-0.5 1.6 1.3 3.6-1.2 4.7q0.4 0.5 0.6 1c0.4 1.7 1.4 3.8-1.6 4.2-1.9-0.2-3.1-2.1-5.1-1.9-1 0-1.9 0.1-2.7-0.2-0.8-0.3-1.2-0.9-1.2-1.7 0.1-1 0.8-1.4 1.5-1.9 0.3-0.2 0.5-0.5 0.4-0.9-0.4-1.8 0.4-3 1.6-4q0.8-0.8 1.5-1.6c1.4 0 2.2 2.5 3.9 0.8 2.2-1.9 3-0.1 3.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s103",
    d: "m95.1-8.4v0.8c0.3 1.2 1.7 0.8 2.3 1.5 1.6 3.3-2.4 2.1-3 3.7-0.8 0.7-1.6 1.3-2.8 1.2-0.4-0.2 0.2 0.2-0.3-0.1q0.1 0.1 0.3 0.1c1.3 0.1 2.1-0.6 3-1.4 0.8-1 1.7-0.8 2.4 0.1 0.7 0.9 0.8 1.9 0.2 2.8-0.8 1.1-1.7 2.2-1.7 3.6-1.5 2.6-4.1 2.1-6.4 2.5-0.9 0.1-1.7-0.3-2.6-0.3-4.2 0.7-4.2 0.6-4.8-3.7-0.1-0.5-0.6-0.8-1.1-0.9q-1.6-0.1-2.3-1.5c2-0.9 3.7-2.1 3.8-4.6q0.8 0 1.5 0c0.5 0.5 1.3 0.6 1.7 1.1 0.8 0.9 1.3 1.8 1.7 2.6-0.4-0.7-0.7-1.6-1.5-2.4-0.5-0.6-1.3-0.8-1.9-1.3-0.3-2.8 2.3-2.8 3.8-3.8 1.3 0 2.7 0.1 3.1-1.5q0.8 0 1.6 0c0.5 1.5 2.8-0.5 3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m36.2 187.4c-2-1.1-3.3 0.1-4.9 1 1.2 1.4 3.9 0.8 3.9 3.7-3.5-3-5.1 2.4-8.2 1.4q-0.3 0.1-0.5 0.1c-3.6 0.8-3.7 1.4-1.2 4.7q0.1 0.3 0.1 0.5v0.8c0.3 2-1.9 0.4-2.3 1.5q-0.3 0.8-0.7 1.6-0.3 0-0.5 0.1c-1.7 0.5-2.7-0.2-3.4-1.7 1.1-0.4 2.1-0.7 3.5-1.3-2.8-2-5 0.4-7.3 0.6-0.3 1.2-0.9 1.9-2.3 1.5-1.7-4.3-3.8-0.6-5.8-0.2q-0.2-1.5-0.3-2.9 0-0.2-0.1-0.4c-0.2-0.9 0-1.7 0.6-2.4 0.6-0.8 1.8-0.8 2.5-1.7-1.4 0.5-2.3 0-3.1-1.1-0.3-0.6-0.8-1.2-1.1-1.7-0.1-2.8-3.2-3.9-3.6-6.5 3-2.6 6.8-1.4 10.2-1.8q0.5 0 1 0.2c2.3 2.2 3.5-0.7 5.3-1 1.5-0.8 3-1.4 4.2 0.4 0.5 1.1 0.9 2.1-0.1 3.1 0.1 0-0.2 0.1-0.2 0.1 0 0 0.2 0.1 0.3 0.1 0.7-0.3 1.4-0.6 2.2-0.4 0.9 0.3 1.7 0.7 2.2 1.5 0.3 0.8-0.1 1.5-0.2 2.3 2.4-2.7 4-6.4 8.6-5.4 0.7-0.1 1.2-0.4 1.8-0.5 1.3-0.2 2.4 0.3 2.6 1.6 0.2 1.5-0.9 1.8-2.2 1.8-0.3 0-0.7 0.3-1 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s104",
    d: "m1.7 185.1c2.1 1.6 5 2.6 4.6 6.1 0.9 2.6-0.9 3.7-2.7 4.7 1.2 0.6 3.7 0.1 2.7 2.9-2.2 0.9-4.2 2.7-6.9 1.6-0.7-0.5-1.7 0.2-2.4-0.4-0.7-0.4-0.8-1.4-1.4-1.9-0.6-0.9-1-2.1-2.3-2.3q-0.4-0.4-0.8-0.8c0.5-0.6 1.3-1.3 1.9-1 3.3 1.6 3.3-0.7 3.5-2.8-1.3 0-1.8-0.5-1.7-1.9 0.2-1.4 0.4-2.9-1.4-3.5q0-0.7 0-1.5 0.8-0.8 1.5-1.5 3.3-3.5 5.4 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m5.5 205c2.7 0.3 6.1-0.8 6.7 3.7-2.9-0.2-5.2-1.2-6.7-3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m22.4 202.7q0.4 1.5 0.7 3-3.4-0.4-6.8-0.8c0.9-1.2 1.6-2.1 2.3-3 1.2 0.1 2.3 1.3 3.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m-2.9 199.6c0.9 0 1.7 0.1 2.3 0.8-0.8 0.9-1.8 1.7 0 2.8 0.9 0.6-0.3 0.8-0.8 1-1.4-0.5-2.5-3.6-4.5-0.8q-0.1-0.4-0.1-0.7c-0.6-2.8 1.1-3.1 3.1-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s105",
    d: "m23.1 205.7q2.7-0.7 5.4-1.5c-1.9 0.2-2.3 5.4-5.4 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s106",
    d: "m12.4 201.9q1.2-0.8 2.3-1.5c0.4 0.4 1.9 0.6 1.1 1.3-0.7 0.5-2.1 2.5-3.4 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m22.4 202.7c-1.7 1.6-2.6-0.2-3.9-0.8v-0.8q2 0.8 3.9 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m36.2 187.4q0.3-0.5 0.6-0.9c0.5-0.5 2.3 0 1.7-1.3-0.7-1.3-1.7-0.2-2.5 0.3q-0.3 0.1-0.6 0.3c-2.3-1.8-0.5-3.2 0.8-4.1 1.4-1 3.3-1.7 4.8 0.2 0.4 0.6 0.1 1.5 0.9 1.9 1.9 0.6 1.3-1.6 2.2-2 1-0.6 1.8-0.3 2.8 0.3 1.1 0.6 2.5 1.6 4.5 0.5-3.9 0.6-4.5 0.1-4.2-2.8-1.3 0.5-2.1 1.6-3.3 2.2-0.7 0.5-0.3 1.8-1.5 1.9-3.4-4.3-3.6-4.3-8.1-0.2-0.8 0.8-1.6 1.1-2.7 0.9-0.9-0.7-1.2-2.2-2.9-1.6-1.1 0.4-2.4 0-3.3-1.1-1.2-1.8-2.2-3.6-0.2-5.5 2-1.2 3.9 1.6 6.1 0.1 1-0.7 1.5-1.1 1.9-2.3 1.2-4.1-0.9-8.7 1.8-12.5 0.2-0.4 0.5-0.9 0.8-1.3 2.6-1.2 4 1.9 6.3 1.6 1.4 0.6 2.4 1.4 2.1 3.3 0.8-2 0.2-2.9-1.7-3.1-1.7-0.6-3.7-0.9-4.1-3.2q-0.1-0.9 0.2-1.7c0.6-0.9 1.5-1.6 2.2-2.5 2.4-2.8 5-5.3 9.1-4.7q0.6 0 1.1 0.2c1.3 0.1 2.1 0.9 2.9 1.8 0.9 1 2.2 1.8 1.5 3.5-0.6 0.6-1.3 0.8-2.1 0.8-1.6 0.3-2.8-1-4.3-1.2-1 1.4 0.4 2 0.9 2.9 0.3 0.6 0.5 1.2 0.9 1.8 0.3 0.7 0.9 1.2 1.5 1.7 1.1 1.5 2.6 0.4 3.9 0.7 0.9 0.6 1.9 1 2.9 1.5 1.4 1.1 2.3 2.5 2.2 4.3-0.7 2.4-2.4 1.6-3.8 1.3 2.3 1.4 4.3 0.8 6.1-1.2 0.8-0.3 1.5-0.2 2.2 0.2 0.5 0.4 0.6 1 1.1 1.3 1.4 8.8 3.6 17.4 5.7 26.1 0.2 0.7 0.2 1.5 0.3 2.2 0.2 1.3 0.7 6.5 0.7 8.9 0 1.4 0.7 2.1 1.1 3.1 0.8 2 0.2 3.3-2.1 3.2-0.9 0-1.7-0.4-2.7 0-1.3 0.5-2.8 1.6-4.2 0.1-1.3-1.5-0.3-3.1 0.5-4.6-1.5 0.2-2.9 0.3-4.3 0.5-2.5 0.3-3.6-0.7-3.2-3.3 0.3-1.1 0.9-2.3-0.6-3-1.6-0.8-1.3 1.4-2.3 1.7-0.6 0.1-0.7 1-0.9 1.6-2.1 3.1-2.5 3.1-5.1 0.5-1.4-2.3 0-4 1.4-5.6 0.4-0.6 0.9-1.2 1-2 0.7-3.1 3.2-4.1 6.1-2.6 2.9 1.4 2.9 1.4 6 0.8-2 0.4-3.9 1-5.8-0.6-1.9-1.5-4.3-1.1-6.3 0.1-1.2 0.8-2.2 1.6-3.2 0.3-1-1.3-0.5-2.8 0.7-3.7 2.2-1.7 4.1-3.7 6.1-5.5-0.3-0.5-0.4 0.2-0.6 0.2-3 2.2-5.9 1.7-9.6-0.5 1.3 2.9 0.1 5 0.7 7.2 0.4 1.6-1.1 2.3-2.5 2.1-1.4-0.2-2.7 0-4 0.6-0.7 0.2-1.4 0.1-2.1-0.2-0.2-1.7 1.2-3.7-0.8-5.4q2.4 0.8 4.8 1.6c-2.2-1.8-4.3-3.6-5.5-6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m48.4 219.5c-0.9-1.8-3.4-2.3-3.8-4.6q0-0.8 0-1.5c1-2.6 2.6-2.3 3.9-0.6 1.5 1.8 3.1 2.6 5.4 3.1 2.5 0.6 4.1 3.7 7.3 3.4 4.7 0.2 9.1 2.3 14 1.8 2.6-0.3 4.6 1.1 5.5 3.7 0.2 1.2 0.7 2.4 0.2 3.7-2.4 1.7-4.6 0.6-6.8-0.5-1.3-0.6-2.5-1.5-4.1-1.3-2.1-0.1-4.1-0.9-6.3-0.9-1.1 0-1.8 0.3-2.4 1.2-1.5 1.4-3 2.8-5.2 2.4-1.2-0.2-2.6 0.6-3.4-1 0.3-0.2 0.5-0.6 0.8-0.7 0.8-0.2 2.5 0.5 2.1-1.2-0.2-1.2-1.7-1.5-2.8-0.8-0.8 0.6-1.7 1.5-2.4 0.2-0.8-1.6 1-0.8 1.5-1.4 0.3-0.5 0.5-1.2 0.1-1.3-2-0.6-1.3-3.5-3.6-3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m60.7 221c-1 0.1-1.9-1.6-3-0.2-0.4 0.4-1.2 0.6-1.3 0.3-0.7-5.5-8.3-2.5-9.3-7.8-0.3-1.5-1.6 0.2-2.5 0.1-0.5-0.6-1.1-1-1.5-1.6-1.7-0.9-2.5-2.6-3.9-3.8 0.2-0.5 0.5-1 0-1.5q-0.4-0.4-0.3-1c0.2-0.3 0.4-0.8 0.7-0.8 3.8 0.3 7.6 0.1 11.1 1.8 1.3 0.9 2.7 2 3.1-0.8 1.2-1.1 2.6-1.7 4-0.7 1.5 1 0.7 2.2 0 3.5-0.6 1.1 0.8 1.7 1.4 2.4 2.6 3.1 2.8 6.5 1.5 10.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s104",
    d: "m50.7 206.5c-4 2-7.6-0.5-11.5-0.8-1 0.4-1.7 0.2-2.3-0.7v-0.8q0.3-0.4 0.7-0.8c0.8-0.8 2.1-0.8 2.8-1.9 0.6-3.7 0.6-3.7 5.3-2.7 1.9 1.7 5.1 0.5 6.5 3.1-0.5 1.5-2.8 2.4-1.5 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m37.7 204.2h-0.8c-0.6-1.3-0.1-2.5 0.8-3.4 1.4-1.2 0.9-2.3 0-3.5q0.8-0.4 1.5-0.8c2.7-0.2 5.6-0.9 6.1 3.1-1.2 1.2-2.4-0.8-3.5-0.2-1.1 1.5 3.2 1.6 0.5 3.3-1.9-0.7-3.2 0.5-4.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m30.8 201.9c-0.3-0.9-1.5-1.4-1.4-2.8 1.9-0.6 4.2 0.8 6.1-0.7 0.5-0.4 1.3 0.9 0.7 1.1-2.6 0.7-0.9 2.8-1.4 5-1.1-2.2-2.4-2.8-4-2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s30",
    d: "m27 193.5q1.1 0.7 2.3 1.5-0.1 0.7-0.8 0.8c-2.2-0.2-1.5 2.5-3.1 3-2-2.8-1.5-4.6 1.6-5.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m23.1 201.1c0.4-1.1 1.6-1 2.3-1.5 2.6 1 3.5 1.9 2.5 2.6-1-2.2-2.9 2.2-3.8-0.6-0.1-0.2-0.6-0.3-1-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s107",
    d: "m28.5 195.8q0.4-0.4 0.8-0.8c0.8 0.7 2 1.1 1.6 2.5-0.1 0.2-0.6 0.4-0.9 0.4-1.3-0.1-1.4-1.1-1.5-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m36.9 205q1.2 0.3 2.3 0.7 0 0.4 0 0.8c-1 0.6-2.1 0.7-3.1-0.1-1.7-1.4 0-1.3 0.8-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m39.2 208q2.7 1.2 3.9 3.8c-2.3-0.3-3-2.1-3.9-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m43.1 211.8q1.2 0.3 1.5 1.6c-0.5-0.5-3.2 1.1-1.5-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s108",
    d: "m56.1 229.4c1.4-1.1 2.6-2.7 4.6-3 1.5-0.6 3-0.6 4.3 0.6q0.5 0.3 0.8 0.9c0.2 1.1-0.3 1.9-1.3 2.3-3-0.7-5.6 1.1-8.4 1.5q0.5-1.1 0-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m43.8 224.8c-0.6-1.5 0.2-3 0-4.5 0.7 1.7 3.7 2.8 1.6 5.3-0.6-0.1-1.1-0.4-1.6-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s109",
    d: "m43.8 224.8q0.8 0.4 1.6 0.8c0.3 0.8 0.2 1.4-0.8 1.5q-0.4-1.1-0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s23",
    d: "m17.6 229.2c-0.1 0.3-0.1 0.6-0.2 0.8-0.2-0.2-0.5-0.4-0.7-0.6-0.1-0.2 0.1-0.5 0.1-0.7q0.4 0.3 0.8 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s110",
    d: "m50.7 151.4h-0.8c-1.9-0.3-2.5-1.8-3.1-3.3-0.4-0.6-0.5-1.3-0.5-2 0.3-0.9 0.3-2 0.7-2.9 0.7-1.3 2.1-1.4 3.2-1.8 1.5 0 3 0.8 4.6 0.1q0.2 0 0.5 0c1-0.7 2.1-1.3 3.1-1.2 0.6-1.9-3.6 0-1.6-2.6q0.4-0.4 0.8-0.6c1.3-0.1 2.7-0.2 3.9-0.7 1.7-0.5 3.2-1.5 4.9-2 1.9-0.4 3.3-0.3 4.4 1.6-0.9-3 2.4-4.6 2.3-7.6-0.1-0.9 1.8-0.9 2.9-0.3q0.5 0.2 0.9 0.6c1.7 1.3 3.6 2.5 2.1 5.1-4.3 5.6-8.2 11.4-11.4 17.8-1.8 3.5-0.6 7.1-1.6 10.5-0.4 1.7-0.9 3.3 0.7 4.6l0.1 0.1c0.3 0.9-0.3 1.6-0.8 2.2q-1.1 0-2.3 0c-0.8-1.1-2.5 1.4-3-0.7q-1.2-2-2.3-3.9-0.9-1.2-2.3-1.5c-1.8 1-3.6 2.3-4.6-0.8 0-0.4 0-0.7-0.2-1.1-0.7-0.7-1.4-1.3-2.1-1.9-0.9-0.2-1.4-1-2.1-1.5-2-1.4-1-3.1 0-4.1 0.9-1 2.8-1.1 3.9 0.3 0.5 0.8 1.1 1.3 2 1.5 0.8 0.6 1.5 1.4 2.3 0-0.7-0.8-2.1-1-2.3-2.3-0.5-2.3 1-2.8 2.7-3.2-1.8 0.3-3.3 1.3-5 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m57.6 137.7q-0.4 0-0.8 0c-0.7-1.3 2.1-2.6 0-3.9 2.1-1.7 4.1-3.6 5.4-6.1 1.6-0.2 3.3-2 4.7 0.4 0 0 0.2 0.2 0.2 0.2 0 0 0.1-0.3 0.2-0.3 0.9-1.1 1.7-0.3 2.6 0.1 0.6 0.1 0.8 0.5 0.8 1.1 0.2-0.9-0.4-1.1-1-1.3-2.4-2.3-4.9-0.9-7.4-0.3q-0.4 0.4-0.8 0.7c-0.8 0.6-1.8 1-2.7 1.4-1 0.5-2.5 0.3-2.6-0.7-0.3-3-3.6-3.8-4.2-6.5-0.4-1.3 0.5-2 1.1-2.9 1.5-0.8 1.9-2.4 3.1-3.5 0.9-0.7 2-0.6 3-0.8q4.3 1.6 8.7 3.1c0.6 2.4 2.2 1.2 3.5 1q5.3 1.5 10.7 2.9c-1.4 2.9-2.4 6.1-6.1 6.9-0.6-0.1-1.5-0.7-1.8-0.5-0.9 0.7 0.3 0.9 0.6 1.3 0.6 0.7 0.6 1.2-0.2 1.9-1.1 1.1-4.6 1.3-1.5 4.1 0.3 0.3-0.6 2.5-1.4 3.2-0.9 0.8-1.8-0.6-2.7-1-2.2-0.8 0.6-2-0.2-3.2-1.7 1.6-4.4 0.9-5.7 3.2-0.1 0.1-1.1-0.3-1.7-0.5-1.2-0.5-2.5 1.1-3.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m19.3 104q0.8-0.4 1.5-0.8c3.4 0.3 6.4 3.2 10 1 1.3-0.7 2.3 0.6 4 1.4-1-1.5 0-3.1-1.7-3.9 0.9-1.5 2.3-1.5 3.8-1.5 0.6-0.4 1 0 1.3 0.4q0.1 0.5 0.2 1c0 0.6 0.2 1.2 0.8 1.4 0.6 0.4 1.1 0.9 1 1.6q-0.1 0.4-0.5 0.5c0.1 0.1 0.3 0 0.4 0 0.7-0.3 1.2-0.1 1.7 0.4 0.5 0.6 0.4 1.3 0.1 2-0.2 0.5-0.5 0.9-0.7 1.3-2.2 3.9-2.2 3.9 1.7 6.1 0.7 0.8 1 1.6 0.8 2.7-0.3 0.8-0.9 1.2-1.6 1.6q-0.5 0.2-1 0.2-0.5-0.1-1-0.3c-0.6-0.3-1-0.9-1.5-1.3-2-0.5-4.2-0.8-4.5-3.4 0.1 0 0.2 0.2 0.2 0.2-0.4 3.4 2.7 3.2 4.4 4.5q0.4 0.7 0.2 1.5c-0.3 1.1-1.5 1.5-2.1 2.5-2.7 1.9-4.2 0.2-5.5-1.9-1-2.1-0.4-5-2.8-6.5-1.1-1.2-3.7-0.8-3.8-1.7-0.2-1.7-1.8-1.9-2.4-2.8 0.7-1.3 2-0.4 2.7-1.2-2.5-1-4.8-2.2-5.7-5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m52.2 122.4c2.2-0.2 2.1-0.2 2.2 1.6 0 0.4 0.4 0.9 0.8 1.2 1.7 1 1.3-1.6 2.5-1.5 1.4 1.9 1.1 3.4-1.3 4.5 2.2 1.6 3.3-1.5 5-0.5 0.8 1.9 0.2 3-1.6 3.9-1.7 0.9-3.1 0.6-4.6-0.4-1-0.8-1.3-1.9-1.7-2.9 0.1 0.1-0.1 0.1 0 0.1q0.3 1.5-1.1 2c-0.8 0-1.3-0.6-1.7-1.1-1-0.2-1.6-1-2.3-1.6-0.5-0.5-1-0.6-1.5 0 0.3 0.8 0.3 1.4-0.8 1.6-1.3-0.7-2.7-0.4-4-0.5-2.1-0.1-3.6-1.7-3.8-3.4-0.1-1.8 1.6-3 3.6-3.1 1.4 0.2 2.8 0.2 4-0.7 1-0.4 1.6-1.3 2.6-1.7 2.2-0.6 3.8-0.4 3.7 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m-1.4 126.2c-1-0.5-2-1-2.3-2.3 1.6-0.9 3.9 0.1 5.1-2 0.7-1.3 2.2-0.8 3.4-1.1 0.5 0 0 1.1 0.7 0.8 1.5-0.2 1.9-1.7 3.1-2.3 1 0.9 2.1 0.8 3.2 0.3 3.7-1.6 3.8 1.5 4.5 3.5 0.4 1.1-0.5 1.4-1.3 0.9-1.3-0.7-2.5-1.6-3.9-2.6q-1.7 2.8-3.3 5.6c-0.4 0.3-1.2 0-1.5 0.7q-0.4 0.4-0.8 0.8c-1.9 0.7-2.9-1.4-4.5-1.6-0.8-0.2-1.7-0.1-2.4-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s110",
    d: "m42.3 123.1c-1.4 0.3-3.4 1.5-2.9 2.3 0.7 1.1 1.3 3.3 3.6 2.9 1.2-0.2 2.2 0.1 3.1 0.9-2.3 0-4.7-0.3-6.2 2.7-0.9-1.7 0.6-4.5-2.4-3.9-2 0.4-4 1.2-5.9-0.3-0.9 0.1-1.6-0.2-2-1-0.4-1.3 0.4-2.2 1.4-2.9 1.4-0.8 2.7 0.1 4 0.1 2.1 0.1 2-0.9 1.2-2.3 0.1-2.2 1.7 0 2.3-0.8 1.6-2.3 2.4 0.1 3.5 0.6q0.4 0.4 0.6 0.8 0 0.5-0.3 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s111",
    d: "m53 127q1.2 1.1 2.4 2.3c2.7 2.7 4.8 2.1 6-1.6h0.8c0.7 3.8-0.4 5.1-5.4 6.1-0.9 0.5-1.7 0.3-2.2-0.6-0.8-1.5-1.6-0.9-2.4-0.1-0.5 0.4-1 0.4-1.5 0 1.9-2.4-1.6-1.2-1.5-2.3 0.9-0.6 2-0.7 3-0.8 1-1 0.1-2 0-3q0.4-0.6 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m9.4 130.8c-0.4-2.7 0.5-3.6 3.4-2.9 2.8 0.6 5.9 0.4 8.8 0.6 1.1 0.1 2.7 0 2.5 1.6-0.2 1.3-1.6 0.9-2.6 0.8q-1.5-0.1-2.9-0.1c-0.6 0.5-0.9 1.1-1.7 1.3-2.5-0.3-5-0.7-7.5-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s112",
    d: "m32.3 137.7q1.3-3.1 4.6-3.1c2.5-1 4.6 0.3 6.9 0.8 1.3 0.9 2.5 0.9 3.8 0 0.5-0.3 1.1-1 1.5-0.1 0.2 0.3-0.4 1-0.7 1.6-0.3 0.8-1 1-1.8 1.2-0.7 0.1-1.4 0.4-2.1 0.5-1.5-0.4-2.8-0.8-4.2 0.4-1.3 1-2.9 0.4-4.4 0.6-1.3-0.1-2.7 0.1-3.5-1.4q0-0.3-0.1-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m17 131.5q0.8-0.3 1.5-0.7 0.4 0.7 0.8 1.5c0.5 0.8 0 1.3-0.6 1.8q-0.5 0.1-0.9-0.3c-2.5 0.6-5.2 0.4-6.9 3.2-0.9 1.5-2.9 1-3.8-0.9-0.7-0.6-0.7-1.4-0.8-2.3q0.4-0.3 0.8-0.7c1-1.1 2-0.2 3 0q0.4-0.4 0.8-0.8c1.8-1.9 4.2 0.5 6.1-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m31.6 124.7q-0.8 1.1-1.6 2.3-0.1 0.1-0.3 0.3c-0.2 0.1-0.5 0.2-0.7 0.2-0.5 0-0.8-0.5-1.3-0.4 0.4 0.2 0.4 0.6 0.4 0.9-0.3 0.5-0.6 0.8-1.1 0.5-0.6-1.1-1.2-2.2-1.9-3.6-1.1 3.5-2.6 3.2-4.6 0.7 1.4-0.5 2.8-1 3.4-2.5q0.2-0.1 0.5-0.3c2.6-0.5 5.3-0.8 7.2 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m0.9 125.4c2.2 0.1 3.6 1.2 4.6 3.1-0.1 1-0.5 2 0 3h-1.5c-0.9-1.4-2.5-1.6-3.8-2.2v-0.8c-1-1.3-0.5-2.3 0.7-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m17 131.5c-1.8 1.9-3.9 1.9-6.1 0.8q-0.8-0.8-1.5-1.5c1.3-0.3 2.8-0.3 4-0.9 2.1-1 2.8 0.2 3.6 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s113",
    d: "m50.7 136.9c1.3-0.9 2.6-0.3 3.4 0.7 1.3 1.4-1 1.9-1.1 3.1q-0.3 0.4-0.8 0.6-0.6 0.1-1.1 0c-0.9-0.6-1.9-0.9-2.8-1.6q-0.3-0.4-0.4-0.9c0-2.1 2-1.1 2.8-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m23.1 133.1c0.6 0 1.3 0.2 1.8 0 0.9-0.4 1.6-0.6 2.2 0.4 0.8 1.3-0.6 1.2-1.1 1.7-0.5 0.5 0 1.1 0.2 1.7 0.1 1.6-1 1.4-2 1.4-1.7-0.7-2.8-2.1-3.6-3.6 0-1.8 1.6-1.3 2.5-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s111",
    d: "m28.5 114.7c1.8-0.5 3-0.1 3.2 2 0.1 1.1 0.4 2.3 0.6 3.4-0.4 0.4-0.9 0.5-1.5 0.4-0.9-0.9-2.3-1.5-3.1-2.7q-0.3-0.8-0.7-1.5 0.7-0.8 1.5-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s114",
    d: "m43.8 135.4c-2.3-0.3-4.7 0.6-6.9-0.8 0.5-1.7 1.7-2.3 3.1-1.4 1.3 0.8 2.7 1.2 4.1 1.5 0 0 0 0.3-0.1 0.4 0 0.1-0.1 0.2-0.2 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m27.7 117.8c2.1-0.6 3.2 0 3.1 2.3-2.5 2.6-5.3 1.3-8.1 0.5q-0.2-0.3-0.3-0.5 2.7-1.2 5.3-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s113",
    d: "m23.9 137.7c0.9 0 1.7-0.2 2.3-0.8q3.1 0.4 6.1 0.8c-1.4 2.7-5.5 4-7.7 2.5-1-0.6-1.5-1.4-0.7-2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m23.9 123.1c-0.7-0.2-1.5-0.3-2.1-0.6-0.8-0.3-2-0.3-1.7-1.5 0.3-1 1.4-0.8 2.3-0.9 0.8 0.8 4.2 0.4 1.5 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m27 128.5q0.4-0.4 0.7-0.8c0.6-0.8 1.7 0 2.3-0.7q0.8 0.3 1.6 0.7c-1.3 1.9-2.8 2.5-4.6 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m23.1 133.1q-1.1 0.7-2.3 1.5c-1.1 0.8-1.8 0.3-2.3-0.8q0.4-0.7 0.8-1.5c1.4-0.5 2.7-0.2 3.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s110",
    d: "m50.7 136.9c-0.7 0.8-2.1 0.9-2.3 2.3-0.2 0.6-0.5 1-1.2 1-1.7-0.7-2.2-1.8-1.1-3.3q1.2 0 2.3 0 1.2 0 2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s111",
    d: "m27 116.2q-0.2 0.1-0.4 0.2c-1 0.4-2.1 1.1-3-0.2-0.1-0.2 0.1-0.9 0.2-0.9 1.1 0 2.5-0.7 3.2 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m17.9 105.4c0 0.6-0.2 1.1-0.8 1-0.7-0.2-1.5-0.6-1.9-1.1-0.3-0.3 0.4-0.9 0.9-0.9 0.8-0.1 1.5 0.1 1.8 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m50.7 133.1q0.8 0 1.5 0c0.1 1 1.2 1.4 2.1 2.3-2.1 0.2-3.1-1-4.1-1.9 0-0.1 0.1-0.2 0.2-0.3 0.1-0.1 0.2-0.1 0.3-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m6.3 127.7c-0.4-1-1.1-2-0.2-3.3 0.6 0.9 1.2 1.7 1.7 2.6q-0.7 0.3-1.5 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m10.1 133.1c-1 0.5-2 0.1-3 0v-0.8c1.6-2.1 2.1 0.3 3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s110",
    d: "m46.9 127.7c-0.2-0.6-0.9-1.5 0.1-1.7 1.1-0.2 1.2 0.9 1.4 1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s115",
    d: "m52.2 130c-0.8 0.8-1.9 0.8-3 0.8q0.7-0.8 1.5-1.5 0.8 0.3 1.5 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s110",
    d: "m52.2 140.7q0.4 0 0.8 0c0.9 0 1.7 0.1 2.3 0.8-1.1 0.5-2.1 2.1-3.4 0.3q-0.1-0.6 0.3-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m39 83.4c0.8 3 1.4 6.1 0.3 9.2-3.3-0.4-6.7-1.1-10-0.1-3.2-0.5-5.6-2.5-8.5-3.8 2.2-1.4 4.6-1.1 6.9-0.7 0.6-0.4 1.3-0.7 1.8-0.4 4.5 1.9 7 0 8.5-4.2q0.5-0.3 1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m39 83.4q-0.3 0.1-0.6 0.1c-2.9 0.5-5-1.2-7.7-2.2-0.2 1.3-0.7 2.6-0.8 4.1 0 1.3-0.1 2.8-2.2 1.8-2.5-1.3-4.2-2.9-1.8-5.7 0.9-1.1-0.1-1.9-0.5-2.7 1.2-0.4 3.4-0.2 1.4-2.4-1-1.2-1.1-2.6 0.2-3.7q0.4 0 0.7 0c1.8-1.1 3.3 1 5 0.5q0.3 0 0.3 0-0.2-0.3-0.6-0.4c-0.6-0.4-0.7-1-0.6-1.6 0.9-2.4 3-1.8 4.8-1.8q0.6-0.2 1.1-0.6 0.3-0.3 0.8-0.4 0.4 0.1 0.7 0.4c0 4.9 0.4 9.7-0.2 14.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m27.7 87.2c0.7-0.2 1.5-0.8 1-1.2-3-2.5 2.4-4.3 0.4-6.6 0.7-0.1 2-0.5 2-0.4 1.5 3.2 5.9 1.5 7.3 4.5-0.6 7.3-2.5 8.1-10.7 4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m17.8 82.8c0.1 1.7 0.9 2.9-0.2 3.9-0.1 0.2-1-0.1-1.3-0.5-1-1.3-0.1-2.2 1.5-3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m11.7 85.7v-3.9c1.5 0.5 2.3 1.8 2.2 3.1 0 1.1-1.4 0.6-2.2 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s51",
    d: "m37.7 101q-0.4-0.4-0.8-0.8c2.7-2.2 4.8-2.5 6.2 1.4 0.3 1 1.2 1.9 2.6 1.6 0.6-1.1-1.2-2-0.3-3.1 4.7 3.7 6.6 9.8 11.5 13.3 0.8 0.6 1.5 1.3 2.3 1.9q-1.2 0.9-2.4 1.7c-1.6-0.5-2.6 0.9-3.9 1.2-1.3 0.4-2.6 1-3.9-0.1-1-1.9-0.4-3.1 1.5-3.7-0.1 0-0.1 0-0.1 0-1.1 0.4-2.2 0.7-3.2 0.1-4-1.2-4.1-1.3-3-5.4-0.3-1.6-1.9-2.2-2.7-3.6-1.4 0.1-2.8 0.4-3.7 1.7-0.3 0.5-0.7 1.1-1.4 0.6-0.3-0.2-0.5-0.7-0.5-1-0.1-0.8 0.5-1.1 1.1-1.2q1.5-0.4 3-0.8c0.8-2.3-1.7-2.5-2.3-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m5.5 121.6c-0.3 1.1-0.3 2.6-1.7 2.5-1.3-0.1-1-1.1-0.1-1.8 0.4-0.4 0.7-1 1.1-1.5 0.7-0.2 0.6 0.4 0.7 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m0.9 125.4q-0.3 1.6-0.7 3.1-1.3-0.3-1.6-1.5 0-0.4 0-0.8 1.2-0.4 2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s104",
    d: "m60.7 221c-0.9-1.7-1.7-3.2-0.9-5.3 0.7-2-3.1-5.5-5.9-5.6-0.4-3 3.1-2 4-3.8-1.3-1-3 0.8-4.1-0.6-0.9-0.2-1.3-0.7-1-1.6 0.5-2 2.9-0.6 3.7-2.1 1.2-2.3 1.7-0.7 2.7 0.2 0.4 0.5 1.4 0.2 2.2 0.4 0.9 0.2 0.9 1.1 0.9 1.9 0.1 1.1-0.6 0.5-1.2 0.6-2 0.2-1.2 1.7-1.6 3.5 2.7-2.3 5.8 0.1 7.9-2.7 0.8 2.2-0.1 3.8-0.9 5.3-0.2 0.4-0.2 1.1 0 1.4 0.3 0.5 1.2 0.5 1.4 0.1 1.6-3.1 3.7-1.7 5.7-0.6 0.7-0.8 0.3-1.7-0.1-1.8-4.9-0.5-2.5-2.7-1.1-4.6 0.4-0.7 0.6-1.4 0.2-2.2-0.3-0.5-1-0.8-1.3-0.4-2.1 2.7-1.9-1.4-3.2-1.1-0.3-2.2 2-0.8 2.6-1.8 0.8-0.3 1.5-0.4 2.3 0 0.5 1 0.2 2.8 2.1 2.6 3.2-0.5 5.3 1.8 7.8 3.1 0.6 2.5 3.4 3.6 4.3 6q0.2 0.5 0.3 1c-0.1 0.6-0.3 1.1-0.7 1.4-0.9 0.2-1.6-0.5-2.3-0.5 0.8 0.2 1.7 0.6 2.5 1.1q0.5 0.7 0.3 1.5c-0.6 2-2.7 2.4-3.9 3.7q-0.5 0.3-1.1 0.4 0.2 0.1 0.7 0c3.5-1.1 4-0.6 3.4 3.8-2.1 3.4-3.2 3.6-6.6 1.3-1-1.6-2.1-3.6-4.4-3-5.1 1.3-9.8-1.5-14.7-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m82.9 219.5c0.8-1.6 2.3-2.4 3.8-3.1 0.5-0.5 1-0.5 1.7-0.5 1 0 0.5 2.5 2.1 1.2 0.6-0.6 0.6-1.4 0.5-2.2-0.2-1.4-1.3-1.3-2.3-1.3-0.8-0.1-1.5-0.4-2-1-1-1.6-0.8-3.9-3.2-4.6-0.5-0.2-0.4-1.2 0.2-1.7 3.9-0.6 6-4.1 9.2-5.9 2.1-1.2 9.2-0.6 10.6 1 1 1.1 0.9 2.2-0.1 3.3-2.9 3.3-2.8 3.3 1.1 4.2 2.7 0.6 3.1 1.9 2 6q-0.4 0.8-1.1 1.3c-1.2 0.5-2.6 0.9-2.3 2.8 0 0.6-0.2 1.1-0.5 1.5-2 1.4-3.3 3.4-5.4 4.6-2.8 1.1-4.7-0.5-6.5-2.3-1.9 0.3-2.5 6-5.5 1.3v-3.2c-1 0.3-1.2 1.6-2.3 1.6-1.2-1-1-2 0-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s116",
    d: "m143.4 104.1c-3.9 1.7-7.8 2.1-12 0.7-3-0.9-2.5-1.8-0.4-3.1 0.3-0.2 1-0.2 0.6-0.9 3.7-2 8.2-2.4 11.5-5.3 1.7-0.3 2-1.5 1.6-3 0.1-1.7 1.1-2.8 2.4-3.8 4.2-2.2 4.6-2.1 7.7 1.3q0.3 0.5 0.3 1.1c0.2 1.1-0.4 2.1-0.8 3.1-0.3 0.6-0.6 1.1-0.1 1.7 2.6-0.3 5.2-1 7 1.8 1.1 1.7 1.3 3.2-0.9 3.3-1.6 0.1-1.9 2.2-3.5 1.8-0.4-0.3 0.1 0-0.3-0.3q-0.5-0.3-1-0.6c0.3 0.2 0.6 0.4 0.9 0.6 1 0.8 4.1 0.4 1.5 3-2.4-1.4-4.9-2.5-7.6-3-0.8-0.7-1.6-0.6-2.4-0.1-1 1.3-1.9 2.6-3.8 1.7-0.2-0.3-0.3-0.6-0.1-0.9-0.4 0.2-0.3 0.7-0.6 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m105.8 214.9c-0.3-0.5-0.9-1.1-0.9-1.6 0.1-3.5-0.1-3.6-3.9-2-0.3 0.1-0.7 0.2-1.2 0.4-0.8-3.4-1-6.4 3-8 0.9-0.4 0.3-1.4-0.6-1.6-1.1-0.3-2.2-0.5-3.3-0.4-2.2 0.2-4.1-0.5-6-1.3 0.4-3.7 4.4-3.7 6.1-6.1 2.8-0.4 5.5 0 7.5 2.3 0.2 0.1 0.2 0.2 0.4 0.2 4.5 0.5 4.5 0.5 5.1 5.5 1.1-1.7 0.5-4 2.5-4.5 2.2-0.6 2.2 2.1 3.7 2.8 0.5 0.7 0.9 1.6 0.8 2.6-0.7 2.6-2.7 3.8-4.8 4.9-2.4 1.2-4.7 2.3-5.3 5.3-0.3 1.2-1.2 2.7-3.1 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m57.6 58.9q-6.6-1.1-13.3-2.2c0.3-2.6 0.7-5.1 4.1-5.4 2.2 0.4 2.9-0.9 3.2-2.8q0.5-1 1.6-1.3c2.3-0.5 4.9 0.7 6.9-1.3 0.4-0.3 0.9-0.6 1.4-0.6 0.8-0.1 1.5 0.2 1.9 0.8 1 2 0.9-0.9 1.6-0.4 1.9-1.4 3.6-0.4 5.3 0.3 1.1 0.9 0.7 2 0.3 3q-0.3 0.7-0.4 1.4c0 0.4 0 0.9 0.1 1.3 0.2 0.6 0.8 0.9 1.1 1.4 1.4 2.3 1.2 3.9-1.9 3.9-2 0-3.5 2.6-5.2 1.6-2.6-1.5-4.5 0.3-6.7 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s117",
    d: "m111.1 114.2c3 2 5.3 0.4 7.7-1.3 0.7 0.9 0.5 2 0.1 3-0.3 1.9-0.5 3.8 0.8 5.5 1.1 1.5 0.6 2.5-0.8 3.4-0.8 1-2 1.5-3 2.2-1.3 2.3-2.6 1-3.3-0.3-2.3-4.4-6.5-4.7-10.6-5.1-0.5-0.9-0.6-1.7 0.1-2.6 1.9 0.7 3-0.4 3.6-1.8 0.5-1.2 0.2-2.5-1-3.4-1.7-1.3-3.3-2.6-4.4-4.5 2.1 2.4 5.8 1 7.8 3 1.2 0.3 2 1.4 3 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m108.8 83.4q-3.4-7.3-6.9-14.5c0.3-0.8 0.8-1.2 1.6-0.8 1.1 0.9 2 0.5 2.5 0-0.6 1.1-1.7 0.6-2.8-0.3-1.4-1.3-1.5-2.5 0.4-3.5 1.4-0.3 2.8 0.8 4.1 0 0 0-0.1-0.3-0.2-0.2-0.3-0.1-0.5-0.2-0.8-0.3-1.5-1.1-2.9-2.3-3.7-4.1-0.2-1.3 0.9-2.2 1.1-3.5 0.9-2.1 3.5-3.1 4-5.5 1-1 2.1-1.6 3.5-0.8-0.1 1.6 1.9 2.1 2 3.7-1.5 5.2-1.6 10.7-2.5 16-0.8 2.3 0.3 4.7-0.6 6.9q-0.1 0.4-0.2 0.8c-0.6 1.6-0.1 3.2-0.3 4.8 0 0.8 0 1.6-1.2 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m138 152.2c1.6 1.5 2 4.1 4.6 4.8 1 2.7-0.6 3.4-2.9 3.7q-0.4 0.2-0.9 0.3c-0.7 0.3-1.3 1-2.2 0.7-1.1-0.3-1-1.6-1.8-2.2-0.2-0.5-0.6 0.2-0.2-0.1 0.2-0.1 0.2 0 0.3 0.3 0.8 1.4 0.2 2.4-1 3.1-1.1 0.7-2.4 1.1-3.5 0.3-1.2-0.9-2.5-1.7-3.8-2.5q-0.4-2.3-0.8-4.6c1.1-1.8-0.6-3-1-4.5-0.5-1.2 0.8-2.1 0.3-3.3-0.2-3.3-1.1-6.7 1.7-9.8 2.3 1.9 2.5 5.4 5 7.1 0.1 1.4-0.6 3.2 2 3.3 1.1 0.1 1.7 1.3 1.7 2.3 0 2.4 1.4 1.3 2.5 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m157.9 105.5c0.9-1.8-0.9-2.1-1.5-3 2.2-0.6 0.5-2 0.7-3.2 1.3-0.7 2.3 1.7 3.9 0.3-1.3-1.9-2.3-4.1-5.3-2.1-1 0.7-2.2 0.4-3.1-0.6 0.1-0.9-0.1-2 1-2.5 0.8-0.5 1.7-0.9 2.2-1.8 0.8-0.7 1.4-1.4 2-2.2q0.5-0.6 1.1-1.1c0.5-0.5 1.1-1 1.8-1.2 1.8-0.6 3.8-0.4 4.6-3 0.6-2 3.1-1.5 4.8-0.9 1.7 0.6 1.3 1.9 0.4 3-0.8 1.2 0.3 1.9 0.7 2.7 0.3 0.8 0.2 1.5-0.1 2.2-0.4 0.6-0.7 1.3-1.4 1.7q-0.6 0.3-1.3 0.5c-0.3 0.1-0.7 0.2-0.9 0.6q-0.1 0.4-0.4 0.8-0.5 0.8-1.3 1.3c-0.6 0.4-1.4 0.6-1.1 1.6 0.1 0.6 0.2 1.2 0.5 1.8 0.7 1.4 3.2 1.5 3 3.7-1 1.3-1.2 2.9-1.9 4.4q-4.2-1.5-8.4-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s25",
    d: "m146.6 159c2.5 0.9 3.5 3.7 6 4.6-0.2 1-0.7 1.9 1 2.1 0.9 0.1 1.4 0.9 1.5 1.9 0.6 2.1 1.1 4.2-1.4 5.6-0.7 0.5-1 1.4-1.5 2.1-1.1 1.6-2.6 2.8-4.7 2.7-2.4-0.2-1.3-2.8-2.4-3.8-0.9-1.3-0.8-2.8-1-4.2-1-0.9-1.1 0.4-1.6 0.7q-0.7 0.6-1.5 0.8c-1.5 0.1-2.7-0.4-3.4-1.8 0.8-2.4 0.8-4.9 0.8-7.4-0.3-0.9-0.4-1.8 0.4-2.5 2.7 1.3 5-2.3 7.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m21.6 61.2c-1.2-1-2 0.3-3 0.5-2.4 0.5-4.1 0.3-3.1-2.8 2.2 1.9 2.6-0.9 3.8-1.5 1.1 0.4 2.2 0.5 3.3 0.3-1 0-1.9-0.2-2.5-1.1-1.1-0.4-2.2-0.9-3.6-1.4 1.8-0.9 3.8-0.2 5.1-1.6 1.8-1.5 3.2-0.3 4.6 0.7q1.6-0.1 2.3-1.5c0.6-0.7 0.7-1.7 1.7-1.9 2.3-0.2 2.4 1.4 2.3 3-0.1 1.3 1.4 3 2.8 2.6 3.5-1 3.6 1 3.2 3.5 2.2 1.3 1.6 2.7 0.2 4.2q-0.2 0.4-0.6 0.7c-0.7 0.4-1.5 0.2-2.3 0.5-0.9 0.3-1.3 1.9-2.7 1.1-2.5-1.2-1.4-2.9 0.2-5.2-2.9 1.3-5 1.5-7.1 1.4-1.9 0.7-3.4-0.1-4.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s118",
    d: "m156.4 67.3l1.3-3.1c1.6-1 2.9-0.8 2.8 1.3 0 1.6 1.1 0.4 1.5 0.7 1.7 0.7 1.2 2.1 1 3.3-0.4 1.7 0.4 3.6-0.6 5.2-0.9 0.4-1.4 1.1-1.5 2-0.7 0.9-1.9 1.4-2.2 2.7-1.3 1.1-0.8 2.6-0.8 4.1-0.3 1.4-1.1 2.4-2.6 2.7q-0.6 0-1.1-0.2c-2.5-1.2-4.2-2.8-3.2-5.8 1.2-3.5 0.2-7.6 3-10.7 1.1-0.4 1.8-1.2 2.4-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m104 190.3q5.9-5.7 11.8-11.4c3.7-0.4 3.7-0.4 3.7 3.5 2 2.1 1.7 4.5 0.8 6.9-0.1 0.3-0.3 0.6-0.4 0.6-3.3 0.5-5.5 2.4-7.1 5q-0.6 0.1-1.1 0.1c-3.1-0.7-6.1-1.6-7.7-4.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m116.4 178.1c3.8-4.2 8.3-8.1 10.2-13.7 0.8-1.6 1.6-2.9 3.7-1.5 1.8 1.3 3.4-0.7 5.1-0.5 1.2-0.2 2.5-0.6 2.8 1.1 0.3 2 1 4.2-1.7 5.3-0.8 1.2-1.7 2.2-3 2.7-1.4 0.3-3 0-3.9 1.5-0.7 2.9-3.2 3.4-5.6 3.9-1.9 4.1-4.8 2.4-7.6 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m174 167.5c1.6 0 3.1-0.7 4.5-1.3 1.4-0.5 2.5 0.4 3.1 1.5 0.7 1.4-0.8 1.5-1.5 2.1q-0.3 0-0.6-0.2-0.2 0-0.3 0.3c-0.2 0.3-0.2 0.7-0.2 1.1q0 0.5 0 0.9c0 0.7 0 1.3-0.1 1.9-0.2 0.7-0.2 1.4-0.3 2q-0.1 0.5-0.4 1c-1.3 1.8-2.6 3.1-4.8 1.2-1.6-1.3-3.1 1-4.6 0.3-2.1-0.9-1.4-3.4-2.8-4.7 1.3-2.4-0.4-3.8-1.6-5.3q-0.3-0.5-0.4-1c0-1.1 0.8-1.6 1.6-2.1q0.3-0.3 0.7-0.1c2.8 0.1 5 2 7.7 2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s113",
    d: "m166.3 108.5c-2.5-3.7-2.5-3.7 1.6-4.5 0.6-1 1.5-1.5 2.6-1.5 1 0 1.9 0.4 2.7 0.8 0.2 0 0.2 0.4 0.4 0.3q-0.1-0.5 0.1-0.8c0.3-0.8 0.9-1.4 1.7-1.8 2.3 0.4 3.6-2.2 5.8-2.2q0.6-0.1 1.1 0.1c2.4 1.1 0.8 4 2.5 5.4 0.3 1.1 0.7 2.1-0.1 3.2-0.8 0.7-1.8 1.1-2.9 0.7-0.4 0.2-0.2-1-0.6-0.3-0.5 1-1.1 1.6-2.1 1.9-2 1.3-4.4 1.1-6.7 1.2q-3-1.2-6.1-2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m92.1 63.5c-4 0.1-7.8-0.8-11.6-1.4-0.4-0.6-1-1.1-1-1.9 0-2.4-0.3-4.9 1.4-7.1 1-0.8 2.3-0.5 3.5-0.9 0.9-0.3 1.7-0.3 2.5 0.3 0.6 1.1 1.2 2.2 2.1 3-0.7-1-1.8-2-0.6-3.4 1.5-1.3 3.2-1.3 4.9-0.5 1.8 0.9 2.8 2.2 1.4 4.2-1 1.4-1.3 2.9-0.8 4.6 0.1 0.5 0 1.1-0.2 1.6-0.3 0.8-1.1 1-1.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s119",
    d: "m137.5 136.2c-0.9 5.6 2.2 9.3 6 12.7 0.2 0.9 0.6 1.9-1 1.8-1.7-1.8-3.2-3.9-5.1-5.4-4.1-3.3-6.2-7.9-9.1-12.1-0.3-0.5-1-1.2-0.1-1.5 1.4-0.7 2.7-2.4 4.3-1.3 0.9 0.6 1.5 0.6 2.4 0.4 0.6 0.6 0.8 1.4 1.6 1.8 0.6 0.4 1.1 0.9 1.4 1.5 0.3 0.8 0 1.4-0.4 2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s120",
    d: "m57.6 58.9c2.2-1.1 3.4-4.2 6.5-4 0.4 1.8-1.8 1-1.6 2.4 1.3 0.4 2.8 0.5 3.5-0.4 1.2-1.6 2.1-1.8 4.1-1.4 2.3 0.5 0.4-1.2 0.5-2q-0.4-0.5 0.1-1c0.9-0.5 1.8-0.3 2.5 0.5q0.3 0.4 0.5 0.8c2.8 0.8 4.7 2.4 5.5 5.2 0.7 1 0.4 2-0.2 2.9-7.2-0.6-14.3-1.7-21.4-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m188.5 125.4v0.8c-1.9-1.3-3.4-3.2-5.7-3.7-1.3-0.3-1.1-1.2-1.1-1.9-0.1-2.6-1.5-3.5-3.8-3.6q-0.5-0.7-0.9-1.5c0.1-0.7 0.6-1.2 1.3-1.5 1.3 0 2.4-0.4 3.4-1.3 1.9-0.6 2.7 0.6 3.6 1.8-0.5-1.4-2.3-1.7-2.9-3.1q-0.4-1.6 0.8-2.7c1.8-0.4 2.8-2.8 5.1-2.2 2.4 1.4 1.2 3.7 1.3 5.6 0.4 0.7 0.8 1.4 1 2.2q0 0.5-0.1 1c-0.4 1.2-1.6 2-1.6 3.4 0 0.7 0.3 1.5-0.4 2.1 0.9 1.6 2.9 3.1 0 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s121",
    d: "m130.4 37.5c-0.2 1.4-1.4 1.7-2.3 2.4-0.4-0.4 0.1 0.1-0.2-0.3q-0.2-0.1 0.2 0.2c-0.2 0.8-0.9 1.2-1.6 1.5-0.6 0.9-2.3 0.8-2 2.4q-1.3 1.1-2.6 2.1c-2.9 1.1-3.5-0.8-4-2.9-0.1-1.3-1.2-2-1.7-3-0.2-1.5 0.6-2.3 1.8-2.9 3.1-1.6 3.5-2.1 4.3-4.5 1.7-0.9 3.6-0.8 5.4-1.4 0.5 0 1.4 0.2 1.3 0.5-0.4 2.3 1.2 1.6 2.3 1.7 1.1 0.1 2.1 0.3 2.4 1.5-0.4 1.7-2.1 2-3.3 2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s122",
    d: "m154.1 32.7q-0.4 0-0.8 0.1c-0.8-0.8-1.8-0.6-2.7-0.4q-0.5-0.1-1-0.2c-0.7-0.5-1.6-0.7-2.2-1.3-0.5-0.8-1-1.7-2.2-1.5-1 0.1-1.7 1-2.6 1.2q-0.3 0-0.5 0.1-0.3 0-0.6-0.1c-0.8-0.3-1.8-0.3-2.6-0.9-1.2-1.3-3.2-2.5-1.2-4.7 1.2-1.3 2.7-2.1 4.5-1.5-0.1-0.6-0.7-0.5-1-0.7q-0.4-0.3-0.7-0.8c-0.4-1.8 0.2-2.9 2.1-3.2 0.7 0 1.5 0 2.1 0.3 0.8 0.5 1.1 1.3 1.4 2 0.4 0.5 1 0.8 1.5 1.2 0.8 1.3 2.3 1.8 3.2 3 0.4 0.6 0.9 1.2 1.6 1.4 0.3 0.2 0.5 0.3 0.8 0.4 0.8 0.4 1.7 0.1 2.5 0.3 1.1 0.6 2.3-0.1 3.4-0.1 0.8 0 1.5 0.2 2.1 0.8 0.6 1.9-0.9 2.9-1.8 4.2-1.7 0.5-3.5-0.1-5.3 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s123",
    d: "m118.8 42.8c0.8 1.3 1.2 2.9 3.1 3-2.6 2.8-6 4.7-8.3 7.8-0.6-1-3.6-0.7-1.6-3.1-0.6-0.8-1.6-0.7-2.2-1.2-0.7-0.9-1.3-1.7-1.6-2.8q-0.1-0.8 0.3-1.6c1.6-2 4.4-2.5 6.3-4.1q0.5-0.2 1-0.2c1.4 0.3 2.2 1.4 3 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s124",
    d: "m92.8 62q0-0.8 0-1.6c-0.9-1.4 0.1-2.3 1.1-3.1 0.5-0.4 1.4-0.4 1.5-0.9 0.8-5.4 3.7-2 5.9-1.6 0.8 0.5 1.6 1 2.6 1 0.5 0.1 0.9 0.4 1.2 0.8 0.1 1.3-0.7 2.2-1.6 3.1 0.5 0.7 0.4 1.5 0.7 2.2 0.4 0.9 1 1.7 0.5 2.8q-0.2 0.1-0.4 0.3c-2 0.6-0.7 2-0.8 3.1q-0.8 0.4-1.6 0.8c-2-2.5-4.6-4.2-7.6-5.3-0.4-0.6-1-1-1.5-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s125",
    d: "m76 129.3c1.9-2.5 2.2-6.4 6.1-7 3.1 1.2 6.8-0.6 10.5 2.3-5.5 0.3-8 4.2-11.3 6.8-2.3 0.6-3.4-1.7-5.3-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s63",
    d: "m38.5 60c-0.2-1-0.2-2.2-1.2-2.6-0.6-0.3-1.9-0.5-1.6 0.7 0.2 0.9 1.4 1.9-0.1 2.3-1.1 0.2-1.8-1.1-2.1-2.3-0.2-0.6-0.4-1.2-0.6-1.9-2 3.5-3.3 1.8-5.1-0.2 3.9-0.1 4.3-1.3 2.2-4.7q-0.2-0.3-0.1-0.6 0-0.2 0.1-0.2 0.4-0.4 0.8-0.7c1.3-0.7 2.7-0.2 4.1-0.3 0.8 0.1 1.4 0.5 2 1q0.3 0.3 0.5 0.6c0.2 0.2 0.4 0.3 0.7 0.3 2.1 0 3.7 1.4 5.6 2.1 1.4 1.3 1.7 2.4-0.6 3-3.2-1-3.9 1.1-4.6 3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s126",
    d: "m172.7 35.9c0.5-3.1-0.9-4.7-4.1-4.6q-0.3-0.5-0.2-1c0.3-0.6 0.8-1 1.3-1.5 0.7-0.5 1.6-0.9 1.6-1.9-0.4-1.5-1.9-2.9-0.3-4.6 0.7-0.5 1.6-0.4 2.5-0.5 2.6 0.4 2.6-3.3 5.1-3.1q0.8 0.1 1.4 0.8 0.3 0.5 0.4 1c-0.4 2.5 0 5.1-0.4 7.6q-0.4 0.7-1.1 1.1c-2.1 0.3-3.3 1.3-2.7 3.6-0.5 1.4-1.7 2.2-2.6 3.2q-0.5 0.2-0.9-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s127",
    d: "m122.6 151.5c-3.4-2-4 2-5.9 3.1-0.8 0.4-1.5 0.5-2.3 0.9l0.1 0.1c-0.1-2.9 2.6-4.7 3.1-7.3 0.2-1 0.8-1.9 1.2-2.8 0.3-0.8-0.5-2.3 1.1-2.4 1.4-0.1 2.3 1 2.6 2.3 0.3 1.4 0.9 2.6 1.7 3.7q0.7 0.8 0.5 1.8c-0.5 0.8-1.2 1.1-2.1 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m138 152.2c-0.5 0.5-0.5 1.1-0.2 1.7 0.9 1.9-0.2 2.4-1.7 2.3-1.3 0-2.6-0.5-2.2-2.3 0.4-2 2.1-4.5-2.4-3.1-1.4 0.5-2.5-2.2-2.7-3.5-0.4-1.9 2.2-0.8 3-1.8 2.3 2 5 3.6 6.2 6.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s128",
    d: "m117.6 104c0.1-3.8-0.5-7.1 0.4-10.3 0.3-1.1 0.7-2.1 1.7-2.3 1-0.2 1.5 0.9 2 1.5 2.6 2.9 1.9 5.5-1.8 7.9-0.8 0.6-1.3 1.8-2.3 3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m141.8 29.8q0.4 0 0.8 0c0.5-0.2 1-0.3 1.4-0.6 2.2-1.4 2.7 0.6 3.5 1.8 0.8 0.7 2.1 0.1 2.8 1.1q0.6 0.4 0 0.8-5.7 1.2-11.4 2.4c-1.5 1.2-2.5-1.2-3.9-0.5-0.6-0.1-1-0.5-1.3-0.9-0.5-0.9-0.1-1.8 0.1-2.7 0.5-2.5 2.9-1.3 4.2-2 0.5-0.2 1-0.1 1.5-0.1 0.9 0 1.7 0.1 2.3 0.7-0.6 0.8-1.1 1.7-1.8 2.3 0.7-0.6 1.3-1.5 1.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s129",
    d: "m196.2 159.8c-0.6 0.7-0.8 1.5-0.8 2.3 0.5 0.8 0.4 1.6 0 2.3-1 0.1-2-0.1-2.8 0.9-0.6 0.8-1.3 0.5-1.4-0.6-0.1-0.7 0.2-1.7-1.1-0.9-0.6 0.4-0.8 2.2-1.9 1-0.8-1.1 0.4-1.8 1.2-2.4 0.4-0.4 0.9-0.8 1.3-1.2-1.7-2.1-3.9 2.4-5.3-0.7q5-1.1 10-2.2 0.4 0.8 0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s130",
    d: "m168.6 30.6q0 0.3 0 0.7c-2.4 1.4-5.1 1-7.7 1-1.1-2.4 1.7-3.2 2-5.1 0.3-1.9 1.9-2.7 3.3-3.6 0.8-0.2 1.6-0.2 2.3 0 0.9 0.4 1.4 1.1 1 2 0 0.5 0.4 0.3 0.7 0.3 1.3 0.4 2.8 0.5 3.8 1.6q-1.9 1.2-3.8 2.3c-0.6 0.2-1.2 0.3-1.6 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s110",
    d: "m178.6 114.7q-0.8 0.4-1.6 0.8l-4.6-4.5c1.6-2 4.2-1.5 6.2-2.4 1.3 1 2-0.5 3.1-0.8q1.5-0.3 3-0.7 0.2 0.2 0.3 0.3c0.4 1.1-0.4 1.5-1.1 2-0.6 0.6-0.7 1.4-0.7 2.3 0.3 1-0.5 1-1.2 1.1-0.8 0.6-2.1-0.4-2.7 0.9q-0.2 0.6-0.7 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s131",
    d: "m135.7 163.7c-0.6 0.7-3.3-2-2.4 1.4 0 0.2-2.7 0.1-3.3-0.7-1.4-1.8-2.3-0.7-3.4 0q0-1.9 0-3.8c1.4-1.4 2.4-0.6 3.3 0.7 1.2 1.6 3.1 1 3.9 0.1 1.4-1.9-1.1-1.6-1.8-2.4-0.4-0.5-1.7-0.4-1.2-1.4 0.4-1 1.2-0.4 1.9-0.1 1.8 1 3.4 2.2 4.5 3.9q0.3 0.3 0.2 0.8c-0.7 0.4-1.3 0.7-1.7 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s132",
    d: "m168.7 49.7q1.9-6.5 3.9-13c1.3-0.5 2.3 0.4 3.4 0.8 0.6 0.3 1.1 0.8 1.3 1.5 0 0.6-0.2 1-0.6 1.3-0.6 0.3-1.2 0.2-1.8 0.4 0.7-0.1 1.3-0.1 1.8 0.3 0.9 0.9 1.5 1.8 1.2 3.1-0.3 0.8-0.8 1.3-1.7 1.4-0.8-0.1-1.6 0-2 1-1.6 1.5-2.6 3.8-5.5 3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s133",
    d: "m167 56.6q0.7-2.7 1.4-5.4c1.8-1.1 3.3-4.1 5.8-0.9-0.8 1.5 0.9 1 1.2 1.5 0.9 1.7-1.3 2.1-1.4 3.5-0.6 1.7-2.5 1.6-3.6 2.7q-0.5 0.3-1 0.5c-0.9 0.5-1.8 0.5-2.6-0.3-0.3-0.5-0.1-1.1 0.2-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m116.4 178.1c0.5 0 1.1-0.3 1.5-0.1 2.4 1.2 3.7-0.2 4.8-2.1 2.3-0.1 3.5 0.9 3.7 3.2q0 0.6-0.3 1.1c-1.9 2.2-4.1 3.8-7.2 2.6-1-0.1-1.8 0.9-2.9 0.3 0.1-1.6 2.2-1.5 2.6-2.9-0.5-1.4-2.7 0.7-2.8-1.3q0.3-0.4 0.6-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s134",
    d: "m154.8 167.5c-1.5-1.5-3.1-1-4.8 0 1.2-1.1-1.3-4.6 2.6-3.9 1.9-0.1 3.6 0.8 5.3 1.6 1.4 0.8 2.9 0.4 4.3 0.3 1.6 0 2.2 0.7 2.6 2q0.3 0.3 0.3 0.6-0.1 0.4-0.2 0.4c-0.8 0.7-1.7 0.5-2.6 0.3-2.4 0.4-4.8 0.1-7-1.2q-0.2 0-0.5-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m105.8 197.3c-1.9-1.9-5.4-0.1-6.8-3q2.3-1.9 4.6-3.7c2.3 1.3 4.8 2.5 3.8 6-0.4 0.5-0.8 0.9-1.6 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s135",
    d: "m98.4 105c-0.1 0.1 0.9 1.5-1 1.5-2.1-0.2-6.2-3.5-6.2-5.3 0-0.9 0.8-1.3 1.2-0.9 1.8 1.9 7.4-1.9 6 4.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s136",
    d: "m154.3 90.3c-2.1-2-4.7-1.6-7.2-1.6q0.1-0.8 0.2-1.5c2.1-2.7 4.4-3.8 7.5-1.6l0.1 0.1c1.1 0.3 2 0.8 2.1 2.1 0 0.5-0.2 1-0.6 1.4-0.5 0.7-1.1 1.4-2.1 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s137",
    d: "m154.8 85.6c-2.6-0.2-5 1-7.5 1.6 0.7-2.6 2.4-4.7 3.7-7 0.3 2.5 2.6 3.6 3.8 5.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s138",
    d: "m112.1 137.9c0.4-1.2 0.4-2.8 2.2-2.8 1.4 0 2.4 0.8 2.3 2.5-0.2 1.9-0.9 3.8-3 3.8-1.8-0.1-0.9-2.2-1.5-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m161.8 66.5c-0.7 1.4-1.5 2.6-3.4 2.2-1-1.4 3.5-3.6-0.7-4.5 0.1-1.1 0.2-2.2 1.1-3 1.9-0.9 3.3-0.2 4.4 1.4 0.3 0.5 0.4 1.1 0.3 1.7-0.1 1.1-0.8 1.7-1.7 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s139",
    d: "m162.5 62.7c-1.1-0.7-2.8-0.2-3.7-1.5-0.2-2 1.5-3.1 2.3-4.6 0.4-0.4 0.9-0.5 1.4-0.4q0.5 0.2 0.8 0.7c0.3 0.4 0.4 0.9 0.5 1.4 0.3 0.8 0.9 1.5 1 2.4-0.1 1-0.5 1.8-1.3 2.3q-0.6 0.1-1-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s111",
    d: "m106.6 196.5c0.6-2.7-1.6-4.2-3-5.9q0.1-0.4 0.4-0.3c3.1 0.4 5.2 2.9 8 4-1.2 2.2-2.8 3.3-5.4 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s140",
    d: "m174 50.5c-2.1-1.5-3.7 0.7-5.6 0.7q0.1-0.7 0.3-1.5 2.3-1.9 4.5-3.8c0.4-0.8 0.3-1.9 1.6-1.8q1 0.9 1.9 1.9c0.4 1.2-0.1 2-1.2 2.5-0.8 0.3-0.8 1.1-1.1 1.7q-0.2 0.1-0.4 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s141",
    d: "m115.7 89.2c-0.6 1-0.8 2.5-2 2-1.5-0.5-2.3-2-2.3-3.5 0-1 0.9-2.3 1.9-1.9 1.3 0.6 2.2 2 2.4 3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s142",
    d: "m90.1 100c-2.2 0.6-4.2 1.3-6.3 0.3-0.6-0.3-1.1-0.7-1.1-1.4 0.1-0.6 0.7-1.1 1.3-1.2 2.3-0.2 4.5-0.2 6.1 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m83.7 206.3c0.6 2.8 2.9 1.1 4.9 1.8-3.5 0.7 0.3 3.5-1.9 4.5-1.4-0.5-1.4-2.3-3.4-2.7-1.9-0.3-1.3-2.5-0.4-4q0.4 0.2 0.8 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s143",
    d: "m92.6 118.5c1.4-1.4 2.6-3.2 4.7-2.4 1 0.4 1.2 1.7 0.7 2.3-1.6 2.1-3.5 0.4-5.4 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s105",
    d: "m146.6 159c-1.7 0.6-4.4-0.1-3.8 3.4-1.2-1.4-2.6-2-4-2.6-0.3-0.8 0.1-1.9 0.8-1.3 2.4 1.8 2.3-0.5 3-1.5q2 1 4 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s144",
    d: "m134.9 34.4c1.7-1.6 2.9-0.5 4 0.9q-4.1 1.5-8.5 2.2c0.9-0.9 1.7-2 3-2.3 0.4-0.6 0.7-1.3 1.5-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s145",
    d: "m174 167.5c-2.8-0.2-5.7 0.2-7.7-2.4q2.7-0.7 5.4-1.4c-2.7 3.4 2.2 2.1 2.3 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s146",
    d: "m43.1 56.5c1-0.7 0.8-1.5-0.1-2.2-1.2-2.5 0.1-3.6 2.3-4.1 1.2 0 2 0.6 2.8 1.3q0.2 0.2 0.3 0.5c-2.9 0.3-1.5 4.2-4.1 4.7q-0.6-0.1-1.2-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s62",
    d: "m37.7 64.2q0.5 0 1 0c0.8 1.5 0.9 3 0.5 4.6h-0.7c-1.1-0.4-2.2 0-3.3 0-1-0.1-1.6-0.7-2.1-1.5v-0.8c1-0.8 0.6-2.7 2.3-3 0.6 0.6 1.3 1.3 2.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s85",
    d: "m164 28.3q-1.5 2-3.1 4l-0.2 0.1-0.2-0.2q-0.7 0.5-1.1-0.2c-0.1-1.5 0.9-2.6 1.6-3.7q-0.4-0.4-0.3-1c0.5-0.9 1.2-1.3 2.2-1 1 0.3 0.4 1.5 1.1 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s66",
    d: "m143.4 104.1c0.6-1.5-3.9-1.6-1-3.5 0.8-0.5 2-0.9 2.9 0.5 1.2 1.8-0.6 2.1-1.2 3q-0.4 0-0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s147",
    d: "m99.3 97.7c-2.3-1.7-4-2.4-4-4.2 0-0.9 1.1-0.7 1.9-0.6 2.5 0.5 1.1 2.6 2.1 4.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m76 129.2c2 0 3.6 1.4 5.3 2.2q-1.1 1.2-2.3 2.4c0.1-2.2-1.9-3.1-3-4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s148",
    d: "m162.2 56.6h-1.1c0.8-2 1.5-4.1 2.2-6 2.1 0.1 0.3 1.9 1.5 2.2q0.4 0.4 0.3 1c-0.9 1-1.1 2.7-2.9 2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m66.7 166.7c-2.6-1.1-4.5-2.4-0.7-4.6 1 1.4 0.1 3.2 0.7 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s149",
    d: "m108.2 131.4c1.3 1.9 2 3.1 0.6 4.3-0.5 0.5-1.1 0.5-1.3 0.1-1-1.4 0.3-2.5 0.7-4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s150",
    d: "m105 91.1c0.1 0.7 0 1.3-0.8 1.4-1.1 0-1.6-0.6-1.7-1.6 0-0.7 0-1.7 1-1.6 1 0 1.2 1 1.5 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s151",
    d: "m114.4 155.5c-0.7 1.5-0.9 3.9-4 2.4 1.5-0.8 1.5-3.6 4.1-2.3 0 0-0.1-0.1-0.1-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s152",
    d: "m131.6 100.8c1.2 0.3 2.5 0.1 3.2 1.3 0.1 0.2-0.2 0.7-0.5 0.8-1.4 0.5-2.2-0.8-3.3-1.2q0.3-0.4 0.6-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s153",
    d: "m144.7 92.5c0.9 0.8 1.4 2 1 3-0.6 1.1-1.7-0.1-2.6 0 0.2-1.2 0.8-2.2 1.6-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s154",
    d: "m71.4 119.4c-0.8 1.6-2.3 0.5-3.3 1-0.7 0.4-1.2 0.4-1.4-0.5-0.2-0.9 0.4-1.3 1.2-1.5 0.9 1.3 2.3 0.7 3.5 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s155",
    d: "m164.8 167.5c-1.7-2.5-4.9-0.7-6.9-2.3q3.8 0 7.7 0-0.4 1.1-0.8 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s156",
    d: "m108.8 83.4c1.6-1.8 0.1-4.3 1.5-6.1 0 1.9 0 3.9-0.2 5.8-0.1 1.1-0.6 1.2-1.3 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s157",
    d: "m123.3 85.8c0.1 0.7-0.4 1.1-1 1.3-0.9 0.3-1.2-0.2-1.3-0.9-0.1-0.7-0.2-1.7 1-1.6 0.6 0.1 1.2 0.4 1.3 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s158",
    d: "m124.5 43.7c-1.7-2.7 0.6-2.2 2-2.4 0 1.4-1 1.9-2 2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s159",
    d: "m103.8 94.7c1.3 0.7 2.3 1.1 1.6 2.4-0.1 0.3-0.7 0.7-0.8 0.6-1.3-0.6-1.3-1.6-0.8-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s156",
    d: "m110.5 76.5c0.1-2.3-0.6-4.7 0.6-6.9 0.1 2.4 0.4 4.7-0.6 6.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s160",
    d: "m159.4 32q0.6 0.1 1.1 0.2c-2.1 0.7-4.2 0.6-6.4 0.5 1.7-1 3.6-0.3 5.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s61",
    d: "m174.8 39q-1.1-1.1-2.2-2.3 0-0.4 0.1-0.8 0.2 0 0.5 0c0.6-0.7 1.2-1.4 2.1-0.5 0.9 1.4 0.5 2.5-0.5 3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s161",
    d: "m150.3 32.9v-0.8c1.1-0.5 2.3-1.2 3 0.7q-1.5 0.1-3 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m79 61.9c-0.4-0.7-0.3-1.5 0-2.2 0.6-0.4 1.1-0.5 1.6 0q-0.1 1.2-0.1 2.4-0.7-0.1-1.5-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s162",
    d: "m102.1 119q0 1.3-0.1 2.6c-2.6-0.1-0.2-2.4-1.4-3.1 0.7-0.4 1.1 0.1 1.5 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s163",
    d: "m155.1 92.6c0.1 0.2 0.3 0.5 0.3 0.8 0 0.4-0.4 0.6-0.8 0.4-0.1-0.1-0.3-0.4-0.3-0.6 0-0.4 0.1-0.7 0.8-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s163",
    d: "m155 93.5c-0.4 0.9-0.9 2.1-1.7 3.1-1.1 1.4-2.1 1.7-2.1 0.7 0-0.5 0.5-1.7 1.1-2.4 1-1.3 2-2.3 2.7-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s164",
    d: "m105.8 105.4c0-0.1 0 0 0 0-1.8-3.1-3.2-4.4-4.5-5.9 0 0 0 0.1 0 0.1-1-1.9-1.7-2.4-2.4-2.4 0.7 1.8 1.4 2.3 2.5 2.9 0.1 0.5 0.2 1.1 0.3 1.2 1.6 2.3 3.1 4.5 4.4 5.4 0 0.1 0 0.2 0.1 0.3 1.6 2.7 3.3 5.4 4.4 6-2.1-4.3-3.5-5.9-4.8-7.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s135",
    d: "m100.1 107.9c0 0 0 0 0 0-1.1-1.7-2.2-2.5-3.2-3.3 0-0.1-0.1 0-0.1 0-0.5-1-1.1-1.3-2-1.4 0.2 0.9 0.9 1.2 1.9 1.7 0 0.2-0.1 0.5 0 0.6 1 1.2 2.1 2.5 3.3 3.1q0 0 0 0.1c1 1.5 2.1 3 3.2 3.4-1-2.3-2.1-3.2-3.1-4.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s165",
    d: "m119 115.9q-0.1-1.5-0.2-3c1-0.7 1.9-1 1.4 0.8-0.2 0.8-0.8 1.4-1.2 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s166",
    d: "m142.5 150.7q0.5-0.9 1-1.8c0.9 0.8 0.9 1.8 0.1 2.5-0.4 0.4-0.8-0.2-1.1-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s167",
    d: "m92.8 62q1.4 0.3 1.5 1.6-1.1 0-2.2-0.1 0.4-0.8 0.7-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s168",
    d: "m120.7 159.2q-0.3 0.2-0.7 0.5c-0.1-0.3-0.2-0.6-0.1-0.7 0.1-0.3 0.5-0.4 0.7-0.6 0.1 0.2 0.1 0.4 0.1 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m66 169q0.4-1.1 0.8-2.2c1.1 0.9-0.3 2 0.1 2.9q-0.4-0.3-0.9-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m168.6 177.4c1.1-0.4 2.2-0.7 3.1-1.2 2.1-1 3.3-0.6 3.3 2.2 1.2-1.1 2-1.8 2.8-2.5 2.2 0 2.1-2.9 4.1-3.1q0.3 0 0.5 0c0.9 0.4 2.4 1.1 2.5-0.4 0.2-4.4 2.2-0.3 3.4-0.6q-1.6 1.2-3.3 2.3c-0.5 0.4-1.7 0.4-1.3 1.5 0.3 0.9 1.1-0.2 1.6 0 0.7 0.3 0.7 0.6 0 3.3 1.6 0 2.9-2.3 4.8-0.7 1.1 2.5-0.3 3.7-2.3 4.6v0.7c-1.8 1.3-3.7 2.5-5.6 3.6-2.3 1.5-4.7 1.1-5.9-1.8q-0.2-0.4-0.4-0.8c-1.7-0.8-3.7-1.4-3.4-4-0.9-1.6-2.8 0-3.8-1.2-0.5-0.6-0.7-1.2-0.1-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m187.8 182.8q1.1-2.3 2.3-4.6 0.4 0 0.7 0c1.9-0.4 2.3 3.3 4.6 1.5 3.4-0.1 5.8 0.8 6.2 4.6-1.6-0.2-3.1 0.6-4.6 0q-0.8 0.7-1.6 0c-1.3-0.9-2.3-2.8-3.9 0-0.6 1-2.1-1.7-3.7-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m196.2 159.8c1-0.4 1.6-0.1 2.3 0.7 1.2 1.1 2 1.1 2.9-0.6 0.7-1.5 2.3-2.6 4-1.4 2 1.6-0.3 3.3-0.3 5 0 0.1-0.4 0.2-0.6 0.3-1.8-3.4-7.2 0.8-8.3-4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m195.4 179.7c0.3 2.7-1.7 2.3-3.2 2.2-2.9-0.2-0.6-2.6-1.4-3.7 1.4-1.1 3.1-0.7 4.6-0.8 0.7 0.8-0.7 1.6 0 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m215.3 162.9c-3.9-3.4-3.9-3.4-6.4-2.9 0.6-1.3 2.5-2.5-0.5-3.9 4.6 0 5.2 4.2 8.2 5q-0.6 0.9-1.3 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m195.7 168.3c-2.3 6.2-2.3 6.2-6.2 1.6 2.5 1.3 4 0.3 6.2-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s169",
    d: "m203.1 169.8q0.4 0.7 0.8 1.5c-1.4 0-2.8-0.1-4 0.6-0.9 0.5-1.8 0.9-2-0.5-0.1-1.1 0.6-1.9 1.5-1.8 1.3 0.1 2.4 0.6 3.7 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s170",
    d: "m216.9 169.8q0 0.5 0.1 1.1c-2-1.2-2.5 3.4-4.7 1.2 0.2-3.4 2.7-2.2 4.6-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s171",
    d: "m208.4 166.7q0.4 0 0.8 0c0.6 0.4 0.3 1.2 0.8 1.6-0.3 3.1-1.7 1.8-3.1 0.7q0.8-1.1 1.5-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m179.4 171.3c1.2 0.1 2.1-1.6 3.4-0.7 1 0.7-0.6 1.4-0.4 2.2-1.6 0.3-3.4 1.2-3.8-1.5q0.4-0.5 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s170",
    d: "m205.9 164.8c-0.3 1.5-0.3 2.8-1.3 2.7-1-0.1-0.4-1.1-0.1-1.7 0.2-0.3 0.6-0.4 1.4-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m179.4 171.3h-0.8q-0.6-1.1 0-2.3 0.7-0.7 1.5 0v0.8q-0.4 0.7-0.7 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s172",
    d: "m202.9 165.3c-0.9 0-1.3 0.1-1.8 0.1-0.4 0-0.7-0.3-0.3-0.7 0.2-0.2 0.7-0.2 1-0.1 0.2 0 0.5 0.2 1.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m195.4 179.7c-0.8-0.7-0.3-1.5 0-2.3q0.4 0 0.8 0-0.4 1.2-0.8 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s155",
    d: "m193.1 168.1c-0.5 0.1-0.8 0.3-1.1 0.4-0.2 0-0.6-0.4-0.6-0.4 0.2-0.3 0.4-0.6 0.6-0.8 0.2 0.1 0.4 0.3 1.1 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s173",
    d: "m195.4 164.4q-0.5-1.1 0-2.3 2 1.2 0 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m187.8 113.2c-0.6-0.3-1.3-1.1-0.9-1.4 2.2-1.1 1.4-3.1 1.6-4.7-0.4-1.2 0.3-1.6 1.2-2 1.5 0.3 3 1 4.5 0.3 1.6 0.2 4.5-1.7 4.1 2.2q-0.1 0.4-0.3 0.7c-0.5 0.8-1.5 0.1-2 0.5-0.3 0.2-0.3-0.2 0-0.1 0.9 0.1 2 0.4 2.3-1 0.6-1 1.5-1.9 1.4-3.2-0.2-0.7-1.6-1.7 0.3-2q0.4-0.4 0.8-0.8 0.2-0.2 0.4-0.5 0.2-0.4 0.3-0.7c0.5-1 1-2 2.4-1.1 0.8 1 1.8 1.4 3 0.8q0.4 0.8 0.8 1.5c-2.3 2.8-2.2 2.7 0.9 5.4 0.6 0.5 0.8 1.9 0.6 2.8-0.2 0.9-1.3 0.5-1.9 0.2-2.7-1.2-5-0.5-6.9 1.7-0.7 0.8-0.1 1 0.4 1.4v1.5c-0.8 0.8-1.6 0.7-2.4 0-0.4-0.3-0.8-0.6-1.2-0.9-0.6-0.3-1.1-0.8-1.7-0.9-2.6-0.2-5.2-0.2-7.7 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s174",
    d: "m188.5 120.8q-0.7-0.7-1.5-1.5c0.4-0.3 0.7-0.7 1.1-0.9 0.7-0.2 1.3 0 2 0.1 0.6 0.1 1.4 0.3 1.8 0 3.4-3.2 5.6-1.3 7.7 2-3.7 2.8-7.4 0.5-11.1 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m209.7 117.5c-1.8 1.1-2.8 2.2-4.4 2.3-0.3 0-0.5 0.1-0.8 0.1-1.2-0.1 1.5 3.5-1.5 1.6-1-0.6-0.7-2 0.2-3 1-1.1 1.4-3.6 3.9-2.2 0.7 0.4 1.4 0.7 2.6 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m187.8 113.2c2.3-2.9 5.6-1.1 8.4-1.5q0.3 0.3 0.4 0.8-0.1 0.7-0.6 1.2-0.6 0.4-1.3 0.3h-0.8c-1.3-0.1-2.1 2.5-3.8 0.7q-1.2-0.7-2.3-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m190.1 114.7c1.3 0 2.3-1.6 3.8-0.8 0.3 2.9-2.4 3.2-3.8 4.6q-0.8 0.4-1.6 0.8c-0.7-1.9 0.4-3.3 1.6-4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m194.7 114q0.3-0.4 0.7-0.8c1.1-0.1 2.2 0.1 3.1 0.7q1.1 0.4 2.3 0.8c0.4 1.1 0.2 2-0.8 2.5-1 0.5-1.8 0-2.1-0.9-0.5-1.7-3.1-0.3-3.2-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s47",
    d: "m193.4 124.3q-0.4-0.3-0.8-0.6c0.3-0.2 0.6-0.5 0.8-0.4 0.3 0.1 0.5 0.4 0.7 0.7-0.2 0.1-0.4 0.2-0.7 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m36.2 160.6c0.3 1.6 1 3.3-0.9 4.4-0.9 0.6-0.4 1.2-0.4 1.9 0.1 2.1 3.4 4.7-0.8 6.3 1.6 1.8-0.8 3.7 0.3 5.4-1.1 1.3-1.4-3.5-2.9 0-0.7 1.5-2.9 1-4.2-0.2-0.6-0.6-0.9-1.6-1.9-1.7-1.5 1.1-2.1 2.5-1.7 4.5 0.2 1.4 0.6 3.3-2.1 2.3-1-1.9-2 0.1-3 0-2.1-0.1-3.9 2.3-6.2 0.8h-0.7c-4.8-0.9-6.2-3-5-7.4 1.4-2.1-1.5-3.7-0.7-5.7 0.8-1 1.9-1.7 2.6-2.8q0.5-0.3 1-0.4c0.8-0.1 1.5 0 2.2 0.5 1.8 3.1 4.5 4.4 5.5 2.4 1-2.1 3-4.5 1.2-7.2q-1.8-1.4-3.6-2.8c1.5-2.1 3 0.5 4.4-0.3q0.3-0.4 0.6-0.7c0.5-0.4 1.1-0.7 1.5-1.2 0.5-0.5 0.8-1.1 1.3-1.5 4-0.4 7.5-2.4 11.3-3.6q0.8-0.1 1.5 0.3c2.7 1.7 0.3 3.8 0.5 5.8q0.1 0.4 0.2 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m20.1 160.6h-0.8q-2.7-1.9-5.3-3.8-0.7 0.7-1.7 0.6c-1.1 0-2.3 0.2-2.7-1.2-0.6-1.9 1.2-1.8 2.1-2.5 2.2-0.6 4.8 0.3 6.9-1.5 0.3-0.4-0.1 0.1 0.1-0.3 0.4-0.5 1-0.8 1.5-1.1-0.6 0.3-1.1 0.4-1.6-0.1-0.8 0.3-1.6 0.8-2.3 0q0.7-0.8 1.5-1.6c0.7-1.2 0.8-2.3-0.8-3h-0.7q-0.8-0.4 0-0.8v-1.5c0.4-1.2 1.1-2 2.6-2 0.7 0 1.5 0.1 1.2-1.1-0.2-0.1-0.4-0.3-0.6-0.4-3.2-1.5-4.7-3.4-1.7-6.5h0.8q1.1 0.4 2.2 0.8 3.4-0.3 3.1 3.1c2.8 3.1 5.6 1.1 8.4 0 1.2 0.6 2.5 0.8 3.9 0.7 0.2 2-1.8 1.4-2.5 2.3-1.1 1.2-3.1 1.7-3.4 3.7 0.4 0.8 0.4 1.6 0.6 2.9 0.5-1.7 2-2.5 1.6-4.1 0-1 0.3-1.9 1.2-2.5 1.8-0.8 3.7-1.9 5.4 0.3q0.2 0.6 0.2 1.2c-0.9 3.1-1.5 6.4-4.4 8.5q-0.2 0.5-0.6 0.9c-0.2 0.3-0.6 0.5-0.8 0.8-2.1 3.8-2.5 4-6.3 2.5q-0.4 0.3-0.8 0.5c-1.6 0.5-2.9 2-4.7 1q-0.5-0.2-1-0.4 0.3 0.1 0.6 0.2c1.2 0.2 1.7 1 1.8 2.1q-0.3 0.8-0.7 1.5c-0.8 0.3-1.9-0.4-2.3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m7.8 177.4c-1.3 3.8 2.1 4.9 3.9 6.9-3.3 0.6-6.6 1-10 0.8-1.8-0.6-2.8-3.3-5.4-2.3-0.8-6.1 2.2-10.6 6.2-14.7 2.4-2.5 2.8 1.7 4.6 0.9 0.5-0.4 1-0.5 1.5 0 0.7 2.3-0.9 2.2-2.3 2.3-0.6 0.7-1.6 0.7-2.4 1.5 2.1 0.9 4 2 3.9 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m9.4 169h-2.3c0.6-1.4 1.3-2.9 2-4.3 0.5-0.8 1.2-1.8 2.4-1.5 1.5 0.5-0.1 1.8 0.7 2.7q3.1-1.1 6.3-2.2c3.4 0.7 3.2 3.5 1.7 4.9-2 2-0.5 2.5 0.7 3.4-2.2 2.2-5.2 0.4-7.5 2.2-1 0.7-2.6-3.1-1.7-5.2-0.8-0.8-1.6-0.8-2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s60",
    d: "m-2.9 160.6c0.6-0.1 1.5-0.2 1.4-0.8-0.3-1.2-1.4-0.5-2.2-0.7 0.4-2.3 2.2-3 3.9-3.9 1-1 2.5-1.1 3.8-1.5 1.3 0.2 2.9-1 3.8 0.8-0.3 2.8-2.9 3.2-4.6 4.6-1.2 1-2.5 2-3.7 3-2.4 1.9-2.3 0.1-2.4-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m3.2 159.1c0.1-3 3.1-3.1 4.6-4.6h0.8c0.5 2.1 3.2 1.9 3.8 3.8 0.5 1.1 0.7 3-0.2 2.8-2-0.3-4.6 1.7-5.9-1.3-1.3 0.4-1.8 2.2-3.6 1.9-0.6-1 0.7-1.7 0.5-2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s60",
    d: "m12.4 158.3c-1.6-0.9-3.8-1.3-3.8-3.8 0.7-1.5 1.9-0.9 3.1-0.8-3 3.8 1.3 2.2 2.3 3.1q-0.3 1.3-1.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m20.1 140.7c0.8 0.4 1.5 1 0.2 1.3-1.5 0.4-2.8 0.9-4 1.8-0.5-1.6-1.4-2.7-3.1-3.1 1.3-1 2.7-1.6 4.2-0.3 0.7 0.7 1.7 1.1 2.7 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m7.8 143c-1.2 0.7-2.5 0.8-3.8 0.8 0.6-2.2 1.9-2.8 3.8-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m6.3 133.8c1 0.5 1.2 1.3 0.8 2.3-0.7 0.3-1.7 0.7-2 0-0.6-1.1 0.7-1.5 1.2-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m0.2 129.2c1.6 0.2 3.2 0.4 3.8 2.3q-0.4 0-0.8 0-1.5-1.1-3-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m7.8 148.4c1.6-1-2-3.1 0.8-3.9 2 1.1 3.8 2.2 2.8 5-0.8-0.8-1.5-2.3-2.6-0.2-0.3 0.6-0.7 0.6-0.9-0.2-0.1-0.2-0.1-0.5-0.1-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m18.6 150.7c1.9-0.5 2.3-2.5 3.4-3.8 2.1 2.9 2.1 2.9-0.7 4-0.9 0.4-1.8 0.9-2.7 1.3q0-0.8 0-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m17 146.1c0.5-0.7 0.9-1.7 1.9-1.7 0.7 0 1 0.7 0.8 1.4-0.3 1.3 0.4 3.2-1.9 3.3q-0.4-1.5-0.8-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m16.2 150.7q-0.1 0.1-0.3 0.1c-1 0.3-2 1.5-2.9 0-0.3-0.5-0.2-1.1 0.3-1.3 1.3-0.6 2.4-0.4 2.9 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s175",
    d: "m4 153.7c-0.9 1.4-2.2 2-3.8 1.6 0.5-1.1 1-2.1 2.3-2.3q0.7 0.3 1.5 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m16.3 145.3v0.8c-0.8-0.1-1.8 1-1.9 0.3-0.3-1.2 1.1-0.9 1.9-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m224.5 209.5c3.2 1.8-0.2 3.1-0.3 4.6-2.5-0.3-4.3 2.6-6.9 1.7-3.1-1.1-5.5-0.6-7.3 2.2-3.4 2.6-7.8 4.4-8 9.7 0 0.6-0.6 1-1.2 1.3-1.3 0.3-2.2-0.3-3.1-1.2-1-1.4-1.4-2.9-0.8-4.6 0.3-0.8 0.4-1.2-0.7-1.2-1.9-0.1-1.5-3-3-3.1-1.3-0.1-0.6 2.7-2.5 2.7-0.7 0-1.8 0.6-2.2 0.2-3.5-3-9.9-2-11.1-8-0.3-0.7-0.2-1.4 0.1-2.1q0.1-0.6 0.4-1 0.4-0.4 0.9-0.7c0.3-0.3 0.8-0.6 1-1.1 1.3-3.7 3.8-5.6 7.9-4.7 0.6 0.1 1.2-0.5 1.8-0.5 1 0.3 1.8 0.8 1.3 2q-1 0.6-2.1 1.2 0.7 0.6 1.4 1.1c0.7 0.3 1.2 0.7 0.7 1.5q0.8 1.2 1.6 2.3c-0.5 0.6-0.7 1.1 0 1.6 3.4 2.7 5.6-0.5 7.9-1.9 2.3-1.5 6.8-1.1 8.2 1.5 0.4 0.8 1 1 1.9 0.8 1.5-0.4 1.3-1.6 1.1-2.7 2.1-1 4.1-1.9 6.1 0 0.9-0.3 1.8-0.9 2.6 0.3 1.3 2.1 1.4 2.1 2.7-0.3 0.4-0.6 1.1-1 1.6-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m190.8 205.7q-0.7-0.7-1.5-1.5c-4.7 1.4-7.5 0.6-9.6-2.8 0.6-1.9 2.1-3.2 2.8-5 0.7-0.7 1.6-0.7 2.5-0.7q0.2 0.1 0.5 0.1c1-0.8 2-1.3 3 0 2.7-1.7 5.4-3.1 8.5-0.8-0.3 2-2.2 0.5-3.1 1.5-0.2 1.7 2 0.7 2.4 2-1.1 0.7-2.2 1.6-3.4 2.1-1.8 0.8-1.9 0.6-0.4 2.1 0.5 0.6-0.3 2.2-1.7 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s104",
    d: "m217.6 211.1h-6.1c-1.3-1.5-1.4-3.1-0.7-4.9 0.2 0 0.5 0 0.7 0.1 1 0.9-0.4 3.2 1.8 3.1 0.6 0 2.7-0.1 1.2-1.1-1.4-0.8-0.8-1.9-1.5-2.6-2.1-2.4-5.2-1.7-7.6-3 1.3-2.1 2.4-3.4 5.2-1.2 1.3 1.1 3 1.9 4 3.5 1.1 0.6 2.1 1.4 3 2.3-1.6 1.2 0.4 2.5 0 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s176",
    d: "m217.6 207.3c-1.4-0.2-2.3-1.1-3-2.3 2.2 1 2.2-2.3 4.6-2.2-1.7 1.4-1.6 2.9-1.6 4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s177",
    d: "m190.8 209.5q-0.3-0.7-0.7-1.5c0.7-0.6 1.4-0.6 1.7 0.3 0.3 0.8-0.3 1.1-1 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s178",
    d: "m192.4 213.4c-0.6 0.2-1.3 1.4-1.7 0.8-0.6-1.3 0.9-1.7 1.7-2.4q0 0.8 0 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s104",
    d: "m205.4 202.6c-0.5 0.6-0.7 1.7-1.8 1.5 0-1.2 1-1.2 1.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m216.8 176.6c-2.6-0.1-3.4-0.8-3.9-2.3 1.6 0 2 1.4 3.9 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m206 172.8c-0.3-0.3-0.8-0.6-0.7-0.7 0.2-0.9 1-0.9 1.7-1 0.5 0 0.9 0.4 0.6 0.7-0.4 0.4-1 0.6-1.6 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m210 168.3q-0.4-0.8-0.8-1.6c0-0.5-0.1-1-0.1-1.6 1.4 0.9 0.6 2.1 0.9 3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m218.4 177.4v0.8c-0.4 0.4-1.2 1-1.4 0.3-0.3-0.9 0.8-0.9 1.4-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s179",
    d: "m200.8 228.7c0.1-0.5 0.5-1.2 0.4-1.4-2.4-3.6 0.7-4.9 2.7-6.6 0.8-0.7 1.3-1 1.7-2.3 0.5-1.8 2.7-2.3 4.4-0.4 0.8 2 3.6 1.2 4.6 3 0.6 2 3.5 3.7 0.7 6.1-1.9 0.3-1-4.1-3.8-2.3-3.2 0.4-4.8 3.9-8.1 4-0.8 0.1-1.5 0.5-2.2 0.2q-0.2-0.2-0.4-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s79",
    d: "m215.3 227.1c-0.9-1.6 0.7-4.7-3-4.5 0.6-1.2 1.6-1.1 2.3-1.6q1.9 0.8 3.8 1.6c0.3 0.4 0.5 0.5 0.8-0.1-0.2-0.6-1.3-1.3-0.6-1.8 0.8-0.6 1.1 0.4 1.3 1.1 1.7 1.7 3 3.2-0.7 4.1-1.1 0.3-2.1 1.3-3.1 2q-0.4-0.4-0.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s68",
    d: "m219.2 222.5q0.1 0.9 0.2 1.7c-0.3 0-0.7 0.1-0.9 0-0.6-0.5-0.3-1.1-0.1-1.7q0.4 0 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m176.9 184.2c1.9 2.9 3.5 3 5.3 0.4 1.6-2.1 3.7-0.6 5.6-1.1-0.4 1.6-0.3 2.8 1.9 3.1 1.6 0.2 3.3 0.8 4.9 1.6-2.8 0.5-6.4-1.3-8.1 1.6-0.8 1.4-1.9 3.8-1 6-0.6 0.5-1.3 0.5-2 0.4-1.3 0.1-1.4 1.3-2 2.1-1.4 2.1-3.1 1.9-4.9 0.7-2.1-1.2-1.5-2.6 0.1-4-1.8 1.4-2 4.2-4.6 4.5-2.1 0.2-4.3 0.4-6.1-1-1.6-2.7 0.6-3.8 2.2-5.4-3.2-1.4-4 1.8-5.8 2.7-3.1 0-4.5-1.2-3.9-4.2 0.6-2.7 0.8-5.4 0.6-8.1 0.7-1.1 1.7-1.5 3-1.4q0.6 0.2 1 0.5c0.6 1 1.3 1.9 2.7 2.4 0.1-2.3-1.2-5.5 3-5.2q0.5-0.1 1-0.1c1.7 0.1 3.3-0.5 5 0 0.8 1.2-1.2 1.5-0.9 2.6 1.5 1.3 3.8-2.3 4.8 0.7 0.5 1.4-0.9 1.1-1.8 1.2-0.3-0.1-0.4-0.1-0.5-0.1-0.1 0 0 0 0.4 0.1 0.5 0 0.1 0.6 0.3 0.1 0-0.1-0.1-0.1-0.2-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m195.4 192c-2 1.1-3.6 0.8-4.6-1.6 2.2-1.4 3.1 1 4.6 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m197.7 185.8c0.8 0.3 1.5 0.7 0.6 1.5-0.9 0.8-1.7 0.6-2.1-0.7 0.3-0.7 1.1-0.3 1.5-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m197.7 185.8q-0.7 0.4-1.5 0.8c-1.5-0.3-0.8-1.4-0.8-2.3q0.8 0 1.6 0 0.3 0.8 0.7 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m32.3 71.1q0.4 0.8 0.8 1.6 0.3 0.2 0.2 0.5-0.1 0.2-0.2 0.2c-2.3 3.1-3.5-0.7-5.4-0.7 2.2-0.6 2.7-3.1 4.6-3.9q0.2 0.2 0.4 0.4c0.3 0.7 0.1 1.4-0.4 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m33.1 67.3q1.1 0.4 2.3 0.8c-0.1 2.3-0.4 2.4-3.1 0.7q0.4-0.7 0.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m170.9 104h-3c-1-1.3-3.5-0.9-3.9-3.1 0.4-0.9 1-1.7 0.7-2.8-0.1-0.7 0.4-1.3 0.9-1.7q0.4-0.8 0.7-1.6c1.2-1 2.7-1.1 4.2-1.3 0.8-0.5 0.3 1.6 1.3 0.7 0.6-0.5 1.1-1 1.6-1.6 0.4-0.3 0.8-0.6 0.7-1.3q-0.1-0.6 0-1.3c0.2-1 0.3-1.9 0.3-2.9 0.1-1.8-0.2-3.7 2.6-3.5 0.6 0 0-0.3-0.1-0.4-0.5-1.4 0.7-1.9 1.5-2.6 0.9-1 2.4 0.4 3.1-0.9-0.1 0.1 0 0 0 0 0 0-0.2 0.2-0.2 0.3-0.9 0.8-2-0.2-2.8 0.4-0.4 0.3-0.9 0.6-1.4 0.6-1.9-0.2-4.1-0.9-3.5 2.4 0.1 0.5-0.3 1-0.8 1.2-3.1 1.9-9.3-1.1-9.8-4.6 0.1-0.9 0.3-1.8 1-2.5q0.4-0.3 0.9-0.5c4.1-0.8 8.4-1.2 12.1-3.4-1.7-0.7-2.6-1.8-1.2-3.6 0.7-0.6 1.7-0.4 2.3-1.1-0.1 0.1-0.2 0-0.2 0-0.4 0.3-0.8 0.6-1.3 0.7-1.3 0.3-1.6 1.7-2.7 2.2q-0.5 0.3-1 0.3c-1.1 0.3-2.6-1.8-3.6 0.8-0.4 1.1-2.2 1.5-3.7 1q-0.5-0.3-0.8-0.8c-0.6-1.9-0.2-3.8-0.7-5.6-0.3-1.3 0.2-2.4 0.4-3.6 2-3.4 5.9-3.5 8.8-5.2 0.6-0.4 1.8 0 2 0.6 1 2.7 3 2.2 4.9 2-0.1 0 0-0.1-0.1-0.1-0.8 0-1.5 0.3-2.3 0.3q-1.7-0.1-1.9-1.9c-0.1-1.1 0.3-2.1 1.5-2.2 3.4-0.3 7-1 9.6 2.3 0.3 0.3 0.6 0.7 0.6 1.3q-0.2 0.7-0.2 1.4c0.1-0.3 0-0.7 0.1-1 0.3-0.8-0.2-1.4-0.6-2-0.5-1.8-0.2-3.3 1.4-4.2 2.1-1.2 2.8 0.9 4.1 1.7 0.6 0.8 0.2 1.9 0.6 2.8 0 1.1 0.1 2.1 1.1 3 1.8 1.5 2.6 3.9 1.9 6.1-0.7 2.5 0 4 1.7 5.4v0.8c0.9 0.9 1.7 1.9 3.1 2.2 2.3 1.7 4.1 4.6 7.6 3.9 1.4 2.6-1.5 2-2.3 3-1.5 1.8-4.4 2.1-5.3 4.6-1.8 0.2-3.7 0.2-5.2 0.1-3-0.2-2.4 1.8-3.2 3-0.9 1.2-1.6 2.6-3.5 2-1.7-0.2-2.7-2.7-4.7-1.2 0 0 0 0.1 0.1 0.1 1.8-1.6 2.6 0.7 4 1q0.5 0.2 0.8 0.7c0.5 1.9-0.5 3.3-1.5 4.8-0.9 0.8-2.1 0.8-3.1 1-1.1 0.3-1.7-1.4-2.9-0.8h0.1c-2.2-0.1-3.9 2.5-6.3 1.2 0 0.4 0.5 0.7 0.1 1.1q-0.7 0.8-1.5 1.6c-1 0.5-2.2 0-3.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s180",
    d: "m200 102.5c-0.3 0.8 0.5 1 0.8 1.5-1 1.8-2.7 1.6-4.3 1.5-2.1 0-4.2-0.7-6.3-0.9-1.7-0.1-3.2-2-1.6-3.1 2.3-1.8 2.2-4.6 4-6.4q0.3-0.2 0.5-0.3c0.6 0.5 1.9 1 1.8 1.3-0.9 4.3 2.7 4.8 5.1 6.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m203.9 99.4c-2.5 1.3 0.8 2.6 0 3.8-1.5 0.6-1.3-1.4-2.3-1.5h-0.8q-0.7-1.2-2.1-1.5c-2-0.6-2.9-2-1.6-3.7 1.2-1.6-0.7-1.7-0.9-2.9 1.5-0.1 3.3 0.3 3.1 1.7-0.3 2.1 0.1 1.7 1.7 1.6 1.2-0.1 3.3 0.1 2.9 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m200.8 88.7c-0.5-0.7-1.5-1.9-0.6-2.1 2.2-0.4 3.5-2.8 6-2.5 2 1.9-2.5 0.9-1.1 2.4q-2.2 1.1-4.3 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s114",
    d: "m188.5 93.3q2-0.8 3.9-1.5 0.4 1.5 0.7 3c-0.4 0.6-0.8 1.3-1.6 1.3-1.5 0-2.5-0.6-3-2q-0.3-0.3-0.2-0.5 0.1-0.3 0.2-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m203.2 94.2c-1.1-0.2-2.2-0.1-2.8-1.2-0.3-0.5 0.3-0.9 0.8-1 1.5-0.2 1.9 0.8 2 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m219.2 83.4q0.3 1.1 0.7 2.3c-1.2-0.4-2.6-0.6-2.2-2.3 0.1-0.7 0.9-0.5 1.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m210 103.2q0.4 0.8 0.7 1.6c-0.5 0.1-1.2 0.9-1.5 0-0.2-0.3 0.5-1 0.8-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m211.5 101c-1.1 0.1-2.3 0.7-3.1-0.8 1.1 0 2.2-0.1 3.1 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s181",
    d: "m5.5 49c-1.6-1.4-2.8-2.9-5.5-0.8-1.2 0.8-4.8 1.7-7.1-0.3-0.6-0.6-1.3-0.8-2-0.1-0.6 0.7-1 2.3-2.2 1.3-1-0.7 0.2-2.1 0-3.2 0.5-0.7 0.5-1.7 1.4-2.1 1.8-0.3 3.7 0.6 5.5-0.4q0.4-0.3 0.9-0.5c3-1.1 6.3 0.2 9.2-1.8 0.7-0.5 1.8 0.3 2.1 1.2 0.6 1.2 1.5 1.7 2.6 2 0.8 0.6 1.1 1.4 1.3 2.4q-0.8 1.5-1.6 3c-0.7 1.3-1.5 1.9-2.3 0-0.3-1.5-1.3-1.2-2.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s182",
    d: "m30 48.9c-1.5-0.9-3 1-4.6 0.1-0.3-1 0-2.1-0.5-3-1.8-1.9 0.2-3.5 0.4-5.3q0.4-0.7 1.2-1.1c1-0.5 2-0.8 2.9 0.3 0 0.1-0.2 0.5 0.3 0.2 0.6-0.6 1.4-0.6 2.1-0.5q0.5 0.2 1 0.5c0.8 1 1.5 1.3 2.9 0.5 1-0.6 1.8-1.7 3.1-1.9 1.6 0.2 1.9 1.4 2.1 2.7q0.1 1.1-0.1 2.1c-0.3 1.7-1.9 2.5-2.8 3.8-2.4 1.4-5.4 0.7-8 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s183",
    d: "m11.7 46.7q-1.3-0.3-1.6-1.6c-0.4-0.4-1.2-0.7-1.4-1.2-1.1-3.2-3.2-3.2-5.6-1.6-1.6 1.1-3 1-4.5-0.1-1.7-1.2-2-3.2-2.3-5-0.2-1.2 1.2-1.5 2.2-1.3 1.7 0.3 3.2 1 4.7 1.5 2.8 0.5 5.7 0.6 8.3 2.1 1.3 0.8 2.8 1.4 2.8 3.3 0.1 1.6-0.2 3-1.9 3.9q-0.4 0-0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s184",
    d: "m22.4 49.7c-1.6 0-3.2 0.1-4.7 0.8-1.3 0.5-2.7 0.6-2.2-1.5 0.6-0.6 0.6-1.2 0.5-2-0.7-4.2-0.3-4.5 4.1-4.4 0.5 0.2 1 0.6 1.4 1 3.7 3.7 3.7 3.7 0.9 6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s185",
    d: "m20.1 43.6c-4.1 0.3-4.3 0.7-1.8 4.8-0.8 1-1.9 0.4-2.8 0.6v-0.8c-2.3-1.2-2-3.2-1.9-5.2 0.6-1.1 1.5-1.8 2.7-2.2 1.8 0.6 3.8 0.6 5.4 1.8q0.3 0.5 0 1.1c-0.6 0.4-1.1 0.4-1.6-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m20.1 56.6c1.2-0.3 2.5-0.4 3.7-0.8 0.8-0.3 1.6-1 2.3 0 0.7 0.9-0.4 1.6-0.5 2.4-0.2 1.1-0.6 1.4-1.8 1-1.5-0.5-3.6 0.4-4.5-1.8q0.4-0.4 0.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s67",
    d: "m22.4 49.7c2.9-2.7-1.3-3.5-1.6-5.3 1.1-0.8 2.2-1 3 0.1 0.7 0.9 1.5 0.9 2.4 0.6 1.1-0.3 2.3-0.5 1.4 1.2-0.5 1-1.4 1.8-2.2 2.7q-1.5 0.3-3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s186",
    d: "m30 48.9c0.4-0.5 1.1-0.9 0.8-1.9-0.5-1.6 0.4-1.9 1.5-1.1 1.7 1.3 3.5 1.1 5.4 0.8q0.1 0.2 0.2 0.5c0 1-0.6 1.7-1.6 2-1.9 0.2-3.8 0.4-5.5 1.3q-0.4 0-0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s187",
    d: "m7.8 49.7c0.8 0.8 1.6 0.4 2.3 0 2 0.8 0.1 1.6 0 2.3 0.3 0.8 0 1-0.7 0.8-0.3 0-0.5 0-0.8 0-1-0.2-2.6 0.5-3-0.6-0.4-1.4 1.4-1.7 2.2-2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s76",
    d: "m26.2 54.3q-2.3-0.4-4.6-0.7c0.1-1.5-1.8 0.1-1.8-1.1 0.1-0.9 1-1 1.7-1.2 2.9-1 4 0.7 4.7 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s181",
    d: "m14 42.9c0 1.9 0.8 3.6 1.5 5.3-1.4 0.1-2.6 0-3.1-1.5q0.4-2 0.8-3.9 0.4-0.4 0.8 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m15.5 58.9c-1.3 0.6-2.6 1.2-3.8 0 1.2-1.1 2.5-2.7 3.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s188",
    d: "m30 50.5q0 0.4 0 0.8-0.7 0.7-1.5 1.5c0.2-0.9-1.5-1.6-0.5-2.6 0.6-0.5 1.4 0 2 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m9.4 52.8q0.4-0.4 0.7-0.8c0.8 0.2 1.2 0.6 0.7 1.4-0.2 0.3-0.8 0.7-1.2 0.6-0.6-0.1-0.4-0.8-0.2-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s64",
    d: "m21.6 61.2q2.3 0.8 4.6 1.5c-2.1 1.3-3.6 0.7-4.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s78",
    d: "m216.9 33.7c0.9 0.8-0.1 2.5 1.5 3 0 0 0.3 0.2 0.3 0.2 0 0 0.3 0.3 0.3 0.3 0-0.1 0.2 0.2 0.3 0.2q0.3 0.2 0.7 0.5c0.9 0.7 0.3 1.8 0.7 2.6 1.2 0.1 2.7-0.2 3.3 1.3 0.4 0.8-0.4 1.3-1 1.8-1.5 1.2-2.5 0.2-3.5-0.8-0.4-0.5-0.7-1-1.1-1.5-1-1.2-2-0.9-3.1 0q-0.3 0.8-0.7 1.5c-0.8 0.1-1.3 0.8-2.1 0.8-0.6 1.2 0.7 1.8 0.7 2.8 0.9 1.3 3.1 1.9 2.1 4.1-1.1 1.7-2.3 3.1-4.6 3-0.7-1.3-1.7-1.9-3-0.7 0.8 2 3.5 1 4.6 2.7-0.7 2.4-4.2-0.1-4.6 2.6-0.4 0.5-0.9 0.6-1.4 0.4-1.3-0.6-1.8-1.9-2.3-3.2q0-0.4 0.1-0.7c-0.4-0.2-0.4 0.4-0.7 0.4q-2.5 1-3.8-1.4c-0.7-1-0.1-2.1-0.1-3.2q-0.1-0.6-0.1-1.1c0.1-0.7 0.3-1.3 0.2-2.1-0.5-1.9 0.5-3.1 2.3-3.5 1.6-0.5 2.8-1.4 3.7-2.8 1-0.9 2.5-0.6 3.3-1.9q0.5-0.9 1.3-1.5c2.1-0.9 2.7-3.4 4.7-4.5 0.8-0.2 1.4 0.1 2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s66",
    d: "m210 70.4q-3.8 1.5-7.7 3c-1.2-2.3-2.6-3-4.6-0.7-2.5 0.3-3.1-0.8-1.9-2.8 0.7-1.3 1.3-2.8 2.7-3.6 1.9-1.2 4.2-1.8 5.2 0.5 0.8 2.1 1.9 0.4 2.7 0.9 1.6 0.3 4.3-0.9 3.6 2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s189",
    d: "m211.5 47.4c-0.3-1.3-0.8-2.5-0.9-3.8-0.1-1.4 0.5-1.9 1.7-0.8 0.7 0.5 1.7-0.1 2.3 0.8 3-0.2 4.8 1 4.2 4.3-0.2 1.1-0.8 1.5-1.9 1.1-1.8-0.7-3.5-1.4-5.4-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m206.2 58.1q0.7 0 1.5 0c0.1 1.6-1 3.1 0 4.6-0.6 1.2-1.8 1.2-2.8 1.7-0.4 0.1-0.9 0.1-1.1 0.3-1.4 1.2-2.9 2.2-4.6 0.9-1.7-1.2-2.6-3-1.9-5.2 2.4-2.8 6-0.9 8.9-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s190",
    d: "m204.6 63.5c0.9-0.8 2-0.8 3.1-0.8q0.4 0 0.7 0 0.5 0.3 0.8 0.7c0.4 0.7 0.7 1.4 1.7 1.3 0.5 0 1 0.1 1.4 0.3q0.4 0.4 0.7 0.8c0.7 1-0.2 1.6-0.7 2.3q-0.3 2-2.3 2.3c-0.9-2.3-3-1.3-4.6-1.6-0.6-1.7-2.1-3.3-0.8-5.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s78",
    d: "m226.1 35.2c0.3 3.4-1.6 4.6-4.6 4.6-1.1-0.6-1.3-1.6-1.4-2.7q0.2-1.2 1.2-1.7c1.6 0.3 3.1-0.8 4.8-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s121",
    d: "m225.9 42.2c-0.5 1.7 1.3 3.7-0.9 4.9-0.7 0.4-1.7 0.2-1.9-0.6-0.4-2.2 2.2-2.6 2.8-4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s191",
    d: "m211.5 47.4c2.2-0.9 3.9-0.1 5.4 1.6q-0.8 0.7-1.6 1.5c-0.4-2.1-2.6-2-3.8-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m229.1 36q1.2 0 2.3-0.1c0.5 2.5-1.7 1.4-2.5 2-0.4 0.2-1.3-0.1-1.2-0.5 0.2-0.5 0.9-1 1.4-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s121",
    d: "m213.7 57.2c0.2-1.8 0.6-2.8 2-2.9 0.4 0 1.2 1 1.1 1.3-0.5 1.7-2.1 0.4-3.1 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m224.5 62q-0.7 0.7-1.5 1.5c-1.1-1.2-2.6-1-4.8-0.5 2.4-2.8 4.5-0.8 6.3-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s66",
    d: "m212.3 68.1q0.4-1.2 0.7-2.3c0.7-0.2 1.7-0.9 1.8 0.1 0.1 1.5-1.3 1.9-2.5 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s75",
    d: "m215.3 41.3c0.4-1.3 1.4-1.7 2.6-1.4 0.8 0.2 0.9 0.8 0.5 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s192",
    d: "m220.7 37.5q0.4 1.1 0.8 2.3-0.4 0.4-0.8 0.7c-1.3-0.2-0.5-1.8-1.6-2.2-0.7 0.2-0.9-0.1-0.7-0.8 0.8-0.6 1.5-0.7 2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s193",
    d: "m214.8 68.9c1.5-0.5 2.6-0.9 2.9 0.1 0.3 1.2-0.9 0.8-1.5 0.7-0.4-0.1-0.6-0.4-1.4-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s182",
    d: "m207.7 52.8c1.5-1.9 2.7-2.1 3 0.7q-1.5-0.3-3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s66",
    d: "m219.2 52c0.9-2.1 2.3-1.7 3.8-0.7q-1.9 0.3-3.8 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s87",
    d: "m214.6 43.6c-0.9 0-1.7-0.1-2.3-0.8 0.7-0.4 1.5-2.2 2.3 0q0 0.4 0 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m212.3 65l-0.8 0.8c-0.6 0.4-1.2 0.4-1.6-0.1-0.5-0.7-0.3-1.4 0.3-2q0.3-0.1 0.5-0.2 0.8 0.7 1.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s66",
    d: "m219.2 52c-0.2 0.8 0 2.1-1.1 1.9-1-0.1-0.2-0.9 0.2-1.3 0.2-0.2 0.6-0.4 0.9-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s161",
    d: "m208.5 61.2c0.6-0.6 1.1-1.3 2.1-1.1 0 0 0.1 0.2 0.1 0.3-0.3 0.7-0.9 0.7-1.5 0.8q-0.4 0.8-0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s108",
    d: "m208.4 61.2q0.4 0 0.8 0 0.8 1.1 1.5 2.3c-0.7 0.5-1.5 0.7-2.2 0q-0.1-0.4-0.1-0.8 0-0.7 0-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m204.6 63.5c0.7 1.7 2.3 3.3 0.8 5.3h-4.8c0-2 2-0.5 2.4-1.6-2.3-0.5-6.7 2.2-6.7 4.4 0 0.3 0.9 0.7 1.4 1.1v1.5c-2-1.5-0.5 2.9-2 1.4-1.8-1.8-2.6-4.3-1.3-6.7 0.6-1.1 0.5-1-0.3-2-1.3-1.7-1.5-4.3-2.1-6.6 0-0.2 0.2-0.4 0.4-0.6 0.6-0.4 1.2-0.1 1.8 0.2q0.4 0.2 0.8 0.4c0.8 0.2 1.5-0.4 2.3-0.2q0.2 0.2 0.4 0.3c0.5 0.9 1 1.8 1.4 2.7 0.4 1 0.5 2.6 1.9 2.3 1.8-0.3-0.1-1.5 0.2-2.3 1.5-3.3 2.1 2 3.4 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m197.7 72.7c1.2-3.1 4-1.9 6.2-2.9 0.1 1.8-1.3 2.4-1.6 3.6-1.5-0.1-2.8-2-4.6-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s186",
    d: "m200.8 77.2c-0.2 0.5 0.3 1.9-1 1-1.1-0.7-2.2-1.6-2.1-3.2 1.1 0.7 3.4-0.3 3.1 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m198.5 227.1q1.1 0.8 2.3 1.6c0.6 0.9 0.4 1.8-0.1 2.7-0.6 0.5-1.2 0.9-1.9 1.2q-0.5 0.2-1.1 0.2c-1.9-0.2-3.3 0.7-4.6 2-0.6 0.6-1.4 0.7-2.3 0.7-0.7-0.7-1.5 0.7-2.3 0-3.1-0.6-6.2-1.4-9.4-0.3-1.8 0.6-3.4-0.5-5.1-0.4-2.4 0.6-5-0.4-7.4 0.7-1.8-0.1-3.3-0.9-4.9-1.5q-2.6-0.7-5.3-1.5c-1-0.2-1.3-1.4-2.3-1.5q-2-0.3-2.3-2.3c-0.6-1.8-0.3-3.2 1.7-3.9 2.5 0.6 4.9 1.2 7.7 0.5 1.6-0.4 3.8-0.3 5.1 1.7-0.2-2.1-1.7-1.8-2.9-1.7-5.7 0.2-6.2-1.2-6.3-6.3 0.1-1.1-0.4-2.1-0.4-3.2 0.6-2.1 2-2.9 4.1-2.6 1 0.3 1.6 1.1 2.4 1.7 1.2 1.8 2.5 3.3 5.1 2.9 1.6-0.3 2.7 1.2 4 1.9-1.4-1-3.4-1.7-2.4-4.1 0.8-1.8 1.5-3.6 4.1-2.9 1.7 1 1.4 3.1 2.4 4.5 2.4 0.1 2.4 3.4 4.8 3.5 2.8 0.2 3.1 3.5 5.4 4.4 0.8 0.7 1.5 1.5 2.6 2.9-0.5-1.7-1.4-2.8-0.9-4.1 1.2-1.8 3-2.1 5-2.1 1.5 0 3 0.5 2.7 2.3-0.5 2.3 1.4 2.3 2.5 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m154.1 225.6c-1.7 0.3-1.3 2.2-2.3 3.1-0.8 0.5-0.7 2.2-2.3 1.5-1.6 1.5-3.1 3-5.3 3.5q-0.6 0.1-1.1 0c-2-0.7-4-1.4-5.4-3q-0.3-0.5-0.3-1.1c0.5-2.7 1.9-4.5 4.8-4.6-1-1-1.1-1-4-1.4 0 0-0.3 0.1-0.3 0.2-0.3 0.6 0.1 1.3 0 2-0.1 1.2 0.3 2.5-0.8 3.4-1.2 2-3.1 1.6-5 1.5-0.9-0.2-1.9-0.1-2.5-0.9-0.9-2.7 1.2-3.5 3-4.4q0.3-0.2 0.5-0.5 0.1-0.4 0.1-0.7 0.1-0.6 0.1-1.2-0.1-0.8 0-1.7c0.2-0.7 0.4-1.3 0.5-2 0-1-0.1-2.1 0.5-2.9 3.4-4.6 6.7-9.4 12-12.1 2.3 0.3 4.5 0.2 6.7 0.5 2.6 0.5 4-0.5 5.2-2.6 0.9-0.7 2-0.8 3.1-0.9 3.7 1.7 3.8 2.1 1.2 5.8 2.4-0.1 3.5 2.3 5.6 2.8 0.4 0.4 0.6 0.9 0.6 1.5 0 0.8-0.4 1.5-0.8 2.1q-0.4 0.4-0.8 0.7c-1 0.5-2.1 0.7-3.2 0.7-1 0-1.9-0.8-2.9-0.8-1.8 0-3 0.8-3.9 2.3 0.6 1.6 0.3 3-1.3 3.9-0.6 0.6-1.2 1.2-1.9 1.6-2.1 0-3.1-1.3-4.1-2.8 1.1 1.5 2 3.1 4.2 2.7 1.9 0.8 1.9 0.8 0.5 3.5q-0.2 0.2-0.4 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s194",
    d: "m143.4 232.5q0.3 0 0.7 0c0.6 0.7 1.7 0 2.3 0.8 0 2-0.1 4-3.1 3.2-0.8-0.2-1.2 0.6-1.5 1.3q-0.1 0.3-0.2 0.5c-1.5 1.4-3.1 1.2-4.9 0.6-1.2-0.4-2.7 0.3-4.1 0.5-1.6-0.3-2.8 0.7-4.1 1.3-0.2-0.1-0.3-0.2-0.3-0.2 0.3-3.8-4.8-1.8-4.5-3.5 0.5-2.4 1.6-4-1.8-4.5-0.7-0.7-0.6-1.5-0.1-2.3 1.8-0.7 3.6-1.7 5.7-1.8q0.8 0 1.4 0.6c1.1 2.3 3.3 1.7 5.2 1.9q0.5 0 1.1 0c1.6 0.1 2.7 1 3.4 2.5 0.2-2.2 1.8-1.2 3-1.3 0.6 0 1.3-0.1 1.8 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m200 231q0.4-1.2 0.8-2.3c1.8-0.3 2.4-3.8 5.1-2 0.4 0.3 0.9-0.4 1-0.9 0.9-3.5 2.7-2.5 4.6-1-1.2 2.8-4.7 3.7-5.4 6.9-1.1 1.9-7.2 4-9.1 3.1q-0.4-0.4-0.8-0.8c-0.2-1.2 0.9-1.6 1.5-2.3h0.8c0.6 0 1.2-0.1 1.5-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s133",
    d: "m154.1 231c0.6-0.6 1.2-1.2 1.9-1.8 1.2 1.2 0.1 2.3 0.4 3.3-1.3 0.8-1.3 3.8-3.2 2.7-1.3-0.7-0.2-2.9 0.9-4.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s195",
    d: "m81.3 235.5c-2.7-2.2-5.9-3.9-9.2-5.3q0.2-0.6 0.5-1c1.6-1.5 3.4-0.8 5-0.1 5 2.1 10 2.8 15.2 0.4 1.4-0.7 3-0.4 3.8 1.4q0.1 0.6 0 1.2c-0.9 1.3-1.6 3.1-3.8 1.9-3.2 2.4-7.4 0.4-10.7 2.3q-0.4-0.4-0.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s196",
    d: "m72.9 230.2q-0.4 0-0.8 0c-2 2.8-4.6-0.1-6.8 0.8q-0.4-0.4-0.8-0.8 0.4-1.2 0.8-2.3c1.7-1.6 7.6-1.9 8.8-0.3 1.3 1.5-1.1 1.6-1.2 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s122",
    d: "m212.3 26q-0.4 0.4-0.8 0.8 0 0.3 0 0.5-0.2 0.6-0.6 0.9c-0.8 0.5-1.7 0.6-2.6 0.8q-0.4-0.1-0.8-0.2c0.1 0-0.1-0.1-0.1-0.1 0 0-0.2 0.1-0.2 0.2 0.9 2.7-1.1 3.3-2.8 4.2-0.5 0.5-0.9 1-1.6 1.3-0.7 0.3-1.4 0.4-2.1 0.3-0.9-0.5-1.9-0.7-2.5-1.6-0.4-1-0.2-1.9 0.4-2.7 0.1-1 2.6-0.3 1.3-2.1-0.7-0.6-1.5-1.3-1.3-2.2 0.2-0.9-0.2-0.6-0.6-0.5q-0.5 0-1-0.2c-0.9-0.7-1.1-1.6-1.1-2.6 0.8-3.5 5.5-5.8 9.3-4.7 0.8 0.9 1.2 1.8 0.3 2.8 0 0 0.1 0.2 0.1 0.2 0 0 0.1-0.2 0.2-0.2 0.3-0.2 0.7-0.3 1.1-0.2 0.5 0 0.9 0.3 1.3 0.5 0.5 0.3 1.1 0.6 1.7 0.5q0.5 0 1-0.1c0.7-0.2 1.3-0.1 2 0.3 2.6 1.8 0.5 2.9-0.6 4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m226.1 35.2c-1.6 0.3-3 1.5-4.7 0.8-0.9 0.4-1.7 1.7-3 0.7 0.1-2.5 0.8-3.9 3.6-2.3 0.7 0.5 1.7 0.4 2.5 0q0.8 0.4 1.6 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s126",
    d: "m216.9 33.7q-1.2 0-2.3 0c-0.8 0.2-1.6 0.8-2.5 0.6-0.7-0.2-1.3-0.6-1.6-1.2-0.2-1.3 0.6-2 1.4-2.8q0.4-0.3 1-0.4c1.5-0.1 2.6 0.9 3.8 1.7q0.1 0.3 0.2 0.5 0 0.8 0 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s73",
    d: "m211.5 26.8c1.7-0.1 3.4 0.3 4.9 1.1 0.8 0.5 0.4 0.9-0.3 1.2q-0.6 0.7-1.6 0.7c-1.4-0.6-3.2-0.8-3-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s197",
    d: "m220.7 24.5c-1-0.5-2.1-1-2.3-2.3-0.2-0.7 0.1-1.1 0.6-1.5 0.5-0.3 1.1-0.4 1.7-0.3 2.9 0.9 1.9 2.3 0.5 3.8q-0.2 0.2-0.5 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s78",
    d: "m225.8 28.6c-1.2 1.6-2.2 1.9-4.1 1.5 1.2-1.3 2.2-1.6 4.1-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s198",
    d: "m219.2 21.4q-0.4 0.4-0.8 0.8c-1.1 0.1-2.4 0.7-3.1-0.8q0-0.9 0.7-1.6c1.7-0.8 3.1-1 3.2 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s199",
    d: "m212.3 26c0.2-1.3 1.9-2.5 0-3.8 0.5-0.4 1-0.5 1.5 0 2.8 2.6-0.2 2.9-1.5 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s200",
    d: "m213.8 22.2h-1.5q-0.8 0.4-1.6 0.7c-0.6-0.8-0.4-1.5 0.3-2.2 1.1-0.6 2.2-1.2 3.6-1 0.6 0.1 1.2 0.4 1.5 1q-0.4 0.3-0.8 0.7-0.7 0.4-1.5 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s201",
    d: "m214.6 29.1q0.7 0 1.5 0c0.4 1 2.9 1.4 0.8 3-0.8-1-3.1-0.9-2.3-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s202",
    d: "m223.8 24.5v0.8c-1.1-0.1-2.6 1.7-3.1-0.8 1-0.8 2-1 3.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s203",
    d: "m223.8 24.5q-1.6 0-3.1 0c-0.6-1 1.4-2.1 0-3.1-0.6-0.7-0.4-1.3 0.1-1.9q0.5-0.3 1-0.5c1.1-0.2 2.1 0.1 3.1 0.8 0.6 0.4 0.7 1.1 1.2 1.6q0.3 0.4 0.7 0.8-0.7 1.1-1.5 2.3-0.8 0-1.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s204",
    d: "m38.5 3.8l1.5-0.7c0.5-0.7-0.1-1.8 0.8-2.3 1.8-0.8 3.3-2.2 5.3-2.3 1.3 1.3 0.5 2.5-0.1 3.8-0.3 0.3-0.5 0.6-0.6 1.1 0.1 0.1 0 0.3 0 0.4 0-0.1 0.2-0.3 0.2-0.3 0.5-0.7 0.9-1.7 2-1.2q0.4 0.4 0.8 0.8c1.4-1 3.3 0.7 4.6-0.8h1.5c2.6-0.1 4.1 2.5 2.9 4.8-0.7 1.2-1.4 2.4-2.1 3.6 0.3 0.4 0.5 0.5 0.8 0q0.7-0.4 1.5-0.7c1.4 0.7 1.1 2.1 1.1 3.3q0 0.8-0.5 1.5c-0.5 0.8-1.3 1.1-2.1 1.6-0.7 0.3-1.3 1-2.1 1.4-0.6 0.3-1.3 0.4-2 0.1-0.6-0.5-0.9-1.1-1-1.7-0.5-1.9-1.2 0.2-1.8-0.2-2 0.2-2.2-1.4-2.7-2.7-0.3-0.5-0.9-0.7-1.4-0.9-0.7-0.4-1.2-1.2-2-1.4-0.8-0.6-1.9-0.6-2.8-1.2-0.8-0.8-1.1-1.8-0.8-2.9 0.6-1.4-1.7-1.7-1-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s99",
    d: "m57.6 13q0-1.5 0-3.1 0.8-0.3 1.5-0.7c1.4 0 2.6-0.7 4-0.8q0.5 0.1 0.9 0.4c0.9 1.5 2.1 0.1 3.1 0.3 1.2 0.2 2.5 0.4 3.8 0.5 2 0.2 3.4 1 3.9 3.1-0.7 1.8-3.1 1.9-3.7 3.8-1.6 0.6-3.5 0.3-4.8 1.8q-0.5 0.2-1 0.2c-2-0.6-4.4-0.3-5.9-2.3-0.5-1.1-0.5-2.5-1.8-3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s88",
    d: "m68.3 4.6c-2.1-0.9-5.1-1-4.6-4.6 0.5-0.6 1.1-0.9 1.8-1 1.8 0 2.6 1.1 3.1 2.6 0.1 0.7 0.3 1.4 0.3 2.1q-0.2 0.6-0.6 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s84",
    d: "m68.3 4.6q0-0.4 0-0.8c2.7-3.4 4.1-0.6 5.7 1.3 0.2 0.8 0 1.5-0.7 2.1-1.3 0.8-2.4 0.1-3.4-0.6-0.5-0.2-1-0.5-1.3-0.8q-0.2-0.2-0.3-0.5 0-0.3 0-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s88",
    d: "m63 9.2c-1.3 0.1-2.6 2.6-3.9 0q0-0.4 0-0.8c0.7-0.6 1.3-1.2 2.3-0.7h1.6q0.1 0.1 0.3 0.3c0.1 0.5 0.1 0.9-0.3 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s204",
    d: "m61.4 7.7q-1.1 0.3-2.3 0.7c-0.2-2 2.7-1.9 2-4.5 1.6 1.8 0.6 2.8 0.3 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s88",
    d: "m63 7.7c0.9-2.7 3.2-2.3 5.3-2.4v0.1c-0.7 3.3-2.9 3.1-5.3 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s100",
    d: "m60.7 0c-1.1-0.6-1.1-1.3-0.2-2 0.3-0.2 0.8-0.5 0.9-0.4 0.9 0.8-0.1 1.6 0 2.4q-0.3 0.5-0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s99",
    d: "m56.1 10.7c-0.2 0.6 0.1 1.9-1 1.6-0.7-0.2-0.2-1.1 0.2-1.6q0.4 0 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s205",
    d: "m65.3-0.7q-0.8 0.3-1.6 0.7c-0.5-1.5 0.6-1.5 1.6-1.5q0.3 0.2 0.2 0.5-0.1 0.3-0.2 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s206",
    d: "m60.7 0q0.4 0 0.7 0c0.5 0.2 1.3 0.4 0.9 0.8-0.8 0.8-1.2-0.3-1.6-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s102",
    d: "m40.8 0.8c-0.7 0.6 1.9 2.3-0.8 2.3-2.4-1.5-4.7-3-7.1 0.3-0.5-1.9-0.9-3.4-1.3-4.9q0.3 0 0.7 0c2.2-0.1 4.5-0.9 5.8 1.9 0.5 1.1 1.7 0.4 2.7 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s207",
    d: "m45.3 2.3c-1-1.5 0.6-2.5 0.8-3.8q1.2-1 2.3 0c0.1 1.3-0.1 2.6-0.8 3.8q-0.7 1.2-1.5 2.3-0.8 0.7-1.5 0 0-0.8 0-1.5c0.1-0.4 0.6-0.4 0.7-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s207",
    d: "m53 2.3c1 1.5 1.3 2.7-1.2 2.1-1.2-0.2-2.3-0.9-3.4-1.3 1.2-2.1 3-0.9 4.6-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s208",
    d: "m65.3-0.7q0-0.4 0-0.8c0.3-1.7 1.6-2.4 3-3.1q0.8 0 1.5 0 0.8 0.8 1.6 1.6c0.5 0.6 1.3 1.2 0.8 2.2-0.8 0.8-0.7 1.6 0 2.3h-0.1c-1.2 2.1-2.9 1.2-4.5 0.8q-1.2-1.5-2.3-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s209",
    d: "m157.9-8.4c1.9-0.5 2.8 1.8 4.6 1.5q2.3 0 4.6 0c0 1.1 1.3 2.5-0.8 3.1-1.1 0.7-1.4 2.2-2.5 2.9-1 0.4-2 0.6-3.1 0.6-1.2-0.5-1.1-1.7-1.3-2.7 1-2.3 0.1-3.9-1.5-5.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s210",
    d: "m163.3-1.5c0.1-2 0.8-3.2 3-2.3 0.5 1.7 1.8 1.5 3.1 1.5 0.4 1.3-0.5 1.8-1.4 2.4-1.7-0.2-4 1.6-4.7-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s211",
    d: "m167.9-0.8q0.7-0.7 1.5-1.5 0.4 0 0.8 0c1 0.8 1 1.9 0.7 3.1q-0.2 0.1-0.4 0.2c-0.9 0.2-1.5-0.5-2.2-0.9q-0.3-0.4-0.4-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s96",
    d: "m187-3.8c-0.9 2.8 2.7 2.6 3.1 4.6 0.3 0.4 0.4 0.9 0.4 1.4-0.2 0.5-0.5 0.9-1 1.2q-1.2 0.9-2.6 0.5-0.5-0.2-0.9-0.6c-0.2-0.5-0.1-1.2-0.5-1.7 0 0 0 0.2 0 0.2 0.2 0.5 0.3 1 0.2 1.5q-0.5 1-1.7 1.1c-0.7-0.1-1.4-0.3-2.1-0.7-0.7-0.8-1.3-1.7-2.2-2.3-0.5-0.5-0.7-1.2-0.7-2q0-0.5 0.4-0.9c1.5-0.7 3.2-1.2 3.8-3.1q0.4 0 0.7 0c1.1 0.1 2.2 0 3.1 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s212",
    d: "m179.4-1.5q0 0.4 0 0.8c0.2 1.4-0.6 2.2-1.8 2.8-1.9 0-2.5-1.1-2.1-2.9q0.8-0.7 1.6-1.5 0.3 0 0.7 0c0.1 1.1 0.8 1.1 1.6 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s213",
    d: "m173.2 0q0.4 0 0.8 0c1 1.7-0.2 2.4-1.4 3-1 0.2-1.9 0.2-2.4-0.8-0.3-0.7 0.2-1.1 0.7-1.4q1.2-0.4 2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s204",
    d: "m172.5 2.3c0.5-0.7 1.4-1.3 1.5-2.3q0.8-0.4 1.5-0.8c0.5 1.1 1 2.1 2.3 2.3q0.5 0.2 0.8 0.5c0.7 1.1 2.2 0.7 3 1.5 0.9 1.6 0.2 2.7-1.1 3.5-0.6 0.2-1.2 0.3-1.8 0.3-0.8 0-1.6 0-2.4-0.2-1.6-0.9-2.4-2.8-4-3.8q-0.2-0.6 0.2-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s201",
    d: "m221.5 19.9q-0.4 0.8-0.8 1.5-0.8 0-1.5 0c-0.8-1.4-1.9-1.4-3.1-0.7q-0.8 0-1.5 0c-0.8-0.8-0.8-1.6-0.3-2.5 0.3-0.7 0.6-1.3 0.9-1.9 0.7-1.3 1.8-2 3-2.6 0.4-0.5 0.6-1.1 0.8-1.7 0.2-0.8 0.6-1.5 1.6-1.7q0.5 0 0.9 0.4l0.7 3.1c-0.8 2 0.6 4.2-0.7 6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s214",
    d: "m221.5 10.7q-0.4 0-0.8 0c-0.8-0.4-1.7-0.3-2.5-0.8-1.5-1.2-2.1-3.2-3.8-4.2q-0.2-0.4-0.2-1c0.4-0.9 1.2-1.6 2-2.3 0.9-0.5 1.9-1 3-1.1 1-0.1 1.7 0.6 2.6 0.8 1.1 0.7 3 0.9 2.8 2.6-0.2 1.6-2.2 1.2-3.1 2.2-2 1.3 0.6 2.5 0 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s215",
    d: "m221.5 6.9c0.4-1 1.5-1.3 2.3-1.9 0-1.6-2.4-0.3-2.3-1.9-0.3-0.8-0.8-1.6 0-2.3q1.1 0 2.3 0c0.5 1 0.7 2.2 2.1 2.4q0.6 0.5 0.6 1.3-0.1 0.5-0.4 0.9c-0.8 1.6-3.1 0.7-3.9 2.3q-0.3-0.4-0.7-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s216",
    d: "m221.5 19.9c-1.4-2.2-0.2-4.2 0.7-6.1 0.6 1.6 0 4.2 3.1 3.8 0.2 2.5-1.9 1.7-3.1 2.3q-0.4 0-0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m226.1 21.4q-0.8-0.4-1.6-0.7c-0.1-2.3 1.5-2.4 3.1-2.3q0.7-0.4 1.5-0.8c-0.1 2-1.9 2.6-3 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s186",
    d: "m227.6 18.4c-1.2 0.6-2.4 1-3.1 2.3q-1.1-0.4-2.3-0.8 1.6-1.1 3.1-2.3c0.8 0 1.7 0.1 2.3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s201",
    d: "m224.8 12.5c0.1 0-0.3 0.4-0.6 0.3-0.8-0.3-0.8-1.1-0.7-1.9 0-0.1 0.5-0.5 0.7-0.4 0.7 0.3 0.9 0.8 0.6 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s217",
    d: "m226.1 5.4v-0.8c0.7-1.4 1.7-1.6 3-0.8q0 0.4 0 0.8-1.5 0.4-3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s218",
    d: "m124.2 6.9q0.4 0 0.8 0c0.4 0.3 0.8 0.6 1 1q0.1 0.5 0 1c-0.5 1.5-1.7 2.1-3.1 2.3-2.1 0-3 2.1-4.7 2.7q-0.8 0.2-1.6-0.1c-1.5-1.1-3.3-1.9-4.5-3.4-1.5-1.4-3.8-1.2-5.3-2.8q-0.3-0.5-0.3-1.1c0.5-2.1 1.4-3.7 3.9-2.7q0.3 1.3 1.6 1.6c1.6-0.9 3-2.7 5.3-1.5 1.4 0.5 1.4 3.5 3.9 2.2 0.5-0.4 1-0.2 1.5 0 0.6 0 1.1 0.3 1.5 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s211",
    d: "m95.1 3.8c-0.5-0.9-2.1-0.9-2.2-2.2 0.9-1.3 3.8-0.5 3.5-3.1-0.2-1.2-1.1-1.1-2-0.8 0.2-1.9 2.8-1.9 3-3.8 1.5 0.8 3.5-0.3 4.6 1.5q-0.2 0.5-0.6 0.8c-0.7 0.4-1.4 0.7-1.4 1.7 0.1 0.7 0.1 1.5 0.5 2.1 1 0.1 1.6 0.9 2.3 1.5 0.4 1.1 0.3 2-0.6 2.7-0.8 0.4-1.5 0.3-2.2 0-1.1-1.2-2.3-1.2-3.5-0.3q-0.5 0.2-1 0.2-0.2-0.1-0.4-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s219",
    d: "m101.2-4.6q0.4 0 0.8 0c0.9-0.5 0.2-1.6 0.8-2.3q0.4 0 0.8 0c1.2 0.8 1 1.9 0.7 3.1-1.1 0.9-3 1.1-3.1 3.1q-0.3 0.3-0.7 0.7-1.2-0.8-2.3-1.5c0.3-1.8 1.7-2.4 3-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s220",
    d: "m110.5 3.8q-2.4 0.8-3.1 3.1c-0.7 0.6-1.4 0.7-2.2 0.4q-0.5-0.4-0.5-1c0.2-2.5 2.5-2.9 4.2-4q2.6-1 1.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s221",
    d: "m108.9 2.3c-1.3 1.2-2.1 3.1-3.8 3.8-0.6 0.1-1.1 0.1-1.6-0.2q-0.4-0.4-0.5-1c-0.1-1.9 1.5-2.2 2.8-2.6 1.1 1 2.1-1.8 3.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s222",
    d: "m117.3 4.6c-1.1 0.1-2.2-0.1-2.9 1-0.9 1.2-1.7 0.5-2.4-0.2q0-0.8 0-1.6c1.1-1.4 2.7-1.3 4.2-1.4 1 0.5 1.6 1.1 1.1 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s223",
    d: "m105.8 2.3c-0.5 1.2-2.1 1.6-2.3 3.1-1.3 0.2-1.5-0.6-1.5-1.6q0.4-1.1 0.8-2.3c0.8 1.1 2.6-1.6 3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s221",
    d: "m115.8 3.1q-1.9 0.4-3.8 0.7 0.7-1.5 1.5-3 0.8 0.4 1.6 0.7 0.4-0.4 0.9 0c0.3 0.6 0.3 1.1-0.2 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s224",
    d: "m115.8 1.5q-0.4 0-0.7 0c0.5-1.3 1.3-2.4 3-2.3 0.6 0.7 1.2 1.3 0.8 2.3-1.1 0.7-2.1 1.8-3.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m229.1 3.8q-1.5 0.4-3 0.8-0.4-0.4-0.8-0.8c-0.4-0.5-0.5-1 0-1.5 1.4 0.1 3-0.2 4.2 0.3 1.3 0.5 0.3 1-0.4 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s217",
    d: "m225.3 2.3v1.5c-1.2-0.6-1.6-1.7-1.5-3q0.3 0 0.7 0 0.4 0.8 0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s225",
    d: "m27.7 7.7q0.4 0.3 0.8 0.7-0.1 0.5-0.5 0.9c-0.6 0.3-1.1 0.7-1.8 0.9-0.6 0.2-1.1 0.5-1.4 1-0.4 0.5-0.6 1.1-1 1.6-0.5 0.5-1.1 0.8-1.6 1.2-0.9 0.5-1.8 1.1-2.8 1.4q-0.5 0-1-0.1c-0.7-0.1-1.4-0.5-2.1-0.3-1.1 0.4-1.7 1.6-3 1.6-0.8 0-1.4-0.4-1.8-1-0.4-0.6-0.4-1.3-0.2-2 0.2-0.6 0.2-1.3 0.2-1.9q0-1 0.2-1.9c0.2-0.9 0.7-1.5 1.6-1.9q0.5-0.1 1 0 1 0.3 1.4 1.3 0.2 0.3 0.6 0.3c1-0.3 0.7-0.9 0.5-1.5-0.1-0.9-0.5-1.7-0.2-2.6q0.3-0.4 0.8-0.7c1.2-0.2 2.4 0.4 3.5-0.1 1.5-0.3 2.5 0.4 3.5 1.2 0.7 0.5 1.5 0.7 2.3 0.9 0.4 0.2 0.7 0.6 1 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s226",
    d: "m34.6 6.1q0.8 0.4 1.6 0.8 0.4 0.4 0.5 0.9c-0.1 1.3-0.8 2.3-1.4 3.3-0.6 0.6-1.2 1.1-1.8 1.8q-0.4 0.4-0.8 0.7c-2.2-0.1-5.2 1.5-5.5-2.6 0.4-0.4 0.9-0.6 1.4-0.7 2.4-0.8 4.7-1.8 6-4.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s227",
    d: "m34.6 6.1c-0.5 3-3.1 4-5.3 5.4-1.8-1-1.1-2.1 0-3.1 2.7 1.5 2.7-3.4 5.3-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s228",
    d: "m27.7 7.7q-0.7 0-1.5 0c-0.5-0.8-1-1.5-1-2.5q0.1-0.6 0.3-1.1c0.6-0.9 1.2-1.9 2.5-2q0.2 0.1 0.5 0.2c4 2.4-0.5 3.6-0.8 5.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s229",
    d: "m36.2 7.7q0-0.4 0-0.8 1.1-0.4 2.3-0.8c1-0.6 1.7 0 2.3 0.8q-0.6 1.1 0 2.3c-0.4 1.1-1.3 1.7-2.3 2.1-2.9 0.1-2.2-2-2.3-3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s230",
    d: "m40.8 6.9q-1.2-0.4-2.3-0.8c-0.4-0.7-0.8-1.5 0-2.3 1 1.1 2.5 1.1 3.9 1.2 0.2 1.4-1.3 1.1-1.6 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s231",
    d: "m29.3 8.4c-0.2 1-0.6 2.1 0 3.1h-1.6q-0.4-0.4-0.7-0.9c-0.2-0.9 0.2-1.6 0.7-2.2q0.4 0 0.8 0 0.4 0 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s232",
    d: "m34.6 4.7c0.2-0.3 0.3-0.6 0.4-0.6 0.4 0 0.8 0.1 1 0.4 0.3 0.3 0 0.7-0.4 0.7-0.3-0.1-0.7-0.3-1-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s227",
    d: "m30-0.7c1.3 1.9 0.7 2.8-1.5 3-0.8-1.7 0.9-2.1 1.5-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s207",
    d: "m30-0.8c0.1 1.4-0.6 2.3-1.5 3.1q-1.1 1.2-2.3 2.3c-1 0.3-0.6 1.4-1 2-0.4 0.4-0.8 0.7-1.3 0.3-1.6 0.6-1.4-2.2-3-1.5-1.1 0.7-2.1-0.8-3.1 0q-0.4 0-0.8 0-1 0.2-0.8-0.8c1.4-2.1 3.9 0.1 5.4-1.5q0-0.4-0.1-0.8-0.1-0.2-0.2-0.4c-0.6-0.5-1.5-0.4-2-1.1-0.4-2 2-2.3 2.3-3.8 0.8-1.1 1.1-2.9 3.1-2.3q1.3 0.2 1.5 1.5c-1.9 0.8-0.1 1.5 0 2.3 1.1 1 2.5 0.7 3.8 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s233",
    d: "m69.9 5.4q1.5 0.7 3 1.5c1.2-1.2 2.2-3.1 4.4-1.7 0.2 0 0.4 0.5 0.6 0 0.3-2.1 2.4-1.3 3.4-2.1q-0.3-0.8-0.7-1.6c1.1-0.9 2.4 0 3.7-0.2 0 1.4-2.9 1-1.6 3.1 1.4 2.2 2-0.2 3.1-0.3 0.2-0.1 0.6 0.3 0.9 0.5 0.7 1.1 1.1 2.2 0.4 3.5-0.6 0.7-1.4 1.1-2.2 1.5-1.8 0.9-4.5 0.5-4.9 3.4-1.6 1.4-3.3 2.4-5.5 1.1q-0.4-0.5-0.1-1.1-1.9-1.1-3.8-2.3c-0.8-0.7-1.3-1.5-1.8-2.4-0.2-0.5-0.3-1-0.3-1.5 0.3-0.7 0.7-1.2 1.4-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s83",
    d: "m67.6 2.3q2.3-0.4 4.5-0.8c1.7 0.3 3.2 0.6 3.9 2.3 0.1 1.9-1.7 0.9-2.3 1.6-1.9-0.3-3-3-5.4-1.6q-0.4-0.7-0.7-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s213",
    d: "m73.7 5.4q1.1-0.8 2.3-1.6c1.7-0.9 3.4-1.7 5.3-0.7 0.7 1.6-3.9 0.5-1.5 3-0.8 0.6-1.5 0.6-2.3 0-1.7-0.8-3.1 0.1-4.6 0.8q0.4-0.8 0.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s234",
    d: "m76.8-2.3q0.7 1.2 1.5 2.3c-1.4-0.2-2.2-0.8-1.5-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s83",
    d: "m72.1 1.5c-1-0.7-2-1.5 0-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s235",
    d: "m-8.3 0q-1.1-0.8-2.3-1.5 0-0.8 0.1-1.6c0.7-0.5 1.9-0.3 2.2-1.5q0.8 0 1.6 0c0.7 1.9 2.2 1.8 3.8 1.6 0.5-0.5 1-0.5 1.5 0q0.4 0.7 0.8 1.5c0.8 0.7 1.7 1.4 1.3 2.8q-0.2 0.4-0.6 0.9c-0.7 0.5-1.2 1.2-1.9 1.7-1.2 0.6-1.9-0.1-2.5-1.1q-0.1-0.2-0.1-0.5-0.8-1.1-1.6-2.3c-0.5-0.5-1-0.3-1.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s236",
    d: "m190.1 1.6c-0.1-0.2-0.2-0.4-0.2-0.6 0 0 0.1-0.1 0.2-0.2 2.1-2.8 4.8-2.5 7.6-1.5 1.2 0.6 1.7 1.5 0.8 2.7-1 0.8-2.5 0.7-3.4 1.7q-0.7 0.4-1.6 0.3-0.5-0.1-1-0.3c-0.8-0.7-1.8-1.2-2.4-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s237",
    d: "m197.7 1.5c0.8-0.7 0.4-1.5 0-2.2 0.9-0.3 1.6-0.6 0.8-1.6q-0.3-0.5 0-1c0.6-0.6 1.3-0.8 2-0.7 1 0.2 1.7 0.7 2.1 1.6q0.2 0.5 0.2 1c0 0.6-0.2 1.3-0.1 1.9q0.1 1.7-1.3 2.8-1.5 1-3.2 0.2c-0.5-0.6-0.9-1.1-0.5-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s198",
    d: "m221.5 0.8c0.3 0.7 0.8 1.5 0 2.3q-1.2-0.4-2.3-0.8c-1-0.4-1.9 0-2.9 0-0.6 0.2-1.1 0.5-1.5 1.1q-0.4 0.3-0.8 0.5c-1.6 1.7-3.9 2-5.5 3.5-0.3 0.4-0.5 0.9-0.7 1.3q-0.9 1.3-2.5 1c-1.2-0.5-1.4-1.8-2.1-2.7-1.9-3.4 0.4-4.9 3-6.2 2-1 4.1-0.6 6.1 0.4 0.8-1.3-3.5-2.4 0-3.5 0.6-0.1 1.1-0.3 1.8-0.3 0.6-0.1 1.2-0.3 1.9-0.1 0.7 0.6 2.4-0.9 2.4 1.2 2.3 1.7 4-1.7 6.3-0.7 0.5 2.5-3 1.2-3.2 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s238",
    d: "m206.2 0.8c-0.1 1.3 0 2.5-1.6 3.1-1.9 0.7-0.4 1.5 0 2.2q-0.7 1.1-1.9 1.1c-2-0.4-4.5 0.7-6-1.6 0-0.8 0.4-1.3 1.1-1.7 1-0.3 2-0.4 3-0.8q0.4-1.6 0.8-3.1c0.4-0.4 0.3-1.1 0.7-1.5 0.4-0.8 0.7-1.6 1.4-2.1 0.8-0.1 1.6-0.6 2.5-0.2 0.6 1.5-0.3 3.1 0 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s239",
    d: "m142.6 2.3q1.1-0.4 2.3-0.8c0.5 0.8 0.9 1.6 0.9 2.6-0.1 0.8-0.6 1.6-1 2.4-0.5 0.6-1.2 1.2-1.6 1.9-0.8 0.9 0 1.5 0.5 2.2 0.6 1 0.8 2 0.3 3.1-0.7 0.9-1.6 1-2.6 0.9 1 0.2 2.4 0 2.5 1.7q0 0.6-0.3 1c-0.7 0.7-1.5 1.2-2.5 1.4-2.6 0.3-5-2-7.7-0.5-0.6 0-1.1-0.3-1.6-0.6-1.1-1.1-1.4-2.4-1.5-3.8 0.3-1.1-0.1-2.3 0.4-3.4 1.5-2.2 3.3-0.4 5-0.5 3.5-1.2 1.8-3.8 1.5-6.1 1-0.7 0.7-1.9 1.2-2.8 0.1-0.8 0.5-1.3 1.1-1.7q0-0.4 0-0.8c0.9-0.8 1.7-0.5 2.5 0.1 1.3 1.1-0.7 2.6 0.6 3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s240",
    d: "m115.8 1.5c1 0.6 2 0.2 3.1 0-0.1 0.5-0.5 1.2 0.3 1.2 2.8 0.1 1.6 1 0.4 1.9-0.5 0.9 0.3 1.1 0.8 1.5q0.4 0 0.8 0c-0.7 1.2-1.6 1.5-2.9 0.9-1.1-0.5-1.5-1.3-1-2.4q-0.7-0.8-1.5-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s241",
    d: "m139.5 1.5c-0.4 1.2-0.4 2.6-2.3 2.3q-0.2-1.3-1.5-1.5c-1.6-2.1-1.8-3.7 1.5-3.8 1 0.9 1.9 1.7 2.3 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s233",
    d: "m135.7 9.9c-1.5 0.7-3.2-0.3-4.6 0.8q-0.3 0.4-0.9 0.4c-0.8-0.1-1.4-0.7-2.3-0.8-1-0.3-2.6 0-2.1-1.9 2.3-2.4 4.6-1 6.9 0q1.5 0.8 3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s242",
    d: "m132.7 8.4c-2.3 0.7-4.6-2-6.9 0q-0.4-0.7-0.8-1.5c1.9-0.1 3.8-0.1 5.6-0.3 1.6-0.2 2 0.5 2.1 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s84",
    d: "m124.2 2.3q0.4-0.8 0.8-1.5c1.5-0.2 1.7 0.9 2 2 0.2 0.6 0 0.9-0.6 1-1.1 0.1-1.9-0.3-2.2-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s243",
    d: "m128-2.3h1.6c0.3 0.1 0.8 0 1 0.2 0.6 0.6-0.1 0.9-0.4 1-1 0.2-2 0.2-2.9 0.4-0.5-0.9-0.7-1.6 0.7-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s244",
    d: "m128-2.3q-0.4 0.8-0.7 1.6c-0.5 0.4-1 0.1-1.6-0.1 0.8-1.1-0.7-1.6-0.7-2.6 1.2-0.1 2.2 0.4 3 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s88",
    d: "m124.2 6.9q-0.8-0.4-1.5-0.8c0.5-0.8 1.1-1.5 2-0.7 0.7 0.6-0.3 1-0.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s100",
    d: "m118.9 1.5q-0.4-1.1-0.8-2.3 0.8 0.4 1.5 0.8-0.4 0.8-0.7 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s245",
    d: "m120.4 6.1c-0.6 0-1.4 0.1-1.7-0.6-0.2-0.6 0.5-0.7 0.9-0.9q0.4 0.8 0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s207",
    d: "m140.3-4.6c1 0.1 1.6 1 2.3 1.6v-0.1c0.6 0.5 1.2 1 0.7 1.8-0.3 0.5-0.8 0.9-1.5 0.6q-1.1-0.4-2.3-0.8c-0.6-1.3 0.8-2 0.8-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s235",
    d: "m139.5 1.5c-0.8-0.9-2.6-1.2-2.3-3q1.2 0.4 2.3 0.8 0 1.1 0 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s246",
    d: "m-19 16.8c2.4 0.1 3.2-3.8 6.1-2.3 0.3 0.6 0.6 0.4 0.8 0q2.3-0.3 4.6-0.7c1.4-1 1.2-3.9 3.9-3.3 1 0.5 2.1 0.8 2.6 1.9 0.3 0.7 0.1 1.4 0.2 2.1 0.3 1.7 1.9 1.7 2.9 2.4 0.6 0.5 0.8 1.2 1.2 1.8 0.3 0.9 0.5 1.7 0.2 2.7-0.5 0.9-1.3 1.1-2.3 1.1-0.5 0-1.4-0.2-1.4-0.2 0.2 3.8-2.3 2.7-4.4 2.4-0.9-0.7-1.9-1.2-2.7 0.1-2.2 0.7-3.7-0.6-5.2-1.9-1.6-2.1-4.1-0.8-6.1-1.6-0.4-0.4-0.7-0.8-0.4-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s247",
    d: "m154.1-1.5c0.8 0 1.6 0.1 2.3 0.7-0.2 0.9 0 1.8-0.4 2.6-1 1.2-2.2 1.3-3.2 0.3-1.2-1.1-2.3-0.7-3.5-0.5-0.6-0.1-1-0.3-1.3-0.8-0.2-1.4 0.6-2.2 1.5-3.1 0.4-0.4 0.9-0.5 1.4-0.3 0.7 1.4 2.3 0.1 3.2 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s248",
    d: "m148 0.8h1.5c1.2 1.1 0.8 2.2-0.1 3.3-1.4 1.5-2.9 1.3-4.5 0.5q0-1.5 0-3.1c1.3 0.7 2-0.7 3.1-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s243",
    d: "m141.8-0.8c1.1-0.5 1.3-1.2 0.8-2.3 4 1.8-0.7 3.6 0 5.4-4.6 0 0-2.2-0.8-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s249",
    d: "m155.6 1.5c-0.5-1-1.8-2.3 0.8-2.3 0.4-1 2.8 1 2.3-1.5q-0.4-0.3-0.3-0.5 0.1-0.2 0.3-0.2h0.7q0.8 1.1 1.6 2.2 0.4 0.4 0.5 0.9 0 0.5-0.2 1c-0.8 0.7-0.6 1.7-0.9 2.6-1.1 1.4-2.3 0.7-3.5 0.2-0.9-0.6-1.7-1.1-1.3-2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s211",
    d: "m7.8-2.3c-0.9-1-1.9-1.8-3.4-2 2.1-3 2.1-3 4.1-0.9 1.6-0.7-1.5-2.7 0.8-3.2 0.7 1.1 0.7 2.7 2.4 3.1 0.3 0.7-1.8 1.5 0 2.3v0.7c0.1 0.7 0.2 1.5-0.2 2.1q-0.4 0.4-0.9 0.5c-1.1-0.7-2.6-0.9-2.8-2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s250",
    d: "m16.2 4.6q0.4 0.4 0.8 0.8 0.4 1.1 0.8 2.3c-1 1.5-2.4 1.3-3.9 0.7h0.1c-1.3-0.9-2.1 1-3.3 0.6q-0.8-0.1-1.3-0.8c-0.4-0.7-0.8-1.6-1.2-2.3q-0.2-0.6-0.1-1.1c0.5-1.3 1.3-2.2 2.8-2.3 1 0.1 2.1-0.1 3 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s207",
    d: "m10.9 0c0-0.8 0.1-1.6 0.8-2.3 1-0.3 2.2-1.1 3.2-0.9 2.1 0.5 2.4 1.7 0.6 3.2-1.5-0.1-3.1 2.8-4.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s251",
    d: "m10.9 0c1.5 0.9 3.1-1.3 4.6 0q-0.8 1.5-1.6 3.1c-1-0.3-2 4-3 0-0.6-1-1.2-2.1 0-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s252",
    d: "m22.4 2.3q-0.4 0.4-0.8 0.8c-0.7-0.8-2.9-0.2-2.3-2.3 1.5-0.5 3.1-0.1 4.6 0 0.5 1.5-1.2 0.8-1.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s233",
    d: "m213.8-1.5c0.6-1.1-0.2-1.7-0.8-2.3q0.8-1.2 1.6-2.3c1.7 0.4 1.1 2 1.5 3.1q0.3 0.2 0.2 0.5-0.1 0.2-0.2 0.2c-0.9 0-0.7 2.8-2.3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s219",
    d: "m2.5-1.5q3.3-1 4.6 2.3c1.9 1 1.2 3 1.5 4.6 0.6 0.6 0.8 1.3 0.7 2.2-0.4 1.4-1.4 1.7-2.7 1.6-1.1-0.1-2.1 0.4-3.1 0.9q-0.5 0.1-1.1 0.1-0.6 0-1.1-0.2-0.6-0.3-0.9-0.8c-0.6-1.2-0.1-2.2 0.3-3.3 0.3-0.5 0.7-0.9 1.3-1 0.1 0 0.2 0.1 0.3 0q0.4-0.1-0.1-0.1c-1.4-0.6-1.4-1.8-1.4-3.1-0.5-1.6 0.5-2.4 1.7-3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s207",
    d: "m8.6 5.4c-2.2-1-1-3.1-1.5-4.6 2.3-0.5-0.6-2.3 0.7-3.1q1.6 1.2 3.1 2.3c0 1 0.9 2.1 0 3.1q-1.2 1.1-2.3 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s233",
    d: "m2.5-1.5c1 1.3-1.8 1.7-0.8 3-0.3 0.5-0.7 0.5-1.2 0.4q-0.2-0.2-0.3-0.4-0.4-1.5-0.8-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s253",
    d: "m86.7 7.7c-0.6-1.1-0.6-2.1 0-3.1q1.1 0.4 2.3 0.8c1.1-0.5 1.8 0.5 2.7 0.6 0.3 0.3 0.6 0.5 0.9 0.7 4 2.4 4.1 3.4 0.7 6.6-1.4 0.3-2.7 1.4-4.2 0.9q-0.5-0.3-0.8-0.7c-0.4-1.1-0.9-2.3-1.9-3-0.7-1-0.4-2 0.3-2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s219",
    d: "m86-4.6c0.9-0.3 2.1-0.9 1.7 1-0.2 1.3-0.3 2.3 1.1 2.9 1.2 0.4 1.1 1.1 0.7 2.1-0.5 1.1-1.7 0.9-2.3 0.9-1.7 0-0.6-1.1-0.5-1.9 0.5-2-3.3-1.1-2.3-3.5 0.5-0.5 0.9-1.1 1.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s211",
    d: "m91.3 6.1c-1.1 0.9-1.9 0.4-2.3-0.7q3.1-0.8 6.1-1.6c0.6 0.7 0.8 1.5 0.4 2.3-1.4 1.7-2.8 1.4-4.2 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s224",
    d: "m91.3-0.8q-0.3-0.1-0.6-0.4c-1.2-0.7-1.5-1.7-0.9-2.9 0.2-0.2 0.7-0.5 0.9-0.4 1.4 0.7 0.7 1.9 0.6 3q0.8 0.4 0 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s254",
    d: "m91.3-0.8q0-0.3 0-0.7 1.5-0.4 3.1-0.8c-0.7 1.3-1.8 1.6-3.1 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m21.6 183.5c2.4-0.7 0.4-2.4 0.5-3.5 0.2-2.3 0.8-3.6 3.3-3.3-0.8 1.7 1 2.9 0.8 4.6-0.3 1.8 1.1 1.1 1.8 1.1 1.7-0.1 2.9 0.3 3.6 1.9 0.9-0.1 2-0.4 2.2-1.2 0.9-4.1 5-2.3 7.2-4.1 0.9-0.7 1.2 0.5 1.2 1.3-0.1 1.1-0.6 2.2 0.1 3.2q0.2 0.3 0.2 0.6-0.1 0.2-0.2 0.2c-2-1.8-3.9-4.2-6.6-0.9-0.7 0.8-0.7 1.6-0.3 2.4-3.8-2.1-5.5 1.4-6.4 3.3-2.1 4.3-3.8 2.1-6.3 0.4 1.6-0.5 3.2-0.4 3.5-2.1-0.7-0.6-1.3-1.4-2.3-0.8-0.8 0.8-1.5 0.3-2.3 0q-0.4-0.2-0.2-0.5 0.1-0.3 0.2-0.3c0.7-0.7-0.3-1.5 0-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m6.3 198.8c-0.3-1.6-1.6-1.4-2.7-1.4-2.3 0.1-3.1-1.2-3.5-3.7 3.4 2 5.1 0.3 6.2-2.5q0.4 0.8 0.8 1.5c0.7 1.3 0.4 2.6 0 3.8-0.1 0.9 0.7 2-0.8 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m27 193.5c-2.5 1.2-1.9 3.3-1.6 5.3-1.2-0.5-3.2-0.1-3.3-2.3 0-1.4-0.1-3 1.1-3.8 1.3-1 2.6 0 3.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s104",
    d: "m7.1 196.5c-2.2-1.2 0.4-2.5 0-3.8 0.8 0.9 1.2 0.7 1.9-0.3 1-1.5 2.2-0.2 2.9 0.4 1 1-0.4 1.7-1 1.9-1.4 0.3-2 2.5-3.8 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m12.4 184.3c2.1-0.2 3.9-1.8 6.2-0.8-2.1 0.3-3.6 5-6.2 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m21.6 185.8v0.8c-0.1 1.2-0.3 2.4-1.9 1.9-0.6-0.1-1.5-0.4-1.4-1.1 0.3-2 2.4-0.6 3.3-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m12.7 188.8c-0.8-0.6-2.5 0.6-2.7-1.1 0-0.3 0.6-0.9 1-1 1.5-0.3 1.5 1 1.7 2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s169",
    d: "m16 196c-0.7 0.3-1.1 0.5-1.5 0.6-0.5 0.1-1-0.1-0.7-0.7 0.2-0.3 0.8-0.5 1.2-0.6 0.2-0.1 0.5 0.3 1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m14.5 188.9c0.3-1 1.1-1.4 1.6-1 0.9 0.7-0.2 0.9-0.6 1-0.3 0.1-0.7 0-1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m19.4 190.3c-0.2 0.2-0.3 0.3-0.4 0.5-0.3-0.3-0.6-0.5-0.8-0.7 0-0.1 0.3-0.5 0.4-0.4 0.3 0.1 0.5 0.4 0.8 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m23.9 186.6c1.2-0.9 1.9-0.6 2.3 0.8q-1.1-0.4-2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m2.2 188.7c-1.1-0.6-2.9 0.9-3.2-1.2-0.1-0.5 0.1-1.4 0.8-1.4 1.5 0 2.1 1.1 2.4 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m-2.1 191.2c-0.5-2.5 1.4-1 2.1-1.1 0.7-0.1 0.6 1 0.3 1.4-0.9 1.3-1.7 0.3-2.4-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m45.3 199.6q-2.6-2.3-6.1-3.1c1.8-1.7 4-0.8 6.5-0.9-0.9-1.1-1.6-1.9-2.2-2.6-0.7-1-0.8-1.4 0.7-1.6 1.7-0.1 0.9-0.8 0.3-1.7-0.5-0.8-2.3-1.3-1.3-2.5 1-1.2 3.3-1.8 4.2-0.9 2.5 2.7 5.2 1 7.9 1.1 0.9-0.5 1.6-0.7 1.5 0.7-1.1 3-2.8 5.3-6 6.2-1.1 0.3-1.5 1.3-0.9 2.5 3.5-1.6 6.9-3.9 10.5-0.1 0.5 0.6 1.1 0.4 1.5-0.3 1.1-2 2.9-0.7 4.4-0.8 1.1-0.1 2.2 1.6 2 2.7-0.3 1.9-1.5 0-2.3 0.2-3.1 0.8-5.9 0.1-8.8-1.1-2-0.8-2.2-0.3-2.5 1.8-0.2 1.2-0.4 3-2.5 2.7-2.2-0.9-5.5 1.3-6.9-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s174",
    d: "m35.4 160.6c-1.3-1.2-4.2-2.4 0-3.8 1-0.3-0.1-1.5 0-2.3-0.1-3.1 2.1-4.8 4.3-6.3 1-0.7 1.8-1.3 2.3-2.3q0.4-0.5 0.8-0.9c1.7-0.9 3.2-1 4.1 1.1q0.4 0.7 0.7 1.5c-2.8 3.3-6 6.3-8.4 9.9v1.6c0.4 1.4-0.6 1.3-1.4 1.3-0.8 0-1.7-0.5-2.4 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s36",
    d: "m39.2 157.5c-0.5-0.3-1.2-0.8-0.4-1.3 0.8-0.6 1.7-1.1 2-2.2 1-3.4 3.1-5.8 6.8-6.4 0.8 0.1 2-0.1 1.4 1.3-0.6 1.3 0.4 1.8 0.9 2.5-3.6-0.7-5.7 1.6-7.8 3.9-0.9 0.9-1.4 2.1-2.9 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m60.7 168.3c0.9 0.3 1.3 0 1.7-0.9 0.4-0.9 1-0.9 1.7-0.2 0.9 0.8 0 1.2-0.4 1.8-0.1 0.2-0.3 0.4-0.3 0.7-0.5 3.5-2 3.9-4.6 1.5-0.7-0.6-1.9-1.5-2.8 0.2-0.6 1.1-1.4 0.8-2.1 0-0.8-1.1 0.1-1.5 0.7-2.1 1.8-1.9 4.2 0.3 6.1-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s255",
    d: "m43.8 182c-0.1-1.8 1.6-2.8 2.2-4.3 0.4-0.9 2-0.4 2.8 0.6 1.1 1.5 0.9 2.7-1.1 3.3 1.8 1.4 2.8 0.4 3.9-0.5 0.8-0.7 2.3-1.1 2.8-0.1 0.6 1.4-1.1 1.1-1.7 1.7-3.3 2.6-5.9-0.6-8.9-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m42.3 162.1c1.4-1.6 3.1-1.9 5.5-0.9-2.1 2.5-2.9 5.5-4.6 8.5-1.4-2.7 0.7-5.3-0.9-7.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m31.6 184.3c-1.7-0.2-3-2.1-5-1-0.7 0.4-1.7 1.4-2.2 0-0.6-1.6 0.5-2 1.8-2 0.8 0.7 1.8 0.8 2.8 0.4 3.5-1.7 3.5-0.1 2.6 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s167",
    d: "m50.7 151.4c1.5-2.5 5.2-1.8 6.3-5 2 4.5-2.9 4.3-4 6.6-0.7-0.6-1.3-1.4-2.3-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m35.4 160.6c0.8-1.8 2.6-1 3.8-1.5q1.6 1.5 3.1 3c-2.8 2.6-4.1-1-6.1-1.5q-0.4 0-0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m49.5 176.1c-0.8-0.3-1.5-0.9-1.2-1.3 0.8-1.2 1.1-3 3-3 0.5 0 1.2 0.5 0.9 0.9-0.7 1.3-1.3 2.7-2.7 3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m62.8 178.2c-1.2-0.5-1.3-2-2.7-1.7-1.2 0.3-1.4-0.8-1.7-1.5-0.1-0.3 0.1-0.8 0.3-0.9 1-0.5 1.7 0.2 2.5 0.5 1.4 0.6 1.5 1.9 1.6 3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m55.3 155.2c0.6 0.7 1.5 1.1 1.4 2.1-0.1 0.2-0.8 0.6-1.2 0.6-1.6 0-2.2-1.3-2.5-2.7q1.2 0 2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m56.1 162.9c0.9-0.8 1.9-2 3.1-1 0.7 0.6-0.5 1.7-0.8 2.5-1.1 0-2.1-0.3-2.3-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m56.8 188.1q-0.7-0.3-1.5-0.7c-0.2-0.5-1.5-1.4 0.1-1.4 1.2 0 3.1-0.6 3.5 1.1 0.3 1.8-1.2 1-2.1 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m55.4 166.2c-1.4 0.8-2.4 2.2-3.9 1-0.2-0.1-0.2-0.7-0.1-0.9 1.2-1.3 2.4-0.7 4-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s256",
    d: "m49.2 159.1c1.1 0.1 2.1 0.7 3.2 0.2 1.4-0.7 1.3 0.5 1.4 1.3q-1.9 2.5-3.9 0-0.3-0.8-0.7-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m45.4 158.9c-1.1-0.1-2.5 1.3-3.3-0.3-0.1-0.2 0-0.6 0.2-0.7 1.4-1.1 2.1 0.5 3.1 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m42.3 184.3v-0.8q0.8-0.7 1.5-1.5c0 1.1 1.2 2.2-0.1 3.1-0.6 0.5-1.1-0.3-1.4-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m49.9 160.6q2 1.1 3.9 0c-0.3 1.2-1.2 1.5-2.3 1.5q-1.3-0.2-1.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m59.1 180.1c-0.3 0.1-0.6 0.5-1 0.7-0.5 0.1-0.7-0.3-0.5-0.6 0.2-0.4 0.5-0.8 0.9-1 0.4-0.1 0.7 0.2 0.6 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s257",
    d: "m72.9 230.2c-0.1-0.8 1.7-2-0.7-2.4-2.4-0.3-4.6-0.5-6.9 0.1h-0.8c-0.8-1.8 0.3-2.2 1.7-2.3 1.2-0.1 2.4 0.4 3.7 0 1.9-0.7 3.4 0.5 4.9 1.3 1.9 1 3.7 1.7 5.8 1 5.4-0.2 10.6-1.9 15.9-3 2.4-1.3 5.4-1.4 7.7-3.1q0.7-0.3 1.6-0.2c1.5 0.2 2.6 2.7 4.5 1 2.3-3 2.8-3.1 4.9-0.4 1.3 1.7 2.8 0.9 4.1 0.7 2-0.3 3.8-0.5 4.9 1.6 1.3 3.6-1.2 4.7-3.7 5.9-1.6 1.8-3.9 2-5.7 1.3-3.5-1.3-7.2-0.3-10.7-1.4-1.3-0.4-2.6 0-4 0.5-1.2 0.5-2.8 1.6-4.2 0.2-1.1-0.9-2.2-0.6-3.2-0.1-5.2 2.7-10.3 1.9-15.3-0.6-1.6-0.9-3-1.2-4.5-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m96.7 225.6c-1 0.4-2 0.7-2.8 1.3-2.5 2.2-6 0.7-8.7 2.9-1.4 1.2-2.8-1.9-4.6-1.9-0.9-0.6-1.8-1.1-0.8-2.3 1.6-1.3 4.4 1.8 5.4-1.5 1.4 1 2.5 1.1 2.9-0.9 0.9-3.6 2.4-2.4 4.2-0.6 1.1 1.2 2.6 1.8 4.4 1.5q0.7 0.7 0 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s258",
    d: "m69.9 225.6c-1.5 1.6-4.4-0.4-5.4 2.3-1.1-1-3.1 0.2-3.8-1.5 0.1-1 0.3-2 0.5-3.4 2.6 2.1 5.9 1.3 8.7 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m37.7 204.2c1.1-1.8 1.7-5.1 4.6-1.5-1 2.1-3.2 0.5-4.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s111",
    d: "m38.5 142.3c-1.2-2.6-3-1.4-4.6-0.8-0.7-0.3-1.2-0.7-0.8-1.5q1.5-0.8 3.1-1.6c2.8 0 5.4-2.7 8.4-0.7 1.4 0.2 1 2.9 3 2.3q0.4-0.4 0.8-0.8c0.8 1 2.3 0.5 3.1 1.5q0.4 0 0.7 0v0.8q-0.5 0.8-1.5 0.8-1.5 0.7-3.1 1.5c-0.4 0.3-0.9 0.6-1.4 0.3-2-1.2-4.1-2.1-6.6-1-0.4 0.1-0.9-0.4-1.1-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s51",
    d: "m38.5 142.3c0.2 0 0.5 0 0.7-0.1 2.5-1 5.3-0.5 8.1 1.4q0.2 0.1 0.3 0.2c1.3 1.3 1.6 2.2-0.7 2.3q-1.9-1.2-3.8 0c-2.8 0.2-4.7-0.6-4.6-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m64.8 153.6c-1.1 0.9-2 2-3.2 2.7-0.4 0.2-1.4-0.6-1.4-1.4 0-1.4 0.6-2.5 2-2.8 1.1-0.3 1.9 0.5 2.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m63 144c-0.9 0.5-1.7 0.9-2.9 1.7 0.2-2.4 1.2-2.7 2.9-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s51",
    d: "m50.7 142.3l1.5-0.8c1.1 0.9 2.1 0 3.1 0-1.3 1.8-2.8 1.9-4.6 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m59.1 159.2c1.3-1.2 2.4-1.7 3.3 0.2-1.2 0-2.2-0.1-3.3-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m57.6 137.7c1.3 0.2 2.6-1 3.8 0-1.2 0.5-2.5 1.1-3.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s51",
    d: "m52.9 145.2c-0.3 0.1-0.7 0.3-1 0.3-0.1 0-0.3-0.3-0.4-0.5 0.3-0.1 0.6-0.3 0.9-0.3 0.1-0.1 0.3 0.2 0.5 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m62.2 127.7c1.3-2.5 5-1 6.3-3.9 0.5 1.4 0.9 2.7 1.4 3.9q0.3 0.3 0.2 0.5-0.1 0.3-0.2 0.3c-0.9 0-2-0.8-2.3 0.7-0.8 0.7-1.6 0.7-2.3 0.1 0.4-3.5-2.3-0.6-3.1-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s180",
    d: "m52.2 122.4c-0.7-1.8-2.2-1.9-3.8-1.6-0.9 0.5-1.8 0.2-2.2-0.7-0.5-0.9 0.2-1.3 0.9-1.7 2.1 0.5 4.7-1.4 6.5 1.1q0.1 0.3 0.2 0.6c-0.2 1-1 1.6-1.6 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s259",
    d: "m69.9 128.5v-0.8c0.7-0.5 1.1-1.7 2.8-1.5-1.6 1.8-0.9 4.5-3.1 6.2-0.9-1.5 0.3-2.7 0.3-3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s180",
    d: "m53 117q1.9-2.1 3.8 0-0.2 2.8-3 3.1c-1.1-0.8-0.9-2-0.8-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s180",
    d: "m65.3 129.3q1.1 0 2.3-0.1c0.4 1.1 0.4 2.3-0.9 2.3-1.3 0.1-1.2-1.3-1.4-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s260",
    d: "m75.6 122.8c-0.4 0.3-0.7 0.6-1 0.6-0.2 0-0.6-0.4-0.6-0.7 0-0.2 0.4-0.6 0.6-0.6 0.3 0 0.6 0.3 1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m23.9 123.1c0.9-1.7-0.8-2.1-1.5-3 2.8-0.2 5.6-0.5 8.4 0h1.5c2.3 3 2.3 3 3.9 1.5 1.7 0.3 2.2 0.9 1.3 2.8-0.7 1.6-1.2 1.5-2.6 0.7-0.9-0.6-2.2-0.3-3.3-0.4-2.6-0.4-5.3-0.2-7.7-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s180",
    d: "m45.4 108.6c0 1.9-1.5 4.6 2.3 4.6 0.2 0.8 0.6 1.7 0.6 2.5 0.1 1.2-0.1 2.4-1.3 2.9-1.2 0.5-1.9-0.4-2.5-1.2-0.5-0.9-1.2-1.6-2.2-1.9-5.6-1-5.9-2.4-1.5-8.4 0.5 0.6 1.4 0.3 2.1 0.6 0.5 0.3 1.1 0.3 1.7 0.3q0.5 0.2 0.8 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s110",
    d: "m42.3 115.5c2.3-1 3.1 0.9 4.1 2.5 1.4-1.6 0-3.5 1.2-4.8 1.2 0.6 2.5 0.8 3.9 0.8-1.1 1-2.2 2.1-2.3 3.8-0.2 0.8-1.1 0.9-1.6 1.5-1.5 1.4 0.7 1 0.8 1.5-0.3 1.3-1.2 1.6-2.3 1.6-1.3 0.5-2.5 0.8-3.8 0-0.7-1.2-2.2-2.1-1.5-3.9h0.7c0.5-0.3 1.3 0 1.5-0.7q-0.3-1.2-0.7-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s180",
    d: "m33.9 114c1.2 2.6 4.4 1.3 6.1 3-0.5 0.6-1 1.2-1.2 2q-0.2 0.2-0.3 0.3c-4.5 0.6-6.3 0.3-4.6-5.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m35.4 110.2c-2.3-0.4-4.6-0.8-7.4-1.4 4.2-1.2 4.2-1.2 7.4 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s261",
    d: "m37.7 101c0.8-0.1 1.6-1.7 2.3 0.2 0.5 1.2 2.3 2.3 0 3.6q-0.8-0.4-1.5-0.8c-0.7-0.6-1.4-1.2-0.8-2.3q0-0.4 0-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s180",
    d: "m40.8 118.5c-0.1 1.5 3.5 1.6 1.5 3.9-1.8 0.6-2.1-2.2-3.8-1.6v-1.5c0.3-0.6 0.6-1.2 1.5-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s174",
    d: "m45.4 108.6h-0.8c-0.8 0.5-1.5 0.2-2.3 0q-1.3-0.2-1.5-1.5 0.3-0.8 0.7-1.6c1.7 0.6 3.3 1.3 4.4 2.8 0.1 0-0.1 0.1-0.2 0.2-0.1 0.1-0.2 0.1-0.3 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m33.9 114c-1.2-0.8-3.2 0-3.9-2.1 2-0.3 3.2 0.2 3.9 2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s51",
    d: "m37.7 101.7q0.4 1.2 0.8 2.3c-1.1 0.1-2.4 0.6-2.6-1.1-0.2-1.3 1-1 1.8-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m40 118.5q-0.8 0.4-1.5 0.8c-0.4-0.6-1.4-1-0.8-1.8 0.5-0.7 1.5-0.4 2.3-0.5 0.5 0.5 0.2 1 0 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s180",
    d: "m43 117.8c0.6 0.4 1.2 0.8 2 1.4-1.5 0.4-2.5-0.2-3.5-0.7q0.8-0.3 1.5-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s180",
    d: "m42.3 122.4h3.8c-1.4 1.9-3 2.2-3.8 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m53 127h-0.8c-0.6-0.8-1.4-1.4-0.9-2.7 1.8 0.1 1 1.9 1.7 2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s51",
    d: "m47.6 140c-1.8 1.3-1.9 1.3-3-2.3q0.8-0.4 1.5-0.8c0.2 1.2 0.6 2.2 1.5 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m30 127c-0.6 0.6-1.4 0.7-2.3 0.7 0-2.7 1.7-0.1 2.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s110",
    d: "m51.5 140.7c-1.3 0-2.6 0.1-3.1-1.5 1.3 0 2.6-0.1 3.1 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s46",
    d: "m32.3 68.8c1.1 0 2.5 1.3 3.1-0.7 0.6-0.6 0.2-2.1 1.5-1.9 1.6 0.2 1.5 1.5 1.6 2.6-0.5 0.4-0.8 0.9-0.8 1.5 0.2 0.7 0.8 1.5-0.1 2-0.6 0.4-1.3 0.1-1.6-0.5-0.9-2.2-2.3-1.2-3.7-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m38.2 75.2c-2 2.2-2 2.2-4.5 1.6 1.1-1.5 2.3-1.8 4.5-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m33.1 73.4v-0.7c1.5-1 2.1 0.2 3 1.1-1.2 0.5-2-0.4-3-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s110",
    d: "m37.7 70.3q-0.4-0.5-0.8-1 0.8-0.2 1.6-0.5-0.4 0.8-0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m32.3 85.2c0.6 0.1 1 0.4 0.9 0.9-0.1 0.6-0.5 0.9-1.1 0.7-0.2-0.1-0.6-0.4-0.6-0.7-0.1-0.5 0.3-0.8 0.8-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s112",
    d: "m47.6 119.3q0.3-1.3 1.6-1.5 1.9-0.4 3.8-0.8c2.9 0.4 0.9 2 0.8 3.1-2-1-4-1.5-6.2-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s180",
    d: "m51.5 114c-0.2-0.7-1.9-0.9-0.6-1.9 0.3-0.3 1-1.2 1.4-0.4 0.3 0.7 0.7 1.9-0.8 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m86.7 212.6c0.3 0 0.5 0 0.8-0.1 3.2-1.5 5.9-2.5 4.9 3.1-0.2 0.9 1.6 1.2 1.6 2.8-2.4 0.1-4.7 1.5-7.2 0.3-1-0.7 4.1-1.6-0.1-2.3v-1.5q-0.4-0.3-0.3-0.5 0.2-0.3 0.3-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m86.7 214.1v0.8c-1.1-0.2-2.2-0.5-3.1 0.6-0.7 0.9-1.8 1.2-2.6 0.2-0.8-1.1-0.1-2.2 0.7-3 0.8-1 1.5-1.1 2.5-0.2 0.7 0.7 1.7 1.1 2.5 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s24",
    d: "m82.9 219.5q0 1.5 0 3c-1.8-0.5-3.5-1.3-5.5-2.9 2.2-0.5 3.8-0.4 5.5-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m158.7 202.7c-0.9 3.1-2.6 4.7-6.1 3.5-2-0.6-4.6 1.7-6.2-1.2-2.9-1.3-6.3-0.7-8.8-3-0.1 0-0.1-0.1-0.2 0 2 1.4 2.9 3.2 2 5.6-0.9 2.1-2.6 3-4.9 2.9-0.3-0.1-1-0.2-1.1-0.1-1.2 3.9-4.9 3-7.6 3.9-0.5 0.8-0.8 2.1-1.6 2-3.2-0.4-4.5 2.4-6.5 3.8-0.9 0.6-1.8 1.4-2.8 0.8-2.3-1.4-3.6 0.4-5.2 1.4-1.1-0.1-2.2 0-3.1-0.7-0.2-0.2-0.5-0.5-0.4-0.7 0.8-2 0.4-3.7-1.1-5.2q0.4-0.4 0.7-0.8c0.8-0.2 1.7-0.6 1.7-1.4-0.4-4.1 2.5-5.4 5.5-6.8 1.8-0.9 3.4-2.2 5.1-3.3 1.3-3.4 1.3-3.4 3.3-2.2 1.7 3.1 4.2 5 7.8 5-3.5-0.3-6.3-2.6-6.8-5.4q0.4-1.1 1.3-1.9 0.9-0.6 2-0.7c1.5 0.2 2.4-0.6 3.1-1.7q0.4-0.4 0.8-0.7c1.3-1.9 3-3.2 5.4-2.2 2.2 1 3.8 0.5 5.4-1.1 1-1.1 2.4-1.4 3.7-1.7 2 0.2 4.5-0.1 3.6 3.2-0.2 0.7 0.1 0.5 0.4 0.4 2.7-0.7 3.6 1.4 4.8 2.9 1.7 2.1 4.6 2.8 5.8 5.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m105.1 215.7c1.1 1 2 0.5 2.9-0.3 0.7-0.6 1.3-0.8 2-0.1 0.8 0.8-0.1 1.3-0.2 1.9-0.4 2-2.4 2.3-3.2 3.8q-0.3 0.5-0.8 0.6c-2.5 0.6-2.9-1.4-3.8-2.9-0.3-1-1.5-1.9-0.4-3 1-1.1 2.3-0.6 3.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m96.6 225.6v-1.5c1.9-1.2 2.5-4.2 5.4-3.9 0.7 0.8 2.4 0.7 2.3 2.3-1.7 2.2-5.9 3.9-7.7 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m104.3 222.5c-0.7-0.7-2.1-0.9-2.3-2.3v-1.5c2-0.4 1.8 2.7 3.8 2.3 0.5 0.5 0.5 1 0 1.5q-0.7 0-1.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m156.4 102.5q-2-0.6-3.9-1.2c1.7-0.5 3-0.3 3.9 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s57",
    d: "m106.6 196.5c2.1 0 3.2-2.4 5.4-2.2 0.6 0.5 1.6 0.8 1.9 0 1.3-3.8 4.2-3.7 7.3-3.2 0.7 0.1 1.2-0.4 1.8-0.7 2.1-1.2 4.1-1.1 5.9 0.7 1.6 1.6 2.1 3.4 0.7 5.4-1.5 1-3.2 1.5-4.6 2.6-1.4 0.6-2.7 0.4-3.8-0.7-0.9-1-1.9-1.2-2.7 0.2-0.3 0.9-0.1 2-1.2 2.5-2.1 0.5-1.6-1.7-2.5-2.5-1 1.6-0.3 3.3-0.6 4.8-0.3 1.1-1 1.8-2.1 2-1.4 0.2-1.7-0.8-1.9-1.8-0.4-1.8-0.7-3.7 0.3-5.4-1.5-1.2-3.9 3.3-4.7-0.9q0.4-0.4 0.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s113",
    d: "m117.3 201.1q-0.4-1.5-0.7-3c3-1.8 5.1 0.7 7.6 1.5q-0.4 0.8-0.7 1.5c-1.1 0.3-1.7 2-3.1 0.8-1.6-0.7-1.1 1.6-2.3 1.5q-0.4-1.1-0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s73",
    d: "m46.1 51.3c-2.1-0.1-2.7 1.3-3.1 3q-3-1.1-6.1-2.3v-0.7c-0.4-0.4-0.5-0.9-0.3-1.5q0.2-0.4 0.7-0.7c2.1-1.3 4.8-0.2 6.7-2.1 0.6-1.6 1.2-3.2 3.2-3.5q0.9-0.2 1.8-0.6 0.4-0.2 1-0.3 0.5-0.1 1 0c1.5 1.5 3.4 0.6 5.1 0.9q0.9 0.4 1.2 1.2c0.2 0.6 0 1.1-0.1 1.7-0.6 1.2-1.5 1.5-2.7 1.1-1.2-0.2-2.6-0.8-2.3 1.4 1.8 1.6 0.1 2.6-0.7 3.6-1.2 1.4-2.2 0.4-3.1-0.5-0.3-1.5-1.7-0.1-2.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s78",
    d: "m72.9 54.3v-0.8c-0.4-0.6-0.9-1.3-1.8-1.1q-0.5-0.1-1-0.3c-0.6-0.4-0.8-1-1-1.6v-1.5c3.7-1.4 6.3-4.1 8.9-6.8 0.6-0.5 1-1.1 1.7-1.2 2.7 0.6 2.7 2.1 1.5 4.1 0-0.1 0 0.1 0 0.1 0 0 0.2 0 0.2 0 0.5-0.1 0.8-0.1 1.2 0 0.7 0.2 1.3 0.3 1.9 0.6 3.1 1.2 3.2 2.2 0.5 4.6-3.1 0.3-6.3 0-8.2 3.6-0.3 0.8-2.4 1.5-3.9 1-0.1-0.1-0.1-0.2-0.1-0.3 0-0.2 0.1-0.3 0.1-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s75",
    d: "m79 42.8c-2.8 2.9-4.8 7-9.9 6.2q0.8-1.2 1.5-2.3 0.1-0.3 0.1-0.6c1.5-1.4 1.9-4.2 4.8-4 1.2-0.1 2.6-0.8 3.5 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s262",
    d: "m65.3 46.7c-0.4 1.2-0.8 2.3-1.2 3.8-1.1-1.2-2.5-2.1-1.1-3.8-0.7-1.9-1.2-3.8-0.1-5.7 0.4-0.5 0.9-0.7 1.5-0.7q0.5 0.2 0.9 0.6c0.4 0.9 0.6 1.8 0.9 2.7 0.3 1.2-0.7 2-0.9 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s216",
    d: "m65.3 46.7c-0.6-1-0.2-2.1 0-3.1 0-0.9-0.1-1.8 0.2-2.7q0.6-1 1.8-0.8c1.2 0.5 0.9 1.7 1.3 2.6 0.2 0.8 0.8 1.4 1.4 1.8 0.6 0.7 1.2 1.2 0.6 2.2-1.8 0.3-3.5-1.1-5.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m54.5 46.7c0.9 0.3 1.5 0.2 1.6-0.8q0.9-0.6 1.9-0.7c1.1 0.1 2.1 0.5 2.7 1.5-0.3 1.7-0.3 3.5-3 1.8-1-0.6-2.6-0.2-3.9-0.3-0.5-0.9 0-1.3 0.7-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s216",
    d: "m54.5 46.7q-0.3 0.7-0.7 1.5-0.8 0.4-1.6 0.7c-0.6-0.3-1.3-0.5-2.5-1.1 1.9-0.6 3-2.2 4.8-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s190",
    d: "m63.7 41.3q-0.4 2.7-0.7 5.4-0.8-0.4-1.6-0.8-0.2-0.2-0.4-0.4c-0.8-1.1-0.4-2.2 0.3-3.2 0.7-0.7 1.3-1.6 2.4-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s78",
    d: "m70.6 52.8q0 0.4 0 0.7-2.3 0.1-2.3-2.3c1.1-0.8 1.7 0 2.3 0.8q0.8 0.4 0 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s190",
    d: "m60.7 46.7c-0.9-0.1-2 0.7-2.3-0.8 1-1.7 1.1-1.7 3 0q-0.3 0.4-0.7 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s263",
    d: "m55.8 50.9c0.5 0.3 0.6 0.8 0.4 1.3-0.1 0.3-0.4 0.6-0.7 0.3-0.2-0.2-0.3-0.7-0.4-1 0-0.4 0.2-0.7 0.7-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s58",
    d: "m70.6 52q-1.1-0.4-2.3-0.8 0.4-0.3 0.8-0.7c1.5-0.5 1.5 0.5 1.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m101.2 55.8c-1.5 0.3-2.8-0.4-4.7-2.4 1.6 3.5 1.3 5.1-1.9 5-1.2 0-1.6 1-1.8 2-1.9-1.1-0.3-2.3-0.1-3.5 0.2-1.2 2.1-2.1 1.1-3.2-1.1-1.3-3-1.8-4.8-0.9q-0.6-0.5-0.7-1.3c0.5-0.7 0.3-1.4-0.4-1.9-0.2-2.4 2.6-3 3.1-5 0.4-0.6 0.7-1.3 1.2-1.8 1-0.5 1.8-1.4 3-1.4 1 0.2 1.9 0.3 2.7 1q0.9 1.1 1.3 2.6c0.1 1.1-0.2 2.1-0.8 3 0.1-0.1 0.1 0.1 0.2 0.1 2-1.1 3.8 0.7 5.8 0.5 0.8 0 1.7 0 2.5-0.1 1.2-0.1 2.4 0.2 3.5 0.5q1.3 0.2 1.6 1.5-1.9 0.4-3.9 0.8c-0.2 0.4-0.3 0.9-0.6 1.3-1.2 1-2.5 1.7-3.9 2.3q-0.5 0.2-1 0.2-0.4 0-0.7-0.2c0 0-0.3-0.1-0.3-0.1 0 0 0 0.3 0 0.4q0 0.4-0.4 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m107.4 52q0.4-0.4 0.7-0.8c1.1 0.9 0.8 1.7-0.1 2.5-1 0.9-2 1.9-2.9 2.9h-1.6c-1.6-0.3-2.4-0.9-0.7-2.3 1.5-0.8 3.3-1 4.6-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m103.4 68.1c2.2 0.1 4.3-3.1 6.4 0.2-2.1-2.1-4.1 3-6.4-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m108.9 62.7c1.7 1.8 1.3 2.8-1.1 3-1.2 0.2-2.5 0.2-3.5-0.7 0.8-0.7 1.3-1.7 2.6-1.5q0.2 0 0.5 0 0.7-0.4 1.5-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m102.8 62q0.4-1.2 0.7-2.3 2.4 1.5 3.9 3.8c-2.2 1.3-3.2-0.8-4.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s44",
    d: "m108.9 62.7c0.1-0.5-0.1-1.2 0.6-1.4 0.1-0.1 0.4 0.2 0.5 0.3 0.1 0.8-0.5 1-1.1 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s105",
    d: "m137.2 162.1v-0.7q0.3-1.3 1.6-1.6 0.3 1.2 0.7 2.3c-0.7 0.7-1.5 0.6-2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s63",
    d: "m164 79.8c0.7 5.7 5.2 3.4 8.5 4.3-0.3-2-1.5-4.1 0.8-4.8 0.9-0.3 3.1-1.4 3.8 1-1 2.1-1.9 4.2-2.7 6.4-1.5 0.7-2.2 2.1-3 3.3q-0.3 0.1-0.5 0.2c-3.3-0.6-3.4-1.1-0.6-4.8-1.9-0.2-3.6-1.4-4 2-0.4 3-3.7 1.1-5.5 2-0.7-3.4 0.8-6.4 2-9.5 0.1-0.4 0.8-0.5 1.2-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s163",
    d: "m164 79.8c-1.1 3.2-0.4 7-3.2 9.6q-0.6 0.5-1.3 1c-1.2-0.2-2.1-0.8-2.3-2.1-0.9-2 1.3-3.6 0.7-5.6 0.2-1 1-1.8 1.1-2.8 0.1-0.7 0.2-1.4 0.7-1.9 0.9-0.6 1.4-1.5 2.2-2.2 0.9-0.4 1.8-0.7 2.4 0.2 0.6 0.7 0.3 1.4-0.2 2-0.1 0.6 1.2 1.2-0.1 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m175.5 91c0.6 0.1 1.6 0 1.5 0.7-0.3 1.5-1.8 1.5-3 1.6-1.5 1.3-3.1 0.6-4.6 0q0.4-0.8 0.8-1.5c1.5-1.7 3.5-0.6 5.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s113",
    d: "m165.6 96.4q0 1.1 0 2.2c-0.5 0.5-1 0.5-1.6 0.1-0.8-0.6-2.5-0.9-1.7-2.4 1-1.9 2.2 0.4 3.3 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s264",
    d: "m169.4 93.3q2.3 0 4.6 0c-0.2 0.8 0.2 2.3-1.5 1.5-0.5-0.4-1.2-0.1-1.6-0.7q-2.3 0.4-4.6 0.7v-0.7c0.3-0.7 0.9-0.9 1.6-0.8q0.7 0 1.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s64",
    d: "m175.5 91c-1.4 2.5-3.6 0-5.3 0.8q0.3-0.8 0.7-1.6c1-1.2 2.2-1.3 3.5-0.5q0.2 0.3 0.4 0.5 0.3 0.4 0.7 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m157.9 87.8q0.8 1.3 1.6 2.6-0.3 0.3-0.7 0.7c-1.1 0.5-1.8-0.2-2.5-0.8 0-0.6-0.1-1.2-0.7-1.6q0.3-0.4 0.7-0.9c0.5-0.4 1-0.3 1.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m164 98.7q0.8 0 1.6 0c2.7 2.9-1 1.5-1.6 2.3q-1.4-1.2 0-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m167.9 93.3q-0.8 0.4-1.6 0.8c-0.7-0.9-0.9-2 0.3-2.4 1.4-0.5 1.1 0.9 1.3 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s113",
    d: "m161 95.2c-0.2 0.1-0.4 0.3-0.7 0.4-0.2-0.3-0.3-0.6-0.4-0.9 0-0.1 0.4-0.4 0.6-0.4q0.7 0 0.5 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m145.7 173.6c3.2-0.3 1.8 1.7 1.2 3 4.1 0.4 3.6-3.8 5.6-5.3 0.6 0.5 1.2 0.4 1.8 0.4 2.6-0.3 3.8 0.5 2.8 3.2-0.4 1.3 0 2.5 0.2 3.7q-0.1 0.6-0.4 1.1c-1.6 1.9-3.9 1.4-6 1.8-1.4 0.5-1.5 1.9-2.2 2.9-1.6 2.4-4.2 2.1-5.2-0.5-0.7-2-2.4-3.8-1.4-6.1 0.6-1.1 0.5-2.3 0.9-3.4 0.5-0.8 1.2-1.1 2.2-0.9q0.2 0.1 0.5 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m156.4 179c-0.3-1-1-2.2-0.7-2.9 1.5-3.4-1.1-3.9-3.1-4.8 0.7-0.2 1.8-0.1 2-0.5 0.5-1.2-1-0.6-1.3-1.1-1.6-2.4 1.7-1 1.5-2.2 0.5-0.4 1-0.5 1.4-0.2 2.1 1.6 4.2 1.3 6.3 0.2q1.2 0.4 2.3 0.8c0.7 1.2 2.7 2 1.7 3.7-0.9 1.4-2.5 2.1-4.3 1.9-1.8-0.2-2.4 0.6-2.7 2.3-0.2 1.6-0.4 3.7-3.1 2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m133.4 170.5c1.1-0.7 0.8-2.1 1.5-3 1.8-1 2.4 0.5 3.1 1.5 0.8 0.9 1.9 1.4 3.1 1.5 0.8 0.7 1.1-0.2 1.5-0.6 1.1-0.9 2.3-1.5 3.8-0.9 0.6 1.7-1.9 2.8-0.7 4.6-1 0.7-2.6-0.1-3.2 1.4-3.1 0.2-6.2-0.2-9.3-0.8q-0.5-0.2-0.9-0.7c-0.4-1.3 0.8-1.9 1.1-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m138 169q-1.5-0.7-3.1-1.5c0.5-1.6 2-0.5 2.7-0.9 0.6-1.2-3.1-1.5-0.4-2.9-0.5-1-1-0.1-1.5 0q0.2-1.3 1.5-1.6h2.3c0.8 0.6 1.9 1.2 0.5 2.3-0.6 0.4-0.7 0.9-0.5 1.6 0.6 2 0.6 2-1.5 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m146.4 169c-1.3 0.3-2.2 1.7-3.8 1.5-0.5 0-0.6-0.4-0.8-0.7 0.8-5 3-1 4.6-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m141.8 169.8q0.4 0.4 0.8 0.7c-0.2 0.8 0.1 2.1-1.2 2-0.9-0.2-0.3-1.3-0.3-2q0.3-0.3 0.7-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m37.7 64.2c-1.1 0.7-2.3 1.8-2.3-0.7q1.1 0.4 2.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m29.3 60.5c0.1-0.1 0.3-0.4 0.5-0.4 0.1 0 0.3 0.2 0.5 0.4-0.2 0.2-0.4 0.4-0.5 0.4-0.2 0.1-0.4-0.2-0.5-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s265",
    d: "m165.9 63.5q-0.1 1.9-0.2 3.8c-0.5 0.3-0.6 0.9-0.9 1.3-0.5 0.7-1 1.5-2 1.5q-0.6-0.1-0.9-0.5c-1-1 1.4-2.1-0.1-3.1-0.4-1 0.5-1.6 0.9-2.3q0.3-0.3 0.6-0.7c0.6-0.8 0.5-2 1.5-2.6 0.7-0.1 1.3 0.2 1.7 0.8 0.3 0.8-0.2 1.3-0.6 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s266",
    d: "m161.9 69.6q0.3 0 0.7 0c0.9 0.6 1.8 1.1 2.1 2.2 0.1 0.8 0.4 1.4 0.8 2.1 0.5 0.9 0.5 1.8 0.3 2.8-0.3 0.5-0.7 1-1.2 1.2q-0.3 0-0.6 0.1c0.3-1.2-0.3-1.6-1.5-1.4-0.7-0.4-1.3-0.9-0.8-1.8 0.2-1.7-0.7-3.5 0.2-5.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s45",
    d: "m129.6 196.5c0-1.4-0.5-2.7-1.3-3.8-1.6-2.2-3.2-2.8-4.8 0-2.6 0-3.4-1.8-3.9-3.8-0.5-2 0.4-4.2-0.7-6.1 2.6-0.3 4.1-3 6.9-3.1-0.1 0 0 0.1-0.1 0-0.2-1.9-2-2.5-3-3.8 1.2-0.6 0.5-2.7 2.1-2.8 1.4-0.2 1 1.5 1.7 2.2 1.2-0.7 0.8-2.3 1.5-3.2 2.8-2.1 3.9-1.7 4.6 1.5 1.1 0.6 0 1.9 0.8 2.6 0.9-0.4 1.5-1.3 2.5-1.4 0.9 0.2 1.7 0.6 2.1 1.5 0.5 0.9 0.2 2 0.8 2.9 0.2 0.8 1.1 1.1 1.6 1.7 2.7 3.2 5.9 6.2 3.7 11.1-0.4 0.2-0.9 0.3-1.4 0.6-2.1 1.3-8.2 2.5-10.8 2.1-0.6 1.1 1.7 1.4 0.6 2.5-1.3 1.3-2-0.4-2.9-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m119.6 188.9c1.1-0.8 1.2 0 1.3 0.8 0.2 1.6 1.4 2.3 2.6 3-1.2 1-2.1-0.1-3.2-0.3-1.7-0.4-3.7-0.4-4.6 1.2-1.5 2.8-1.3 2.9-3.7 0.7 0.6-0.2 1.4-0.6 1.2-1.2-1.2-4.3 1.4-4.3 4.3-3.7 0.8 0.1 1.5 0 2.1-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m132.6 173.6c-1.2-1.4-2.3-3.2-4.6-1.5-0.5-1.3-0.6-2.3 1.3-2 1.4 0.2 2.8 0.3 4.1 0.4 1.1 1.4-0.4 2.1-0.8 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s256",
    d: "m156.4 179c1.4-0.7 1.8-1.6 1.6-3.3-0.4-2.5 1.3-3.6 3.7-3.5 4.6 0.1 4.6 0.1 3.1-3.9v-0.8c1.4 0.8 2.1 3 4.9 1.4-1.2 2.2-1.5 3.9-3.4 4.7q-0.1 0.2-0.2 0.5c-0.7 0.6-1.5 1.2-2.1 1.9q-0.5 0.5-1.1 0.9c-0.9 1.1-1.2 2.6-2.5 3.3-1.4 0.9-2.9 1.9-4-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m162.5 175.9q0.4-0.4 0.8-0.8c0.8-0.8 2.2-0.7 3-1.5 2.6 0.2 2.5 2 2.3 3.8q0.4 0.8 0.8 1.6 0.7 0.7 0 1.5c-0.5 0.5-1.1 0.5-1.7 0.1-1.4-0.8-2.4-1.2-2.5 1.2-0.1 1.8-1.3 2-2.7 1-2.6-2.3-0.5-4.6 0-6.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m178.6 171.3q1.9 0.8 3.8 1.5c-0.5 1-1 2-1.4 3-0.3 0.8-0.1 1.9-1.2 2-1.2 0.1-1.5-1.1-2-1.9 0.7-0.8 0-1.5 0-2.3 0-0.8 0.1-1.7 0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s155",
    d: "m177.8 173.6c0.7 0.5 2 0.1 2 1.2 0 1.2-1.2 1-2 1.1-0.7-0.8-1.5-1.5 0-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m175.9 169.7c0.1 0.2 0.2 0.5 0.4 0.8-0.3 0.1-0.6 0.3-0.9 0.3-0.1 0-0.4-0.3-0.4-0.5q0-0.7 0.9-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m180.1 169h-1.5c-0.5-0.1-1.3-0.1-1.3-0.3-0.1-0.7 0.6-0.8 1-0.7 0.6 0.2 1.2 0.7 1.8 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s167",
    d: "m175.5 101.7c-0.7-0.8-1.9 0-2.4-0.6-0.8-0.7-2.1-1.6-1.3-2.7 0.7-0.9 2-0.4 2.5 0.7 0.7 1.6 1.9 0.7 2.9 0.7 1.5 0 2.9-1.1 4.4-0.4-2 0.8-3.2 3.8-6.1 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s167",
    d: "m181.6 99.4q1.2-1.1 2.4 0c1.9 0.3 2.6 1.4 2.2 3.3-0.2 1.8-0.8 3.1-3 2.1 0.7-2.3-1.9-1-2.3-2.2 2.3-0.6 2.4-1.7 0.7-3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s110",
    d: "m183.2 104.8c1.4-0.2 2.1-0.8 1.5-2.3 1.8-1.2 3.2-0.9 3.6 1.3 0.4 2.7-1.3 3.4-3.6 3.3q-0.8-1.2-1.5-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m181.7 107.8c-0.8 1.2-1.7 2-3.1 0.8 0.8-0.2 1.8-0.2 1.8-1.4 0-0.7-2.3-0.9-0.7-1.7 1.5-0.7 1.9 1 2 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s180",
    d: "m176.7 104.9c-0.1 0.8-0.3 1.6-1.2 1.7-1.3 0.1-0.9-1.2-1.3-1.9-0.6-1.2 0.5-0.7 0.9-0.8 0.9-0.3 1.5 0 1.6 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m170.9 104c0.9-0.7 1.9-1.3 3.1-0.7q0 0.3 0 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m72.9 54.3c1.1-0.6 4.2 0.8 2.4-2.5-0.1-0.1 1.5-0.4 0.8-1.5 2.8 1 5.3-3.6 8.3-0.6-0.5 1.3-1.8 1.9-2.4 3.1q-0.3 0.4-0.7 0.7c0.4 2.2 0 4.2-0.7 6.2q-0.8 0-1.5 0c-0.9-0.8-4.6 0.4-2.1-2.9 0 0-0.6-0.7-1-0.9-1.7-0.9-2.1 1.1-3.3 1.6-0.2-1.1-0.6-2.2 0.2-3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s184",
    d: "m81.3 52.8q-0.3-3.4 3.1-3.1c1.4-0.9 2.7-1.8 0-2.7-0.8-0.3-1.5-0.7-2.3-1.1q0.1-0.3 0.2-0.5c1.1-0.8 2-1.7 3.3-2.2 4.4-1.3 5.2-1.1 6.5 1.9-0.6 2.2-2.7 3-3.9 4.6 0.5 1-0.2 1.9-0.3 2.8-0.3 0.4-0.7 0.6-1.2 0.3q-1.2 0.4-2.3 0.7c-0.9-0.7-2.2 0.1-3.1-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m86.7 52.8q0.4-0.4 0.8-0.8c-0.1-1.4 0.6-1.3 1.5-0.8v1.6c-0.6 1.4 0.6 2.3 1 3.5 0.3 0.6 1.1 1.3 0.1 1.9-0.8 0.4-1.6 0.2-2.2-0.2-1.4-0.8 0.1-0.9 0.4-1.4 0.6-1-0.5-1.3-1.1-1.4-3.4-0.2-0.1-1.7-0.5-2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s73",
    d: "m81.3 52.8c1.3-0.6 3-3.1 3.1 0.7-1 0.6-2 0.2-3.1 0q0-0.3 0-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s267",
    d: "m85.4 57.4c-0.2 0.3-0.4 0.6-0.7 0.8 0 0-0.5-0.3-0.4-0.4 0.1-0.3 0.3-0.5 0.5-0.8 0.2 0.1 0.3 0.2 0.6 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m70.6 52.8v-0.8c1.3 0.1 1.8-1.4 3.2-1.7-0.3 1.2-0.6 2.2-0.9 3.2q-1.1-0.3-2.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s113",
    d: "m184.7 107.1c1.2-0.8 2.9-1 2.7-3-0.1-1.8-1.5-1.6-2.7-1.6 0.8-1.3 0.2-2.2-0.8-3.1q1.6-0.4 3.1-0.7c1.8-0.6 2.5-2.9 4.6-3.1q0.8-0.4 1.5-0.8c0.9 1.7-2 3.2 0 5.2 0.5 0.6-2.9 1.1-4.1 2.5 2 2.8 5.4-0.4 5.4 0 0.5 3.7 2.8 1.9 4.5 2 0.7 0 1.3-0.3 1.9-0.5 0.6 0.4 1.6 0.8 1.7 1.3 0.1 0.8-0.9 1.1-1.6 1-1.3-0.2-1.4 1.4-2.4 1.5q-0.4 0.5-0.8 0c-0.7-1.8-0.7-1.8-3.8-0.7-1.4-0.3-2.7-0.7-3.8-1.6q-0.8 0.8-1.6 1.6-2.3 1.1-4.6 2.3 0.4-1.2 0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m181.6 112.4q0.8-0.4 1.6-0.7c1.7 1.6 5.8 2.2 2.4 5.9-0.5 0.5-0.8 1.5-1.7 1-0.9-0.4-0.8-1.3-0.4-1.9 1.6-2.4 0.2-3.1-1.9-3.5q-0.1-0.2-0.2-0.4 0.1-0.2 0.2-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s113",
    d: "m178.6 114.7q-0.4-0.7-0.8-1.5c1.3-1.2 2.6-0.9 3.9 0 0 0.8 0.5 1.8-0.5 2.4-1.2 0.8-1.9-0.3-2.6-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m190.1 114.7q-0.8 2.3-1.6 4.6h-1.5c0.3-2 1.2-3.6 3.1-4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s268",
    d: "m122.7 32.9c-0.1 1.9 2.1 3.9-0.1 5.8-2.5-2.6-4.3-0.9-6 1.1q-0.3 0.4-0.7 0.7c-0.8 0.2-1.5 0.9-2.4 1-1.7-0.4-3.3 0.9-5.1 0.4q-0.5-0.2-0.9-0.6c-0.3-0.5-0.4-1-0.5-1.6q0-0.8 0.1-1.6c0.9-2.1 3.4-2.7 4.4-4.8 0.8-0.9 1.6-1.9 2.6-2.6 2.7-0.3 5.5-1.3 8.1 0.6q0.6 0.7 0.5 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s269",
    d: "m134.9 34.4q-0.7 0.4-1.5 0.8c-2.2-0.6-4.3-1.6-6.1-3.1q-0.5 0.6-1 0.1-0.3-0.5-0.2-1.1c0.7-1.4 1.7-2.2 3.2-2.1 1.3 0.7 3.2 0.5 3.8 2.3 0.1 0.9 0.5 1.7 1.1 2.4q0.4 0.3 0.7 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s270",
    d: "m115.8 39.8q0.4 0 0.8 0c2.2-0.1 2.9 1 2.3 3-1.3 0-2.7 0.2-3.1-1.5q-0.7-0.8 0-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s271",
    d: "m128.1 39.8h-2.6c0.2-1.6 2-1.9 1.6-3.8 1.9 1.4 0.7 2.7 1 3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s215",
    d: "m126.5 32.1q0.4 0 0.8 0-2.1 1.5-4.6 0.8-0.4-0.4-0.8-0.8c1.2-2.5 1.2-2.5 4.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s198",
    d: "m133.4 17.6c2.6-4.3 5.1-1 7.7 0q0.3 0.3 0.7 0.5c0.8 0.4 1.4 0.8 0.8 1.8-1.5 0.1-1 1.5-1.5 2.3-1.9 1.9-4.7-0.7-6.6 1.3q-1.2 0.5-2.4 0.1c-2.8-2.7-2.7-3.5 1.3-6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s272",
    d: "m144.9 22.2c-0.8-0.8-0.4-1.5 0-2.3 1.8-1.6 3.5-3.7 5.7-0.5 0.3 0.8 0.1 1.6 0.1 2.4 1.2 0.6 0.7-1.1 1.5-1.1q1.7-0.8 3.3 0.2c1.6 3.5-1.3 4.5-3.3 6-1 0.3-1.5-0.2-1.9-0.9-1.5-0.7-3.1-1.4-3.9-3.1-0.4-0.5-0.9-0.7-1.5-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s273",
    d: "m150.3 19.9c-1.8-1.9-3.6 0.4-5.4 0q-1.2 0-2.3 0-0.8-0.8-1.5-1.5c0.6-0.7 1.7-0.7 2.3-1.6q0.3-0.3 0.7-0.6c0.7-0.3 1.6-0.3 2.1-0.9q0.5-0.5 1.1-0.9c1-0.7 1.8-1.5 3.2-1 0.8 0.4 1.1 1.3 1.5 2 0.3 0.7 0.7 1.4 0.7 2.1q0 0.6-0.3 1.1c-0.3 0.7-0.8 1.1-1.6 1.3q-0.3 0-0.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s274",
    d: "m134.2 22.2c2.3-1.8 4.6-1.3 6.9 0 0.6 0.5 1.5 0.5 2.2 1.1 1.5 1.4 1 2.2-0.7 2.7-1.3-2.7-2.6-0.7-3.8 0-0.8-0.8-1.7 0.1-2.5-0.3-1-1-2.1-1.9-2.1-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s272",
    d: "m161 27.6q0 0.3 0 0.7h-2.3c-1-0.4-2.1 0.4-3.1 0q-1.6 0.3-3.3 0.6c-0.1 0.1-0.2-0.1-0.2-0.2q0.2-0.2 0.4-0.4c-0.1-2.4 1.2-3.6 3.4-4 2.5-1.1 3.6 0.5 4.7 2.3q0.3 0.4 0.4 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m136.5 25.2c0.8 0.1 1.6 0.2 2.3 0.8-2.2 1.7 0.9 2 0.8 3.1q-0.4 0.4-0.8 0.8c-1.5 0.8-2.7 0.1-3.9-0.5-1.3-0.7-1.9-1.8-1.5-3.2 0.5-1.7 1.8-1.4 3.1-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s270",
    d: "m156.4 25.2c-1.6 0.7-3.5 0.9-3.8 3.1v-0.8c-0.3-0.2-0.8-0.3-0.8-0.7 0.8-2.1 3.2-3.1 3.8-5.4-0.1-0.8 0.3-1 1-0.8 1.9 1.6 0.2 3.1-0.2 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s272",
    d: "m147.2 31.4c-1-0.3-1.5-2.6-3.1-0.8-0.8-1.3-0.4-2.3 0.8-3.1 1.8 0.3 4 0.1 3.1 3.1q-0.1 0.7-0.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s275",
    d: "m142.6 26c2.3-2.4-0.9-2.6-1.5-3.8 0.7 0.1 1.5 0.1 2.1 0.5 0.8 0.6 2.5 0.6 2.4 1.9-0.2 1.7-1.8 1.3-3 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s161",
    d: "m147.2 31.4q0.4-0.4 0.8-0.8c1.5-0.6 2.1 0.1 2.3 1.5-1.5 0.2-2.9 0.5-4.8 0.8 0.8-0.8 1.3-1.1 1.7-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s85",
    d: "m155.6 28.3q1.5-1.3 3.1 0c-1 2.2-2.1 1.5-3.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s92",
    d: "m144.9 27.5q-0.4 1.6-0.8 3.1-0.7-0.4-1.5-0.8c0.5-1 1-2 2.3-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s75",
    d: "m151.8 26.8q0.4 0.4 0.8 0.7c-1-0.2-2.7 0.8-2.3-1.5q0.7 0.4 1.5 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s236",
    d: "m144.9 22.2c0.4-0.2 0.9-0.6 1.3-0.5 0.7 0.2 0.4 0.8 0.2 1.2q-0.8-0.3-1.5-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s270",
    d: "m108.1 39.8v1.5c1.8-0.6 3.3-2.4 5.4-0.8 0.3 0.7 1.2 0.2 1.6 0.8-1.7 1.9-3 4.3-6.2 3.8-0.6 0.6-1.1 1.5-2.1 1.6-1.7-1.5-2.6 0-3.8 0.9-2.3 0.4-3.7-0.8-4.8-2.5q-0.4-1.1-0.8-2.2c-0.6-0.8-0.4-1.4 0.3-1.9 2.2 0.2 2.9-2.5 4.9-2.7 1.9 0.4 4-0.2 5.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s217",
    d: "m106.6 45.9q1.2-0.4 2.3-0.8 0 0.8 0 1.6-0.1 0.2-0.1 0.4c-0.5 0.7-0.8 1.5-1.1 2.3q-0.1 0.1-0.3 0.3-1.6 0-3.1 0c-0.9-0.8-1.1-1.7-0.4-2.8 0.5-1.3 2-0.2 2.7-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s217",
    d: "m110.4 49c-0.8 0.7-1.7 1.7-3 0.7 0.4-1.1 0.5-2.3 1.5-3q1.4 0.7 1.5 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s276",
    d: "m115.1 41.3c-0.5-0.4-1.8 0.9-1.6-0.8q1.1-0.3 2.3-0.7 0 0.7 0 1.5-0.4 0-0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m101.2 58.9c2.1 1.7-0.1 2.6-0.7 3.8-0.4-0.3-0.9-0.5-1.3-0.8-0.6-0.4-1.5-0.6-1.4-1.5 0.2-1.4 1.3-0.9 2.1-1 0.4-0.1 1-0.1 1.3-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m101.2 58.9c-1.6 1-3.2 2-0.7 3.8-1.6-0.4-3.6-0.8-3.1-2.9 0.5-2.1 2.5-0.7 3.8-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m102.8 62q2.3 0.7 4.6 1.5c-0.8 0.9-1.9 1.3-3.1 1.5-0.2-1.2-2-1.6-1.5-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m102.8 54.3c-0.6 1.1 0.2 1.6 0.7 2.3 0.1 0.3 0.1 1 0.1 1-1.4 0.2-1.7-1-2.4-1.8q0-0.7 0-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m30.8 50.5c1.4-1.8 3.1-2.6 5.4-2.3 0.3 0.3 0.8 0.3 1 0.8q0.1 0.4-0.3 0.7c-0.5 0.9-1.6 0.2-2.3 0.8-1.2 1-2.5-0.2-3.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s216",
    d: "m34.6 50.5c0.2-2.1 1.6-0.5 2.3-0.8q0 0.8 0 1.6-1.1-0.4-2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m36.9 52c-0.5 0.6-0.7 1.7-1.8 1.4-0.1 0-0.2-0.5-0.1-0.6 0.4-0.8 1.2-0.7 1.9-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m174.7 35.2q-0.7 0.3-1.5 0.7c-0.3-1.8 0.6-2.7 2.3-3 0.1-2 1-3.3 3-3.8 1.6-0.2 3-1.1 4.7-1.4 1.2-0.1 1.2-1.3 1.8-2.1 1.4-1.4 2.4 0 3.4 0.7 1.4 1.9 0.4 3.4-0.9 4.9-0.4 0.3-1 0.5-1.6 0.6-1.4 0.3-2.4 1.6-4 1.4-1.2 0.3-2-0.7-3.1-0.9-0.3-0.3-0.3 0.5-0.1 0.1 0.1-0.2 0.2-0.1 0.4 0 0.9 0.6 1 1.3 0.6 2.2-1 1-2.2 1.2-3.5 1.4-0.6-0.1-1-0.4-1.5-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s239",
    d: "m179.3 20.6q0-0.3 0-0.7c0.6-1-0.3-1-0.8-1.3q-0.3-0.4-0.4-0.9c0-0.9 0.5-1.6 1.2-2.2q1.6-1.1 3.5-0.5 0.5 0.1 1 0.2c1 0.6 1.9-0.1 2.9-0.2 0.8 0 1.5 0.2 2.1 0.7q0.6 0.7 0.6 1.6 0 0.6-0.3 1.1c-0.9 1.3-2.9 1.2-3.7 2.8q-0.4 0.3-0.9 0.5c-1.8 0.1-4 1.8-5.2-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s277",
    d: "m183.9 29.1c-1.6 0.9-3.5 0.7-5.3 0.7-0.5-0.5-0.5-1 0-1.5q0.4-0.4 0.7-0.8c1.3-1.4-0.1-4.4 2.9-4.8q0.6 0 1.1 0.1c0.8 0.3 1.4 0.8 1.8 1.5q0.2 0.6-0.1 1.1c-0.6 1.2 0.2 2.7-1.1 3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s98",
    d: "m182.4 23.7c-2 0.5-0.9 3.5-3 3.8-1.5-2.3-0.9-4.6-0.1-6.9q2.3 0.1 4.6 0.1c1.3 1.9-0.6 2.2-1.5 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s278",
    d: "m174 27.5c-1.6 0.1-3.1 0.1-4.6-0.7q-0.7-0.1-0.8-0.8c0.2-0.5 0.5-1 0-1.5-0.4-1.8 0.6-2.4 2.2-2.5q0.3 0.2 0.3 0.6-0.1 0.3-0.2 0.3c0.1 2.2 3 2.5 3.1 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s86",
    d: "m178.6 28.3q0 0.8 0 1.5-1.5 1.6-3.1 3.1c-1.5-4.8-1.2-5.2 3.1-4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s279",
    d: "m178.6 19.1c-0.8 0.8-1.4 1.8-1.7 2.9-0.5 1.5-1.5 2-2.9 1-0.3-0.6-1.2-0.5-1.3-1.2-0.2-1.2 0.4-1.9 1.3-2.5q0.5-0.2 0.9-0.5c1.1-0.4 2.2-0.9 3.4 0q0.1 0.2 0.3 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s280",
    d: "m178.6 18.4c1 0.2 2.5-0.6 2.8 0.7 0.2 0.9-1.3 0.7-2.1 0.8q-0.3-0.4-0.7-0.8-0.3-0.2-0.2-0.5 0.1-0.2 0.2-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s281",
    d: "m173.2 22.2c0.4 0.1 1 0 0.8 0.8q-1.5-0.1-3.1-0.1 0-0.3 0-0.7-0.1-0.2-0.2-0.5 0.1-0.2 0.2-0.4c1.1-0.5 1.7 0.3 2.3 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s202",
    d: "m168.6 30.6c-0.2-0.8 0.4-1.1 0.9-1.4 0.1-0.1 0.4 0.4 0.7 0.6q-0.8 0.4-1.6 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s269",
    d: "m136.5 25.2c-0.5 0.9-2.3 0.1-2.1 1.7 0.2 1.1 0.8 1.9 1.8 2.3 0.8 0.3 1.7 0.4 2.6 0.7-0.6 2.3-2.6 0.9-3.9 1.5q-0.4 0.4-1 0.2c-0.7-1.4-2.6-0.9-3.4-2.1-0.5-1.1-0.5-2.1-0.3-3.2q0.1-0.6 0.4-1c0.6-0.9 1.1-1.8 2.1-2.3q0.7-0.4 1.5-0.8c1.3 0.6 2.4 1.4 2.3 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s282",
    d: "m134.2 31.4q0.3 0 0.7 0-0.4 1.1-0.7 2.3-1.4-0.5-2.9-1.1 0.7-0.6 1.3-1.2c0.5-0.5 1.1-0.5 1.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s122",
    d: "m141.8 29.8c-0.3 1.5-0.6 3-3.5 2.9 1.5-1.2 2.5-2 3.5-2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s283",
    d: "m164 28.3c-1-0.1-1.1-0.7-0.7-1.5q-0.5-0.5-0.9-1-0.2-0.3-0.3-0.7c-0.3-0.6-0.7-1.1-0.9-1.6q-0.2-0.4-0.2-0.9c0-0.6 0.2-1.2 0.5-1.8 0.3-0.3 0.5-0.7 0.6-1.1q0.1-0.5 0.4-0.9 0.3-0.7 1.1-1c1.9 0.1 3.8 0.8 5.6-0.4 0.6-0.1 1.2-0.1 1.8-0.1q0.6 0.1 1.1 0.4c0.6 0.6 1 1.2 0.9 2.1-0.1 1.2-1.1 1.4-2.1 1.6-1 0.6-1.3 2-2.6 2.1-0.4 0.2-0.9 0.2-1.3 0.4q-0.4 0.3-0.7 0.6c-0.7 1.3-2.5 1.9-2.3 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s284",
    d: "m168.6 26q0.4 0.4 0.8 0.8c-0.5 0.7-0.7 2-2 1.5-0.4-0.2-0.8-0.8-0.8-1.1 0.2-1.1 1.4-0.7 2-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s285",
    d: "m166.3 24.5q0-0.8 0-1.5c0.5-0.5 1.1-0.5 1.6-0.1q1.5-0.7 3-1.5 0 0.4 0 0.8-1.1 1.1-2.3 2.3-1.1 0-2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m181.6 113.2q-1.9 0.5-3.8 0c0.2-2 1.6-2.3 3.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s270",
    d: "m181.6 32.1c1.4-0.3 2.3-1.7 3.9-1.5 0.6 0.8 1.9 0.9 2.1 2.1 0.3 2-0.5 3.4-2 4.5q-0.7 0.3-1.4 0.3c-0.3 0-0.7 0.1-0.9 0.4-0.1 0.4-0.2 0.8-0.2 1.2q-0.1 0.4-0.3 0.8c-1 1.6-2.3 1.3-3.7 0.8-0.8-0.4-1.5-0.9-2.1-1.7h-2.2q0-1.9-0.1-3.8 0.8 0 1.6 0c0.9-1.1 2.3 0.5 3.2-0.5 0.6-1 1.2-1.9 2.1-2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s286",
    d: "m177.1 44.4q-0.4-1.6-0.8-3.1c-0.3-1.1 0.6-1.1 1.2-1.3 1.8 0.3 3.3 1.1 5.4 0.5 2.4-0.7 2.3 1.9 2.9 3.4-1.5 2.7-4.5 1-6.6 2.2-1.1-0.1-1.8-0.7-2.1-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s287",
    d: "m177.1 44.4q1.1 0.3 2.2 0.7c0.9-0.3 1.4 0.1 1.8 0.8-1.6 2.8-3.2 1.7-4.8 0q-1.3-0.2-1.5-1.5 0.7-0.7 1.5 0 0.4 0 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s274",
    d: "m177.8 40.6q-0.8 0.3-1.5 0.7c-0.7-0.1-2.1-0.1-1.9-0.4 0.6-0.9 1.7-1.3 2.6-1.9 0.9 0 1.7 0.1 2.3 0.8-0.2 0.7-0.6 1.2-1.5 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s197",
    d: "m176.3 44.4q-0.8 0-1.5 0-0.8 0.7-1.6 1.5c-0.3-0.8-0.9-1.8 0.1-2.4 1.2-0.8 2.1 0.1 3 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m165.9 63.5l0.3-1.5c-0.3-0.5-0.3-1.1 0-1.6q0.4-1.2 0.8-2.3 1.2-0.4 2.4-0.7c0.4 0.3-0.1-0.1 0.2 0.2q-0.1-0.1-0.2-0.2c0.7-1.7 2.7-1.3 3.8-2.3 0.6-1.5 2.9-1.4 3-3.3q0.1-0.5 0.3-1 0.6-0.7 1.4-0.9 0.5-0.1 1 0.1c1.6 0.7 3 1.5 3.5 3.3 0.3 0.3 0.7 0.4 1.1 0.3 0.6 0 1.1 0.2 1.7 0.5 0.2 0 0.5 0.2 0.6-0.2q0-0.4 0-0.8c-0.2-0.8-1.1-0.9-1.4-1.6q-0.2-0.6-0.2-1.1c0.5-1.4 1.6-1.3 2.7-1.1 1.3 0.1 2.7-0.1 4.1 0.3 1.4 0.4 3.1 0.3 4 1.9 0.5 0.8 0.6 1.6 0.2 2.4q-0.2 0.4-0.6 0.7c0.2-0.2 0.4-0.1 0.5-0.3 2.2-0.9 3.1 0.1 3.3 2.2q-0.3 1.2-1.5 1.6c-1.5 0-3-0.9-4.5-0.7-0.5 0-1.2 0.1-1.5-0.1-2.4-2.5-2.8-0.4-3.4 1.4-0.2 0.3-0.3 0.6-0.5 1-3.1-1.4-6.6 0-10.3-1.5 1.3 4.6 4 1.3 5.9 1.6 0.3 1.1-1.1 1.8-1 2.9-1.1-0.6-2.5-0.4-3.6-0.8-3.3-1.2-6.4-2.6-9.1 1.1-0.1 0.2-2-0.2-3 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s189",
    d: "m177.1 52c0.1 2.8-2.9 1.7-3.9 3.1 0.1-1.2-1.5-0.7-1.7-1.7 1.1-1.3 3.2 0.6 4-1.4q0.2-0.1 0.3-0.3c0.5-0.2 0.9-0.1 1.3 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s190",
    d: "m175.5 52l-2.7-0.3q0.6-0.6 1.2-1.2 1.9-0.4 1.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s155",
    d: "m162.5 167.5c-0.4 2.6-1.6 3.3-3.9 1.7-1.1-0.8-2.5-1.2-3.8-1.7 2.6-0.8 5.1 0.2 7.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s42",
    d: "m163.2 64.3q-0.2-0.1-0.5-0.1-0.1-0.7-0.2-1.5 0.4 0 0.8 0 0.7 0.8-0.1 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s286",
    d: "m187 50.5c-0.8 0-1.5-0.5-2.3 0-0.8 0.9-0.2 2.4-1.2 3.3-0.6 0.2-1 1-1.9 0.5 0.1-2.1-2.8-1.9-3-3.8q0.1-0.3 0.3-0.5c0 0 0-0.2 0-0.2-0.4 0.3-0.8 0.4-1.1 0.7q-0.4 0.4-0.7 0.7c-1.9-0.2-3-0.9-2.3-3q1.3-0.8 1.5-2.3c1.5 0 3.1 1.1 4.6 0 0.3-1 1.1-1.2 2-1.2 3.5 0.2 3.6 0.1 2.7-3.5 0-1.9 0.8-2.9 2.8-2.7q0.5 0.1 1 0.2c1.8 0.6 3.1-2 4.9-0.7 0.3 0.2 0.6 0.4 0.9 0.6 1.4 0.6 3.1 1 2.9 3-0.3 2.1-2 1.8-3.6 1.9-1 0-2 0.1-2.8 0.8-0.6 0.5-1.1 1-1.7 1.4 0.7-0.5 1.3-1.1 2.1-1.7 4.2-0.9 4.5-0.8 5 3.1-0.1 0.6-0.4 1.1-0.8 1.6-1.5 2-3.7 1.4-5.7 1.4-1.2 0-2.4 0-3.6 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s288",
    d: "m174.8 48.2c0.1 1.5 1 2.4 2.3 3v0.8q-0.8 0-1.6 0-0.7-0.8-1.5-1.5c-0.2-0.8-0.5-1.5-0.4-2.2 0.1-1.2 0.7-1.3 1.2-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m46.1 51.3c1.2-0.8 2.3-1.5 3.5-2.3 0.4 1.5-0.5 2.2-1.2 3-0.8 0-1.6-0.1-2.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s184",
    d: "m163.3 25.2q0 0.8 0 1.6-1.2 0.4-2.3 0.8-0.4-0.1-0.8-0.1c-0.6-2.9 1.2-2.7 3.1-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m169.4 180.5q0-0.8 0-1.5c2-1.5 3.8-1.4 5.4 0.7-1.7 1.1-3.5 1.6-5.4 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m197.7 107.8h0.8c0.8 1.9-0.5 1.7-1.7 1.9-2 0.3-4 1.4-6.4-0.6 2.7-0.4 4.8-1.6 7.3-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m190.1 105.5c1.5 0 2.8 0.5 3.8 1.6-1.8 0.8-3 0.2-3.8-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m196.2 112.4v-0.7c1.9-0.9 2 0 1.5 1.5-0.9 0.5-1.5 0.6-1.5-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s257",
    d: "m196.2 112.4q0.8 0.4 1.5 0.8 0.4 0.4 0.8 0.7c-1.1 0-2.2 0.1-3.1-0.7q0.4-0.4 0.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m201.6 101.7c1 0.1 1.5 1 2.3 1.6-1.8 0.9-1.7-0.9-2.3-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s59",
    d: "m26.2 154.5c0.7-1.1 0.7-2.9 2.9-2.6 0.9 0.5-0.3 1.1-0.2 1.8 0.1 0.8 0.3 1.5 1.3 1.4 1 0 1.8-0.4 1.4-1.6-1-2.4 0.9-2.4 2.3-2.8 1.4 1.2 0.4 2.5 0 3.8-3.3 2.3-6.8 3.5-10.8 3.8-0.7-0.6-1.2-1.4-2.3-1.5-0.1-0.7 0-1.1 0.8-0.8 2 0.9 2.3-3.3 4.6-1.5-0.4 0.3 0.2-0.2-0.2 0.2q-0.1 0.1 0.2-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m7.8 177.4c-0.9-1.2-1.6-2.6-3.5-2.5-2.1 0.1-3.7-0.6-3.1-3.1 0.7-2.5 2.5-1.4 4-0.9 0.4 0.1 0.7 0.3 1.1 0.4 2.7 3.4 2.7 3.4 1.5 6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m33.9 154.5c-1.2-1.3-0.6-2.6 0-3.8 1.1-2.5 4.1-2.8 5.6-5.1 0.8-1.1 2.4 0.5 3.6 1.2q-3.9 3.9-7.7 7.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m20.1 160.6c0.2-1.2-0.9-1.8-1.2-2.8 2.1-0.8 2.6 1 3.5 2-0.4 1.4-1.6 0.6-2.3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m9.4 169q1.1-2.7 2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s41",
    d: "m33.9 143c0.6 0.7 1.5 1.7 0.5 2.2-2.3 1.2-1.9 4.8-4.8 5.1-1.3 0.1-2.1-1.4-1-2.5 1.3-1.3 0.6-2.2-0.1-3.3 1.4-1.9 3.4-1.7 5.4-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s111",
    d: "m43.1 146.8c-1.8-0.7-3.3-0.7-4.5 1.3-1 1.7-3.3 1.4-4.7 2.6q2.3-4.2 4.6-8.4c1 1.8 3 2.6 4.6 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s289",
    d: "m33.9 143c-1.7 1.1-3.7 0.9-5.4 1.5-0.6-3.6 3.1-3 4.6-4.5q0.4 0.7 0.8 1.5c-0.2 0.5-0.5 1 0 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m21.6 156q-0.4 0.4-0.8 0.8c-1.1-1-2.6 0.2-4-0.7 1.7-2.1 3.3-1.1 4.8-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s47",
    d: "m23.5 144.9c-1.2 0-1.5-0.3-1.3-0.6 0.2-0.4 0.7-0.7 1.1-0.9 0.4-0.1 0.7 0.1 0.6 0.6-0.2 0.5-0.5 0.9-0.4 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s60",
    d: "m6.3 159.8c-0.6-0.5-1.6-1.1-1.6-1.4 0.3-1.2 1.4-0.8 2.2-0.7 0.9 0.2 2.1 0.2 2.5 1.4-0.8 1.2-2.1 0.6-3.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s179",
    d: "m186.2 225.6c-1.1 0.3-2.6 2-2.7-1 0-1.4-1.6-2-2.4-3.1-1.8 1 0.4 2.1-0.3 3-1 0.3-1.9-0.3-1.8-0.9 0.7-3.7-1.4-4.5-4.2-4.9-0.1-2.2 1.5-3.5 2.5-5.1q0.3-0.1 0.5-0.2c0.8 0.2 1.3 0.7 1.5 1.5 0.5 2 1.5 2.9 3.7 2 0.9-0.3 2.8-0.8 3 0.7 0.7 4.2 3.2 2.7 5.6 2.1 0-0.8-3-2.1 0-2.2 2 0 3.6-0.6 5.2-1.3 0.7 1.2-0.1 1.6-0.7 2.1-0.8 0.6-1.1 1.4-0.4 2.2 0.8 1.2 1.5 0.4 2.1-0.2 1-1 2-0.9 3.5 0.2-3.9 1.2-3.5 3.9-2.8 6.6-1.5 0-2.3 1.6-3.9 2 1-1.9-4.2-4 1.3-5.5-3.1-0.9-5.2 0.4-7.4 0.5-0.3 1.1-1 1.8-2.3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s179",
    d: "m167.9 211.8v-1.5c-2.4-2.7-2.3-2.7 1.3-4.2q0.5-0.1 1-0.1c2.3 0.9 3.5-1 5.1-1.9 5.1 0.2 6.1 1.9 4.1 7h-0.8q-0.3 0.2-0.2 0.5 0.1 0.2 0.2 0.2-0.4 0.8-0.8 1.6c-1.3 1.3-2.5 1.8-3.8 0-3.3 1.5-3.6 3.3-1.2 5.4 1.1 0.9 2.1 2.1 2.9 3.3 0.3 0.4-0.6 1-1.3 1-1.8-0.1-3-0.8-3.6-2.7-0.3-1.1-1.6-2-2.7-1.4-4.2 2.5-4.4-1.2-5.6-3.3-0.3-0.7 0.2-1 0.7-1.1 1.7 0.8 3 0.5 3.9-1.2 0.3-0.5 0.8-0.9 0.8-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m179.4 211.1c0.3-3.5-0.5-6-4.6-6.1q-0.4-0.2-0.7-0.3c-1.4-3.9-0.2-4.9 5-4.4q0.7 0.2 1 0.8c2.6 2.4 5.9 2.9 9.2 3.1-0.2 0.6-0.6 1.4-1.2 1.3-4.5-1.3-6 1.9-7.5 5-0.2 0.4-0.6 0.8-1.2 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m178.6 211.8c-1-0.2-2.1-0.4-1.8-1.9 0.1-0.2 0.6-0.6 0.8-0.6 1 0.1 0.9 1.1 1 1.8q0 0.4 0 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m180.1 201.1h-0.8c-3.1-1.2-5.4-0.4-6.2 3.1q-0.3 0.4-0.8 0.7c-1.5 0.1-3 0.3-2.9 2.4-2.7-0.1-0.8 2.1-1.5 3-1 0-2.4 1.1-2.8 0-1.4-3.6-3.1-0.8-4.9-0.3-0.5-1.8-0.7-3.9 0.9-4.6 4.3-1.6 0.5-2.4-0.1-3.5-1.1 0.5-2-0.4-2.9-0.3-1.9 0.1-3.5-0.1-2.9-2.6 0.4-2 1.8-3 3.9-2.6 1.1 0.3 2.1 0.8 3.3 0.9 1.2 0.8 2.7 0.1 3.9 0.8 1.9 1.2 4-1.8 5.9 0.2 1-1.4 3.6-1.9 2.8-4.3-0.2-0.9-1-1.6-0.2-2.4 0.4-0.5 0.9-0.2 1.3 0.2 0.7 0.8 1.7 1.4 1.8 2.7 0.2 1.3-3.5 2.3-0.3 3.8 2.6 1.3 3.1-1.2 4.2-2.5 0.4-0.5 0.9-0.4 1.4 0q0 0.4 0 0.7c-0.6 1.4 0.2 2.7 0.3 4-1.2 0.2-2.3 0.4-3.4 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m183.2 196.5c-0.1-0.1-0.2-0.3-0.2-0.5 0-0.1 0.1-0.1 0.2-0.2h2.3c-0.5 1-1.3 1.2-2.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s290",
    d: "m162.5 198.1c-0.9 0.2-0.9 3-2.3 1.1-3.2-4.4-2.8 0.5-4.9 1.2 2.6 0.7 4.1 1.1 5.7 1.5-0.4 1.5-1.5 0.7-2.3 0.8-4.4 0.5-5.8-3.4-8.1-5.8-1-1-1.5-2-2.8-0.8-1.2 1-2.3 1-3.4 0-0.7-0.5-1-1.1-0.7-2 0.6-1.7 2.3-0.1 3.4-1.2-1.1-0.4-2-0.6-3-0.9-0.8-3.9-2.4-7.5-4.6-10.7-0.5-0.8-1.6-0.9-2.3-1.6-0.9-1 0-2 0-3 3.2-0.9 4.6-0.5 6.2 1.5-1.1 1.5 0.3 2.3 1 3.2 1.4 1.7 1.5 1.6 0.9 3.6 2.9-0.6 3-3.9 4.9-5.3 1.7 1.4 3 3.3 5.8 2 1.1-0.6 2.7 0.4 3.4 1.8 2 2 2.7 4 1 6.8-0.9 1.5-1.7 3.9 1.3 4.7 1.8-0.2 3.6 0.1 3.4 2.3-0.1 1.6-1.4 1.4-2.6 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s291",
    d: "m159.4 183.5c-1 0.2-1.9 0.3-2.8-0.4-0.6-0.6-1.4-0.7-1.9 0.2-0.3 0.8 0.3 2.4-1.8 1.5-1.3-0.5-2.2-0.9-2.2-2.5 0-0.9-0.3-1.7-0.4-2.6h6.1c3.8 0.1 4.9-1.2 3.8-4.8 1.1-0.3 1.5 0.8 2.3 1v6.9q-1.5 0.4-3.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m162.5 198.1c0.7-0.1 1.8 0 1.7-1-0.1-1.3-1.5-1.5-2.5-2.1 1.2-1.1 0.2-3.3 2.7-3.8 3.2-0.7 5.7-1.3 5.9 3.2-1.8 0.6-4.2 0.8-4 3.7-1.2-0.2-2.5 4.4-3.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s291",
    d: "m162.5 182.8c3.2-0.9 0.9-4 2.3-5.6 2.6-0.4 2 3.7 4.6 3.3-3.6 1.3-2.5 3.6-1 5.9-3.6 1.1-5.4-0.2-5.9-3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m177.1 184.3c-1.2 0.5-2.1 2-4 1 1-1.8 2.3-2.1 4-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m169.1 183.8c0.8-1.1 1.9-0.7 2.8-0.8-0.5 1.1-1.4 1.5-2.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s63",
    d: "m164.6 77.9q0.1-0.7 0.3-1.4c1.2-0.7 0.5-2.3 1.4-3.1 3.2-0.8 3.3-3.8 4.5-6.6 1.2 1.6-0.8 4.6 2.4 4.3 0.5 0.6 0.4 1.1 0.1 1.7 0.3-0.6 0.4-1.1-0.1-1.7 1.4-0.3 0.9-3 3.1-2.3 0.3 0.5 0.5 1.1 0 1.6-0.4 1.8 0.6 2.5 2.2 2.6 0.8 0 1.8-0.1 1.8 0.8 0 0.7-0.7 1.5-1.2 2.1-1.1 1.3-1-0.2-1.3-0.6-0.4-0.4-0.4-0.5-1-0.1-3.7 2.7-7.9 3.2-12.2 2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s113",
    d: "m174 86.4c1-1.3 0.6-2.9 0.7-4.3 0.1-1.9 1-1.9 2.4-1.8h1.5c0.5 1-2.1 2.4 0.3 2.9 1.2 0.3 2.5 0 2.9 1.8-2.3 0.2-6-3.4-6.3 2.2q-0.4 0.4-0.9 0.4c-0.5-0.2-0.9-0.5-0.6-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s267",
    d: "m187 59.7c1.8 0.6 1.4 2.7 2.4 3.9 0.4 0.5 0.7 1.7-0.1 2.5-0.5 0.5-1.2 0.4-1.8 0-0.8-0.6-1.8-1.2-1.5-2.4 0.2-1.4 0.7-2.7 1-4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s57",
    d: "m191.6 95.6c-0.6 2.5-1.7 4-4.6 3.1q0.8-2.3 1.5-4.6c1 0.7 2.8-0.4 3.1 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s202",
    d: "m192.4 57.4q1.9-2.8 3.8 0c-0.1 0.8-0.9 1.4-1.1 2.2-0.2 0.7-0.5 1.3-1.2 1.6q-0.8-0.8-1.5-1.5c-1-0.1-2 0.1-3.1-0.8 0.7-1.2 2.4-0.5 3.1-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s197",
    d: "m189.2 67.8c2 0.5 1.6 2.3 2.4 3.3 0.4 0.6 0.8 1.2 0.3 1.7-1.1 1.3-1.5-0.7-2.6-0.6-1.8 0-0.2-0.9 0-1.2 0.6-1.1-0.7-1.9-0.1-3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m186.4 86.7c2.4-1 3.7 0.4 5 1.7 0.1 0.1-0.4 1.1-0.7 1.1-2 0.1-3.4-0.9-4.3-2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s57",
    d: "m188.5 93.3v0.8c-2.4-1.2-5.3 0.1-7.6-1.6 0.5-0.4 1-0.4 1.5 0 2.3-1.8 4.3-1.4 6.1 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s202",
    d: "m176.3 70.4c-0.2-0.5-0.5-1.1 0-1.6 0.8-0.4 0.2-2.9 2.3-1.5 0.8 0 1.6 0 2.3 0.7-1 2-2.6 2.5-4.6 2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s258",
    d: "m166.3 73.4c0 1.5 1.5 1.9 2.2 2.8-1.2 1.4-2.4 0.4-3.6 0.3q-0.1-1.6-0.2-3.1l0.3-0.2 0.3 0.1q0.5 0.1 1 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s113",
    d: "m195.4 81.8c1-0.1 1.9-0.2 3-0.3 0.4 1.9-1.4 2.4-2.2 3.4-2.2-0.5-1.3-1.8-0.8-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s292",
    d: "m165.3 73.3q-0.3 0-0.6 0.1-0.3-0.8-0.7-1.5c-1.1-1.5-0.2-2.6 0.7-3.7q0.5-0.4 1-0.9-0.2 3-0.4 6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s64",
    d: "m195.4 81.8c0.1 1.1 0 2.2 0.8 3.1-0.3 1.1-1.1 1.1-1.7 0.4-1.1-1.4-0.4-2.6 0.9-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m181.6 79.5c0.3 0.7 0.9 1.6-0.1 2-1.2 0.5-1.9-0.8-2.9-1.2 0.9-0.8 2-0.7 3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m191.9 77.1c-1.3-0.9-2.2-1.3-2.7-2.6 2-0.5 2.8 0.2 2.7 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m170.9 94.1q0.8 0.4 1.6 0.7c-1.1 0.8-1.6 2.9-3.7 1.5 0.4-1.1 2.2-0.8 2.1-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m179.6 97.2c-0.2 1.1-0.8 1-1.5 0.8-0.6-0.1-1.3-0.3-0.7-1.1 0.3-0.4 0.3-1.5 1.2-1 0.4 0.3 0.7 0.9 1 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m181.6 79.5c1.4-1.4 2.5-1.3 3.6 0.6-1.4 0.6-2.4-0.6-3.6-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s31",
    d: "m180.9 68c-0.9 0.1-1.7 0-2.3-0.7 1.1-1.1 2.1-1.6 2.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m174.8 87.2h0.7c0 1.1 0.1 2.2-0.7 3-1.6-1-1.8-2 0-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s35",
    d: "m183.1 87.6c0.3 0.3 0.8 0.7 0.8 1.1 0.1 0.5-0.4 0.5-0.7 0.2-0.3-0.3-0.5-0.7-0.8-1.1 0.2 0 0.4-0.1 0.7-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m182.4 92.5q-0.8 0-1.5 0.1c-0.3-0.5-0.7-1 0.1-1.2 0.7-0.1 1.1 0.6 1.4 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m181.6 62.7q0.9 0.3 1.7 0.6c-0.1 0.1-0.2 0.5-0.3 0.5-0.7 0-1-0.6-1.4-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s293",
    d: "m195.2 80.2c0.2-0.3 0.4-0.6 0.6-0.8 0-0.1 0.5 0.2 0.5 0.2-0.2 0.4-0.3 0.7-0.5 1-0.2-0.1-0.3-0.2-0.6-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s122",
    d: "m-9.8 44.4c0.3-1.8-1-3.6 0-5.4-1-1.6 0-2.7 0.8-3.9 1-1.7 1.8-3.4 4.1-3.4 3.5-0.1 5.9 2.6 9 3.5 0.6 0.2 1 0.8 0.8 1.5-0.4 1.2-1.4 1.4-2.4 1.5q-2.4-0.6-4.8-1.3c1.6 0.6 0.4 2.4 1.6 3.5 1.7 1.6 2.2 0.8 3.8 0.1 3.4-1.4 5.8 0.5 7 4.6-0.3 0-0.9 0.1-1.1-0.1-4-3.8-8.4-0.4-12.7-0.6-0.6-0.3-0.9-0.9-1.4-1.3q-0.1 0.3 0.2 0.5c0.4 0.3 0.9 0.4 1.2 0.8-2 1.3-4 0.8-6.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s269",
    d: "m26.2 45.1c-2.1 1.9-3.5-1.1-5.3-0.7q-0.4-0.4-0.8-0.8 0.7 0 1.5 0 0.4-0.2 0.3-0.6c0-0.1-0.1-0.2-0.3-0.2-1.9 0.1-3.9 0.3-5.3-1.5-0.3-0.5-0.1-1 0.2-1.5 0.9-1 2.2-0.9 3.3-1.3 2.3-0.6 3.8-2.8 6.2-3.3q0.3 0 0.6 0 0.4 0-0.2 0c-0.6 0-1.2 0.1-1.8 0-0.9-0.4-1.7-0.9-1.8-2q0.1-0.5 0.4-1c0.9-0.6 1.7-1.3 2.9-1.5 2.4-0.7 4.6-2.5 7.4-1.3 0.9 0.1 1.9 0.1 2.6 0.8 0.6 0.6 0.6 1.4 0.3 2.1q-0.2 0.5-0.6 0.9c-0.2 0.2-0.5 0.4-0.5 0.8 1.4 0.1 2.8 0.2 4 0.9q2.5 1.7 0.5 3.9-0.3 0.1-0.6 0.2c-1.1 1.2-2.3 2.5-3.5 3.6-0.9 0.9-2.1 0.8-3.1 0.2-1.1-0.5-0.6-1.4-0.3-2.3 0.5-0.9 1.5-1.2 2-2.1q0-0.4-0.2-0.7c0 0.1-0.3-0.2-0.2-0.1 0 0 0-0.1 0.1 0 0.1 0.2 0.1 0.3 0.2 0.5-0.1 0.5-0.3 0.8-0.6 1.1-0.6 0.3-0.9 0.8-1.3 1.3h-3c-0.8-0.7-1.6-0.3-2.3 0-0.9-0.3-1.1 0-0.8 0.8 0.8 1.3-2.5 2.6 0 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s269",
    d: "m40 41.3q-0.4-1.1-0.8-2.3c0.9-1.2 1.6-2.8 3.7-2.1 2.5 3.3 2.6 4.7 0.1 7.1q-0.6 0-1.1-0.2c-0.8-0.7-1.1-1.8-1.9-2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s269",
    d: "m37.7 46.7c0-1.8 2-2.3 2.3-3.9 1.2-0.9 1.7 0 2.3 0.8 0.5 0.4 1.4 0.1 1.7 0.9 0.1 0.5-0.1 1-0.5 1.4-1.4 0.4-2.3 1.5-3.6 2-1.1 0.2-1.7-0.5-2.2-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m26.2 41.3c-0.8-0.6-1.8-1.3-0.5-2.3 0.4-0.3 1.4-0.6 1.6-0.4 0.7 0.6-0.4 1.2-0.3 1.9q-0.4 0.4-0.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s294",
    d: "m42.3 43.6q-1.2-0.4-2.3-0.8c-0.5-0.5-0.2-1 0-1.5q2.3 0 2.3 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s269",
    d: "m29.3 40.5c-0.1 0.9-0.2 1.8-0.2 3.1-0.9-1.5-0.4-2.3 0.2-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s295",
    d: "m17 40.5q-0.4 0.4-0.7 0.8c-0.3 1.2-1.2 1.5-2.3 1.6q-0.4-0.1-0.8-0.1c-1.6-2.9-4.7-3-7.5-3.7-1.1-0.3-2.3 0-3.2-0.9 0.4-0.5 0.8-1.1 1.5-2.1-4.1 0.6-5.7-3.6-9.2-4q-0.1-0.2-0.1-0.5 0.3-0.5 0.9-0.2 0.7 0 1.5 0c0.9-0.7 1.9-1 3-0.9 1.5 0.1 2.2 1.6 3.5 2.1q1 0.5 2.2 0.8c0.4 0.2 0.8 0.4 1.2 0.7 0.8 0.5 1.6-0.2 2.3-0.2q0.8-0.1 1.5 0.4 0.8 0.9 1.4 2 0.3 0.3 0.4 0.8c0.2 0.3 0.4 0.7 0.7 0.9 1.1 1.2 4.6-1.4 3.7 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m21.6 42.8c0-0.9-0.6-2 0.9-2.3 0.6-0.1 1.1 0 1.2 0.6 0.3 1.6-0.7 2.2-2.1 2.5q0-0.4 0-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s182",
    d: "m37.7 46.7q1.1 0.3 2.3 0.7c-0.3 2.1-1.6 1.9-3.1 1.6q-0.4-0.4-0.7-0.8 0.7-0.8 1.5-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s75",
    d: "m214.6 29.1c0.5 1.2 2.1 1.6 2.3 3-1.8 0.3-3-1.3-4.6-1.5q-0.3-0.3-0.2-0.7-0.1 0.4 0.2 0.7c0.7 1.6-1 1.5-1.5 2.3 0.2 0.7 0.8 0.7 1.5 0.8q1.1-0.6 2.3 0c-1.5 1.2 2.5 2.6 0.3 2.7-2 0.1-1.7 4.1-4.2 1.8-0.4-0.2-0.9-0.2-1.3-0.5-0.6-0.7-1.1-1.5-1.9-2 0.1 0 0 0 0.1 0 0.6 0.4 0.9 1 1.3 1.5 0.5 0.8 0.4 1.9 1.1 2.6-0.2 2.4-0.2 2.4-3.9 1.5-1.6 0-2.3-1.5-3.5-2.1q-0.4-0.4-0.6-0.9c-0.5-0.7-1.2-1.3-1.1-2.3 0-1.5 1.5-1.6 2.4-2.3 0.6-1.1-1.7-1.1-1-2.3 1.3-0.2 3 0.4 3.8-0.9 1-1.5-1.6-1.6-1.5-2.9 1.4-1.2 2.2-0.2 3.1 0.7 1.2 0.5 2.2 0 3-0.8q0.4-0.3 0.8-0.7 1.5 1.1 3.1 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s182",
    d: "m203.1 38.2q2.2 0.9 3 3.1c0.1 2.3-1.6 3-3.3 3.2-1.9 0.3-1.9 1.6-2 2.9-0.7 0.8 0.6 1.6 0 2.3-2.1 4-2.4 4.1-6.1 2.3-1.1-0.9-2.9-0.2-3.9-1.5q-0.7-0.4 0-0.8 2.3-0.7 4.6-1.5c0.3-0.2 0.8-0.3 0.8-0.8-0.2-3.1-2.1-3.5-4.6-3 0.9-1.6 2.5-1.5 3.9-1.7 0.8-0.1 1.5-0.5 1.5-1.4 0-0.9-0.9-1.4-1.6-1.1-3.1 1.3-1-1.3-1.5-2-0.4-0.4-0.8-0.8-0.9-1.4q0-0.5 0.2-1.1 0.3-0.4 0.7-0.8 0.5-0.1 1.1-0.1c1.2 0.4 1.7 1.5 2.2 2.5 0.5 0.8 1.6 1 2.1 1.8 0.9 0.9 1.7 2.2 2.8 0.2 0.2-0.5 0.5-0.8 1-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m193.9 61.2v-2.3c0.8-2 2.7-0.7 4-1.4q0.4-0.2 0.7-0.5 0.2-0.5 0.4-1 0.2-0.5 0.6-0.9c1.6-0.8 3.3-0.6 5 0 1.7 0.4 2.1 1.5 1.6 3-0.4 1.9-1.4 3.1-3.4 2.3-1.7-0.7-3.4-0.1-5.1 0-1.5-0.8-2.3 1.6-3.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s296",
    d: "m194.7 52c2.2-0.3 4.6 0 6.1-2.3q-0.4 1.5-0.8 3.1c0.2 1.8-1 1.7-2.2 1.6-1.1-0.2-2.1-0.5-3.1-0.8-0.5-0.6-0.2-1.1 0-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s297",
    d: "m197 53.5c1 0 2.1 0.1 3-0.7q1.5 1.7 3.9 1.5 0.3-0.5 0.7 0 0 0.4 0 0.8c-1.6 0.3-3.6-0.8-4.6 1.5-1.8-0.2-2.5-1.6-3-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s108",
    d: "m204.6 54.3q-0.4 0-0.7 0c-0.4-1.1-1.4-2.3 0-3.3 0.6-0.4 0.8 0.7 1.2 1 1.5 1.2 0.3 1.7-0.5 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s66",
    d: "m206.9 48.2c0.1-0.9-1.3-1.8-0.6-2.2 0.9-0.6 2.3-0.4 3.5-0.6l-0.6 1.3c-0.4 1-0.5 2.5-2.3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s189",
    d: "m206.9 48.2c1-0.1 1.6-1 2.3-1.5 0.2 0.9 1.7 1.9 0.3 2.8-1.1 0.6-2.2 0-2.6-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s126",
    d: "m210 39.8q-1.4-0.8-1.5-2.3c0.4-0.5 1-0.4 1.5 0q0.4 0.4 0.7 0.7-0.3 0.8-0.7 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m204 46.5c0.3 0.4 0.7 0.7 0.9 1.1 0.2 0.4 0 0.8-0.5 0.5-0.4-0.2-0.6-0.6-0.9-1 0-0.1 0.2-0.3 0.5-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s296",
    d: "m200.8 49.7c0.1-0.7-2.3-1.5 0-2.3 0.3 0.8 0.8 1.6 0 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s75",
    d: "m218.4 36.7q1.5-0.4 3-0.7-0.3 0.7-0.7 1.5-1.2 0-2.3 0 0-0.4 0-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s75",
    d: "m218.4 37.5q0.4 0.4 0.7 0.8c-0.6 0.6-1.6 0.6-1.9-0.1-0.4-1.1 0.8-0.5 1.2-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s65",
    d: "m208.5 63.5q1.1 0 2.2 0c-0.4 1-0.7 1.9 0.8 2.3-0.2 1-0.7 2.3-1.8 1.5-1-0.8-2.5-2-1.2-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s60",
    d: "m193.9 61.2c1.1-1.1 2.2-2.2 3.8-0.8-0.8 0.7-1.6 1.4-2.6 1.9-1.1 0.6-1.6 0.1-1.2-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s298",
    d: "m112.7 233.3q-0.1-0.6-0.3-1.1c-4.4 2-8.1-2.4-12.4-1.2-1.3 0.3-2.7 0.5-4.1 0.7v-0.7c1.8-0.9 3.8-1.1 5.4-2.5 0.8-0.8 1.7-1.3 2.2 0.4 1.6-0.7 3.4 2.2 5-0.2 0.6-0.9 1.3 0.1 2 0.3 3 1 6 2.6 9.1 0.4 1.6-0.6 1.7 0.8 2.3 1.6 0.5 0.5 0.2 1 0 1.5 0.3 0.7 0.8 1.4 0.2 2-0.6 0.7-1-0.1-1.5-0.4-2.5-1.8-5.4 0.7-7.9-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s258",
    d: "m157.9 218.7c0.4 0.3 1 0.6 1.1 0.9 0 4.8 0 5 4.5 4.2 2.6-0.5 4.2 1.6 6.4 1.6 0.5 0 0.6 1.2 0.3 1.2-3.6-0.7-3.3 4-6 4.6-1.1-1.7 0.7-2.7 0.6-4.1-3.4-1.8-7.6 2.2-10.7-1.5 1.6-1.6 1.2-3.5 0.6-5.4 0.9-0.9 2.2-0.9 3.2-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s136",
    d: "m186.2 225.6q1.2-0.8 2.3-1.5c1 1 2.1 1.9 2.9 3 1.4 1.9-0.6 2.9-1.5 3.7-1.3 1.1-1.7-0.6-2.1-1.3-0.6-1.3-1-2.6-1.6-3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s26",
    d: "m174 213.4h3.8c0.5 2.6-0.7 4.3-3 5.3-2.7-1.4 0.4-3.7-0.8-5.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s28",
    d: "m157.9 218.7c-0.4 1.7-2 1.1-3.1 1.5q-0.3-0.2-0.2-0.5 0.1-0.2 0.2-0.2 1.2-1.5 2.3-3.1 2.7 0.4 0.8 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m163.3 214.9q-0.4 0.4-0.8 0.8-0.8-0.8-1.5-1.6c1-2.1 2 0 3 0 0.2 0.7 0 1-0.7 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s299",
    d: "m124.2 213.4q1.9-1.6 3.7-3.2c1.6 0.3 0.3 2.6 2 2.8 1.1-0.4 0.8-1.5 0.7-2.2-0.6-2.9 1.3-2.5 2.9-2.3 1.5 0.2 2.9 1.7 4.2-0.7 1-1.8 0.8-3.1-0.7-4.5-0.4-0.3-0.4-0.9-0.5-1.4 0.3-0.6 1.1-0.3 1.5-0.8-0.2-1 0.1-2.3 1-0.6 0.9 1.8 1.7 2 3.5 1.7 2.1-0.5 3.2 1 3.9 2.8-1.4 2.7-5.4 3.4-5.4 7.4 0.1 1-2 0.2-3 1.4-1.8 1.9-2.2 4.2-3.1 6.5-3.9 2-6.1-0.9-8.6-3-0.8-0.7-1-1.7-1.4-2.6-0.3-0.5-0.3-1-0.7-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m126.5 216.4c3.2 0.5 5.1 3.7 8.4 3.9q-0.3 0.7-0.7 1.5c-0.5 1.3-1.6 1.2-2.7 1.3-1.9 0.2-3.9 0.4-5.5 1.8-0.8 0.5-1.7 0.7-2.5-0.1-1.8-2.1-3.8 0-5.6 0-3.6 0-4.3 0-4.7-3.5-1.3 0-1.2 1.5-2 2q-0.4 0.4-0.9 0.2-0.8-0.4-0.8-1.2 0.1-0.3 0.2-0.5c1-1 0.5-2.4 1.1-3.6 1.4-0.2 1.8 1.6 3 1.7 1 0.2 2.8 0.5 2.6-0.5-0.5-2.8 0.6-2.6 2.6-2 0.8 0.2 1.4-0.4 0.6-1.4-0.8-1.1-0.6-2.1 0.7-2.7 1.5-0.5 2.2 0.1 2.1 1.6 0 0.6 0.4 1.1 0.9 0.8 1-0.4 0.8-1.5 0.9-2.3q0.4 0.4 0.8 0.7c0.5 0.8 1.1 1.5 1.5 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s300",
    d: "m125.8 224.1c-0.5-1.5-0.4-2.4 1.7-2.2 2.2 0.2 4.4-0.1 6.7-0.1 0.4 0.5 0.2 1 0 1.5-0.4 0.5-0.5 1 0 1.5h0.7c0.8 1.1 0.3 1.8-0.7 2.3-2.5-1.2-3.1 1.6-4.6 2.3q-0.4 0.4-0.8 0h-1.5c-1-1.6-2-3.3-1.5-5.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m143.4 226.4c-0.1 0.1-0.2 0.3-0.2 0.3-2.4-0.2-3.7 1.3-5.2 2.7-0.9 0.5-1.5 0.5-1.5-0.7 0.5-1.1 0.1-2.1 0-3.1 0.8-0.9 0.8-2.9 2.8-2.3 1.8 0.4 4 0.4 4.1 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m153.3 216.5c-1.8 1.4-4.3 3-0.1 4.1 0.4 0.1 0.6 0.8 0.9 1.2-0.5 0.2-1 0.7-1.4 0.6-1.6-0.7-4.3-0.8-4.3-2.8 0-2.3 1.6-4.1 4.9-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m143.4 226.4c-2.2-1.6-4.2-4.1-6.9-0.8q0.4-1.5 0.7-3.1c1.8 0 3.6 0.1 5.3 0 0.9 0 1.9-0.9 1.8 0.8-0.1 1.1 1.8 2.8-0.9 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m163.3 214.9q0.4-0.4 0.7-0.8c0.7-1.7 2.1-0.4 3.1-0.7 1.3 1.3 1.4 3.2 0.1 3.8-1.7 0.9-3-0.8-3.9-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m154.8 219.5v0.7c0.4 0.5 0.8 1 1.2 1.5 1.6 2.4 1.3 3.9-1.9 3.9-1.3-1.3 1-2.5 0-3.8 0-0.9 0.1-1.7 0.7-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s300",
    d: "m134.2 231.7q-0.8-1.1-1.6-2.3c1.2-0.8 2.9 0.8 3.9-0.7q0.7 0.4 1.5 0.7v0.8c-0.7 1.2-1.8 1.5-3.1 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s299",
    d: "m143.2 213.3c1.1-1.7 1.8-2.5 3.1-1.6 0.2 0.2 0.4 0.8 0.3 0.9-0.9 1.2-2 0.6-3.4 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m139.7 216.5c1-1.7 2.1-1.9 4.1-2.6-1.3 2-2.1 2.7-4.1 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m137.2 222.5c-1.4-0.2-1.2-1.2-0.8-2.2 0.1-0.2 0.7-0.4 0.9-0.3 1.2 0.8 0.2 1.7-0.1 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m134.2 224.8c-0.8-0.2-1.8 0-2.1-1.1q1.1-0.2 2.1-0.4c0.4 0.5 0.2 1 0 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m167.9 211.8q0.8 0.3 1.6 0.5-1.2 0.5-2.4 1.1 0.4-0.8 0.8-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m134.2 227.1l0.7-2.3c0.6 0.7 1 1.4 0.5 2.3-0.3 0.5-0.8 0.3-1.2 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s301",
    d: "m125.8 224.1c1.9 1.3 2.6 3.1 1.5 5.3-1.7 1-3.4 1.8-5.4 1.6-1-0.2-1.6-1-2.3-1.6-0.2-0.6-0.1-1.7 0.4-1.5 3.6 1.5 2.7-1.7 3.5-3.1q1.1-0.3 2.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s276",
    d: "m206.9 7.7v-1.6c6.7-0.9 4.8-1.5 7.6 3.4 1.5 0.8 2.7 1.8 2 3.8-0.8 0.9-1.8 1.5-2.9 1.3-3.1-0.3-5.7-0.1-6.3 3.8-0.1 0.7-1.1 0.8-1.9 0.7-3.3-0.6-7.3 1.2-8.4 3.9q-0.8 0.6-1.7 0.3c-1.3-0.7-1.6-1.8-1-3.1 0.8-1.1 1.7-2.3 3.1-3 0.8-0.6 1.1-1.6 1.5-2.5q0.2-0.8 0.9-1.2c2.1-0.5 5 1 6.1-2.3 0.5-1.1 2.1-1.9 1-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s216",
    d: "m188.6 39.8c-1.6-0.6-2.2 0.1-2.3 1.5q-0.1 0.2-0.1 0.4c0 0.6 0 1.2-0.4 1.7q-0.2 0.1-0.3 0.2c-1.4-1-2.4-2.7-4.6-1.5-1.6 0.9-2.1-0.9-3.1-1.5q0.8-0.4 1.5-0.8c1.2 0.1 2.4 0.7 3.1-0.8 0.4-1.1 1.5-1 2.3-1.4 0.4-0.2 0.7-0.4 0.8-0.9 0-1.5 0.4-2.8 1.5-3.8 0.4-0.5 0.7-1.2 1.3-1.6 1.1-0.6 2.5-0.7 3.2-1.9q0.4-0.4 0.9-0.6c1.2-0.6 2.3-1.8 3.9-1.2 0.7 0.4 1.3 1.1 0.9 1.8-1.2 1.8 0.6 2.4 1.3 3.5 0.8 0 1.6 0.1 2.3 0.8 0 1.2-0.4 2.1-1.5 2.7-1.8 0.8-3-1-4.6-1.2-1-0.5-1.1 0.3-1.4 0.9-0.4 0.8-1.4 1.1-2 1.8q-0.4 0.3-0.8 0.5c-0.8 0.3-1.4 0.8-1.9 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s278",
    d: "m196.2 28.3c-1.4 0.3-2.3 1.7-3.8 1.5q-0.5-0.5-1.1-0.8 0.6 0.3 1.1 0.8c-0.6 2-1.8 2.9-3.9 2.3-0.9-0.1-1.5-0.5-1.5-1.5 0-1.3 1.6-2.3 0.8-3.8 0-0.8 0.5-1.4 1.1-1.7 0.4-0.1 0.9-0.1 1.1-0.4 0.2-0.5-0.2-0.1-0.3 0-1.3 0.3-2.4-0.4-3.3-1.2q-0.5-0.3-0.9-0.6c-0.5-0.7-1.3-1.2-0.8-2.2 0.3-2.5 2-2.5 3.8-2.3 0.8 0.7 1.8 1.2 2.9 1.4 2 0.1 2.7 2 4 3.2h1.6q0.3 1.1 0.7 2.2c0.2 1-0.3 1.7-0.7 2.4q-0.4 0.4-0.8 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s302",
    d: "m196.2 28.3v-0.7c0.2-1.3 1.6-1.5 2.3-2.3 0.3-1.2-1-2.4 0.4-3.8 0.9 2.1-0.3 4.7 1.9 6 1.3 2-0.2 2.5-1.5 3.1q-0.4 1.2-0.8 2.3c-1.5-0.9-3.1 0.9-4.8-0.3 0.3-1.7 2.9-2.2 2.5-4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s303",
    d: "m205.4 19.1c0.4-0.5 1.1-1 1.1-1.5-0.1-4.5 3.2-4.7 6.3-4.5 1.2 0.1 2.2 0 3.3-0.1q0.4 0.4 0.5 1 0 0.5-0.3 1c-0.6 0.5-1.3 0.8-1.9 1.1q-0.5 0.2-1 0.3c-2.3 0.1-3.6 1.5-4.7 3.2-0.6 0.6-1 1.4-1.8 1.8q-0.7 0-1.5 0-0.4 0.8-0.8 0 0.4-1.1 0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m206.9 21.4c-0.5-1-0.3-1.8 0.8-2.3 1.8-0.7 3.7-3 5.6-0.1 0.2 1.4-1.2 1.6-1.8 2.4q-0.4 0.8-0.8 1.5-0.3 0-0.7 0c-0.8-0.1-1.5-0.7-2.3-0.7q-0.4-0.4-0.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s181",
    d: "m199.2 30.6c-0.4-0.4-1.6-1.2-0.1-1.3 1.6 0 1.3-1.1 1.7-1.8 1 0.7 1.7 1.4 2.1 2.7-1.2 0.8-2.5 0.2-3.7 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s274",
    d: "m207.7 28.3q-1.5-0.4-3.1-0.7c-0.5-1.3 0.4-1.8 1.3-1.8 1.5 0.1 1.8 1.3 1.8 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s304",
    d: "m199.3 35.9q0.1-1.5 1.5-2.2 1.1 0 2.3-0.1 0.4-0.3 0.8 0.1l-2.3 2.3c-0.8 0.6-1.6 0.6-2.3-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s75",
    d: "m207.7 22.2c1.2-1.2 2.2-1.5 2.3 0.7-1.5 2-1.6-0.2-2.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s305",
    d: "m210.7 27.5c-0.6 1.7-1.4 2.8-3 0.8q1.5-0.4 3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s216",
    d: "m198.5 25.3c-0.2 1.3-1.3 1.7-2.3 2.3-1-1.8 0.8-1.7 1.5-2.4q0.4 0.1 0.8 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s306",
    d: "m203 23.4c-0.9 0.4-1.2 0.7-1.5 0.6-0.3 0-0.5-0.4-0.8-0.6 0.2-0.2 0.3-0.5 0.5-0.5 0.3 0 0.6 0.2 1.8 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s190",
    d: "m203.9 33.7q-0.4 0-0.8-0.1c-0.4-0.7-1.8-1-0.8-2.2 0.4 0.8 2.1 0.8 1.6 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s200",
    d: "m204.6 21.4q0.4 0 0.8 0c-0.1 0.9 0 1.7-0.8 2.4-0.8-0.9 0.1-1.6 0-2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s307",
    d: "m212.3 33.7c-0.8 0.5-1.7 1.2-2.4 0-0.3-0.4 0.4-0.7 0.8-0.8q0.8 0.4 1.6 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s75",
    d: "m211.5 21.4q0.8-1.1 1.5-2.3c-0.3-1.2 0.4-1.7 1.5-1.9 0.6 0.1 1.1 0.4 0.8 1.2q-0.3 1.1-0.7 2.3-1.6 0.3-3.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s308",
    d: "m51.5 16.1q0.4 0.7 0.8 1.5c0.1 0.5 0.1 1.1-0.2 1.6-0.3 0.6-0.7 1.2-1.3 1.6-1.1 0.7-2.3 0.8-3.5 1-0.6 0-1.1-0.1-1.5 0.5-0.8 1.2-1.2 2.4-0.2 3.6 0 2.2-1.3 2.7-3.1 2.6-2.5-1.5-5.7-1.1-7.8-3.3-0.5-0.9-1.1-1.7-1.1-2.8 0.3-0.8 0.9-1.1 1.7-1.3 0.9-0.1 1.8-0.1 2.7 0.1 0.7 0 1.3 0.7 2.1 0.4 0.3-0.3 0.4-0.7 0.6-1 0.4-0.6 0.8-1.1 1.3-1.5 1-0.6 2.1-1.1 3-1.8 0.8-0.3 1.7-0.4 2.5-0.7 1.2 0 2.3-0.3 3.5-0.6q0.2 0.1 0.5 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s212",
    d: "m51.5 18.3q0.4-0.3 0.8-0.7 0.7-0.4 1.5-0.8c0.5-0.4 1.3-0.7 1.5-1.5q1.1-0.4 2.3-0.8c2.7-1 1.6 1.6 2.3 2.4q0.1 0.9-0.4 1.5c-1.2 0.8-2.3 1.6-3.7 2.1-1.6-0.4-3.3-0.6-4.3-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s243",
    d: "m45.3 11.5q1.6 0 3.1 0c0.3 1.7-1.8 2.3-2 3.8-1.9 1.8-3.8 2.5-5.6-0.1q-0.2-0.6-0.2-1.2c0.8-2.3 2.4-3 4.7-2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s95",
    d: "m59.1 16.8c0.3-1.2-0.5-1.8-1.5-2.3q0-0.7 0-1.5c0.6-0.2 1.2-0.4 1.8-0.7 0.9-0.5 2-1.2 2.7-0.1 0.7 1.2-0.7 1.4-1.4 1.8-0.7 0.6-0.7 1.3-0.8 2.1q0.3 1-0.8 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s207",
    d: "m52.2 8.4c-0.4 1.2-1.1 2-2 0.5-0.6-0.9-1-2-1.6-3.5 1.8 0.3 3.3 0 4.4 1.5-0.3 0.5-0.5 1-0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s309",
    d: "m45.3 11.5q-1.9 1.1-3.8 2.3-0.5 0.4-1-0.1c-0.7-1-0.4-1.9 0.2-2.8 0.9-0.7 1.7-1.8 3.1-0.9q1.3 0.2 1.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s310",
    d: "m46.1 14.5c0.2-1.4 1.8-1.8 2.3-3 1.2 0.3 1.2 0.9 0.4 1.7-1 0.9-1.1 1.7 0.4 2.1q0.3 0.6-0.2 1.1c-0.8 0.5-1.6 0.5-2.4 0.2-0.8-0.5-1.1-1.2-0.5-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s213",
    d: "m49.2 16.1v-0.8c1.1-2.1 3-0.9 4.7-1.5-0.5 1.7-1.9 1.4-2.4 2.3-0.8 0.5-1.6 0.7-2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s311",
    d: "m43.8 10q-1.1 0.7-2.3 1.5c-0.9-0.3-1.5 0.5-2.3 0.5q-0.5-0.1-0.9-0.4-0.3-0.5 0.1-0.9c0.3-1.2 1.3-1.5 2.4-1.5 1 0 2.1-0.1 3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s236",
    d: "m44.6 4.6q0.8 0 1.5 0 0.5 0.8 1 1.5c-0.5 0.2-1.2 0.5-1.7 0.5-1.3-0.2-1.1-1.1-0.8-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s89",
    d: "m52.2 8.4c-1.5-1.4 0.7-0.9 0.8-1.5 0.3 0.5 0.9 1.1 0.8 1.4-0.3 0.8-1 0.3-1.6 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s312",
    d: "m48.4 7.9c0.1 0.3 0.4 0.5 0.5 0.8 0.1 0.4-0.2 0.8-0.6 0.7-0.3-0.1-0.6-0.5-0.7-0.8-0.1-0.4 0.2-0.7 0.8-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s313",
    d: "m55.3 15.3c1.7 2.7-1 1-1.5 1.5q0.7-0.7 1.5-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s314",
    d: "m45.3 2.3c0.3 0.7-0.3 0.7-0.7 0.8q-0.5 0-1-0.1c0.3-1 1.1-0.5 1.7-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s315",
    d: "m74.4 13.8c2-0.1 3.7-0.8 5.4-1.6q0.5 0.2 0.9 0.5c0.3 0.6 0.7 1.1 1 1.8 0.5 1.3 0.9 2.6 0.4 4 0 0.7 0.2 1.5-0.1 2.2-1.3 2.1-3 2.9-5.3 1.8-2.8-0.7-4.9 0.6-6.9 2.4-1.3 0.8-2.6 0.9-3.9 0-0.9-0.9-1-2-0.5-3.2 0.2-0.7 0.9-1.2 0.8-2.1-0.2-0.4-0.4-0.8-0.5-1.2q-0.1-0.5 0.3-0.8c0.9-2.4 2.6-2.5 4.6-1.5 0.8-0.8 1.5-1.6 2.7-1.3 0 0 0.2-0.2 0.2-0.3 0.1-0.5 0.1-1.2 0.9-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s88",
    d: "m69.1 6.9q0.4 0.4 0.8 0.8c-0.6 1.4-0.8 3.2-3.1 2.3-1.9 0.3 0 2.4-1.4 3-1.9-0.7-1.2-2.5-1.7-3.8 1-2.6 3.2-2.5 5.4-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s316",
    d: "m74.4 13.8c-0.3 0.8 0.6 1 0.8 1.5q0.4 0.3 0.3 0.5-0.1 0.3-0.3 0.3c-1.5-0.1-3-0.5-4.6 0q0.5-3.4 3.8-3.1 0 0.4 0 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s90",
    d: "m69.1 6.9c-1.9 0.5-3.9 0.8-5.4 2.3q-0.4 0-0.7 0v-1.5c1.5-1.4 3.9-0.7 5.3-2.3 0.5-0.2 1-0.5 1.6 0q-0.4 0.7-0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s317",
    d: "m59.1 16.8q0.4-0.3 0.8-0.7c1.9-0.1 3.6 0.7 5.4 1.5-0.5 1.2-1.7 1.3-2.7 1.8q-1.4 0.3-2.7-0.3-0.5-0.2-0.8-0.7 0-0.8 0-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s318",
    d: "m66.8 10c1.4-0.2 1.9-1.8 3-2.3q0.4 1.5 0.8 3c-1.3 0-2.7 0.3-3.8-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s220",
    d: "m62.2 18.4q1.5-0.4 3.1-0.8h0.7q0 0.4 0 0.8c-0.6 1.3-1.6 1.8-3 1.4-0.6-0.3-1-0.7-0.8-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s213",
    d: "m161 0q0-0.4 0-0.8c0.6-0.8 1.1-1.7 2.3-0.7 1.3 1.4 3.1 0 4.6 0.7q0.3 0 0.7 0c0.5 0.9 0.1 1.6-0.5 2.2-1 0.7-2.2 0.8-3.4 1.1-1.9 0.1-3-0.8-3.7-2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s225",
    d: "m167.9 0.8q0.3-0.8 0.7-1.5c1.1 0.1 1.6 0.9 2.3 1.5-0.5 1.5 0.6 1.5 1.6 1.5q0 0.4 0 0.8c0.3 0.6 0.6 1.2 0.2 1.8-0.6 0.9-1.7 0.9-2.4 1.7-0.6 0.6-0.9 1.5-1.8 1.8-1.2 0.4-2.2-0.2-3.2-0.6-1.2-1.1-3.3-0.9-3.8-2.8 0.6-2.1 2.7-1.8 4.2-2.5 0.8-0.4 1.8-0.6 2.2-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s236",
    d: "m187 3.1q1.2-0.4 2.3-0.8c1.3 0.3 2.6 0 3.8 0.8h0.1c0.9 0.5 2.2 0.6 2.2 2.2q0.1 0.4 0.4 0.8c0.6 0.9 1.6 1.1 2.6 1.3 0.9 0.1 1.8 0.5 1.7 1.6 0 1-0.8 1.6-1.7 1.5-2-0.1-4 0.9-5.9-0.1-0.9-0.4-1.1-1.5-2.2-1.7-2.4-0.3-2.6 2.1-3.9 3.2-1.9 0.4-3.9 0.1-5.5 1.4-0.7 0.1-1.4 0.1-2-0.3-0.9-0.7-1.5-1.8-2.7-1.9q-1.5-0.4-2-1.8c-0.2-1.5 0.4-2.3 1.8-2.4q0.6 0 1.1 0.1c0.9 0.2 1.8 0.7 2.9 0.5 0.8-0.1 1.4-0.7 2.2-0.9 0.8 0 1.4-0.3 1.2-1.3q0.1-0.5 0.4-0.9c1-0.6 2.2-0.8 3.2-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s103",
    d: "m180.9 3.8c-1.4 0.7-2.7 0.7-3.8-0.4-0.4-0.4 0.3-0.8 0.7-1.1 0.8-0.5 0.4-2.8 2.3-1.5q2 0.2 2.3 2.3c-0.3 0.6-1.1 0.3-1.5 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s319",
    d: "m183.2 0.8c-0.9-2 0.6-2 1.6-1.7 2.1 0.6 2.5 2.1 1.4 4q-0.3 0.4-0.7 0c-0.8-0.8-2.2-1-2.3-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s245",
    d: "m180.9 3.8q0.8-0.4 1.5-0.7 0.8 0.3 1.6 0.7-0.1 0.3-0.2 0.6c-1.2 3-2.1 3.4-3.7 1.7 0.7-0.6 1.4-1.2 0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s320",
    d: "m193.1 3.1c-1.4 0.5-2.7 0.2-3.8-0.8q0.4-0.4 0.8-0.8c1.3 0 2.4 0.3 3 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s321",
    d: "m180.1 0.8q-1.1 0.7-2.3 1.5 0-0.4 0-0.8c0.1-1 0.9-1.5 1.5-2.2 1.1 0.1 1.1 0.7 0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s322",
    d: "m185.5 3.1q0.4 0 0.7 0h0.8c-0.8 0.9-1.9 1.3-3.1 1.5q-0.3-0.3-0.2-0.5 0.1-0.3 0.2-0.3h0.1q0.7-0.3 1.5-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s93",
    d: "m177.1 7.6c-1.1 0.1-2.1 0.3-2.4 1.6-1 1.3-2.3 0.4-3.4 0.2q-0.5-0.2-0.9-0.6c-0.8-1-1-2.2-1-3.4 0.9-0.9 2-0.8 3.1-0.8 1.5-0.1 2.5 0.9 3.8 1.5q1.1 0 2.3 0c0.3 1.4-0.6 1.4-1.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s213",
    d: "m176.3 6.1c-1.8 0.7-3.8 2.1-3.8-1.5-0.2-0.5-0.5-1 0-1.5 2.4-0.4 3.2 1.2 3.8 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s103",
    d: "m177.1 7.6q0.7-0.7 1.5-1.5 0.8 0 1.5 0c2.5 1.2 2.5-1.6 3.8-2.3q0 0.4 0 0.8 0.1 0.4 0 0.8c1.2 1.9-0.8 1.6-1.5 2.3-0.7 0.6-1.3 1.4-2.3 1.5-0.9-0.8-2.2-0.7-3-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s323",
    d: "m216.1 14.5q0-0.3 0-0.7c1-0.7 2-0.5 2.8 0.3q0.2 0.2 0.3 0.4-1.6 1.2-3.1 2.3c-0.7 0.4-0.9 0-1.1-0.6 0-0.8 0.6-1.2 1.1-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s313",
    d: "m219.2 9.2q0.7 0.8 1.5 1.5-0.4 0.8-0.8 1.6-0.5 0.3-1 0.1c-1.4-1.2-1.2-2.3 0.3-3.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s75",
    d: "m219.2 12.2q0.4 0 0.7 0.1c0.5 1 0.8 1.9-0.7 2.2-1.2-0.7-2-1.5 0-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s199",
    d: "m215.3 16.1q0.4 0.4 0.8 0.7-0.4 0.8-0.8 1.6-0.3-0.4-0.7-0.8c-1-0.5-1.6-1.2-0.8-2.3 0.8-0.4 1.3 0.1 1.5 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s249",
    d: "m213.8 10.7c-0.7-0.5-2.1 0.5-1.7-2 0.6-3.8-3.4-1.7-5.2-2.6q3.5-1.5 6.9-3c0.7 0.2 1.2 0.6 0.8 1.5q0 0.4 0 0.8c0.6 1 2.5 0.5 2.5 2.3-0.1 2.1-2 2.2-3.3 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s201",
    d: "m213.8 10.7c1.2-1.6 3.2-3.2 0.8-5.3 2.9-0.4 3.2 2.3 4.6 3.8-0.2 1-0.6 2 0 3-0.8 0.8-0.4 1.6 0 2.3q-1.6-0.3-3.1-0.7 0-0.4 0-0.8c0.1-1.6-1.3-1.8-2.3-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s253",
    d: "m216.1 1.5c1.2-0.5 2.2-0.2 3.1 0.8q-1.6 0.4-3.1 0.8-0.2-0.2-0.3-0.4c-0.2-0.4-0.1-0.8 0.3-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s253",
    d: "m214.6 4.6q-0.4-0.8-0.8-1.5 0-0.4 0-0.8c1.1-0.6 1.7 0.2 2.3 0.8 0.5 1.5-0.5 1.5-1.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s244",
    d: "m105.1 6.9q1.1 0 2.3 0v0.8c3 0.3 3.5 2.8 4.5 5q0 0.8-0.5 1.5c-0.6 1-1.2 2-1.5 3.2-0.5 1.9-0.8 4-3.4 4.2-4.7 2.4-9.8 3.3-15.1 3.1q-0.8 0.2-1.6 0c-1-0.3-1.9-1-2.8-1.5-0.7-0.5-1.1-1.2-1.9-1.7-0.5-0.4-1-0.9-1.3-1.5q-0.1-0.6 0-1.1c0.7-2.1 1.1-4.5 4.3-3.9 0.8 0.2 1.6 0.3 2.5 0.5 0.8 0.2 1.7 0.2 2.4 0.5 0-0.2 0-0.4 0.1-0.7 1.3-2.8 2.3-5.6 2-8.7 2.8-1.9 5.6 0 8.4 0 0.6 0 1.1 0.2 1.6 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m118.1 13c1.4-1.2 1.6-4.2 4.6-3.1 1.3 1.3 4-0.9 4.6 1.9 0.3 1.3-0.1 2.3-1.3 3-2.4 1.2-4.7 3.2-7.5 0.9-0.7-0.8-1-1.7-0.4-2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s324",
    d: "m110.4 13.8q0.4-0.4 0.8-0.8c-0.4-3.1-0.4-3.1 1.5-3 1.7 0.4 3.4 1 3.9 3 0.2 0.7-0.1 1.1-0.5 1.5-1.7 0.2-3 1.9-4.9 1.2-0.7-0.5-1.1-1-0.8-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s242",
    d: "m126.5 11.5c-0.8-0.2-2.1-1.3-2.2-0.2-0.2 1.7-0.9 2.8-2.2 2.1-1.8-1.1-0.2-2.4 0.6-3.5 1.6 0.7 1.4-2.1 3.1-1.5 0.5 0.9 1.6 0.2 2.2 0.8 0.5 0.3 0.6 0.8 0.5 1.3q-0.1 0.5-0.5 0.8c-0.5 0.2-1 0.3-1.5 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s220",
    d: "m112.7 10c-1.7 0.3-0.2 2.4-1.5 3-1.6-1.6-1.6-4.2-3.8-5.3 2.2-2 3.9 1 6 0.5q-0.3 0.9-0.7 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s324",
    d: "m115.8 13.8q0.4-0.4 0.8-0.8h1.5q0.4 1.2 0.8 2.3c0.1 0.8 0 1.5-0.6 2.1-1 0.8-2.1 1.1-3.3 0.3q-0.4-0.4-0.6-1c-0.4-1.4 0.5-2.1 1.4-2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s198",
    d: "m119 9.3c-1.6 0.8-2.7 0.8-3.5-0.5-0.1-0.2 0.1-0.9 0.2-1 1.5-0.5 2.3 0.4 3.3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s249",
    d: "m95.1 6.1q0-1.1 0-2.3 0.4 0 0.8 0c1.5-0.3 2.9-1.5 4.6-0.7q0.7 0.4 1.5 0.7 0.8 0.8 1.5 1.6 0.4 0.4 0.3 0.9c-1.1 1.7-2.4 0.7-3.7 0.5-1.5-0.3-3-0.6-4.5-0.5q-0.2-0.1-0.5-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s240",
    d: "m100.5 3.1c-1.4 1-2.9 1.9-4.6 0.7 0.3-0.7-1.5-1.6-0.1-2 1.7-0.6 3.7-1.2 4.7 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s84",
    d: "m103.5 6.1q0-0.4 0-0.7 0.8 0.3 1.6 0.7 0 0.4 0 0.8-0.4 0.4-0.8 0.8c-0.6-0.4-1.2-0.7-0.8-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s325",
    d: "m18.6 14.6q0.3-0.1 0.7-0.1c1.1-0.5 2.3-0.7 3.5-0.3q0.8 0.7 1.1 1.7c0.3 1.4-0.3 2.5-0.9 3.6 0 0.7 0.3 1.2 0.5 1.7 0.2 0.6 0.3 1.3 0 1.9-0.6 0.9-1.6 1.6-2.1 2.7-0.5 0.4-1.1 0.8-1.6 1.1-0.8 0.4-1.4 1-2.3 1.1-1.5-0.4-2.8-1.3-3.9-2.3-0.7-0.7-0.4-1.8-1.1-2.6q-0.5-0.5-1-1c-0.5-0.6-1.2-1-2-1.3q-1-0.4-1.5-1.4-0.4-0.8-0.2-1.7c0.4-1 1.2-1.4 2.2-1.2q0.5 0.1 1 0.4c3.1 1.7 3.1-2.5 5.2-2.7 0.7-0.1 1.4 0.3 1.9 0.7 0 0 0.2 0.1 0.2 0.1 0 0 0-0.1 0-0.1q0-0.3 0.3-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m23.1 16.1q-0.3-0.8-0.7-1.5-0.4-0.4-0.3-0.8c0.2-0.6 0.9-0.9 1-1.5q0.4-0.8 0.8-1.6 0.3-0.4 0.7-0.6c1.1-0.1 2.3-0.5 3.1 0.6v0.8q2.5 1.8 5.4 0.7 0.4 0.4 0.4 0.9c-0.7 0.9 0 1 0.7 1.1q0.9 0.7 0.9 1.8c-2.3 3.3-6.3 3.8-10.5 1.4-0.6-0.3-1-0.9-1.5-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s315",
    d: "m6.3 7.7c0.8 0.3 1.5 0.8 2.3 0q0.8-0.7 1.5 0 0.4 0.4 0.8 0.7 0.9 0.6 1.5 1.5c0.2 0.6 0.5 1.1 0 1.6-1.1 1.3-2.5 2.2-3.7 3.4-1.5 0.7-3.1 1.1-4.4-0.3-1.3-1.3-0.9-2.7 0.3-3.9 0.1-0.4 1.1-0.2 0.7-1-1.8-1.7 0.5-1.4 1-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s326",
    d: "m14 8.4c1.3 0 2.3-1.6 3.8-0.7 0.8 0.4 2.5-0.3 1.1 2.1-1.7 2.9-2.3 0.4-3.4 0.2q-0.8-0.8-1.5-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s327",
    d: "m16.3 14.5c-1 0.5-0.8 1.6-1.2 2.2-1.3 1.8-2.8 3.6-5 0.9 0.7-1.1 1.7-1.8 3.1-1.5 0.9-0.9 1.5-2.2 3.1-2.3q0.2 0.2 0.1 0.5 0 0.2-0.1 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s207",
    d: "m8.6 13.8c0.6-2 2.1-2.2 3.8-2.3 0.4 0.8 0.8 1.5 0 2.3-0.8 0.2-1.6 0.7-2.5 0.8-0.6-0.1-1-0.3-1.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s207",
    d: "m12.4 9.9q-1.3-0.2-1.5-1.5c1-0.2 2-4.2 3.1 0q-0.8 0.8-1.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s93",
    d: "m27.7 10.7q-1.5 0-3 0c-0.5-1.5 1.1-0.8 1.5-1.5q0.8-0.4 1.5-0.8 0 1.2 0 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s328",
    d: "m13.2 16.1c-0.5 1.5-1.7 1.6-3.1 1.5-0.4-1.1 0-1.8 1-2.2q0.3-0.1 0.6-0.1 0.7 0.4 1.5 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s244",
    d: "m10.1 13.8c0.8-0.8 1.6-0.4 2.3 0q-0.4 0.7-0.7 1.5c-0.8 0.5-1.7 0.8-2.3-0.1-0.4-0.6 0.2-1.1 0.7-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s210",
    d: "m26.2 9.2q-0.8 0.8-1.5 1.5-0.4 0-0.8 0c-0.3-0.5-1-1.4-0.9-1.5 1-0.9 2.1 0.3 3.2 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s322",
    d: "m23.9 6.9q0.4-0.4 0.8-0.8c0.3-0.6 0.6-1.2 1.5-0.7q0.6 1.1 0 2.2c-0.8 0.1-1.6-0.1-2.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s329",
    d: "m16.3 14.5q0-0.3 0-0.7c1.3-1.4 1.5 0.5 2.3 0.8q0 0.3-0.1 0.7h0.1q-1.2-0.4-2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s329",
    d: "m22.4 13.8q0 0.4 0 0.8c-1 0.5-2.1 0.1-3.1-0.1q1.2-0.7 2.3-1.5 0.7 0.1 0.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s219",
    d: "m15.5 10l-0.3 2.1c-0.3 0-0.6 0-0.7-0.1-0.6-1.1 0.3-1.5 1-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s237",
    d: "m22.4 13.8q-0.4-0.4-0.8-0.8 0.8-0.4 1.5-0.7c0.8 1 0.1 1.3-0.7 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s330",
    d: "m17.8 5.4c1-1.1 2-0.5 3.1 0-1.1 1-2.1 0.5-3.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s316",
    d: "m34.6 16.1q-0.4-0.8-0.7-1.6c-0.6-0.3-0.4-1.1-0.8-1.5q0-0.4 0-0.8c0.3-0.7 0.9-1.1 1.5-1.5 0.2-1.2 0.7-2.2 1.6-3 0.4 0.3 2.7-1.4 1.2 1.1-0.6 1.1 0.1 1.6 1 1.9q0.1 0.4 0.1 0.8c-0.3 0.7-1.6 1.2-0.8 2.3 0.3 0.5 0.5 0.9 0.6 1.5-0.1 1.6-1.4 2.8-1.8 4.3q-0.8 0.8-1.9 1c-4.6-1.5-0.2-3 0-4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m34.6 10.7q-0.7 0.8-1.5 1.5c-1.7-2.6 1-1 1.5-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s331",
    d: "m26.2 5.4q-0.8 0.3-1.5 0.7c-0.2-0.6-0.8-1.3 0-1.9 0.5-0.4 1.1 0 1.5 0.4q0 0.4 0 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s332",
    d: "m22.4 2.3q0.7-0.8 1.5-1.5c0.3 0.2 0.8 0.5 0.7 0.6-0.4 1.1-1.4 0.8-2.2 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s213",
    d: "m79.8 13q0-0.4 0-0.8c-0.6-0.4-1.5-0.9-1.6-1.4 0-1.1 1.2-1 1.9-1.3 1.4-0.4 2.9-0.7 4.3-1.1 0.8 0.3 1.9 0.2 1.8 1.5-1.5 2.4-4 2.6-6.4 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s224",
    d: "m77.5 6.1q1.2 0 2.3 0c-0.9 1.5-2.4 1.6-3.9 2-0.1-1.4 1.2-1.3 1.6-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s333",
    d: "m85.9 9.9q-0.7-0.7-1.5-1.5 1.2-0.4 2.3-0.8c0.5 0.8 0 1.6 0 2.3q-0.4 0.3-0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s89",
    d: "m-5.2 3.8c1.1-0.1 1.1-0.7 0.8-1.5q1.1 0.8 2.3 1.5 0.2-0.1 0.5-0.3 0.3 0.1 0.6 0.1 0.8 0.5 1.1 1.4 0.1 1-0.5 1.7c-1.3 1-2.6 1.6-4 0.2 0.7-1.3-0.3-2.1-0.8-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s334",
    d: "m-1.4 3.8q-0.3 0-0.7 0c0.3-1.1-1.2-2.4 0.2-3.3 0.5-0.3 1 0.5 1.3 1 0.2 0.9 0.2 1.8-0.8 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s225",
    d: "m-1.4 3.8c0-0.8 0.2-1.6 0.8-2.3q0.4 0 0.8 0c0.7 0.5 1.2 1.1 0.7 1.9-0.6 0.9-1.4 1.1-2.3 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s322",
    d: "m197.7 1.5q0.4 0.8 0.8 1.6-0.2 0.4-0.6 0.7c-0.6 0.4-1.1 0.8-1.9 0.7-0.7-0.2-1.1-0.8-1.3-1.4 0.4-1.7 1.8-1.5 3-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s335",
    d: "m194.7 3.1q0.7 0.4 1.5 0.8c0.5 0.5 0.4 1.1 0 1.7-0.8 0.5-1.6 0.4-2.3-0.2-0.1-0.8 0.1-1.8-0.8-2.3q0.8 0 1.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s336",
    d: "m197.7 3.1q0.4 0 0.8 0c0.7-0.4 1.5-0.4 2.3 0-0.1 1.5-1.6 0.9-2.3 1.5-0.6-0.3-1.2-0.7-0.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s278",
    d: "m202.3-1.5c0.3 0.8 0.3 1.4-0.7 1.5-1.2-1.2-0.7-1.6 0.7-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s198",
    d: "m192.4 10c2.1-0.9 4.4-0.6 7.6-0.6-2.5-1.5-5.5-0.5-6.1-3.3 2.8 0.3 5.6 1 8.4 0h2.3q0.4 1.6 0.8 3.1c0.4 0.4 0.5 0.9 0.3 1.5q-0.4 0.7-1.2 0.8c-0.4 0.1-0.8 0.2-1.2 0.3 0 0-0.3 0.2-0.3 0.2-0.4 1.9-1.9 1.4-3.1 1.6-0.8 0.4-1.5 0.9-2.4 0.3-0.8-1.4-1.9-1.2-3.1-0.6-0.8 0.1-1.5 0-2.2-0.4-0.8-0.8-1.2-1.7-0.4-2.7q0.3-0.1 0.6-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s221",
    d: "m205.4 10.7q0-0.7 0-1.5 1.3-0.2 1.5-1.5c2 1.2 0.6 2.5 0 3.8q-0.4 0.4-0.9 0.4c-0.5-0.2-0.9-0.5-0.6-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s262",
    d: "m216.1 3.1q-1.1-0.4-2.3-0.8c0.4-1.4 1.1-1.7 2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s232",
    d: "m202.3 6.1c-2.8 2.1-5.6 1.7-8.4 0q0-0.3 0-0.7 1.1 0 2.3 0 0.4-0.4 0.8 0 2.6 0.4 5.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s337",
    d: "m197 5.4q-0.4 0-0.8 0 0-0.8 0-1.5 0.8-0.4 1.5-0.8 0.4 0.7 0.8 1.5-0.8 0.4-1.5 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s306",
    d: "m118.1 16.8q0.4-0.7 0.8-1.5c2-0.5 4.3 0.2 6.1-1.5 1.1 0.7 3.4-0.5 3.3 2.1 1.9-1.5 2.7 1.3 4.3 0.9q0.4 0.4 0.8 0.8c0.3 1.9-4.2 3-0.7 5.4 0 1.2-0.4 2.4-1.6 3-1.2-0.2-2.2-0.9-2.4-2.1-0.4-2.5-2.3-2.8-4.3-2.9-1.1 0.1-2.3-0.3-3.4 0.2q-0.7 0.3-1.5 0.2-1.1-0.3-1.9-1-0.8-0.8-0.8-2c0.1-0.8 0.7-1.2 1.3-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s90",
    d: "m155.6 1.5q0.8 0.8 1.5 1.6c0 1.9 3 1.2 2.8 3.2-0.1 1.1-0.8 1.7-1.6 2.2-1.1 0.3-2.1 0.7-3.2 0.8-0.9 0-1.6-0.5-2.3-0.8-0.9 0-1.3 0.6-1.6 1.3q-0.9 1.3-2.4 1.2c-0.3 0.1-0.6 0.1-0.8 0.3-0.6 0.4-1.3 0.8-2.1 0.7q-0.5-0.2-0.9-0.6c-0.4-0.5-0.4-1.2-0.5-1.9q0-0.5 0-0.9c-0.1-0.5-0.3-0.9-0.5-1.3-0.1-0.4-0.3-0.8 0.1-1.2-0.1-0.7-1.5-2 0.8-1.5 2-0.7 4.6-0.6 4.6-3.8 2.3-2.4 3.9 1.9 6.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s221",
    d: "m132.6 16.8c-2.7-1-5.7 2.3-8.5-0.3 0.8-1.4 2.4 0.2 3.1-1.2-0.2-1.2-1.8-0.6-2.2-1.5 1.2-0.3 1.5-1.2 1.5-2.3q0.8-0.4 1.6-0.8c1.5 0.3 3 0.7 3.8 2.3 0 1.3-0.2 2.7 0.7 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s101",
    d: "m142.6 10.7c-1.7 0.6-2.8-0.1-2.7-1.8 0.1-1.6 1.3-1.9 2.7-1.2 1.8-0.9 2.4 0.1 2.7 1.7-0.2 1.9-1.1 2.2-2.7 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s90",
    d: "m144.1 16.8h-0.7c1-1-5.1-2 0-3 0.7-0.8 0.2-2.9 2.3-2.3 1.2 0.9 3.6 1.3 2.3 3.8q-0.4 0.4-0.8 0.8c-0.8 1-2.1 0.1-3.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m131.9 13c-1.3-0.7-3.1-0.7-3.8-2.3h-0.1q1.2-0.9 2.3 0 0.4 0 0.8 0c0.4 0.7 1.8 1.1 0.8 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s272",
    d: "m145.7 11.5q-1.2 1.1-2.3 2.3-0.4-1.5-0.8-3.1c1.1 0 2-0.3 2.3-1.5q0.4-0.6 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s100",
    d: "m145.7 9.2q-0.4 0-0.8 0-0.8-1.4-2.3-1.5 0.2-1.3 1.5-1.6 0.4 0.4 0.8 0.8c0.7 0.3 1.2 0.7 0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s220",
    d: "m143.4 16.8c0.4 2.3-1.4 1.3-2.3 1.6v-0.8q1.1-0.4 2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s213",
    d: "m130.3 10.7q-1.1 0-2.2 0v-1.5c1.5-0.6 2.1 0.1 2.2 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s327",
    d: "m-7.5 10.7q0.8-0.7 1.5-1.5c1.7-1.9 3.8-2 6-1.2 0.6 0.3 0.1 2.3 1.7 1.2q0.4 0 0.8 0c0.2 0.4 0.5 0.5 0.7 0 0.7-1.2 1.8-1.6 3.1-1.5-0.2 0.5-1.6 1 0 1.5 0.4 0.8-0.2 1.2-0.8 1.5 0 1.1-1.5 1.9-0.4 3.1 1.1 1.2 2.3 0 3.5 0q0.7 0 1.5 0c-0.5 1.5 0.6 1.5 1.6 1.5q-0.8 1.2-1.6 2.3c-0.5-0.2-1-0.5-1.5 0-1.5 1.6-3.1 0.1-4.6 0.1q-0.5-0.1-0.9-0.4c-0.5-0.3-0.8-0.6-1.1-1-0.6-0.8-1.4-1.3-2.3-1.6-0.7-0.4-1.1-0.9-1.1-1.7q-1.1-0.8-2.3-1.5c-1.1-1-2.5-0.7-3.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s338",
    d: "m8.6 19.1q0.8 0.4 1.5 0.8c0.4 0.5 0.7 1 0.7 1.7-0.8 3.5-3.3 3.2-5.9 2.5-1.1 0-1.9-0.7-2.9-0.9-0.7-0.3-1.4-0.8-1.1-1.8 0.9 0 1.7-0.1 2.3-0.7 0-0.8 0-1.6 0.6-2.2 1.8-1.3 3.3-0.5 4.8 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s339",
    d: "m0.9 21.4q0.8 0.4 1.6 0.8c0.9 1.5 1.7 3.2 0.6 4.8-0.8 1.1-2 1-3 0.3-0.6-1-1.5-0.5-2.3-0.5-1.4-0.3-2.1-1.4-3-2.3q0-0.4 0-0.8 0.4-0.5 0.8 0c1.1-0.2 2.4 1 3.4-0.5-0.5-1.5-2.7 0.3-3-1.7 1.6-1.7 3.3-0.5 4.9-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s340",
    d: "m3.2 15.3v1.5c-0.3 0.7-0.6 1.2-1.5 0.8-1.8-0.4-4.5 0.5-3.8-3 0.9-1 1.8-0.1 2.6-0.1 0.9 0.3 1.9 0.2 2.7 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s320",
    d: "m0.2 15.3q-1.2-0.4-2.3-0.7c-0.5-0.2-1.1-0.3-0.9-1 0.2-0.7 1-0.5 1.6-0.6q0.8 0.4 1.6 0.8 0.6 0.7 0 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s327",
    d: "m1.7 17.6q0.7-0.4 1.5-0.8 0.4 0 0.8 0c0.5 0.7 0.3 1.3-0.2 1.9-0.4 0.4-0.7 0.8-1.3 0.4q-0.4-0.7-0.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s340",
    d: "m2.5 19.1q0.4-0.3 0.7-0.7c0.8-0.2 1 0.1 0.8 0.7q-0.4 0.8-0.8 1.6c-1-0.2-1.1-0.7-0.7-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s341",
    d: "m0.2 26.8c0.4-0.5 2.5 1.3 1.5-1.3-0.3-0.8-0.5-2.4 0.8-3.3q1.1 0.4 2.3 0.8c1.9 3.1 1.8 3.6-2 6.5-1.1 0.2-1.8 1.3-3 1.5-0.9 0-1.9 0.4-2.7-0.4q0-0.8 0-1.5c0-0.9-0.1-1.7 0.6-2.4 0.8-0.3 1.7-0.6 2.5 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s220",
    d: "m-2.9 30.6h3.1q0.2 0.3 0.1 0.5-0.1 0.2-0.2 0.2c-1 0.2-2 1.5-3 0.1q0-0.4 0-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s342",
    d: "m-2.1 27.5q-1.6 0-3.1 0.1v-1.6c1-0.7 2-0.5 3 0 0.9 0.1 2-0.8 2.3 0.8-0.8 0-1.6 0.1-2.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s247",
    d: "m159.4 6.1c-1.5-1.2-4.3 0.1-5-2.7 0.8-0.8 1.9 0.4 2.7-0.3 1.1 0 2.1 0.9 3.1 0 0.6-0.7 1.3-0.8 2.1-0.3 0.9 0.9 0.1 1.3-0.6 1.8 1.1 1.1 3.1 0.6 3.9 2.3 0.4 0.4 0.4 0.9 0.2 1.4q-0.4 0.4-0.9 0.5c-1-0.2-1.9-0.8-3-0.9-0.9-0.4-1.8-0.9-2.5-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s219",
    d: "m162.5 3.1q-1.2 0-2.3 0c-0.9-0.5-2-0.9-2.9-2.3h3.7c0.7 0.3 1.4 0.6 1.8 1.4q0 0.5-0.3 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s209",
    d: "m162.5 2.3q-0.8-0.8-1.5-1.5 0-0.4 0-0.8 1.9 0.8 3.8 1.5 0.3 0.6-0.1 1.1c-0.8 0.5-1.5 0.3-2.2-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s207",
    d: "m10.1 7.7q-0.7 0-1.5 0 0-1.2 0-2.3c1.3 0.2 1.5 1.2 1.5 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s81",
    d: "m0.2 9.2c-2.1-1.3-4.1-0.8-6.2 0q-0.7-0.4-1.5-0.8 0-0.3 0-0.7c1.1-0.1 2.2 0 3.1-0.8q1.9-0.4 3.8-0.8c0.8-0.6 1.5-0.6 2.3 0q-0.4 1.5-0.8 3.1-0.3 0.4-0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s343",
    d: "m1.7 6.1q-1.1 0-2.3 0 0-0.7 0-1.5c1-0.8 2-0.7 3.1 0 0.7-0.4 0.5-1.8 1.6-1.7 0.3 0 0.6 0.8 0.7 1.2 0.1 1.3-1.1 1-1.8 1.3-0.5 0.2-0.9 0.5-1.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s235",
    d: "m2.5 4.6q-1.6 0-3.1 0-0.4-0.4-0.8-0.8c1.4-0.2 2.2-0.7 1.6-2.3q0.7 0 1.5 0 0.4 1.6 0.8 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s344",
    d: "m0.2 9.2h0.7q0.4 0 0.8 0c-0.8 0.7-1.6 1.6-3.3 1.1 0.8-0.5 1.3-0.8 1.8-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s345",
    d: "m3.2 9.2c0.4 0.8 0.3 1.7-0.6 1.6-0.6 0-0.1-1-0.1-1.6q0.4 0 0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s238",
    d: "m95.9 17.6c-2.2 2.7-3.5-1.4-5.4-0.8-1.4-2.6 1.1-3.3 2.3-4.5 2.2-2.7 2.2-2.7-0.7-3.7-1.5-0.5-0.8-1.6-0.8-2.4q1.9 0.4 3.8-0.1 0.4 0.3 0.3 0.5-0.1 0.3-0.3 0.3c3 3.6 0.1 6.3-1.5 9.2 0.7 0.5 2 0.4 2.3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s346",
    d: "m85.9 9.9h0.8c2 0.2 3.4 0.7 2.3 3.1q-2 1.7-4.5 2.5c-1.5 0.4-2.7-0.1-3.9-0.9q-0.4-0.8-0.8-1.6c1.3-2.5 3.7-2.9 6.1-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s232",
    d: "m84.4 14.6c1.8 0.2 1.8-4.9 4.6-1.6q0 0.4 0 0.8c0.6 1 0.2 1.7-0.8 2.3-2.7-0.9-2.2 2.4-3.8 3-0.8 0.1-1.5 0-2-0.7-0.5-1.1-0.1-2.1 0.6-3 0.4-0.4 1-0.5 1.4-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s279",
    d: "m88.2 16.1q0.4-1.2 0.8-2.3 1.9-0.8 3.8-1.6-1.1 2.3-2.3 4.6c-0.8 0-1.6-0.1-2.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s43",
    d: "m110.4 223.3h0.8c0.3 1.2 1 2.8-1.4 1.8-1.5-0.6-3.1-1-4-2.6v-1.5h0.8c1.1 0 2.2 0 3.1 0.8-0.4 0.8 0.1 1.2 0.7 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m41.2 111.4q0 1.1-0.9 1.3c-0.4 0.1-0.8-0.2-0.7-0.6 0.2-0.5 0.6-0.8 0.8-1.2 0.3 0.2 0.6 0.4 0.8 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m42.3 108.6c0.8-0.8 1.5-0.3 2.3 0-0.8 1-1.5 2.1-2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m120.4 201.9c1.1 0 1.8-1.4 3.1-0.8 1.2 1.4 2.3 3.1 3.8 4.1 1.3 1 2.1 0.4 3.7-2.1 0.6 1.3 1.2 2.4 1.9 4.1-4.7-1.1-10.4 1.2-12.5-5.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s112",
    d: "m125 198.8c0.6-0.8 1.2-1.6 1.7-2.5 1.2-2.3 2-0.7 2.9 0.2-0.1 0.4-0.1 0.8-0.2 1.1-0.4 1.2 0.8 2.9-0.6 3.5-1.8 0.7-2-1.6-3.1-2.3q-0.3 0.5-0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s111",
    d: "m125 198.8q0.4 0 0.7 0-0.7 0.4-1.5 0.8c-2.6 0-5.1-1-7.6-1.5 2.2-2.5 4.3-3.8 6.3 0.2 0.2 0.4 1.4 0.4 2.1 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m138 201.1q-0.8 0.4-1.5 0.8c-1.5 0.5-2.6 0.3-3.5-1.4 1.9-0.6 3.4 0.4 5 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s347",
    d: "m43 45.1q0.4-0.3 0.8-0.7c0.6-2-0.6-4.6 1.7-6.1 2-0.9 3.3-3 5.8-2.7 0.9 0.1 1.5 0.4 1.9 1.2 0.4 1.2-0.3 2.5 0 3.7-0.3 0.9-0.6 1.7-1.1 2.4-0.4 0.4-0.9 0.4-1.4 0.7q-0.4 0-0.8 0c-0.6-0.6-1-0.2-1.2 0.5-0.2 0.4-0.6 0.6-1 0.3-1.3 0.2-2.2 0.6-1.6 2.1 0.2 0.8 0.3 1.5-0.7 1.7q-0.8 0-1.6 0c-0.9 0-1.9 0.1-2.3-0.8-0.5-1.3 0.8-1.7 1.5-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s203",
    d: "m52.2 40.5c-0.5-1.2-1.2-2.4 0.8-3q0.3 0 0.5 0.1c0.7 0.3 1.4 0.5 1.8 1.2 0.4 0.6 0.4 1.4 0.7 2 0.4 1.2 2.2 2.3 0.1 3.6-1.9 0.5-3.9 1.3-5.4-0.8q0.4-0.4 0.8-0.8c0.7-0.6 0.8-1.4 0.7-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s186",
    d: "m43 45.1c-2.3 3.4 2 1.8 2.4 3.1-2.7 1.6-5.6 1.6-8.5 1.5q0-0.4 0-0.7 1.6-0.8 3.1-1.6c0.2-1.8 1.4-2.3 3-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m56.1 44.4c0.7-1.7-1.7-1.7-1.6-3.1q0.6-0.5 1-1.1c0.4-0.7 0.9-1.5 1.2-2.3q0.8-1.2 2.4-1c1.4 1.2 3.5 0.5 4.8 2q0.2 0.5 0 1.1c-0.9 0.9-1.9 1.7-3.2 1.9-2.1 0.1-1.4 3.6-3.9 3.2q-0.4-0.4-0.7-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s262",
    d: "m56.8 45.1c1.3-1.3 0.2-4.3 3.1-4.6 0.9 0.7 2.1 1 2.3 2.3q-0.4 1.6-0.8 3.1c-1 0-2-0.9-3 0q-1.2 0-2.3 0 0.4-0.4 0.7-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s189",
    d: "m48.4 43.6c-0.4-0.6-1-1.4 0-1.6 1-0.3 1.1 1 1.5 1.6q-0.3 0-0.7 0-0.4 0.6-0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s122",
    d: "m48.4 43.6q0.4 0 0.8 0c-0.2 0.8 0.2 1.9-0.9 2.1-0.7 0.2-0.6-0.8-0.6-1.3q0.3-0.4 0.7-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s63",
    d: "m41.3 51q0.3 0.4 0.6 0.8c-0.2 0.1-0.5 0.4-0.5 0.3-0.3-0.2-0.5-0.4-0.7-0.7 0.2-0.1 0.4-0.2 0.6-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m82.1 45.9h-1.5c-0.8-1.4 1.3-3.4-0.8-4.6-1.1 0.9-2.2 1-3.3 0q-0.3-0.4-0.3-1c0.3-2.4 3.6-1.9 4.1-4.2q0.1-0.5 0.4-1c1.3-2 3.1-2.8 5.4-2.3 0.3 0.3 0.5 0.1 0.7-0.2 0.5-0.6 1.2-0.8 2-0.7q0.5 0.1 0.9 0.5 0.2 0.2 0.4 0.4 0.2 0.5 0.2 1.1c-0.2 0.9-0.6 1.7-1.1 2.4q-0.4 0.4-0.8 0.7c-1.4 0.5-0.9 1.8-1.1 2.8q-0.2 0.8-0.8 1.3c-1 0.5-2.2 0.7-2.5 2.1-0.2 1.2-0.8 2.1-1.9 2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s126",
    d: "m76.7 40.5c0.9 0.9 2 0.8 3.1 0.8q-0.4 0.8-0.8 1.5-1.9 0.4-3.8 0.8c-0.7-1.6-1.6-3.4 1.5-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s348",
    d: "m80.6 45.9c-0.3 0.9-0.7 1.6-2.3 1.2 0.9-0.5 1.6-0.9 2.3-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s76",
    d: "m76.7 40.5c-1.6 0.5-1.5 1.8-1.5 3.1-2.2 0-2.1 3.5-4.6 3.1q-0.7-0.8-1.5-1.6c0.1-1.1-0.6-1.4-1.6-1.5-1-1-0.4-2 0.1-3.1q0.3-0.4 0.8-0.6c2.4 0.2 4.7-0.7 7-1 0.6 0.1 1 0.4 1.3 0.9q0 0.4 0 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s287",
    d: "m68.3 40.5h-0.7q-0.8 0.4-1.6 0.8-0.7 0.7-1.5 0v-0.8c-0.3-0.1-0.8-0.3-0.8-0.8q0-0.3 0-0.7-0.4-0.4-0.3-0.9c0.3-1.1 1.1-1.8 1.5-2.7q0.4-0.7 1-1.3c0.9-0.8 1.5-1.9 2.7-2.3 3.5-1.9 3.8-1.8 4.9 1.4-0.1 0.8-0.3 1.6-1 2-0.1 0-0.2 0.1-0.1 0.2 1.3-1.2 1.8-4.1 4.6-2.1 1 1.3 0.3 2.8 0.3 4.2-0.4 1-1.1 1.8-2.3 1.9-2.1 0.8-4.4 0.9-6.7 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m63.7 39.7q0.4 0.4 0.8 0.8-0.4 0.4-0.8 0.8-0.7 0.8-1.5 1.5c-1.3-0.2-1.8-1.2-2.3-2.3 1.3 0.1 2.6-0.1 3.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s190",
    d: "m64.5 41.3h1.5c0 0.9-0.1 1.7-0.7 2.3-0.7-0.6-0.8-1.4-0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s287",
    d: "m67.5 43.6c1.8-1.4 2.6 0.1 3.9 0.9-0.8 0.9-1.6 0.5-2.3 0.6q-0.8-0.7-1.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s270",
    d: "m95.1 42.1q-1.1 0.8-2.3 1.5c-0.8-1.3-0.2-2.2 0.7-3.1-0.8 0.5-1.4 1.1-2.2 1.2-0.6 0.2-1.1 0-1.7 0-1-0.1-1.9-0.2-2.4-1.2-0.3-1.7-0.8-3.4 1-4.6v0.1c1.1-0.4 0.9-1.7 1.6-2.3 0.9-1.1 2.1-0.3 3.2-0.5 0.6 0 1.1 0.1 1.6 0.1 0.5 0.1 1 0.2 1.4 0.6 0.6 0.6 0.6 1.5 1.3 2 0.5 0.4 1.2 0.6 1.6 1.1 0.4 0.4 0.7 0.9 0.9 1.4 0.1 1.1-0.1 1.9-1.1 2.4-1.4 0-2.3 1.2-3.6 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s190",
    d: "m104.3 47.4c0.5 0.8 0 1.5 0 2.3-2.6-0.3-5.2-0.9-7.6 0.8q-1-1.2 0-2.3 0.7-1.5 1.5-3.1c2.2-1.5 2.8 1.9 4.6 1.6 0.4 0.4 1.2 0.1 1.5 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s215",
    d: "m94.3 40.6q-0.7 1.5-1.5 3-0.3 0.8-0.7 1.5c-2.1-2.2-4.5-1.4-7-0.7-0.5 0.4-1.2 0.4-1.4-0.2-0.4-1.1 0.5-1.6 1.3-2.2 1.3-0.6 2.8 0.1 4-0.8q0.4-0.3 0.8-0.7h1.5c1 0.8 2-1.2 3 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m101.2 54.3c-0.9 0.1-2.1 0.6-2.3-0.9-0.2-0.6 0-1.1 0.7-1 0.9 0.3 2.2 0.3 1.6 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s283",
    d: "m95.1 42.1c0.7-1.2 1.8-1.6 3.1-1.6q0.3 0.3 0.2 0.6-0.1 0.2-0.2 0.2-0.4 0.8-0.8 1.6c-0.8-0.1-1.7-0.2-2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s146",
    d: "m107.4 52c-0.9 2.2-2.9 2-4.6 2.3 1.3-1.2 2.8-1.9 4.6-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s216",
    d: "m96.7 48.2q0 1.1 0 2.3c-0.6-0.1-1.4 0-1.6-0.7-0.2-1.1 0.7-1.4 1.6-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s70",
    d: "m89 51.2q-0.8 0.4-1.5 0.8c-1.1-1.2 0.3-1.6 0.7-2.3 1.1 0.1 1.1 0.8 0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s349",
    d: "m95.5 55.7c0.2 0.3 0.6 0.6 0.6 0.8-0.1 0.5-0.5 0.5-0.8 0.3-0.3-0.2-0.3-0.6-0.5-0.9 0.2 0 0.4-0.1 0.7-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m174.8 87.2q-0.9 1.5 0 3-2 0-3.9 0c-0.1-2.2-0.6-4.6 3.1-3.8q0.4 0.4 0.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s33",
    d: "m143.4 178.2c-2.7 2.1-4.1-1.3-6.2-1.5q-0.7-0.8-1.5-1.6c-0.8 0.9-2.7 1.3-1.5 3.1-0.7 0.9-1.4 1.8-2.4 0.7-0.8-0.9-1.1-2.1-0.7-3.2 0.3-0.8 1-1.4 1.5-2.1 1.6-0.5 3.3-1.5 4.2 0.8 1.4-1.1-1.1-1.7 0.2-2.3 0.5-0.3 1.7 0 1.7 0.3 0.5 2.3 2.7 1.1 3.9 2q0.4-0.6 0.8 0c2.6 1.2 1.5 2.5 0 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s39",
    d: "m154.8 176.4c-0.1 0.8-0.2 1.4-1 1.3-0.2 0-0.6-0.6-0.5-0.7 0.2-0.5 0.2-1.3 1-1.3 0.2 0 0.4 0.5 0.5 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m143.4 174.4h-0.8c0.7-1.5 1.9-0.9 3.1-0.8-0.7 0.6-1.5 0.8-2.3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m132.4 182.9c1.5 0.3 3 0.7 2.8 2.8-0.1 1.1-0.6 2.1-1.8 2-1.7-0.3-2.2-1.9-2.6-3.3-0.2-1.1 0.5-1.7 1.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s290",
    d: "m134.2 178.2c-0.6-0.1-1.6 0-1.5-0.7 0.3-1.6 1.4-2.4 3-2.4q-0.8 1.6-1.5 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s37",
    d: "m125.7 179.7c0.9-1.2 2.3-0.4 3.3-0.8-0.8 1.3-1.6 2.8-3.3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s40",
    d: "m137.2 179.7c1 0.3 2.5-0.4 2.3 1.6-1.5 0.6-1.8-0.7-2.3-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s34",
    d: "m122.9 184.9c-0.1 0.2-0.1 0.4-0.3 0.5-0.1 0-0.4-0.1-0.5-0.2-0.3-0.4-0.1-0.6 0.3-0.7 0.2 0 0.4 0.3 0.5 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s27",
    d: "m166.3 173.6c0.1 2.8-2 1-3 1.5 0.7-1.1 1.4-2.2 3-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s78",
    d: "m89.8 40.5v0.8c-1 1.3-2.9 0.3-3.9 1.5-0.1 0.6-2.3 0.2-0.7 1.6-0.5 1.6-1.9 1.5-3.1 1.5q0.4-1.5 0.8-3c0.1-1.9 1.4-2.4 3-2.4q0.4-0.4 0.8-0.7 0.4-0.4 0.8 0c0.6 0.6 1.4 0.7 2.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s285",
    d: "m89.5 46.1c-0.2 0.1-0.6 0.3-1 0.5-0.1-0.3-0.4-0.7-0.3-0.9 0.1-0.2 0.5-0.4 0.8-0.5 0.4 0 0.8 0.2 0.5 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s85",
    d: "m119.6 20.7q0.4-0.4 0.8-0.8c1.8-0.3 1.5 1.1 1.6 2.1-0.4 0.7-1.1 1.1-1.7 1.3 0.6-0.1 1.1-0.5 1.6-1.1 0-1.5 1.2-1.9 2.3-2.3 5-0.9 5.8 2.7 6.9 6.1q-0.7 0.8-1.7 0.9c-0.8 0.1-1.6-0.2-2.3 0.3-1 0.5-1.6 1.8-3 1.4-0.6-0.4-1-0.9-0.7-1.7q0.6-0.7 0.8-1.6c-0.1 0.4-0.4 0.8-0.6 1.3-1.1 0.9 0.3 2.4-0.7 3.4-1.9 1.3-3.5 0.3-5.2-0.4-0.7-0.8-1.3-1.8-2.2-0.2-0.4 0.3 0.2 0-0.2 0.3-0.4 0.5-2.2 0.2-1 1.7-0.3 1.3-0.6 2.7-1.6 3.8-0.6-1.4-2-1-3.1-1.3-1.3-0.5-2.8-0.6-3.7-2-0.4-0.7-0.6-1.3-0.7-2.1 0.3-1.9 2.1-2.3 3.1-3.4 0-0.9-1.3-0.9-1.4-1.8q-0.2-0.5-0.1-1c1.5-2.3 2.7-4.5 6.2-2.7 2 1 4.4-1.2 6.6-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s201",
    d: "m110.4 32.9c1.1 0.5 2.1 1 2.3 2.3-0.6-0.2-1.3-0.2-1.4 0.5-0.2 2.1-1.9 2-3.2 2.5-0.7 0.8-1.6 0.8-2.6 0.7-1.6-0.9-2.9-2-4.2-3.2-0.3-0.4-0.6-0.9-1-1.2-0.6-0.7-1.2-1.3-1.1-2.2q0.1-0.9 0.8-1.3c0.6-0.3 1.3-0.4 2-0.4 0.5 0.1 1 0.3 1.5 0.4 2.3 0.9 4.1 3.3 6.9 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s182",
    d: "m114.3 31.4c-1.5-1.4-0.3-1.8 0.7-2.3 0.9-0.9 1.8-1.6 3.1-0.8 1.4 0.9 2.8 2 4.6 0.8 0.3-0.7 0.7-1.2 1.5-0.8q1.2-1.1 2.3-2.3c0.6 0 1.1 0.1 1.5 0.5q0.6 0.6 0.6 1.5c-0.1 1.5-2.2 1.7-2.1 3.4q0 0.3 0 0.7c-1.5 0.8-3.1-1.9-4.6 0-2.4-1.3-5.2 0.5-7.6-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s202",
    d: "m105.1 38.2q1.5 0 3 0 0 0.8 0 1.6c-1.7-0.3-3.8 1.1-5.3-0.8q0.1-0.2 0.3-0.4c0.6-0.5 1.3-0.5 2-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s336",
    d: "m117.5 35.5c1-0.8 1.9-1.8 3.7-1-1.2 1.3-2.5 1-3.7 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s85",
    d: "m113.6 36.4c0.4 0.4 0.7 0.6 0.8 0.9 0.2 0.5 0.2 1-0.5 1-0.3 0-0.5-0.5-0.6-0.8-0.1-0.3 0.2-0.6 0.3-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s336",
    d: "m126.5 31.4c-1.2-0.8-3.3-1.5-0.1-2.5 0.6-0.2 1.1-0.9 1.6-1.3 1.5-0.7 2.1 0.3 2.5 1.4 0.1 0.7-0.2 1.1-0.9 0.8q-1.6 0.8-3.1 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s10",
    d: "m129.6 29.8l0.7-0.7q0.4-0.4 0.8 0c1.1 0.7 2.8 0.5 3.1 2.3h-1.6c-1-0.5-2.5-0.1-3-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s101",
    d: "m156.4 20.7q-0.4 0.4-0.8 0.7-1.9 0-3.8 0.1c-1.1 1-2.1 0.7-3.1-0.1q0.8-0.8 1.6-1.5h-0.1c0.6-0.5 1.5-0.6 1.6-1.5v-0.8c0.6-0.7 1.3-0.9 2.1-0.4-0.1-0.2-0.2-0.3-0.4-0.4-0.7-0.6-1.8 0-2.5-0.7q-0.4-1.2-0.7-2.3c0.4-2.9 2.7-2.9 4.9-3 1.5 0.9 2.1-0.1 2.6-1.3 0.8-0.7 1.9-1 3-0.9 1.7 0.5 1.7 2.1 2.1 3.5 1 1.9-1.6 2.6-1.5 4.2-0.7 2.1-0.3 4.9-3.6 5.1-0.6 0-1-0.3-1.4-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s269",
    d: "m148.7 21.4q1.6 0 3.1 0.1c0.2 0.6 1.7 0.5 1.2 1.4-0.6 1.1-1.7 1.1-3 0.9-1.7-0.2-1.5-1.3-1.3-2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m155.6 11.5c-2 0.1-3.5 1.5-5.3 2.3-0.7 0.1-1.2 0.4-1.2 1.2 0.1 0.5 1.2 1.2-0.1 1.3-0.3 0.1-0.7-0.6-1.1-1 0-1.7-2-2.2-2.2-3.8q1.2-0.2 1.5-1.5 0.8-0.7 1.5 0c0.9 0.5 1.2-0.2 1.6-0.8 0.4-0.4 0.9-0.6 1.5-0.6 1.2 0.7 2.8 0.8 3.9 1.8q0.2 0.6-0.1 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m154.8 16.8c0.6 0.8 1.2 1.6 1.8 2.5-2.4 1.5-2.8-2.5-4.8-1.7q-0.4-0.8-0.8-1.5c1.5-1 2.8-0.6 3.8 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s272",
    d: "m144.1 16.8c0.4-3 2-0.9 3.1-0.7-0.7 1.6-1.6 2.5-3.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s350",
    d: "m151.8 18.4c0.2 0.2 0.8 0.5 0.7 0.6-0.4 1-1.4 0.8-2.3 0.9q0.8-0.8 1.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s282",
    d: "m156.4 20.7q0.7 0 1.5 0c1.9-0.2 3.5 0 3.8 2.3 0.1 1 2 0.8 1.6 2.2-1.1 0.7-2.8 0.7-3.1 2.3-1.5-0.4-1.5-3.3-3.8-2.3-1-1.5 0.3-3 0-4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s190",
    d: "m98.2 41.3v-0.8c0.6-0.6 0.7-1.4 0.7-2.3q0.2-0.2 0.4-0.3c1.3-0.2 3-1.4 3.5 1.1-1.1 0.6-1.6 1.6-2.1 2.7-1.2 2.4-1.8 0.3-2.5-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s64",
    d: "m104.3 47.4q-0.8-0.4-1.5-0.7c1-1.8 2.3-1.7 3.8-0.8q-1.1 0.8-2.3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s78",
    d: "m108.1 41.3c-0.1 0.5-0.2 1-0.8 1-0.2 0-0.5-0.6-0.4-0.8 0.3-0.6 0.8-0.3 1.2-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s190",
    d: "m108.9 46.7c0 1.2-0.3 2.4-1.5 3-1.7-2.1-0.5-2.8 1.5-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s201",
    d: "m181.6 32.1q-0.7 1.6-1.5 3.1c-0.7 0.2-0.9-0.1-0.8-0.8 0.2-0.9-1.3-1.9-0.4-2.6 0.5-0.4 1.8 0.2 2.7 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s278",
    d: "m183.9 29.1c0.1-1.3-0.2-2.7 0.8-3.8 0.5 0 0.6 0.4 0.8 0.7 1 1.8 0.7 2.9-1.6 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s121",
    d: "m185.5 26q-0.4-0.4-0.8-0.7 0-0.4 0-0.8 0.4-0.5 1-0.7c1.5 0.1 3.2 0.1 3.6 2.2q-0.8 0.4-1.5 0.8-1.2-0.4-2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s324",
    d: "m187 30.6q0.8 0.8 1.5 1.5-0.7 0.4-1.5 0.8c-0.5-0.8-2.3-0.7-1.5-2.3q0.8 0 1.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s293",
    d: "m179.3 34.4q0.4 0.4 0.8 0.8c-1.3 2.7-2.5-0.5-3.8 0 0.7-1.5 1.9-0.9 3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s278",
    d: "m188.5 17.6q0-0.8 0-1.5-0.4-0.5-0.6-1-0.3-0.8 0.1-1.6c1.7-3 3.6-1.4 5.5-0.1 0.5 0 1.1 0.1 1.6 0.4 0.8 0.7 1.2 1.5 1.2 2.6q-0.1 0.5-0.3 1c-1.2 1.6-3 2.1-4.8 2.5-1.7 0.2-2.2-1-2.7-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s351",
    d: "m178.6 12.3l2.3-0.1c0.5 0.2 0.9 0.4 1.1 1q0 0.5-0.3 1c-0.7 0.4-1.3 1-1.6 1.9l-1.5 1.5q-0.3-0.1-0.5-0.1c-1-1-2.6-1.4-2.9-3.1q-0.1-0.5 0.2-1c0.9-0.7 1.7-1.9 3.2-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s285",
    d: "m184.7 20.7c0.4 0.6 2.4-0.4 1.5 1.5-0.3 1.9-1.6 1.8-3 1.5q-0.4 0-0.8 0 0.8-1.5 1.6-3 0.3 0 0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s352",
    d: "m188.5 17.6c0.9 0.9 1.8 1.6 3.1 1.5q0.3 0.4 0.3 0.8-0.4 0.7-1.1 0.7c-1.6 0.1-3.9 0.9-2.3-2.2q0-0.4 0-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s340",
    d: "m180.1 16.1c-0.6-1.6 0.2-2.1 1.6-2.3 0.6-0.2 1.3-0.4 1.9 0q0.4 0.3 0.6 0.8c0.1 0.8-0.2 1.3-1 1.5q-1.6 0-3.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s309",
    d: "m183.2 16.1l0.7-1.6c2-2.3 3.4-1.1 4.6 0.8q0 0.4 0 0.8-1.1 0-2.3 0c-1 0.6-2 0.6-3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s241",
    d: "m178.6 18.4q0 0.4 0 0.7-1.5 0.4-3.1 0.8c-0.6-2.9 0.9-3.1 3.1-2.3q0 0.4 0 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s340",
    d: "m183.2 16.1q1.5 0 3 0c-0.5 1.3-1.7 1.2-2.8 1.1-0.7 0-0.3-0.7-0.2-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s283",
    d: "m183.2 23.7q1.5-0.7 3-1.5c2.2 1.6 0.1 1.7-0.7 2.3q-0.4 0-0.8 0-0.8-0.4-1.5-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s244",
    d: "m178.6 17.6c-1.4 0.3-2.7 0.7-3.1 2.3q-0.4 0-0.7 0-0.3 0-0.5 0c-1.3-0.1-1.5-1.1-1.8-2-0.6-1-1.9-1.3-2.2-2.6-0.2-1.2 0.6-2 1-3q0.3-0.8 1.1-1.1c1.9-0.2 2.6 1.1 3.1 2.6 1.1 1.2 3.3 1.5 3.1 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s353",
    d: "m170.9 21.4q0.8-0.7 1.6-1.5c0.7-0.6 1.5-0.5 2.3 0q-0.8 1.1-1.6 2.3-1.1-0.4-2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s306",
    d: "m131.1 29.1q-0.4 0-0.8 0-1.1-0.8-2.3-1.5-0.3-0.4-0.7-0.8c0.3-0.7 0.9-0.8 1.5-0.8q1.2 0 2.3 0c1.4 1 0.2 2.1 0 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s242",
    d: "m172.5 13q-0.8 1.2-1.6 2.3c0.1 1 1.1 2 0.1 3q-0.8 0.1-1.6 0.1c-1.1-0.1-2.1-0.4-3-1.1-0.4-0.2-0.9-0.5-1.2-0.9-1.2-4 2.7-3.3 4.3-4.8 1.2 0 2.1 0.5 3 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s242",
    d: "m161.7 23c-0.9-1.4-2.6-1.4-3.8-2.3 2-0.9 0.8-3.9 3.1-4.6 0.4-0.5 0.9-0.5 1.5-0.3 0.4 0.3 0.7 0.8 0.7 1.4-0.2 0.9-1.1 1.8 0 2.7h0.1c0.4 0.8-0.1 1.3-0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s315",
    d: "m167.1 16.1c1.3 0.2 1.8 1.2 2.3 2.3-2 3-4.1 0.8-6.1 0q-0.3-0.5 0-1c0.9-1.4 2.8-0.1 3.8-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s238",
    d: "m171 18.3c-0.1-1-1-2-0.1-3 1.2 0.6 2.4 1 3.1 2.3-0.7 0.4-1.3 1.2-2.3 0.8q-0.4 0-0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s101",
    d: "m163.3 17.6v0.8q0 0.7-0.1 1.5c-0.7-0.1-1.6 0.1-1.7-0.9-0.2-0.7 0.5-1.1 1-1.4l0.4-0.3q0.2 0.2 0.4 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s279",
    d: "m171.7 18.4q1.1-0.4 2.3-0.8c-0.6 1 0.2 1.6 0.8 2.3q-1.2 0-2.3 0-0.4-0.8-0.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s321",
    d: "m163.3 25.2c0-1.1-3.5 0.2-1.6-2.2 0.7 0.6 2.5 0.5 1.6 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s348",
    d: "m162.5 21.4q0.4-0.7 0.8-1.5c0.7 0.2 1.1 0.5 0.7 1.3-0.4 0.7-0.9 0.7-1.5 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s273",
    d: "m167.9 22.9q-0.8 0.1-1.6 0.1c-0.3-0.2-1.3-0.4-0.7-0.8 0.7-0.5 1.6 0.1 2.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s354",
    d: "m182.4 37.5c-0.3-0.8-1-1.8 0.1-2.3 1.2-0.5 1.2 0.7 1.5 1.5q0.2 0.3 0.2 0.6 0 0.3-0.1 0.3-0.4 0.3-0.9 0.3-0.5 0-0.8-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s87",
    d: "m183.2 37.5h0.8c0.8-0.5 1.5-0.6 1.5 0.7-0.9 0.9-2 0.8-3.1 0.8h-0.8c-0.4-1.5 1.2-0.9 1.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s64",
    d: "m185.5 38.2q-0.8-0.3-1.6-0.7 0-0.4 0.1-0.8 0.7 0 1.5 0c0.4-0.1 1-0.4 1.2 0.2 0.3 0.9-0.5 1.1-1.2 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s216",
    d: "m183.2 37.5q-0.8 0.7-1.6 1.5c-0.4-0.1-1.1-0.3-0.8-0.9 0.3-0.7 1-0.5 1.6-0.6q0.4 0 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s216",
    d: "m186.3 41.3c1.1 0.1 2.8 0.6 1.7 1.9-1.1 1.2-1.5 4.2-4.1 3.1-1.1-0.5-1.9-1-3-0.4q-0.8-0.4-1.6-0.8c1.8-1.7 4.3-0.2 6.2-1.5 0.5-0.7-0.2-1.7 0.7-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m183.2 53.5c-0.8-1.6 0.4-2.3 1.5-3v0.8c0.8 0.7 1.8 1.2 2.3 2.2v0.8c-0.5 1-1.6 0.3-2.3 0.8q-0.7-0.4-1.5-0.8-0.4-0.2-0.3-0.5 0.2-0.3 0.3-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s202",
    d: "m197 53.5q1.5 1.6 3 3.1v0.8c0.2 0.7 0 1-0.7 0.7h-0.1c-0.5-0.4-1.2-0.8-1.5-1.5-0.4-1.7-1.5-2.1-3-1.5q-0.8-0.4 0-0.8 0-0.4 0-0.8 1.1-0.5 2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s146",
    d: "m197.7 56.6q0.8 0.8 1.5 1.5c-1.8 0-3.6-0.1-5.3 0.8-0.4-2.3 1.4-1.2 2.3-1.5q0.8-0.4 1.5-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s184",
    d: "m184.7 55.1c0.6-0.7 1.5-0.8 2.3-0.8 0.6 1.2-0.9 1.9-0.4 3.2-1.6-0.5-1-1.9-1.9-2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s286",
    d: "m187 53.5q-2-0.2-2.3-2.3c1 0.6 3.9-0.8 2.3 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s76",
    d: "m169.4 57.4c0.7 0.1 1.6-0.3 2 0.4 0.1 0.2-0.4 1-0.8 1.1-1 0.1-1-0.8-1.2-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s355",
    d: "m179.4 50.5h-1.6c0.6-1.2 1.1-2.4 2.3-3.1 1 1.4-0.3 2.1-0.7 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s356",
    d: "m190.8 49.7v0.8c-1.2-0.1-2.5 0.6-3.8 0 1.1-1 2.5-0.7 3.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m183.2 53.5q0 0.4 0 0.8c-0.5 0.8-1.1 1.4-2 0.8-0.7-0.5 0-0.7 0.4-0.8q0.8-0.4 1.6-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s357",
    d: "m194.7 54.3v0.8h-2.6v-0.6q1.3-0.1 2.6-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m191.6 44.4c-0.2 0.6-0.8 1.5-0.6 1.7 1.1 1 2.1 1.7-0.5 1.6-0.9 0-1.8 0.5-3.5 1 1.6-2.1 2.3-4 4.6-4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s358",
    d: "m193.9 36.7v1.5c-1.2 0.2-1.7 1.3-2.5 2-0.9 0.9-1.7 1-2.1-0.4-0.2-1.2 0.7-1.8 1.5-2.3 0.9-0.9 1.9-1 3.1-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s288",
    d: "m179.4 50.5q0.3-1.5 0.7-3.1c0.9 0.2 1.7 0.4 3 0.7-1.5 0.9-2.6 1.7-3.7 2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s201",
    d: "m190.8 37.5q-0.7 1.1-1.5 2.3-0.4 0-0.7 0c-1.1-2.6 0.4-2.6 2.2-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s58",
    d: "m196.2 47.4c0.5 0.2 1.2 0.3 0.9 0.9-0.4 0.7-1.1 0-1.7-0.1q0.4-0.4 0.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s48",
    d: "m26.2 154.5c-0.1 0.5 0.2 1.2-0.6 1.4-0.1 0.1-0.4-0.2-0.4-0.3-0.2-0.8 0.4-1 1-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m169.4 207.3c-0.8-1.1-3.7-0.7-2.4-2.9 1.3-2.1 3.6-1.5 5.5-0.2 0.8 2.2-0.9 2.5-2.3 3.1q-0.4 0-0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s38",
    d: "m170.2 207.3q1.1-1.6 2.3-3.1c1-0.4 1.5 0.3 2.3 0.8-0.3 1-0.5 2.1-0.8 3.3q-1.9-0.5-3.8-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m174.8 205q-1.2-0.4-2.3-0.8c1.8-4.5 3.4-5.1 6.8-3.1-2.4 0.2-5.8-0.8-4.5 3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s52",
    d: "m167.7 199.5c0.2 0.1 0.6 0.3 0.9 0.6-0.2 0.2-0.5 0.7-0.6 0.7-0.5-0.2-1-0.4-1.2-0.7-0.2-0.4 0.2-0.7 0.9-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s359",
    d: "m173.2 71.1c0.6 0.6 0.8 1.3 0.4 2.1-0.3 0.7-0.7 1.4-1.6 1-0.5-0.3-1.2-0.7-1.3-1.2-0.1-1.1 0.9-0.9 1.6-0.9 0.6-0.1 0.8-0.4 0.9-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s278",
    d: "m59.1 37.5q-1.3 0.2-1.5 1.5c-1.1 0.7-1.9-0.1-2.8-0.6-0.7-0.2-1.3-0.3-1.8-0.9q-0.8-0.4-1.5-0.8c-1.5-1-2.5 0.1-3.6 0.8-1.4 0.1-2.3 1.8-3.9 1.2-0.5-0.2-0.6-0.8-0.9-1.2-1.6-0.2-2.7 0.8-3.9 1.5 0-1.1 1.3-2.5-0.7-3.1q-0.4-0.4-0.3-0.9c1-2.4 3-1.7 4.8-1.6 2.1 0 4.2 0.3 6.1-1.2q0.5-0.5 1.2-0.8c1.7-0.4 3.3-1 4.9-1.5q0.6 0.1 1 0.3c1.7 1.4 1.5 2.9 0.3 4.4 0.1 0 0 0.3 0 0.3 0.3 0 0.5 0.1 0.7 0.1 0.5 0.3 1 0.6 1.6 0.8q0.4 0.3 0.6 0.8 0 0.2 0 0.5-0.1 0.2-0.3 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s283",
    d: "m26.2 31.4c-0.7 0.6-1.3 1.4-2.3 1.5-1.5-1.3-1.9 0.6-2.8 0.9q-1.6 0.4-3.2 0.9c-1.5 0-1.9-1.1-1.9-2.4q0.1-0.5 0.4-1c1.3-1.5 3.4-1.8 4.8-3.1 0.4-0.6 0.3-1.2 0.5-1.8q0.2-0.5 0.5-0.9c1.1-0.8 2.6-0.9 3.4-2.1 0.5-0.6 1.2-0.7 1.9-1 1.2 0 2.4-1.2 3.7-0.4 0.8 0.9 0.8 2.1 1.1 3.2q-0.1 0.5-0.3 1c-0.6 0.9-1.9 1-2.3 2.1-0.9 1.4-2.5 1.9-3.5 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s306",
    d: "m38.5 35.2v0.7c-1.4-1.1-4.3 0.9-4.7-2.2 0.4-0.6 1.2-0.3 1.6-0.8q0-0.4 0-0.8c1.1-0.4 1.6-1.7 2.6-2.2q0.8-0.4 1.7-0.2c1.2 0.4 2.4 0.5 3.6 0.6 1.6 0.1 2.7 0.6 2.3 2.5-0.6 1.8-2.2 1.1-3.5 1.2-1.3 0.2-2.9-0.6-3.6 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s360",
    d: "m26.2 31.4c-0.1-1.8 2-2.8 1.5-4.6 1.4-1.1 3.2 0.5 4.5-0.7q0.8-0.2 1.5 0.2c0.9 0.8 0.5 1.8 0.4 2.7-0.2 0.6-0.6 1.1-1 1.6-1.8 0.2-4.4-1.5-5 2-0.1 0.6-0.5 0.5-1.9-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s361",
    d: "m26.2 36c-2 1.2-3.7 3.1-6.1 3.8-0.9-0.3-1.2-0.9-1.2-1.7 0.9-2.3 2.9-3.3 5.2-3.7q0.3 0 0.6 0h2.3c0.5 0.9-0.3 1.1-0.8 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s275",
    d: "m19.3 38.3q0.4 0.7 0.8 1.5c-0.9 0.9-2.1 0.1-3.1 0.7-0.3-1.2-0.9-1.3-1.9-0.7-1.1 0.6-1.9 0-2.7-0.8 2.2-1.7 4.2-3.8 6.9-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s361",
    d: "m17.8 33.7c0.9-0.9 2-0.8 3.1-0.8 0.7-0.5 1.5-0.7 2.2 0q0.8 0.8 1.6 1.5c-2 0.1-3.3 3.6-5.8 1.1-0.5-0.5-0.7-1.2-1.1-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s362",
    d: "m33.9 37.5c0.9-0.4 2-1.2 2.7-0.2 0.9 1.1-1 1-1.2 1.7q-1.2 0.8-2.3 0 0.4-0.8 0.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s345",
    d: "m33.1 30.6c-0.2-0.5-0.5-1 0-1.5q1.7-2.7 3.4 0 0.1 0.6 0 1.1-0.2 0.2-0.3 0.5-1.6-0.1-3.1-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s273",
    d: "m23.1 32.9q-1.1 0-2.2 0c0.4-0.9 0.7-2 2.1-1.8 1 0.2 0.8 1 0.9 1.8q-0.4 0-0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s121",
    d: "m26.2 36q0.4-0.8 0.8-1.6 1 0.2 2 0.4c-0.6 1.3-1.8 1-2.8 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s363",
    d: "m32.3 37.5c-0.6 0.5-1.1 0.5-1.5-0.2-0.4-0.8 0-1.2 0.8-1.4 1.4 0 1.2 0.7 0.7 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s364",
    d: "m33.1 39q1.1 0 2.3 0c-0.4 1.7-2.3 0.5-3.1 1.5q0.4-0.7 0.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s362",
    d: "m32.3 37.5q-0.4-0.8-0.7-1.6c1.8-1 1.9 0.4 2.3 1.6q-0.8 0-1.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s365",
    d: "m35.4 32.9q-0.8 0.4-1.6 0.8c-0.4 0-0.9 0.1-1.6 0.1 0.9-1.4 2.2-0.7 3.2-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s366",
    d: "m37.7 30.6c0.4 2.3-1.4 1.2-2.3 1.5q0.4-0.7 0.8-1.4v-0.1c0.5-0.5 1-0.4 1.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s294",
    d: "m43.1 37.5q0.3 0.4 0.7 0.7c0.6 0.6 1.3 0.3 1.9 0.5q0.2 0.1 0.4 0.3c-1.8 1.3-1.3 3.7-2.3 5.4q-0.8-0.4-1.5-0.8c2.9-1.7-0.3-4.2 0.8-6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s367",
    d: "m19.3 34.4c1.8 2.5 3.6-0.4 5.4 0q-2.7 1.9-5.4 3.9c-2.4-0.9-4.6 0.7-6.9 0.7-0.8-0.1-2 0.3-2.2-0.6-0.3-1.1 0.9-0.7 1.5-0.9q0.5-0.1 0.3-0.5-0.2-0.3-0.3-0.3-0.8-0.7-1.6-1.5c1.8-1.7 4-1.2 6-0.9 1.1 0.2 2.1 0.4 3.2 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s368",
    d: "m19.3 34.4c-2.9 1.6-6.1 0.8-9.2 0.8q-0.4-0.4-0.8-0.8c-0.9 0.5-1.7 1.7-3 0.8q-0.4-0.4-0.8-0.8c-0.2-1.6 1-1.7 2.1-1.8 1.4-0.2 2.7-0.1 4-0.5 1.8-0.1 3.6-0.2 5.4 0 0.2 0.6-0.4 1.5 0.8 1.6q0.8 0.3 1.5 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s350",
    d: "m0.1 31.3q0.1-0.3 0.1-0.7c0.1-1 0.6-1.8 1.5-2.3 0.8 0.6 1.7 1 2 2.1 0.3 1.1 1.6 1.7 1.3 3-0.5 0.6-1.1 0.8-1.8 0.3-1.5-0.1-2.1-1.5-3.1-2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s369",
    d: "m3.2 33.7q0.8-0.4 1.6-0.8c2-1.9 4.3-2.4 6.8-1q0.6 0.4 0.8 1c-2 1.6-4.8-0.1-6.9 1.5-0.8 0-1.6-0.1-2.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s370",
    d: "m6.3 35.2q1.5-0.4 3-0.8c-0.7 1.1-1.5 2-3 1.8 0 0 0-0.6 0-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s371",
    d: "m11.7 36.7c0.9 0.1 1.8 0.1 2.9 0.2-0.9 1.6-1.9 0.9-2.9 0.6q0-0.4 0-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s73",
    d: "m199.3 35.9q1.1 0 2.3 0.1 0.7 0.7 1.5 1.5c-2 3.3-4.5 1-6.9 0.7q-0.8-1.5-1.5-3c1.7-1.1 3.1 0.1 4.6 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s372",
    d: "m196.2 38.2c2.3-0.1 4.7 0.1 6.9-0.7v0.7q0 0.8 0 1.6c-1.5 1.3-3.1 0.8-4.6 0-0.8-0.8-1.9-0.7-2.8-1-0.3 0-0.7-0.3-0.2-0.6 0.1-0.1 0.5 0 0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s73",
    d: "m210 37.5q-0.8 0-1.5 0c-1.1 0.1-1.1-1-1.6-1.5q-0.3-0.3-0.2-0.6 0.1-0.2 0.2-0.2c1.5 0.2 2.4 1.1 3.1 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s372",
    d: "m206.9 35.2q0 0.4 0 0.8-1 0.2-2 0.4c-0.1 0-0.3-0.5-0.2-0.6 0.6-0.7 1.3-1.1 2.2-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s126",
    d: "m212.3 30.6c-0.5-0.1-1.1-0.3-0.7-0.9 0.3-0.4 0.8-0.7 1.2-0.3 0.1 0.2-0.3 0.8-0.5 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s74",
    d: "m198.5 39.8q2.3 0 4.6 0c0.1 0.9 1.2 2.3-1.1 2.2-1 0-2.2-0.1-3 2.1-0.2-2.2-0.4-3.2-0.5-4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s358",
    d: "m193.1 35.9c-0.5-0.4-1.1-0.8-2-1.5 1.6-0.5 2.6 0 3.6 0.8q-0.4 0.4-0.8 0.8-0.4 0.4-0.8-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s282",
    d: "m193.1 35.9q0.4 0.1 0.8 0.1 0 0.3 0 0.7-1.5 0.4-3.1 0.8c-0.4-2.2 1.4-1.3 2.3-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s216",
    d: "m199.3 58.1q0.3-0.4 0.7-0.7c0.5 0.2 1.4 0.3 0.8 1.1-0.5 0.5-1.1 0-1.5-0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m126.5 216.4q-1.4-0.7-1.5-2.3c0.9 0.5 2.2 0.8 1.5 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s32",
    d: "m110.4 223.3c-0.5 0.2-1.2 0.6-1.6-0.1-0.4-0.8 0.3-1.1 0.9-1.4q0.4 0.7 0.7 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s365",
    d: "m206.2 11.5h0.7c-1.8 3.8-2.9 4.1-6.9 2.3q-0.3-0.3-0.2-0.5 0.1-0.3 0.2-0.3c2.1 0 1.7-1.9 2.3-3q0.8 0.3 1.6 0.7c0.6 0.6 1.2 1.3 2.3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s278",
    d: "m198.5 18.4c-1.5 0-2.1 1.4-3.1 2.3q-1-0.9-0.7-2.2 0.2-0.9 0.7-1.7c0.8-0.8 0.3-3.1 2.6-2.4q0.4 0.4 0.6 0.9c-0.1 1 0.9 2.1-0.1 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s98",
    d: "m195.4 18.4q0 1.1 0 2.3c-0.8 0.7-0.3 1.5 0 2.3q-2.3-1.2-4.6-2.4 0.4-0.3 0.8-0.7c1.4-0.3 2.3-1.8 3.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s373",
    d: "m198.5 18.4q-0.4-1.6-0.8-3.1c0.8-0.6 1.6-0.6 2.3 0-1.3 0.7 1.5 3.3-1.5 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s358",
    d: "m200 15.3q-1.1 0-2.3 0 0-0.4 0-0.8-0.2-0.2-0.1-0.5 0.1-0.2 0.1-0.2 1.2-0.4 2.3-0.8 0 0.4 0 0.8 0 0.8 0 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s372",
    d: "m186.2 41.3c0 0.9 0.8 2-0.7 2.3-0.1-0.9-1.9-2.3 0.7-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s374",
    d: "m185.5 24.5c0.6-0.7 1.3-1.3 0.7-2.3 1.3-0.2 2.5 2.9 4 0.2 0.2-0.3 1.3 0.6 1.3 1.4-0.2 1.3-0.3 2.7-2.2 2.2-1.1-0.9-2.5-1.2-3.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s270",
    d: "m192.4 29.8c-1-0.1-2.4 0.2-2.5-1.4-0.1-0.2 0.2-0.5 0.4-0.5 1.5-0.3 1.8 0.8 2.1 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s201",
    d: "m213.8 15.3q0.4 1.1 0.8 2.3-0.8 0.8-1.6 1.5c-1.8-1.5-3.5 1.8-5.3 0 1.6-2 1.7-6.3 6.1-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s201",
    d: "m215.3 16.1q-0.7-0.4-1.5-0.8c0.6-0.6 1.5-0.7 2.3-0.8q-0.4 0.8-0.8 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s375",
    d: "m56.1 30.6q-0.4 0-0.8 0c-0.7 0.6-1.2 0.4-1.7-0.2-0.7-1.3-1.9-0.9-2.9-1-2.5-0.3-4.6-1.4-6.1-3.4-5.2-2.4 0.7-3 0.8-4.6 0.3-0.5 1.1-0.2 1.5-0.7 1.1-1 2.5-0.7 3.8-0.8 2.1-0.6 4.2-1.4 5.1 1.6q0 0.6-0.3 1.1c-0.8 0.8-1.7 0.7-2.7 0.8-0.5 0.1-1.2 0.1-1.7 0.4 0.9 0.3 1.7 0 2.6 0q0.5 0 0.9 0.3c0.4 0.3 1 0.6 1.6 0.6 1.1 0.2 2.4 0.1 3.2 1.1q1.5 4.1-2.8 4.8-0.3 0-0.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s345",
    d: "m36.2 19.1c-0.9-1.8 0.5-2.7 1.5-3.8 1-1.8 2.3-1.7 3.8-0.7 1.6 2.4 3.1 0.4 4.6-0.1q0.4 0.8 0.8 1.6c0.4 0.4 0.8 0.8 0.7 1.5-0.6 0.6-1.4 0.8-2.3 0.8-0.8 0.3-1.7 0-2.5 0.3-1.8 0.4-3.6 0.4-5.3 1.4-0.6 0.3-1.5 0.3-1.3-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s306",
    d: "m44.6 26q3 1.2 6.1 2.3 0.3 0.3 0.3 0.6 0 0.4-0.1 0.4-0.3 0.5-0.8 0.7c-2.3 1.8-4.7 0.7-7 0.4-1-0.5-1.3-1.3-1.1-2.4q0.1-0.2 0.3-0.5c0.9-0.2 2.5 0.4 2.3-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s368",
    d: "m55.3 21.4c-0.9-2.3-3.4-0.1-4.6-1.5q0.4-0.8 0.8-1.5c1.8-0.2 3.2 0.5 4.6 1.5 0.5-0.4 1-0.5 1.5-0.2q0.4 0.4 0.3 1-0.2 0.9-1.1 1.2-0.9 0.2-1.5-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s283",
    d: "m34.6 24.5c2.5 1.3 5.6 0.8 7.7 3-3.3 2.6-5.8 1.8-7.9-2.5q0.1-0.3 0.2-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s204",
    d: "m47.6 17.6q-0.3-0.8-0.7-1.5 1.1 0 2.3 0 1.1 0 2.3 0c-0.9 1.4-2.1 2.2-3.9 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s376",
    d: "m42.3 19.9q-0.4 0.8-0.8 1.5c-1.2 1.4-2.5 0.7-3.9 0.2-0.2-3.8 2.3-2.4 4.2-2.2q0.2 0.2 0.5 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s377",
    d: "m37.7 21.4q1.9 0 3.8 0c0.5 0.5 0.2 1 0 1.6-1.2 0.4-2.2 0-3-0.8q-1.6 0-3.1 0c-0.5-0.8 0-1.3 0.6-1.8 0.9-0.2 1.3 0.4 1.7 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s247",
    d: "m36.2 20.7q-0.4 0.7-0.8 1.5-0.8 0.4-1.5 0.7c-0.5 0.5-1.1 0.6-1.7 0.3-2-3.2 0.9-2.4 2.3-2.9 0.6-0.2 1.2-0.1 1.7 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s283",
    d: "m32.3 22.9q0.8 0 1.6 0.1c1 0.1 1.1 0.7 0.7 1.5-1.6 2.1-2.4 0.5-3.2-0.7 0-0.7 0.2-1.1 0.9-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s229",
    d: "m38.5 22.2q1.5 0.4 3 0.8c-1.4 1.5-2.6 1.7-3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m43.1 17.6q1.1 0.4 2.2 0.8c-0.8 0.9-1.8 1.3-3 1.5-0.9-1.2-0.1-1.7 0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s378",
    d: "m46.9 20.7q-0.8 0.3-1.6 0.7c-0.3 0-0.9 0-1-0.2-0.2-0.6 0.4-0.5 0.7-0.5 0.6-0.1 1.2 0 1.9 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s379",
    d: "m57.6 19.9q-0.7 0-1.5 0c0.5-1.6 0.7-3.8 3-1.5q0.4 0 0.8 0c0.1 1.8-1.1 1.6-2.3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s80",
    d: "m41.5 14.6q-1.9 0.3-3.8 0.7-0.4-0.4-0.8-0.8c-1.4-1-1.1-1.7 0.5-2.1 1.2 0.1 2.5 0.3 3.4 1.4h0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s316",
    d: "m40.8 13.8c-1-0.3-2.5 1-3.1-0.8 0.2-0.8 1.2-0.8 1.5-1.6 0.8-0.9 1.6-2 2.3 0.1q-0.4 1.1-0.7 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s380",
    d: "m39.2 11.5c0.5 1.4-0.7 1.3-1.5 1.5-1.1 0.1-1.1 0.7-0.8 1.5-1.6-0.4-1.9-1.8-1.3-3 0.6-1.5 1.9 0.5 2.9 0q0.3 0 0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s341",
    d: "m57.6 19.9q1.1-0.8 2.3-1.5 1.1-0.6 2.3 0 0.4 0.3 0.8 0.7 0.3 0.4 0.8 0.7c1.2 0.1 2.5 0.1 3 1.6q-0.4 1.5-0.8 3.1c3.9 1.5 1.7 3.2 0.3 5-0.8 0.4-2.2-0.1-2.4 1.4q-0.7 0.5-1.6 0.4c-2.8-0.7-2-3.6-3.2-5.3-1.1 0.2-2.3 0.7-3-0.8-0.5-0.5-1-0.9-1.3-1.6q-0.1-0.8 0.5-1.4 0-0.4 0-0.8h1.5c0.5 0 0.8-0.3 0.8-0.8q0-0.3 0-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s18",
    d: "m69.8 23.7c1.1-2.2 4.7-3.4 6.9-2.3 0.3 2.7-2.7 2.4-3.6 4-0.9 0.3-1.9 0.5-2.8 0.3-0.8-0.5-1.1-1.1-0.5-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s340",
    d: "m72.9 24.5c0-2.6 3-1.5 3.8-3.1 2 0.8 3.4 0 4.6-1.5q0.5-0.3 1 0c1 2-0.3 3.1-1.5 4.3q-0.5 0.2-1.1 0.3-1.6-0.1-3.1 0.6c-1.4 0.5-2.7 0.8-3.7-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s377",
    d: "m69.8 23.7q0.4 0.8 0.8 1.5 0.4 0.4 0.4 0.9c-0.2 1.6-2 1.8-2.6 2.9q-0.6 0.6-1.5 0.6-0.5-0.1-0.9-0.5c0-1.6 1.9-3.1 0-4.6 1.4 0 2.6-0.2 3.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s327",
    d: "m71.9 17c0.9 0 1.8 0.3 1.8 1.4 0 1.1-1.1 1.3-1.9 1.5-1 0.3-1.4-0.4-1.5-1.2-0.2-1.1 0.6-1.5 1.6-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s381",
    d: "m66.8 21.4c-1.3-0.4-3 0.1-3.8-1.5 1.7-0.6 3.3-1.9 5.3-0.8 0 1.1-0.3 2-1.5 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s382",
    d: "m84.4 14.6q-0.4 0.3-0.8 0.7c-1.1 0.8-0.8 2.3-1.5 3.3-0.6 0.3-1.1 0.2-1.5-0.2 0.8-1.3 0.2-2.6 0-3.8 1.3-0.7 2.5 0 3.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s338",
    d: "m80.6 18.4q0.7 0 1.5 0 0.4-0.8 0.8 0 0.7 0.3 1.5 0.7 0 0.4 0 0.8c-0.2 0.7-0.6 1-1.4 1-0.4-0.2-0.5-0.7-0.9-1q-0.4 0-0.8 0-0.3-0.8-0.7-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s317",
    d: "m68.3 19.1q-2.7 0.4-5.3 0.8 0-0.4 0-0.8 1.5-0.4 3-0.7c1-0.5 1.8-0.3 2.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s284",
    d: "m75.2 16.1q0-0.4 0-0.8c0.6-0.1 1.5-0.7 1.6-0.1 0.2 1.1-1 0.7-1.6 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s235",
    d: "m164.8 2.3q0-0.4 0-0.8c0.9-0.8 2-0.7 3.1-0.7 1.1 1.8-0.6 2.2-1.6 3-1.4 0.4-1.4-0.6-1.5-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s321",
    d: "m164.8 2.3q0.8 0.8 1.5 1.5c-1.4 0.9-3 0.5-4.6 0.8q0.4-0.8 0.8-1.5 0-0.4 0-0.8 1.2 0 2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s236",
    d: "m169.4 5.4c0.7 0.9 2.1 1.4 1.5 3-1 0.6-2 1-2.3-0.7 0-0.9 0.2-1.7 0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s93",
    d: "m168.6 7.7c0.7 0.6 1.5 0.7 2.3 0.7 0.2 1.2-0.6 1.5-1.4 1.8-1.7 0.2-3.1-0.1-3.9-1.8v-1.5q1.5 0.4 3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s283",
    d: "m188.5 15.3c-1.4-0.7-2.9-1.1-4.6-0.8h0.1c-0.7-0.9 0-1.5 0.6-2.1 0.5-0.3 1.2-0.5 1.6-0.9-0.5-3.6 2.5-3.7 4.6-4.6 0.9 1.2 0.2 2.3-0.2 3.5-0.7 1.1-0.7 2.6-2.1 3.4q0 0.7 0 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s227",
    d: "m169.4 9.2q0.8-0.4 1.5-0.8 1.9 0.4 3.9 0.8 1.1 0.4 2.3 0.8c0.6 1.7 0 2.9-1.6 3.8-1.5-0.1-2.1-1.5-3.1-2.3-1 0.7-2 0.3-3-0.4-0.5-0.6-0.6-1.2 0-1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s321",
    d: "m186.2 11.5q-0.3 0.8-0.7 1.5c-1.3 0.6-2.6 1-3.9 0q-0.3-0.4-0.7-0.8c1.5-1.9 3.3-1.9 5.3-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s279",
    d: "m175.5 13.8q0.8-1.9 1.6-3.8c0.4 0.8 3.3-0.1 1.5 2.3-0.9 0.8-1.7 1.6-3.1 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s383",
    d: "m189.3 10q0.8-1.6 1.5-3.1c2.2 0.2 1.9 1.6 1.6 3.1-1.1 0.3-2.1 1.2-3.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s250",
    d: "m182.4 7.7q0.8-1.2 1.5-2.3c0.8 0.6 1.6 1.1 2.4 1.7-1.3 1.6-2.6 0.3-3.9 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s384",
    d: "m177.1 7.7c1.2-0.1 2.4 0.3 3 1.5-1.3 0-2.4-0.3-3-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s96",
    d: "m183.2 0.8c0.4-0.4 0.9-0.8 1.5-0.4 0.1 0.1 0.2 0.5 0.1 0.6-0.6 0.4-1.1-0.1-1.6-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s276",
    d: "m107.4 23.7q0 0.4 0 0.8c0.3 0.7 0.2 1.4-0.2 2.1-1.5 2-3.7 1.9-5.8 1.7q-0.8 0-1.5-0.3c-0.9-0.7-1.8-0.3-2.7-0.2-1.4 0.1-2.6-0.8-3.9-1.2-1-0.7-2-1.4-2-2.9 1.1-1.1 2.3-1.5 3.8-0.8 3.2 1.4 5.6 0.1 7.8-2.1 1.3-1.4 2.4-1.4 3.7-0.1 1.2 0.8 0.7 2 0.8 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s324",
    d: "m107.4 23.7c-3-0.3-0.2-2.1-0.8-3 1.8-0.7 1.3-2.8 2.3-3.9q0.4-0.4 0.9-0.5c1.7 0.5 3.6-0.9 5.2 0.5 0.5 0.6 0.7 1.2 0.6 1.9 0.3 1.6 2.1-0.2 2.5 1.2q0.7 0.4 1.5 0.8c-3 0.7-5.8 3.2-9.2 0.8-0.6-0.4-1.6 2-3 2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s315",
    d: "m82.1 19.9c0.7-0.2 0.7 0.3 0.8 0.8 1 0.6 2 0.1 3 0 1.9-0.9 1.8 0.2 1.6 1.5-0.7 3.4-3.4 3.3-6 3.5-1-0.3-2-0.6-1.7-2q1.2-1.9 2.3-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s86",
    d: "m100.5 15.3c-0.6 0.7-1.2 1.5-1.9 2.3-1.5-1.3-0.4-2.2 0.4-3 0.8-1.5 2.3-2.4 3-3.9 0.6-0.6 1.3-1.3 2.3-0.7 0.7 1.7-0.4 2.7-1.5 3.8q0 0.4 0 0.8c-0.6 0.8-1.6 0.3-2.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s385",
    d: "m82.1 24.5c2-0.2 3.6-1.4 5.4-2.3q1.1 0.7 2.3 1.5 0.4 0.6 0 1.1c-1.3 0.9-2.9 1.1-4.3 1.4-1.4 0.3-3.2 0.6-3.4-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s100",
    d: "m95.1 6.9q0-0.4 0-0.8c2.8-1.3 5.6 1.4 8.4 0q0.4 0.8 0.8 1.5c-3.1 0.8-6-1.3-9.2-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s386",
    d: "m102.8 13.8c-0.2-1.6 0.8-2.7 1.5-3.8q0.8 0.7 1.5 1.5c-0.3 0.9-0.9 1.5-1.5 2.3-0.5 0.4-1 0.2-1.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s386",
    d: "m102 10.7q0 3.1-3 3.9c-0.2-2.2 1.8-2.7 3-3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s387",
    d: "m89.8 24.5q0-0.4 0-0.8 0.7 0 1.5 0 1.5 0.8 2.3 2.3c-1 1.4-2.2 1-3.4 0.3q-0.5-0.4-0.7-0.8-0.1-0.6 0.3-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s302",
    d: "m109.7 16.8h-0.8c-0.6-1.5 0.8-2.1 1.5-3q0.4 0.7 0.8 1.5c0.3 1.4-0.6 1.4-1.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s388",
    d: "m85.9 20.7c-1 0.7-2 2.2-3 0q0.7-0.4 1.5-0.8 0.8 0.4 1.5 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s389",
    d: "m93.1 21c-1 0.5-2 0.8-3.2 0.5 0.9-1.5 2.1-0.6 3.2-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s198",
    d: "m104.3 13.8c-0.6-1.6 0.7-1.8 1.5-2.3 0.6 1.5-0.3 1.9-1.5 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s390",
    d: "m100 19.4c-0.6 0.3-0.9 0.6-1.1 0.6-0.3 0-0.6-0.3-0.8-0.6-0.1-0.3 0.1-0.7 0.5-0.7 0.4 0.1 0.8 0.4 1.4 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s391",
    d: "m102.8 15.3c0.6 0.1 1.3 0.2 1.5 0.9 0.1 0.2-0.3 0.7-0.6 0.7-0.6 0.2-0.8-0.3-0.9-0.8q-0.3-0.3-0.2-0.5 0.1-0.3 0.2-0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s392",
    d: "m91.1 18.9q-0.5-0.4-1-0.8c0.2-0.1 0.5-0.4 0.8-0.3 0.5 0 0.9 0.3 0.9 0.9 0 0.1-0.4 0.1-0.7 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s232",
    d: "m102.8 15.3q0 0.4 0 0.8-1.2-0.4-2.3-0.8c0.6-0.6 1.4-0.8 2.3-0.7q0 0.3 0 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s302",
    d: "m95.9 17.6q-1.2-0.8-2.3-1.5c0.9 0.2 2.7-0.7 2.3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s218",
    d: "m109.7 16.8q0.7-0.7 1.5-1.5c1.4-1 2.8-1.7 4.6-1.5q-0.4 1.5-0.8 3c-1.8 0.8-3.5 1.3-5.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s218",
    d: "m115 19.1q0-1.1 0-2.3c1.1 0.6 2.1 0.2 3.1 0q-0.4 0.8-0.8 1.6c-0.5 0.8-1.2 1.3-2.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s393",
    d: "m2.5 31.4q-0.4-1.6-0.8-3.1c2.8-0.7 3.5-2.7 3.1-5.3 2 0.3 4.1 0.8 5.3-1.6 0.8-0.6 1.6-0.5 2.3 0q0.4 0.4 0.8 0.8c-0.2 1.2 0.5 2.4 0.2 3.7-1 1.3-2.2 0.5-3.3 0.2-0.5-0.4 0.3-0.9-0.1-1.1-0.2-0.1-0.6 0.2-0.5 0.7 0.7 1 2.5 0.3 2.7 1.9 0.1 1.3-0.9 1.9-1.6 2.7q-0.7 0.4-1.5 0.4c-0.6 0.1-1.2-0.1-1.7 0.3-1.6 1.5-3.2 1.2-4.9 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s394",
    d: "m30.8 22.2q-1.5 0.7-3 1.5c-1.4-1.1-3.3 0.5-4.6-0.8q-0.4-0.7-0.8-1.5c-0.4-1 0.3-1.3 1-1.7 1.2-0.1 2.4-0.7 3.6-1 2.8-0.5 4.2 0.8 3.8 3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s395",
    d: "m10.1 25.3c1 0.8 2.1 0.9 3.1 0q0.3-0.6 0.7-0.1c1.9-0.2 2.9 1.2 3.9 2.3q0.1 0.3 0.1 0.6c-0.7 1.6-2.1 1.8-3.6 1.9q-0.5-0.2-1-0.5c-0.6-0.6-1.1-1.3-1.6-1.9-0.9-1-2.8-0.6-3.1-2.3q0.8-0.7 1.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s339",
    d: "m23.2 22.9c1.7-0.9 3.2-0.6 4.6 0.8q-0.8 0.4-1.6 0.8c-1.7 1.1-3.5 1.2-5.3 0.7-0.8-2.2 0.9-2.1 2.3-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s328",
    d: "m4 19.1q-0.4-0.3-0.8-0.7 0.4-0.8 0.8-1.6c2-2.7 2.9 1.6 4.6 0.8v1.5c-1.5-0.5-3.1-0.5-4.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s376",
    d: "m23.1 16.1c0.6-0.2 1.1-0.5 1.6 0 0.7 1.3 2.4 2.5 0 3.8-1.1-0.1-2.3 0.7-3.1-0.8q0.8-1.5 1.5-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s212",
    d: "m20.8 25.2c1.8-0.3 3.4-1.9 5.4-0.7-0.7 2-2.4 1.3-3.8 1.6-1.1 0.8-2.1 0.9-3.1-0.1q0.8-0.4 1.5-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s396",
    d: "m13.9 25.2q-0.3 0-0.7 0.1c-0.2-1.1-2.4-2.1 0-3.1 3.3 0.2 0.3 2.1 0.7 3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s397",
    d: "m19.3 26q1.6 0 3.1 0.1 0 0.3 0 0.7c-0.1 1.3-0.9 1.8-2.1 2-1.1 0-1.8-0.5-2.5-1.3 0.1-0.8 0.7-1.3 1.5-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s95",
    d: "m18.5 15.3c0.6 0.6 1.7 1 1.2 2-0.2 0.3-1.7 0.5-2 0.2-1.1-1.1 0.8-1.4 0.9-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s398",
    d: "m21.6 19.1q1.2 0.6 2.3 0c0.5 0.5 0.5 1.1 0 1.6q-0.8 0.3-1.5 0.7c-0.7-0.6-0.8-1.4-0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s377",
    d: "m18.7 21.7c0.2 0.2 0.7 0.4 0.7 0.5-0.1 0.3-0.3 0.7-0.5 0.8-0.5 0.2-1 0.1-1-0.5 0-0.2 0.4-0.5 0.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s328",
    d: "m12.4 21.4q-1.1 0-2.3 0 0-0.7 0-1.5 1.6 0.2 2.3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s327",
    d: "m15.2 19.5c-0.3 0.2-0.5 0.5-0.8 0.7 0 0.1-0.3-0.2-0.5-0.3 0.2-0.3 0.4-0.5 0.7-0.8 0 0 0.3 0.2 0.6 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s319",
    d: "m23.9 20.7q0-0.8 0-1.6c2-0.5 0.8-1.9 0.8-3 3.3 2 6.6 1.5 9.9 0 1.2 1.2-3 2.5 0 3.8q0.3 0.2 0.2 0.5-0.1 0.2-0.2 0.2c-0.7 0.8-2.9 0.2-2.3 2.3q-0.3 0.4-0.7 0.8c0.4 0.5 0.5 1 0 1.5-0.9-0.8-0.8-1.9-0.8-3-0.7-2.5-2.8-1.9-4.4-1.7-0.8 0.1-1.6 0.6-2.5 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s399",
    d: "m33.1 13q0.4 0.8 0.8 1.5c-1.2 0.7-2.4 2.2-3.8 0.3 0.5-1.5 2.3-0.8 3-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s322",
    d: "m26.3 14.1c-0.3-0.2-0.8-0.4-1-0.8-0.2-0.4 0.2-0.8 0.6-0.6 0.5 0.1 1 0.4 1.2 0.8 0.3 0.4-0.1 0.7-0.8 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s400",
    d: "m5.5 10.7q0.4-0.7 0.8-1.5c0.5 0.1 1.5-0.3 1.3 0.7-0.2 0.9-1.1 1.3-2.1 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s308",
    d: "m34.6 20.7q0-0.4 0-0.8 0.8-0.4 1.6-0.8c2.3-0.3 4.3-2.3 6.9-1.5q-0.4 1.1-0.8 2.3c-1.6 0.3-3.7-0.8-4.6 1.5q-0.8-0.4-1.5-0.7-0.8 0-1.6 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s236",
    d: "m197.7 13.8q0 0.4 0 0.7c-1.2 0.3-0.8 2.3-2.3 2.3q-0.4-1.1-0.8-2.2-0.7-1.2 0.1-2.4c0.7-1.2 1.9-1.9 3.1-1.3 1.3 0.7-0.6 1.9-0.1 2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s236",
    d: "m189.3 10c1-0.2 2-0.6 3.1 0q-0.6 1.1 0 2.2c0.6 0.7 1.3 1.3 0.7 2.3-1.4-0.8-2.7-2.5-4.6-0.7 1.6-1.1-1.6-3 0.8-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s100",
    d: "m193.1 14.5q-0.3-1.1-0.7-2.3 1.1 0 2.3 0 0.8 1.2-0.1 2.4-0.7-0.1-1.5-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s401",
    d: "m202.3 10c-0.7-0.3-1.4-0.5-1.1-1.5 0-0.1 0.6-0.2 0.6-0.2q0.3 0.8 0.5 1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s402",
    d: "m206.2 11.5c-1.2 0.9-2 0.6-2.3-0.8q0.7 0 1.5 0 0.4 0.4 0.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s215",
    d: "m115 19.1q1.2-0.4 2.3-0.7 0.4 0.7 0.8 1.5c-1.7 0.2-3.5 1.5-5.2-0.3 0.6-0.7 1.5-0.4 2.1-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s284",
    d: "m124.2 19.9l-2.3 2.3q-0.7-1.2-1.5-2.3c1.3-1.2 2.6-0.1 3.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s100",
    d: "m155.6 10.7c-1.4-0.1-3.2 0.5-3.8-1.5q-0.3-0.3-0.3-0.6 0-0.3 0.1-0.3c1.1-1.3 2.1 0.7 3.2 0.1q1.6-0.4 3.1-0.7c1.4-0.5 2.8-1.4 4 0.3-0.6 1.4-2.1 0.8-3.1 1.2-1.5-0.4-1.6 2.1-3.2 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s360",
    d: "m161.7 8.4c-1.1-1-2.5-0.7-3.8-0.8q0.8-0.7 1.5-1.5 1.6 0.4 3.1 0.8 0.4 0.4 0.6 0.9 0.2 0.8-0.4 1.5-0.5 0.3-1 0-0.4-0.5 0-0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s403",
    d: "m151.8 8.4v0.8q-0.8 0-1.5 0c0.3-1.6 0.3-3.8 3-2.3-0.1 0.9-1 1-1.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s404",
    d: "m151.7 4.4c-0.8 0-1-0.3-1-0.9 0.1-0.3 0.3-0.8 0.5-0.8 0.6 0 0.9 0.4 0.9 0.9 0 0.3-0.3 0.6-0.4 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s316",
    d: "m148.7 10q-0.7 0-1.5 0c-0.5-1.2 0.3-1.8 1.1-1.7 1.1 0.1 0.6 1 0.4 1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s284",
    d: "m151.8 8.4q0.7-0.7 1.5-1.5 0.8 0.8 1.5 1.5c-1 1-2 0-3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s362",
    d: "m145.7 8.4q-0.4-0.7-0.8-1.5c0.4-0.4 1.1-0.9 1.5-0.3 0.5 0.7-0.2 1.3-0.7 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s223",
    d: "m0.2 15.3v-1.5c0.9 0.6 2.7-0.4 3 1.5q-1.5 0-3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s98",
    d: "m169.4 9.2q0.4 0.8 0.8 1.5c0.1 0.7-0.2 1-0.9 1.2-0.5 0.1-1.1 0.3-1.6 0.5-1.3 0.2-2.3-0.4-3.3-1.3q-0.7-1.1 0-2.3 0.2-0.2 0.4-0.4 0.4 0 0.8 0 1.9 0.4 3.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s207",
    d: "m162.5 7.6q0-0.3 0-0.7c1.5-0.6 2 0.4 2.3 1.5q-0.3 0.4-0.8 0.5c-0.8-0.1-1.1-0.8-1.5-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s375",
    d: "m83.9 12.5c-0.3 0.1-0.5 0.3-0.7 0.2-0.1 0-0.2-0.3-0.3-0.5 0.2-0.1 0.4-0.3 0.6-0.3 0.2 0.1 0.2 0.4 0.4 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s244",
    d: "m82.9 18.4h-0.8c0-1.3-0.1-2.6 1.5-3.1q-0.3 1.5-0.7 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s294",
    d: "m47.6 36.7c1.3-0.6 2.6-1.1 3.9 0-2.2-0.1-3.3 2.3-5.4 2.3-0.5-1.4 0.5-1.8 1.5-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s405",
    d: "m52.2 40.5c1.9 1.5 0.5 1.9-0.7 2.3 0-0.8 0.1-1.6 0.7-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s307",
    d: "m53 37.5q1.1 0 2.3 0c0.4 0.4 0.5 0.9 0.2 1.5q-0.5 0.4-1 0-1.2-0.2-1.5-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s92",
    d: "m54.5 39q0.4 0 0.8 0c1.1 0.5 1.5 1.2 0.8 2.3q-0.8 0-1.6 0 0-1.1 0-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s201",
    d: "m55.3 34.4c1.6-1 0.6-2.5 0.8-3.8 1.4-0.8 2.8-0.7 4.3 0 0.6 0.3 1.3 0.5 2 0.7 0.7 0.2 1.4 0.5 1.8 1.1q0.3 0.4 0.5 1c0 0.9-0.2 1.9 0.3 2.8 0 1-0.5 1.6-1.3 2.1v0.7c-1.5-0.5-4.2 2.4-4.6-1.5 0.8-0.2 0.5-0.5 0.1-0.8h-0.1c-0.6-0.6-1.4-0.7-2.3-0.7-0.8-0.1-1.6-0.2-2.3-0.8-0.1-0.7 0-1.1 0.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s201",
    d: "m56.1 41.3q-0.4-1.1-0.8-2.3 0-0.7 0-1.5 1.1 0.8 2.3 1.5-0.8 1.2-1.5 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s283",
    d: "m86.7 33.7c-2.3-0.5-3.8 0.9-5.4 2.2-3.3 0.3-3.7-0.1-2.6-3.1q0.3-0.5 0.7-0.8c1-0.7 1.9-1.7 3.3-1.7 1.6-0.2 3.2-0.9 4.7 0 0.8 0.7 2.1 1.1 1.6 2.6-0.8 0-1.7 0.1-2.3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s216",
    d: "m79.8 32.9c-1.5 2 0.4 2.3 1.5 3q0 0.4 0 0.8c-1.3 1.6-2.9 1.5-4.5 0.8-1.8-1.3-0.1-2.6-0.1-3.9q-0.4-0.5 0-1 0.5-0.4 1-0.6c0.9-0.1 1.6 0.1 2.1 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s86",
    d: "m76.8 37.5c1.4-1 3-0.5 4.5-0.8 0.1 3.4-3 2.1-4.6 3.1q-0.7 0-1.5 0-0.4-0.3-0.3-0.5 0.2-0.3 0.3-0.3c0.5-0.5 0.5-1.6 1.6-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s306",
    d: "m87.5 39.8q-0.4 0-0.8 0c-3.5-2.9-0.5-3.2 1.5-3.8q-0.4 1.9-0.7 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s272",
    d: "m92.8 34.4c-1.7 2.6-1.9-0.8-3-0.7q-0.1-0.4-0.1-0.8c-0.1-0.7-0.6-1.4 0.3-1.9q0.8-0.4 1.7-0.1c1.3 0.9 1.9 2 1.1 3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s306",
    d: "m85.9 40.5q-1.5 1.2-3 2.4c-0.7-2.9 1-2.8 3-2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s244",
    d: "m89.8 31.4c0.2 0.5 0.4 1-0.1 1.5q-0.3 0-0.7 0-1.1-0.8-2.3-1.5 1.5-1.5 3.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s86",
    d: "m86.7 33.7c0.5 0.6 0.5 1.1-0.2 1.5-0.2 0.1-0.5 0-0.7-0.1q0.4-0.7 0.9-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s283",
    d: "m89.8 33.7c-0.1 1.1-0.3 2-1.6 2.3 0.6-0.8 0.1-2.2 1.6-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s361",
    d: "m75.2 39v0.8c-2.2 1.1-4.4 2.5-6.9 0.7 2.1-1.6 4.7-0.6 6.9-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s341",
    d: "m77.5 32.9q-0.4 0-0.7 0c-1.3 0.8-2.6 0.3-3.9 0-1.2-2.4-2.5-0.3-3.8 0-1.4-0.8-2.9-1.4-1.5-3.4q4.7-1.8 9.7-2.3c0.8 0.1 1.6 0.3 2.1 1.1 1 2.2-1.1 3.1-1.9 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m67.6 29.8q0.7 1.5 1.5 3.1-1.2 1.1-2.3 2.3c-0.9-0.7-1.6-1.6-2.3-2.5-0.3-0.7-1.4-1.1-0.8-2.1q-0.2-1-0.4-2 1.3 0.2 2.7 0.5h0.8c0.3 0.2 0.7 0.3 0.8 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s306",
    d: "m72.9 32.9c1.3-1.6 2.6 0.4 3.9 0q-0.1 0.4-0.1 0.7c-1.3 0-2.2 0.2-2.9 1.6-1.4 3-3.1 2.7-4.7 0 0.6-0.7 1.5-0.6 2.3-0.8q1.3-0.2 1.5-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s236",
    d: "m65.3 32.1c1.2 0.7 1.5 1.8 1.5 3.1q-0.4 0.4-0.8 0.7c-1.4 0.4-1.3-0.9-1.7-1.5q-0.2-0.4-0.6-0.7 0-0.4 0-0.8c0.3-0.7 0.7-1.2 1.6-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s283",
    d: "m64.5 33.7c1.5 0 0.6 1.8 1.5 2.2-0.5 1.1-1 2.1-2.3 2.4q0.4-1.2 0.8-2.3-0.8-1.2 0-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s406",
    d: "m71.4 34.4c-0.4 1.5-1.5 0.8-2.3 0.8 0.3-1.6 1.2-1.5 2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s73",
    d: "m98.2 37.5q-0.8-0.4-1.6-0.8c-0.8-0.6 0-1.7-0.7-2.3q-0.8 0-1.6 0-0.3-0.4-0.3-0.9c0.5-0.9 1.1-1.6 2.1-1.8 1.1 0 1.7 0.8 2.3 1.5 0.7 0.9 0.9 1.8 0.8 2.8-0.1 0.7-0.5 1.2-1 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s202",
    d: "m94.3 40.6c-1-0.1-2 0.9-3-0.1 1.9-0.9 3.7-1.9 6.7-1.5-1.6 0.7-2.6 1.1-3.7 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s407",
    d: "m94.4 33.7q0 0.3-0.1 0.7-0.7 0-1.5 0-0.7-1.5-1.5-3 0.2-0.3 0.3-0.5 0.8-0.5 1.7-0.3 0.5 0.1 1 0.5c0.7 0.8 0.8 1.7 0.1 2.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s275",
    d: "m95.9 34.4c0.7 0.7 0.8 1.5 0.7 2.3-0.8 0.4-1.9 0.6-2.3-0.3-0.4-1 1.8-0.7 1.6-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s279",
    d: "m98.2 37.5q0-0.8 0-1.5 0.5-0.3 1-0.3c0.8 0.2 1.4 0.6 1.4 1.4-0.1 0.9-1 0.8-1.7 1.1q-0.3-0.3-0.7-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s408",
    d: "m91.7 38.1q-0.5 0.3-1 0.5c0-0.2-0.2-0.5-0.2-0.5 0.3-0.3 0.6-0.5 0.9-0.7 0.1 0.2 0.2 0.4 0.3 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m85.9 42.8c0.7-2 2.4-1.3 3.9-1.5-0.7 2-2.4 1.4-3.9 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s277",
    d: "m101.2 27.5c0.3-0.7 0.8-1.6 1.6-1.1 1.5 1.1 2.5 0 3.8-0.4 1.1 0 1.7 0.7 2.3 1.5-0.5 1.5-2.4 1.1-3.1 2.3-0.5 2.3-2.6 0.8-3.8 1.6-0.5 0.2-1 0.4-1.5 0-0.8-0.6-0.9-1.3-0.8-2.2 0.2-0.8 0.9-1.2 1.5-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s184",
    d: "m110.4 32.9c-1.6 2.2-3.3 2.4-5.3 0.4-0.6-0.5-1.6-0.8-2.3-1.2 0.9-2.2 2.4-1.3 3.8-0.7q1.9 0.7 3.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s284",
    d: "m121.9 22.2c-0.3 3.8-1 4.1-5.2 2.1 1.3-1.9 3.1-2.3 5.2-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s242",
    d: "m123.5 26.8c0.4-4.9 0.5-5 5.4-4.6-2.3 1.9-3.9 3.2-5.5 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s409",
    d: "m108.9 27.5c-1.1 0-2-0.2-2.3-1.5q0.4-0.7 0.8-1.5c1.2 1.2 3.4-0.2 4.5 1.7-1 0.5-2 0.9-3 1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s279",
    d: "m118.1 28.3q-1.5 0.4-3.1 0.8c0.5-1-1.9-2 0-2.7 1.4-0.5 3.2-0.5 3.1 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s86",
    d: "m106.6 31.4c-1.3 0-2.7-0.3-3.8 0.7q-0.4-0.4-0.8-0.7c0.5-2.4 2.7-0.7 3.8-1.6q0.4 0.8 0.8 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s410",
    d: "m124.2 28.3q-0.8 0.4-1.5 0.8-1.9-2 0.8-2.3h-0.1q0.4 0.7 0.8 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s279",
    d: "m113.1 24.7c-0.2-0.2-0.5-0.4-0.5-0.7 0-0.6 0.5-0.8 1-0.7 0.3 0.1 0.7 0.5 0.7 0.7 0 0.6-0.6 0.7-1.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s411",
    d: "m128.8 26q-0.7 0.4-1.5 0.8-0.4-0.4-0.8-0.8c0.8-0.6 1.6-1.9 2.3 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s336",
    d: "m100.5 29.1q0 1.1 0 2.3-0.4 0.3-0.8 0.7c-0.5 0.9-0.8 2.1-2.3 1.6q-0.7-0.8-1.5-1.6-0.8 0.1-1.3-0.5c-0.4-0.5-0.9-0.9-1.6-1-0.7 0-1.3 0.3-1.7 0.8h-4.6c-1.3-1.2-2.6 0.6-3.8 0-2-1.4-2.2 0.8-3.1 1.5q-1.2 0-2.3 0c-1.2-2 1-2.6 1.5-3.8 0.6-1.5 1.7-1.8 3-1.6 0.3-0.1 0.5-0.2 0.7-0.4 2.1-1.7 4.5-2 7.1-1.9 1.5 2.6 4.5 1.1 6.5 2.3 1.1 0.3 1.9-0.8 3-0.4 0.6 0.6 1.7 0.8 1.2 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s270",
    d: "m98.9 38.2c1-0.7 1-1.5 0.1-2.2q0.1-0.3 0.1-0.6c0.8-1 1.7-1.4 2.9-1 0.6 1.6 3.9 1.1 3.1 3.8-0.7 0.7-1.5 0.8-2.3 0.8q-1.9-0.4-3.9-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s277",
    d: "m97.4 33.7c0.7-0.6 1.3-1.4 2.3-1.6q0.8 0.8 1.5 1.5c-0.4 1.2-1.4 1.7-2.3 2.4q-0.3 0-0.7 0-0.4-1.2-0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s198",
    d: "m98.9 36q0.9-1.5 2.3-2.4 0.4 0.4 0.8 0.8-1.5 0.8-3.1 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s360",
    d: "m162.5 16.1q-0.8 0-1.5 0c-0.9-0.1-1.9-0.1-1.6-1.4 0.2-1.3 0.5-1 1.6-0.7 1.4 0.4 0.9-0.9 0.7-1.8 0-1.8 1.2-1.6 2.4-1.4 1.7 0.7 1.1 2 0.6 3.2-0.5 0.9-1 1.8-2.2 2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s239",
    d: "m155.6 10.7c0.8-0.7 0.9-2.1 2.3-2.3 0.5 0.5 0.3 1 0 1.6 2.2 3.3-1.7 2.4-2.7 3.6q0.2-1.1 0.4-2.1 0-0.4 0-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s412",
    d: "m164.8 11.5c-1.1 0-2.2-0.1-3.1 0.7-0.9-0.8-0.1-2.1-0.7-3q0.3-0.5 0.7 0h0.8c0.6-0.1 1.1-0.4 1.5-0.8h0.8q0 1.2 0 2.3 0.3 0.3 0.2 0.5-0.1 0.3-0.2 0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s340",
    d: "m161.7 9.2q-0.3 0-0.7 0-1.5 0.4-3.1 0.8c-0.5-0.6-0.2-1.1 0-1.6q1.9 0 3.8 0 0 0.4 0 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s393",
    d: "m154.8 16.8c0.6-0.7 1-1.5 2.1-1 0.2 0.1 0.4 0.8 0.3 1-0.7 1-1.6 0.3-2.4 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s276",
    d: "m195.4 18.4c-1.2 0.5-1.8 2.8-3.8 1.5q0-0.4 0-0.8c0.8-1.6 2.9-1 3.8-2.3q0 0.8 0 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s236",
    d: "m181.6 13h3.9q-0.8 0.8-1.5 1.5c-0.9 0-1.7-0.1-2.4-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s413",
    d: "m169.4 11.5q0.4-0.4 0.8-0.8c1.1-1 1.5 0.4 2.2 0.8q0.1 0.8 0.1 1.5c-1.1 0-2.2 0.1-3.1-0.8q-0.4-0.2-0.3-0.5 0.2-0.2 0.3-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s99",
    d: "m169.4 11.5q0 0.4 0 0.7c-1.1 0.2 0.1 3.7-2.7 1.9-0.8-0.5-0.6 1.3-1.1 2-1.1 0.2-1.3-0.5-1.5-1.3q0.1-0.6 0.3-1.1c0.3-2 2.2-1.7 3.5-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s388",
    d: "m164.8 14.5q0.4 0.8 0.8 1.6 0.7 0 1.5 0c-0.9 1.5-2.3 1.5-3.8 1.5 0-1.3-0.6-2.8 1.5-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s414",
    d: "m164.8 14.5q-0.8 1.6-1.5 3.1h-0.8v-1.5q0.2-1.6 1.5-2.3 0.4-0.5 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s98",
    d: "m43.1 29.8c2.3 0.5 4.5-0.5 6.8-0.7 0.7 0.6 1.3 1.2 1.3 2.1q-0.1 0.6-0.5 0.9l-0.8 0.8c-1.7 0.8-3.5 1.4-5.3 0 0.3-1.3-0.4-1.5-1.4-1.5-1.4-0.1-2.8 0.2-4-0.8 1-2 2.3-1.9 3.9-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s269",
    d: "m44.6 32.9q2.7 0 5.3 0c0.4 0.7 2 1.9-0.2 1.8-2.5-0.2-5 1-7.6-0.2-1.1-0.5-2.5 0.1-3.6 0.7-0.6-1.8 0.6-1.9 1.8-1.7 1.5 0.1 3 0.5 4.3-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s415",
    d: "m50.7 32.1q0-0.3 0-0.7c0.1-1.3 0.9-1.9 2.2-2q0.5 0 0.9 0.4 0.7 0.4 1.5 0.8c-1.3 1.2-2.7 2-4.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s269",
    d: "m47.6 36.7q-0.7 1.2-1.5 2.3c-0.8 0-1.6-0.1-2.3-0.8 1.5 0 2-2.5 3.8-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s371",
    d: "m55.3 34.4q-0.4 0.4-0.8 0.8-0.7 0.1-1.4 0.3c0-0.3-0.1-0.8 0-1 0.7-0.9 1.4-0.8 2.2-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s369",
    d: "m59.2 36.7c0.9 0.3 1.8 0.6 3 1-1.3 0.9-2.2 0-3.1-0.2q0-0.4 0.1-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s281",
    d: "m56.8 35.9c1.2-0.9 1.8-0.1 2.3 0.8-0.8 0-1.6-0.1-2.3-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s308",
    d: "m43.1 29.8c-1.4 0-2.7 0.2-3.9 0.8q-0.8 0-1.5 0-0.8 0-1.5 0 0-0.4 0-0.8c-0.3-1.4-1.7-1.9-2.3-3h-1.6c-0.3-0.2-0.7-0.3-0.7-0.8q0-0.4 0-0.8v-1.5c0.9 0.5 1.8 1.5 3 0.8 1.9 2.6 4.5 3.5 7.7 3q0.4 1.2 0.8 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s416",
    d: "m17.8 27.5c1-0.5 1.6 0.2 2.3 0.8 1 0.2 2.7-2 3 0.8-2.1 0.4-3.1 3.9-6.1 2.2-0.8 0.1-1.6 0.9-2.5 0.5q-0.8-0.4-1.1-1.2c0-0.6 0.1-1.1 0.6-1.5 1.3-0.3 2.7-0.6 3.8-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s417",
    d: "m14.7 31.3c0.8-0.2 1.6-0.8 2.3 0q0 0.4 0 0.8c-1.3 1.6-2.8 1.8-4.6 0.8q-0.4 0-0.8 0c0.1-2.4 1.9-1.4 3.1-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s418",
    d: "m23.1 29.1c-0.8-1.2-2.1-0.2-3-0.8q1.1-0.8 2.3-1.5c0.8 0.5 1.7 1.1 0.7 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s236",
    d: "m31.6 26q0.4 0.4 0.7 0.8c-1.5 0.9-3-0.1-4.5 0 1.1-1 2.5-0.7 3.8-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s283",
    d: "m33.9 26.8c1.3 0.5 2.4 1.4 2.3 3-0.9-0.9-1.8-1.6-3.1-0.7-0.6-1.1 0.2-1.7 0.8-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s328",
    d: "m14.7 31.3q-1.5 0.8-3.1 1.6c-2.3-1.1-4.5 0-6.8 0-0.7-0.7-2.1-0.2-2.3-1.5 2.9 1 2.9-1.6 3.8-3.1 0.7 0.5 1.4 1 2 1.7 1.8 1 3.9-0.9 5.7 0.6q0.3 0.4 0.7 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s389",
    d: "m59.9 32.1c-1.7 0.5-2.2-1.9-3.8-1.5 1.4-1.3 2.7-2.6 3-4.6 0.9 0 2.3-0.9 2 1.1-0.2 1.4 0.4 2.5 1.1 3.5q-0.1 0.2-0.2 0.4c-0.6 0.5-1.5 0.5-2.1 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s362",
    d: "m53.8 24.5c-2.3 2.2-4.5-0.4-6.9-0.4q2.6-0.9 5.3-1.9c0.4 0.8 2.2 0.7 1.6 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s419",
    d: "m53.8 24.5c-0.6-0.8-2.3-0.7-1.6-2.3q1.6 0 3.1 0 0 0.8 0 1.5-0.1 0.7-0.8 0.8-0.3 0-0.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s397",
    d: "m53.8 29.8q-0.4 0-0.8 0c-0.9 0.2-1.9 0.7-2.3-0.7q0-0.4 0-0.8c1.1 0 2.2 0 3.3 0 0.5 0 1.2 0 0.9 0.7-0.1 0.4-0.7 0.6-1.1 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s362",
    d: "m54.5 24.5q0.4-0.4 0.8-0.8c1 0.1 1.1 0.7 0.8 1.5-1.3 1.2-1.6 0.6-1.6-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s375",
    d: "m50.7 29.1q1.2 0.4 2.3 0.7-1.1 0.8-2.3 1.6c-0.6-0.7-0.8-1.5-0.8-2.3q0.4 0 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s209",
    d: "m57.6 20.7c0.4 0.2 1.6-0.4 1.2 0.7-0.3 0.7-1.3 0.7-2 0q0.4-0.4 0.8-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s126",
    d: "m65.3 32.1q-0.8 0.4-1.6 0.8-0.8-0.4-1.5-0.8-0.7-0.8 0-1.5 0.8 0 1.5 0c0.5 0.5 1.6 0.4 1.6 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s420",
    d: "m64.2 23.6c-0.5 0.3-0.7 0.5-1.1 0.7-0.3 0.2-0.7 0.1-0.6-0.4 0-0.3 0.4-0.6 0.7-0.7 0.2-0.1 0.5 0.2 1 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s319",
    d: "m89.8 25.2c-1.2 0.3-1.2 4.5-3.6 1.1-0.1-0.2-2.6 0.7-3.3 2q-1.9 0.4-3.9 0.8-0.7-0.4-1.5-0.8c-1.4-2.5-3.3 0-4.9-0.5-1.1-0.1-1.6-0.8-2-1.8q0-0.4 0-0.8c0.7-0.6 1.5-0.7 2.3-0.7 1.3 0 2.6-0.1 3.8-0.8 1.1 0.2 2.1-0.4 3.1 0 0.6 0.7 1.4 0.8 2.3 0.8 2.5 2.1 5.1-1.3 7.7 0q0 0.4 0 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s99",
    d: "m79.8 23.7c-1 0.5-2 1-3.1 0q1.6-1.3 3.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s387",
    d: "m72.9 26.8q2.9-0.8 5.8-1.5c0.4 1.5-0.5 2.2-1.2 3-3.3 0.7-6.5 2.1-9.9 1.5q-0.4-0.3-0.8-0.7 0.4-0.4 0.8-0.8c1.4-1.8 3.9 0.3 5.3-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s421",
    d: "m72.9 26.8c-0.7 4.2-3.7 0.6-5.3 1.5 0.4-1.6 1.6-2 3-2.3q1.2 0.4 2.3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s321",
    d: "m96.7 28.3c-2.3 0.8-6.3-1-6.9-3.1q1.9 0.4 3.8 0.8c0.9-0.2 2.4-4.5 2.5 0.4 0 0.1 0.8 0.3 1.3 0.4 0.5 0.8 0.7 1.6-0.7 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s366",
    d: "m96.7 28.3q0.3-0.7 0.7-1.5c1-0.6 2.1-1.9 3.1 0-0.4 0.5-0.7 1.2-1.5 0.7-0.8 0.4-1.2 1.8-2.3 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s303",
    d: "m99 27.5q0.7-0.3 1.5-0.7 0.4 0.4 0.7 0.7-0.3 0.8-0.7 1.6-0.8-0.8-1.5-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s422",
    d: "m104.9 22.9c-0.3 0.2-0.5 0.4-0.8 0.6-0.1 0-0.4-0.4-0.4-0.4 0.2-0.3 0.5-0.5 0.8-0.8 0.1 0.2 0.2 0.3 0.4 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m14 30.6c-2.1 1-4.1 0.4-6.2 0-0.2-0.8 0.1-1 0.8-0.8q0.8 0 1.6 0c1.1-0.7 1.9-2.3 3.7-1.5q0 0.4 0.1 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s327",
    d: "m13.9 28.3q-1.9 0.7-3.7 1.5c0.1-1 0.9-1.5 1.5-2.2 0.8 0 1.6 0 2.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s240",
    d: "m10.1 25.3q-0.7 0-1.5 0-0.5-0.1-1.1-0.2c0.8-1.2 1.9-0.4 2.9-0.5 0 0 0.2 0.2 0.2 0.2q-0.2 0.3-0.5 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s423",
    d: "m8.6 29.8q-0.4 0.4-0.8 0.8-0.7-1.2-1.5-2.3c1.1 0 2 0.3 2.3 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s238",
    d: "m164 8.4c-0.2 0.9-0.5 1.6-1.5 0.8q0-0.8 0-1.6 0.8 0.4 1.5 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s388",
    d: "m164.8 13.8h-0.8c-0.6-1.1 0.2-1.7 0.8-2.3q0-0.4 0-0.8 1.5 0.4 3.1 0.8c-0.9 0.9-2.5 0.9-3.1 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s424",
    d: "m64.5 33.7q0 1.1 0 2.3-1.1 0-2.2 0 0.7-1.2 1.4-2.3 0.4 0 0.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s325",
    d: "m62.2 30.6q0 0.8 0 1.5-1.2 0-2.3 0 0.7-1.4 2.3-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s303",
    d: "m79.8 32.9c0.3-1.9 0.4-4.3 3.1-1.5q-1.6 0.7-3.1 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s82",
    d: "m95.1 31.4q0.4 0.4 0.8 0.8-0.3 1.2-1.5 1.5-0.4-1.2-0.8-2.3c0.5-0.5 1-0.5 1.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s384",
    d: "m91.3 31.4c0.2-0.8 0-2 1.5-1.6q0.7 0.8 0 1.5-0.7 0.1-1.5 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s253",
    d: "m92.8 31.3q0-0.7 0-1.5 1.6 0.2 2.3 1.6-0.7 0-1.5 0-0.4 0-0.8-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s319",
    d: "m82.9 28.3q0.8 0.2 1.7 0.4c-0.1 0.2-0.1 0.5-0.2 0.6-0.9 0.2-1.4 0-1.5-1z"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfacmSlogo);
export default __webpack_public_path__ + "static/media/BFACM_slogo.af230872ec6f7ea1eff3feb4e7673f14.svg";
export { ForwardRef as ReactComponent };